/******/ (function() { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ 4714:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/*
 *  Copyright 2011 Twitter, Inc.
 *  Licensed under the Apache License, Version 2.0 (the "License");
 *  you may not use this file except in compliance with the License.
 *  You may obtain a copy of the License at
 *
 *  http://www.apache.org/licenses/LICENSE-2.0
 *
 *  Unless required by applicable law or agreed to in writing, software
 *  distributed under the License is distributed on an "AS IS" BASIS,
 *  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *  See the License for the specific language governing permissions and
 *  limitations under the License.
 */

// This file is for use with Node.js. See dist/ for browser files.

var Hogan = __webpack_require__(6729);
Hogan.Template = (__webpack_require__(9549).Template);
Hogan.template = Hogan.Template;
module.exports = Hogan;


/***/ }),

/***/ 6729:
/***/ (function(__unused_webpack_module, exports) {

/*
 *  Copyright 2011 Twitter, Inc.
 *  Licensed under the Apache License, Version 2.0 (the "License");
 *  you may not use this file except in compliance with the License.
 *  You may obtain a copy of the License at
 *
 *  http://www.apache.org/licenses/LICENSE-2.0
 *
 *  Unless required by applicable law or agreed to in writing, software
 *  distributed under the License is distributed on an "AS IS" BASIS,
 *  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *  See the License for the specific language governing permissions and
 *  limitations under the License.
 */

(function (Hogan) {
  // Setup regex  assignments
  // remove whitespace according to Mustache spec
  var rIsWhitespace = /\S/,
      rQuot = /\"/g,
      rNewline =  /\n/g,
      rCr = /\r/g,
      rSlash = /\\/g,
      rLineSep = /\u2028/,
      rParagraphSep = /\u2029/;

  Hogan.tags = {
    '#': 1, '^': 2, '<': 3, '$': 4,
    '/': 5, '!': 6, '>': 7, '=': 8, '_v': 9,
    '{': 10, '&': 11, '_t': 12
  };

  Hogan.scan = function scan(text, delimiters) {
    var len = text.length,
        IN_TEXT = 0,
        IN_TAG_TYPE = 1,
        IN_TAG = 2,
        state = IN_TEXT,
        tagType = null,
        tag = null,
        buf = '',
        tokens = [],
        seenTag = false,
        i = 0,
        lineStart = 0,
        otag = '{{',
        ctag = '}}';

    function addBuf() {
      if (buf.length > 0) {
        tokens.push({tag: '_t', text: new String(buf)});
        buf = '';
      }
    }

    function lineIsWhitespace() {
      var isAllWhitespace = true;
      for (var j = lineStart; j < tokens.length; j++) {
        isAllWhitespace =
          (Hogan.tags[tokens[j].tag] < Hogan.tags['_v']) ||
          (tokens[j].tag == '_t' && tokens[j].text.match(rIsWhitespace) === null);
        if (!isAllWhitespace) {
          return false;
        }
      }

      return isAllWhitespace;
    }

    function filterLine(haveSeenTag, noNewLine) {
      addBuf();

      if (haveSeenTag && lineIsWhitespace()) {
        for (var j = lineStart, next; j < tokens.length; j++) {
          if (tokens[j].text) {
            if ((next = tokens[j+1]) && next.tag == '>') {
              // set indent to token value
              next.indent = tokens[j].text.toString()
            }
            tokens.splice(j, 1);
          }
        }
      } else if (!noNewLine) {
        tokens.push({tag:'\n'});
      }

      seenTag = false;
      lineStart = tokens.length;
    }

    function changeDelimiters(text, index) {
      var close = '=' + ctag,
          closeIndex = text.indexOf(close, index),
          delimiters = trim(
            text.substring(text.indexOf('=', index) + 1, closeIndex)
          ).split(' ');

      otag = delimiters[0];
      ctag = delimiters[delimiters.length - 1];

      return closeIndex + close.length - 1;
    }

    if (delimiters) {
      delimiters = delimiters.split(' ');
      otag = delimiters[0];
      ctag = delimiters[1];
    }

    for (i = 0; i < len; i++) {
      if (state == IN_TEXT) {
        if (tagChange(otag, text, i)) {
          --i;
          addBuf();
          state = IN_TAG_TYPE;
        } else {
          if (text.charAt(i) == '\n') {
            filterLine(seenTag);
          } else {
            buf += text.charAt(i);
          }
        }
      } else if (state == IN_TAG_TYPE) {
        i += otag.length - 1;
        tag = Hogan.tags[text.charAt(i + 1)];
        tagType = tag ? text.charAt(i + 1) : '_v';
        if (tagType == '=') {
          i = changeDelimiters(text, i);
          state = IN_TEXT;
        } else {
          if (tag) {
            i++;
          }
          state = IN_TAG;
        }
        seenTag = i;
      } else {
        if (tagChange(ctag, text, i)) {
          tokens.push({tag: tagType, n: trim(buf), otag: otag, ctag: ctag,
                       i: (tagType == '/') ? seenTag - otag.length : i + ctag.length});
          buf = '';
          i += ctag.length - 1;
          state = IN_TEXT;
          if (tagType == '{') {
            if (ctag == '}}') {
              i++;
            } else {
              cleanTripleStache(tokens[tokens.length - 1]);
            }
          }
        } else {
          buf += text.charAt(i);
        }
      }
    }

    filterLine(seenTag, true);

    return tokens;
  }

  function cleanTripleStache(token) {
    if (token.n.substr(token.n.length - 1) === '}') {
      token.n = token.n.substring(0, token.n.length - 1);
    }
  }

  function trim(s) {
    if (s.trim) {
      return s.trim();
    }

    return s.replace(/^\s*|\s*$/g, '');
  }

  function tagChange(tag, text, index) {
    if (text.charAt(index) != tag.charAt(0)) {
      return false;
    }

    for (var i = 1, l = tag.length; i < l; i++) {
      if (text.charAt(index + i) != tag.charAt(i)) {
        return false;
      }
    }

    return true;
  }

  // the tags allowed inside super templates
  var allowedInSuper = {'_t': true, '\n': true, '$': true, '/': true};

  function buildTree(tokens, kind, stack, customTags) {
    var instructions = [],
        opener = null,
        tail = null,
        token = null;

    tail = stack[stack.length - 1];

    while (tokens.length > 0) {
      token = tokens.shift();

      if (tail && tail.tag == '<' && !(token.tag in allowedInSuper)) {
        throw new Error('Illegal content in < super tag.');
      }

      if (Hogan.tags[token.tag] <= Hogan.tags['$'] || isOpener(token, customTags)) {
        stack.push(token);
        token.nodes = buildTree(tokens, token.tag, stack, customTags);
      } else if (token.tag == '/') {
        if (stack.length === 0) {
          throw new Error('Closing tag without opener: /' + token.n);
        }
        opener = stack.pop();
        if (token.n != opener.n && !isCloser(token.n, opener.n, customTags)) {
          throw new Error('Nesting error: ' + opener.n + ' vs. ' + token.n);
        }
        opener.end = token.i;
        return instructions;
      } else if (token.tag == '\n') {
        token.last = (tokens.length == 0) || (tokens[0].tag == '\n');
      }

      instructions.push(token);
    }

    if (stack.length > 0) {
      throw new Error('missing closing tag: ' + stack.pop().n);
    }

    return instructions;
  }

  function isOpener(token, tags) {
    for (var i = 0, l = tags.length; i < l; i++) {
      if (tags[i].o == token.n) {
        token.tag = '#';
        return true;
      }
    }
  }

  function isCloser(close, open, tags) {
    for (var i = 0, l = tags.length; i < l; i++) {
      if (tags[i].c == close && tags[i].o == open) {
        return true;
      }
    }
  }

  function stringifySubstitutions(obj) {
    var items = [];
    for (var key in obj) {
      items.push('"' + esc(key) + '": function(c,p,t,i) {' + obj[key] + '}');
    }
    return "{ " + items.join(",") + " }";
  }

  function stringifyPartials(codeObj) {
    var partials = [];
    for (var key in codeObj.partials) {
      partials.push('"' + esc(key) + '":{name:"' + esc(codeObj.partials[key].name) + '", ' + stringifyPartials(codeObj.partials[key]) + "}");
    }
    return "partials: {" + partials.join(",") + "}, subs: " + stringifySubstitutions(codeObj.subs);
  }

  Hogan.stringify = function(codeObj, text, options) {
    return "{code: function (c,p,i) { " + Hogan.wrapMain(codeObj.code) + " }," + stringifyPartials(codeObj) +  "}";
  }

  var serialNo = 0;
  Hogan.generate = function(tree, text, options) {
    serialNo = 0;
    var context = { code: '', subs: {}, partials: {} };
    Hogan.walk(tree, context);

    if (options.asString) {
      return this.stringify(context, text, options);
    }

    return this.makeTemplate(context, text, options);
  }

  Hogan.wrapMain = function(code) {
    return 'var t=this;t.b(i=i||"");' + code + 'return t.fl();';
  }

  Hogan.template = Hogan.Template;

  Hogan.makeTemplate = function(codeObj, text, options) {
    var template = this.makePartials(codeObj);
    template.code = new Function('c', 'p', 'i', this.wrapMain(codeObj.code));
    return new this.template(template, text, this, options);
  }

  Hogan.makePartials = function(codeObj) {
    var key, template = {subs: {}, partials: codeObj.partials, name: codeObj.name};
    for (key in template.partials) {
      template.partials[key] = this.makePartials(template.partials[key]);
    }
    for (key in codeObj.subs) {
      template.subs[key] = new Function('c', 'p', 't', 'i', codeObj.subs[key]);
    }
    return template;
  }

  function esc(s) {
    return s.replace(rSlash, '\\\\')
            .replace(rQuot, '\\\"')
            .replace(rNewline, '\\n')
            .replace(rCr, '\\r')
            .replace(rLineSep, '\\u2028')
            .replace(rParagraphSep, '\\u2029');
  }

  function chooseMethod(s) {
    return (~s.indexOf('.')) ? 'd' : 'f';
  }

  function createPartial(node, context) {
    var prefix = "<" + (context.prefix || "");
    var sym = prefix + node.n + serialNo++;
    context.partials[sym] = {name: node.n, partials: {}};
    context.code += 't.b(t.rp("' +  esc(sym) + '",c,p,"' + (node.indent || '') + '"));';
    return sym;
  }

  Hogan.codegen = {
    '#': function(node, context) {
      context.code += 'if(t.s(t.' + chooseMethod(node.n) + '("' + esc(node.n) + '",c,p,1),' +
                      'c,p,0,' + node.i + ',' + node.end + ',"' + node.otag + " " + node.ctag + '")){' +
                      't.rs(c,p,' + 'function(c,p,t){';
      Hogan.walk(node.nodes, context);
      context.code += '});c.pop();}';
    },

    '^': function(node, context) {
      context.code += 'if(!t.s(t.' + chooseMethod(node.n) + '("' + esc(node.n) + '",c,p,1),c,p,1,0,0,"")){';
      Hogan.walk(node.nodes, context);
      context.code += '};';
    },

    '>': createPartial,
    '<': function(node, context) {
      var ctx = {partials: {}, code: '', subs: {}, inPartial: true};
      Hogan.walk(node.nodes, ctx);
      var template = context.partials[createPartial(node, context)];
      template.subs = ctx.subs;
      template.partials = ctx.partials;
    },

    '$': function(node, context) {
      var ctx = {subs: {}, code: '', partials: context.partials, prefix: node.n};
      Hogan.walk(node.nodes, ctx);
      context.subs[node.n] = ctx.code;
      if (!context.inPartial) {
        context.code += 't.sub("' + esc(node.n) + '",c,p,i);';
      }
    },

    '\n': function(node, context) {
      context.code += write('"\\n"' + (node.last ? '' : ' + i'));
    },

    '_v': function(node, context) {
      context.code += 't.b(t.v(t.' + chooseMethod(node.n) + '("' + esc(node.n) + '",c,p,0)));';
    },

    '_t': function(node, context) {
      context.code += write('"' + esc(node.text) + '"');
    },

    '{': tripleStache,

    '&': tripleStache
  }

  function tripleStache(node, context) {
    context.code += 't.b(t.t(t.' + chooseMethod(node.n) + '("' + esc(node.n) + '",c,p,0)));';
  }

  function write(s) {
    return 't.b(' + s + ');';
  }

  Hogan.walk = function(nodelist, context) {
    var func;
    for (var i = 0, l = nodelist.length; i < l; i++) {
      func = Hogan.codegen[nodelist[i].tag];
      func && func(nodelist[i], context);
    }
    return context;
  }

  Hogan.parse = function(tokens, text, options) {
    options = options || {};
    return buildTree(tokens, '', [], options.sectionTags || []);
  }

  Hogan.cache = {};

  Hogan.cacheKey = function(text, options) {
    return [text, !!options.asString, !!options.disableLambda, options.delimiters, !!options.modelGet].join('||');
  }

  Hogan.compile = function(text, options) {
    options = options || {};
    var key = Hogan.cacheKey(text, options);
    var template = this.cache[key];

    if (template) {
      var partials = template.partials;
      for (var name in partials) {
        delete partials[name].instance;
      }
      return template;
    }

    template = this.generate(this.parse(this.scan(text, options.delimiters), text, options), text, options);
    return this.cache[key] = template;
  }
})( true ? exports : 0);


/***/ }),

/***/ 9549:
/***/ (function(__unused_webpack_module, exports) {

/*
 *  Copyright 2011 Twitter, Inc.
 *  Licensed under the Apache License, Version 2.0 (the "License");
 *  you may not use this file except in compliance with the License.
 *  You may obtain a copy of the License at
 *
 *  http://www.apache.org/licenses/LICENSE-2.0
 *
 *  Unless required by applicable law or agreed to in writing, software
 *  distributed under the License is distributed on an "AS IS" BASIS,
 *  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *  See the License for the specific language governing permissions and
 *  limitations under the License.
 */

var Hogan = {};

(function (Hogan) {
  Hogan.Template = function (codeObj, text, compiler, options) {
    codeObj = codeObj || {};
    this.r = codeObj.code || this.r;
    this.c = compiler;
    this.options = options || {};
    this.text = text || '';
    this.partials = codeObj.partials || {};
    this.subs = codeObj.subs || {};
    this.buf = '';
  }

  Hogan.Template.prototype = {
    // render: replaced by generated code.
    r: function (context, partials, indent) { return ''; },

    // variable escaping
    v: hoganEscape,

    // triple stache
    t: coerceToString,

    render: function render(context, partials, indent) {
      return this.ri([context], partials || {}, indent);
    },

    // render internal -- a hook for overrides that catches partials too
    ri: function (context, partials, indent) {
      return this.r(context, partials, indent);
    },

    // ensurePartial
    ep: function(symbol, partials) {
      var partial = this.partials[symbol];

      // check to see that if we've instantiated this partial before
      var template = partials[partial.name];
      if (partial.instance && partial.base == template) {
        return partial.instance;
      }

      if (typeof template == 'string') {
        if (!this.c) {
          throw new Error("No compiler available.");
        }
        template = this.c.compile(template, this.options);
      }

      if (!template) {
        return null;
      }

      // We use this to check whether the partials dictionary has changed
      this.partials[symbol].base = template;

      if (partial.subs) {
        // Make sure we consider parent template now
        if (!partials.stackText) partials.stackText = {};
        for (key in partial.subs) {
          if (!partials.stackText[key]) {
            partials.stackText[key] = (this.activeSub !== undefined && partials.stackText[this.activeSub]) ? partials.stackText[this.activeSub] : this.text;
          }
        }
        template = createSpecializedPartial(template, partial.subs, partial.partials,
          this.stackSubs, this.stackPartials, partials.stackText);
      }
      this.partials[symbol].instance = template;

      return template;
    },

    // tries to find a partial in the current scope and render it
    rp: function(symbol, context, partials, indent) {
      var partial = this.ep(symbol, partials);
      if (!partial) {
        return '';
      }

      return partial.ri(context, partials, indent);
    },

    // render a section
    rs: function(context, partials, section) {
      var tail = context[context.length - 1];

      if (!isArray(tail)) {
        section(context, partials, this);
        return;
      }

      for (var i = 0; i < tail.length; i++) {
        context.push(tail[i]);
        section(context, partials, this);
        context.pop();
      }
    },

    // maybe start a section
    s: function(val, ctx, partials, inverted, start, end, tags) {
      var pass;

      if (isArray(val) && val.length === 0) {
        return false;
      }

      if (typeof val == 'function') {
        val = this.ms(val, ctx, partials, inverted, start, end, tags);
      }

      pass = !!val;

      if (!inverted && pass && ctx) {
        ctx.push((typeof val == 'object') ? val : ctx[ctx.length - 1]);
      }

      return pass;
    },

    // find values with dotted names
    d: function(key, ctx, partials, returnFound) {
      var found,
          names = key.split('.'),
          val = this.f(names[0], ctx, partials, returnFound),
          doModelGet = this.options.modelGet,
          cx = null;

      if (key === '.' && isArray(ctx[ctx.length - 2])) {
        val = ctx[ctx.length - 1];
      } else {
        for (var i = 1; i < names.length; i++) {
          found = findInScope(names[i], val, doModelGet);
          if (found !== undefined) {
            cx = val;
            val = found;
          } else {
            val = '';
          }
        }
      }

      if (returnFound && !val) {
        return false;
      }

      if (!returnFound && typeof val == 'function') {
        ctx.push(cx);
        val = this.mv(val, ctx, partials);
        ctx.pop();
      }

      return val;
    },

    // find values with normal names
    f: function(key, ctx, partials, returnFound) {
      var val = false,
          v = null,
          found = false,
          doModelGet = this.options.modelGet;

      for (var i = ctx.length - 1; i >= 0; i--) {
        v = ctx[i];
        val = findInScope(key, v, doModelGet);
        if (val !== undefined) {
          found = true;
          break;
        }
      }

      if (!found) {
        return (returnFound) ? false : "";
      }

      if (!returnFound && typeof val == 'function') {
        val = this.mv(val, ctx, partials);
      }

      return val;
    },

    // higher order templates
    ls: function(func, cx, partials, text, tags) {
      var oldTags = this.options.delimiters;

      this.options.delimiters = tags;
      this.b(this.ct(coerceToString(func.call(cx, text)), cx, partials));
      this.options.delimiters = oldTags;

      return false;
    },

    // compile text
    ct: function(text, cx, partials) {
      if (this.options.disableLambda) {
        throw new Error('Lambda features disabled.');
      }
      return this.c.compile(text, this.options).render(cx, partials);
    },

    // template result buffering
    b: function(s) { this.buf += s; },

    fl: function() { var r = this.buf; this.buf = ''; return r; },

    // method replace section
    ms: function(func, ctx, partials, inverted, start, end, tags) {
      var textSource,
          cx = ctx[ctx.length - 1],
          result = func.call(cx);

      if (typeof result == 'function') {
        if (inverted) {
          return true;
        } else {
          textSource = (this.activeSub && this.subsText && this.subsText[this.activeSub]) ? this.subsText[this.activeSub] : this.text;
          return this.ls(result, cx, partials, textSource.substring(start, end), tags);
        }
      }

      return result;
    },

    // method replace variable
    mv: function(func, ctx, partials) {
      var cx = ctx[ctx.length - 1];
      var result = func.call(cx);

      if (typeof result == 'function') {
        return this.ct(coerceToString(result.call(cx)), cx, partials);
      }

      return result;
    },

    sub: function(name, context, partials, indent) {
      var f = this.subs[name];
      if (f) {
        this.activeSub = name;
        f(context, partials, this, indent);
        this.activeSub = false;
      }
    }

  };

  //Find a key in an object
  function findInScope(key, scope, doModelGet) {
    var val;

    if (scope && typeof scope == 'object') {

      if (scope[key] !== undefined) {
        val = scope[key];

      // try lookup with get for backbone or similar model data
      } else if (doModelGet && scope.get && typeof scope.get == 'function') {
        val = scope.get(key);
      }
    }

    return val;
  }

  function createSpecializedPartial(instance, subs, partials, stackSubs, stackPartials, stackText) {
    function PartialTemplate() {};
    PartialTemplate.prototype = instance;
    function Substitutions() {};
    Substitutions.prototype = instance.subs;
    var key;
    var partial = new PartialTemplate();
    partial.subs = new Substitutions();
    partial.subsText = {};  //hehe. substext.
    partial.buf = '';

    stackSubs = stackSubs || {};
    partial.stackSubs = stackSubs;
    partial.subsText = stackText;
    for (key in subs) {
      if (!stackSubs[key]) stackSubs[key] = subs[key];
    }
    for (key in stackSubs) {
      partial.subs[key] = stackSubs[key];
    }

    stackPartials = stackPartials || {};
    partial.stackPartials = stackPartials;
    for (key in partials) {
      if (!stackPartials[key]) stackPartials[key] = partials[key];
    }
    for (key in stackPartials) {
      partial.partials[key] = stackPartials[key];
    }

    return partial;
  }

  var rAmp = /&/g,
      rLt = /</g,
      rGt = />/g,
      rApos = /\'/g,
      rQuot = /\"/g,
      hChars = /[&<>\"\']/;

  function coerceToString(val) {
    return String((val === null || val === undefined) ? '' : val);
  }

  function hoganEscape(str) {
    str = coerceToString(str);
    return hChars.test(str) ?
      str
        .replace(rAmp, '&amp;')
        .replace(rLt, '&lt;')
        .replace(rGt, '&gt;')
        .replace(rApos, '&#39;')
        .replace(rQuot, '&quot;') :
      str;
  }

  var isArray = Array.isArray || function(a) {
    return Object.prototype.toString.call(a) === '[object Array]';
  };

})( true ? exports : 0);


/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// This entry needs to be wrapped in an IIFE because it needs to be in strict mode.
!function() {
"use strict";

;// ./src/scripts/lang/algoliaTranslations.js
/**
 * @fileoverview Handles translations for Algolia search functionality by processing
 * and decoding translation strings from the global window.defaultAlgoliaTranslations object.
 */

/**
 * Object that will store the processed translation strings.
 * @type {Object.<string, string>}
 */
var languageStrings = {};

/**
 * Safely decodes URI components and HTML entities from a string.
 *
 * @param {*} str - The string to decode (or any value that might be a string)
 * @returns {*} The decoded string, or the original value if not a string or if decoding fails
 */
var safeDecodeURI = function safeDecodeURI(str) {
  try {
    // Return the input as is if it's not a string
    if (typeof str !== 'string') return str;
    var decoded = str;

    // Decode URI components (e.g., %20 → space)
    decoded = decodeURIComponent(decoded);

    // Decode HTML entities (e.g., &amp; → &) using textarea element
    var textArea = document.createElement('textarea');
    textArea.innerHTML = decoded;
    decoded = textArea.value;
    return decoded;
  } catch (e) {
    // Log the error and return the original string if decoding fails
    console.warn('Failed to decode:', str);
    console.warn('Error:', e);
    return str;
  }
};

// Process each translation string from the global Algolia translations object
Object.keys(window.defaultAlgoliaTranslations).forEach(function (key) {
  languageStrings[key] = safeDecodeURI(window.defaultAlgoliaTranslations[key]);
});

;// ./node_modules/embla-carousel/esm/embla-carousel.esm.js
function isNumber(subject) {
  return typeof subject === 'number';
}
function isString(subject) {
  return typeof subject === 'string';
}
function isBoolean(subject) {
  return typeof subject === 'boolean';
}
function isObject(subject) {
  return Object.prototype.toString.call(subject) === '[object Object]';
}
function mathAbs(n) {
  return Math.abs(n);
}
function mathSign(n) {
  return Math.sign(n);
}
function deltaAbs(valueB, valueA) {
  return mathAbs(valueB - valueA);
}
function factorAbs(valueB, valueA) {
  if (valueB === 0 || valueA === 0) return 0;
  if (mathAbs(valueB) <= mathAbs(valueA)) return 0;
  const diff = deltaAbs(mathAbs(valueB), mathAbs(valueA));
  return mathAbs(diff / valueB);
}
function roundToTwoDecimals(num) {
  return Math.round(num * 100) / 100;
}
function arrayKeys(array) {
  return objectKeys(array).map(Number);
}
function arrayLast(array) {
  return array[arrayLastIndex(array)];
}
function arrayLastIndex(array) {
  return Math.max(0, array.length - 1);
}
function arrayIsLastIndex(array, index) {
  return index === arrayLastIndex(array);
}
function arrayFromNumber(n, startAt = 0) {
  return Array.from(Array(n), (_, i) => startAt + i);
}
function objectKeys(object) {
  return Object.keys(object);
}
function objectsMergeDeep(objectA, objectB) {
  return [objectA, objectB].reduce((mergedObjects, currentObject) => {
    objectKeys(currentObject).forEach(key => {
      const valueA = mergedObjects[key];
      const valueB = currentObject[key];
      const areObjects = isObject(valueA) && isObject(valueB);
      mergedObjects[key] = areObjects ? objectsMergeDeep(valueA, valueB) : valueB;
    });
    return mergedObjects;
  }, {});
}
function isMouseEvent(evt, ownerWindow) {
  return typeof ownerWindow.MouseEvent !== 'undefined' && evt instanceof ownerWindow.MouseEvent;
}

function Alignment(align, viewSize) {
  const predefined = {
    start,
    center,
    end
  };
  function start() {
    return 0;
  }
  function center(n) {
    return end(n) / 2;
  }
  function end(n) {
    return viewSize - n;
  }
  function measure(n, index) {
    if (isString(align)) return predefined[align](n);
    return align(viewSize, n, index);
  }
  const self = {
    measure
  };
  return self;
}

function EventStore() {
  let listeners = [];
  function add(node, type, handler, options = {
    passive: true
  }) {
    let removeListener;
    if ('addEventListener' in node) {
      node.addEventListener(type, handler, options);
      removeListener = () => node.removeEventListener(type, handler, options);
    } else {
      const legacyMediaQueryList = node;
      legacyMediaQueryList.addListener(handler);
      removeListener = () => legacyMediaQueryList.removeListener(handler);
    }
    listeners.push(removeListener);
    return self;
  }
  function clear() {
    listeners = listeners.filter(remove => remove());
  }
  const self = {
    add,
    clear
  };
  return self;
}

function Animations(ownerDocument, ownerWindow, update, render) {
  const documentVisibleHandler = EventStore();
  const fixedTimeStep = 1000 / 60;
  let lastTimeStamp = null;
  let accumulatedTime = 0;
  let animationId = 0;
  function init() {
    documentVisibleHandler.add(ownerDocument, 'visibilitychange', () => {
      if (ownerDocument.hidden) reset();
    });
  }
  function destroy() {
    stop();
    documentVisibleHandler.clear();
  }
  function animate(timeStamp) {
    if (!animationId) return;
    if (!lastTimeStamp) {
      lastTimeStamp = timeStamp;
      update();
      update();
    }
    const timeElapsed = timeStamp - lastTimeStamp;
    lastTimeStamp = timeStamp;
    accumulatedTime += timeElapsed;
    while (accumulatedTime >= fixedTimeStep) {
      update();
      accumulatedTime -= fixedTimeStep;
    }
    const alpha = accumulatedTime / fixedTimeStep;
    render(alpha);
    if (animationId) {
      animationId = ownerWindow.requestAnimationFrame(animate);
    }
  }
  function start() {
    if (animationId) return;
    animationId = ownerWindow.requestAnimationFrame(animate);
  }
  function stop() {
    ownerWindow.cancelAnimationFrame(animationId);
    lastTimeStamp = null;
    accumulatedTime = 0;
    animationId = 0;
  }
  function reset() {
    lastTimeStamp = null;
    accumulatedTime = 0;
  }
  const self = {
    init,
    destroy,
    start,
    stop,
    update,
    render
  };
  return self;
}

function Axis(axis, contentDirection) {
  const isRightToLeft = contentDirection === 'rtl';
  const isVertical = axis === 'y';
  const scroll = isVertical ? 'y' : 'x';
  const cross = isVertical ? 'x' : 'y';
  const sign = !isVertical && isRightToLeft ? -1 : 1;
  const startEdge = getStartEdge();
  const endEdge = getEndEdge();
  function measureSize(nodeRect) {
    const {
      height,
      width
    } = nodeRect;
    return isVertical ? height : width;
  }
  function getStartEdge() {
    if (isVertical) return 'top';
    return isRightToLeft ? 'right' : 'left';
  }
  function getEndEdge() {
    if (isVertical) return 'bottom';
    return isRightToLeft ? 'left' : 'right';
  }
  function direction(n) {
    return n * sign;
  }
  const self = {
    scroll,
    cross,
    startEdge,
    endEdge,
    measureSize,
    direction
  };
  return self;
}

function Limit(min = 0, max = 0) {
  const length = mathAbs(min - max);
  function reachedMin(n) {
    return n < min;
  }
  function reachedMax(n) {
    return n > max;
  }
  function reachedAny(n) {
    return reachedMin(n) || reachedMax(n);
  }
  function constrain(n) {
    if (!reachedAny(n)) return n;
    return reachedMin(n) ? min : max;
  }
  function removeOffset(n) {
    if (!length) return n;
    return n - length * Math.ceil((n - max) / length);
  }
  const self = {
    length,
    max,
    min,
    constrain,
    reachedAny,
    reachedMax,
    reachedMin,
    removeOffset
  };
  return self;
}

function Counter(max, start, loop) {
  const {
    constrain
  } = Limit(0, max);
  const loopEnd = max + 1;
  let counter = withinLimit(start);
  function withinLimit(n) {
    return !loop ? constrain(n) : mathAbs((loopEnd + n) % loopEnd);
  }
  function get() {
    return counter;
  }
  function set(n) {
    counter = withinLimit(n);
    return self;
  }
  function add(n) {
    return clone().set(get() + n);
  }
  function clone() {
    return Counter(max, get(), loop);
  }
  const self = {
    get,
    set,
    add,
    clone
  };
  return self;
}

function DragHandler(axis, rootNode, ownerDocument, ownerWindow, target, dragTracker, location, animation, scrollTo, scrollBody, scrollTarget, index, eventHandler, percentOfView, dragFree, dragThreshold, skipSnaps, baseFriction, watchDrag) {
  const {
    cross: crossAxis,
    direction
  } = axis;
  const focusNodes = ['INPUT', 'SELECT', 'TEXTAREA'];
  const nonPassiveEvent = {
    passive: false
  };
  const initEvents = EventStore();
  const dragEvents = EventStore();
  const goToNextThreshold = Limit(50, 225).constrain(percentOfView.measure(20));
  const snapForceBoost = {
    mouse: 300,
    touch: 400
  };
  const freeForceBoost = {
    mouse: 500,
    touch: 600
  };
  const baseSpeed = dragFree ? 43 : 25;
  let isMoving = false;
  let startScroll = 0;
  let startCross = 0;
  let pointerIsDown = false;
  let preventScroll = false;
  let preventClick = false;
  let isMouse = false;
  function init(emblaApi) {
    if (!watchDrag) return;
    function downIfAllowed(evt) {
      if (isBoolean(watchDrag) || watchDrag(emblaApi, evt)) down(evt);
    }
    const node = rootNode;
    initEvents.add(node, 'dragstart', evt => evt.preventDefault(), nonPassiveEvent).add(node, 'touchmove', () => undefined, nonPassiveEvent).add(node, 'touchend', () => undefined).add(node, 'touchstart', downIfAllowed).add(node, 'mousedown', downIfAllowed).add(node, 'touchcancel', up).add(node, 'contextmenu', up).add(node, 'click', click, true);
  }
  function destroy() {
    initEvents.clear();
    dragEvents.clear();
  }
  function addDragEvents() {
    const node = isMouse ? ownerDocument : rootNode;
    dragEvents.add(node, 'touchmove', move, nonPassiveEvent).add(node, 'touchend', up).add(node, 'mousemove', move, nonPassiveEvent).add(node, 'mouseup', up);
  }
  function isFocusNode(node) {
    const nodeName = node.nodeName || '';
    return focusNodes.includes(nodeName);
  }
  function forceBoost() {
    const boost = dragFree ? freeForceBoost : snapForceBoost;
    const type = isMouse ? 'mouse' : 'touch';
    return boost[type];
  }
  function allowedForce(force, targetChanged) {
    const next = index.add(mathSign(force) * -1);
    const baseForce = scrollTarget.byDistance(force, !dragFree).distance;
    if (dragFree || mathAbs(force) < goToNextThreshold) return baseForce;
    if (skipSnaps && targetChanged) return baseForce * 0.5;
    return scrollTarget.byIndex(next.get(), 0).distance;
  }
  function down(evt) {
    const isMouseEvt = isMouseEvent(evt, ownerWindow);
    isMouse = isMouseEvt;
    preventClick = dragFree && isMouseEvt && !evt.buttons && isMoving;
    isMoving = deltaAbs(target.get(), location.get()) >= 2;
    if (isMouseEvt && evt.button !== 0) return;
    if (isFocusNode(evt.target)) return;
    pointerIsDown = true;
    dragTracker.pointerDown(evt);
    scrollBody.useFriction(0).useDuration(0);
    target.set(location);
    addDragEvents();
    startScroll = dragTracker.readPoint(evt);
    startCross = dragTracker.readPoint(evt, crossAxis);
    eventHandler.emit('pointerDown');
  }
  function move(evt) {
    const isTouchEvt = !isMouseEvent(evt, ownerWindow);
    if (isTouchEvt && evt.touches.length >= 2) return up(evt);
    const lastScroll = dragTracker.readPoint(evt);
    const lastCross = dragTracker.readPoint(evt, crossAxis);
    const diffScroll = deltaAbs(lastScroll, startScroll);
    const diffCross = deltaAbs(lastCross, startCross);
    if (!preventScroll && !isMouse) {
      if (!evt.cancelable) return up(evt);
      preventScroll = diffScroll > diffCross;
      if (!preventScroll) return up(evt);
    }
    const diff = dragTracker.pointerMove(evt);
    if (diffScroll > dragThreshold) preventClick = true;
    scrollBody.useFriction(0.3).useDuration(0.75);
    animation.start();
    target.add(direction(diff));
    evt.preventDefault();
  }
  function up(evt) {
    const currentLocation = scrollTarget.byDistance(0, false);
    const targetChanged = currentLocation.index !== index.get();
    const rawForce = dragTracker.pointerUp(evt) * forceBoost();
    const force = allowedForce(direction(rawForce), targetChanged);
    const forceFactor = factorAbs(rawForce, force);
    const speed = baseSpeed - 10 * forceFactor;
    const friction = baseFriction + forceFactor / 50;
    preventScroll = false;
    pointerIsDown = false;
    dragEvents.clear();
    scrollBody.useDuration(speed).useFriction(friction);
    scrollTo.distance(force, !dragFree);
    isMouse = false;
    eventHandler.emit('pointerUp');
  }
  function click(evt) {
    if (preventClick) {
      evt.stopPropagation();
      evt.preventDefault();
      preventClick = false;
    }
  }
  function pointerDown() {
    return pointerIsDown;
  }
  const self = {
    init,
    destroy,
    pointerDown
  };
  return self;
}

function DragTracker(axis, ownerWindow) {
  const logInterval = 170;
  let startEvent;
  let lastEvent;
  function readTime(evt) {
    return evt.timeStamp;
  }
  function readPoint(evt, evtAxis) {
    const property = evtAxis || axis.scroll;
    const coord = `client${property === 'x' ? 'X' : 'Y'}`;
    return (isMouseEvent(evt, ownerWindow) ? evt : evt.touches[0])[coord];
  }
  function pointerDown(evt) {
    startEvent = evt;
    lastEvent = evt;
    return readPoint(evt);
  }
  function pointerMove(evt) {
    const diff = readPoint(evt) - readPoint(lastEvent);
    const expired = readTime(evt) - readTime(startEvent) > logInterval;
    lastEvent = evt;
    if (expired) startEvent = evt;
    return diff;
  }
  function pointerUp(evt) {
    if (!startEvent || !lastEvent) return 0;
    const diffDrag = readPoint(lastEvent) - readPoint(startEvent);
    const diffTime = readTime(evt) - readTime(startEvent);
    const expired = readTime(evt) - readTime(lastEvent) > logInterval;
    const force = diffDrag / diffTime;
    const isFlick = diffTime && !expired && mathAbs(force) > 0.1;
    return isFlick ? force : 0;
  }
  const self = {
    pointerDown,
    pointerMove,
    pointerUp,
    readPoint
  };
  return self;
}

function NodeRects() {
  function measure(node) {
    const {
      offsetTop,
      offsetLeft,
      offsetWidth,
      offsetHeight
    } = node;
    const offset = {
      top: offsetTop,
      right: offsetLeft + offsetWidth,
      bottom: offsetTop + offsetHeight,
      left: offsetLeft,
      width: offsetWidth,
      height: offsetHeight
    };
    return offset;
  }
  const self = {
    measure
  };
  return self;
}

function PercentOfView(viewSize) {
  function measure(n) {
    return viewSize * (n / 100);
  }
  const self = {
    measure
  };
  return self;
}

function ResizeHandler(container, eventHandler, ownerWindow, slides, axis, watchResize, nodeRects) {
  const observeNodes = [container].concat(slides);
  let resizeObserver;
  let containerSize;
  let slideSizes = [];
  let destroyed = false;
  function readSize(node) {
    return axis.measureSize(nodeRects.measure(node));
  }
  function init(emblaApi) {
    if (!watchResize) return;
    containerSize = readSize(container);
    slideSizes = slides.map(readSize);
    function defaultCallback(entries) {
      for (const entry of entries) {
        if (destroyed) return;
        const isContainer = entry.target === container;
        const slideIndex = slides.indexOf(entry.target);
        const lastSize = isContainer ? containerSize : slideSizes[slideIndex];
        const newSize = readSize(isContainer ? container : slides[slideIndex]);
        const diffSize = mathAbs(newSize - lastSize);
        if (diffSize >= 0.5) {
          emblaApi.reInit();
          eventHandler.emit('resize');
          break;
        }
      }
    }
    resizeObserver = new ResizeObserver(entries => {
      if (isBoolean(watchResize) || watchResize(emblaApi, entries)) {
        defaultCallback(entries);
      }
    });
    ownerWindow.requestAnimationFrame(() => {
      observeNodes.forEach(node => resizeObserver.observe(node));
    });
  }
  function destroy() {
    destroyed = true;
    if (resizeObserver) resizeObserver.disconnect();
  }
  const self = {
    init,
    destroy
  };
  return self;
}

function ScrollBody(location, offsetLocation, previousLocation, target, baseDuration, baseFriction) {
  let scrollVelocity = 0;
  let scrollDirection = 0;
  let scrollDuration = baseDuration;
  let scrollFriction = baseFriction;
  let rawLocation = location.get();
  let rawLocationPrevious = 0;
  function seek() {
    const displacement = target.get() - location.get();
    const isInstant = !scrollDuration;
    let scrollDistance = 0;
    if (isInstant) {
      scrollVelocity = 0;
      previousLocation.set(target);
      location.set(target);
      scrollDistance = displacement;
    } else {
      previousLocation.set(location);
      scrollVelocity += displacement / scrollDuration;
      scrollVelocity *= scrollFriction;
      rawLocation += scrollVelocity;
      location.add(scrollVelocity);
      scrollDistance = rawLocation - rawLocationPrevious;
    }
    scrollDirection = mathSign(scrollDistance);
    rawLocationPrevious = rawLocation;
    return self;
  }
  function settled() {
    const diff = target.get() - offsetLocation.get();
    return mathAbs(diff) < 0.001;
  }
  function duration() {
    return scrollDuration;
  }
  function direction() {
    return scrollDirection;
  }
  function velocity() {
    return scrollVelocity;
  }
  function useBaseDuration() {
    return useDuration(baseDuration);
  }
  function useBaseFriction() {
    return useFriction(baseFriction);
  }
  function useDuration(n) {
    scrollDuration = n;
    return self;
  }
  function useFriction(n) {
    scrollFriction = n;
    return self;
  }
  const self = {
    direction,
    duration,
    velocity,
    seek,
    settled,
    useBaseFriction,
    useBaseDuration,
    useFriction,
    useDuration
  };
  return self;
}

function ScrollBounds(limit, location, target, scrollBody, percentOfView) {
  const pullBackThreshold = percentOfView.measure(10);
  const edgeOffsetTolerance = percentOfView.measure(50);
  const frictionLimit = Limit(0.1, 0.99);
  let disabled = false;
  function shouldConstrain() {
    if (disabled) return false;
    if (!limit.reachedAny(target.get())) return false;
    if (!limit.reachedAny(location.get())) return false;
    return true;
  }
  function constrain(pointerDown) {
    if (!shouldConstrain()) return;
    const edge = limit.reachedMin(location.get()) ? 'min' : 'max';
    const diffToEdge = mathAbs(limit[edge] - location.get());
    const diffToTarget = target.get() - location.get();
    const friction = frictionLimit.constrain(diffToEdge / edgeOffsetTolerance);
    target.subtract(diffToTarget * friction);
    if (!pointerDown && mathAbs(diffToTarget) < pullBackThreshold) {
      target.set(limit.constrain(target.get()));
      scrollBody.useDuration(25).useBaseFriction();
    }
  }
  function toggleActive(active) {
    disabled = !active;
  }
  const self = {
    shouldConstrain,
    constrain,
    toggleActive
  };
  return self;
}

function ScrollContain(viewSize, contentSize, snapsAligned, containScroll, pixelTolerance) {
  const scrollBounds = Limit(-contentSize + viewSize, 0);
  const snapsBounded = measureBounded();
  const scrollContainLimit = findScrollContainLimit();
  const snapsContained = measureContained();
  function usePixelTolerance(bound, snap) {
    return deltaAbs(bound, snap) <= 1;
  }
  function findScrollContainLimit() {
    const startSnap = snapsBounded[0];
    const endSnap = arrayLast(snapsBounded);
    const min = snapsBounded.lastIndexOf(startSnap);
    const max = snapsBounded.indexOf(endSnap) + 1;
    return Limit(min, max);
  }
  function measureBounded() {
    return snapsAligned.map((snapAligned, index) => {
      const {
        min,
        max
      } = scrollBounds;
      const snap = scrollBounds.constrain(snapAligned);
      const isFirst = !index;
      const isLast = arrayIsLastIndex(snapsAligned, index);
      if (isFirst) return max;
      if (isLast) return min;
      if (usePixelTolerance(min, snap)) return min;
      if (usePixelTolerance(max, snap)) return max;
      return snap;
    }).map(scrollBound => parseFloat(scrollBound.toFixed(3)));
  }
  function measureContained() {
    if (contentSize <= viewSize + pixelTolerance) return [scrollBounds.max];
    if (containScroll === 'keepSnaps') return snapsBounded;
    const {
      min,
      max
    } = scrollContainLimit;
    return snapsBounded.slice(min, max);
  }
  const self = {
    snapsContained,
    scrollContainLimit
  };
  return self;
}

function ScrollLimit(contentSize, scrollSnaps, loop) {
  const max = scrollSnaps[0];
  const min = loop ? max - contentSize : arrayLast(scrollSnaps);
  const limit = Limit(min, max);
  const self = {
    limit
  };
  return self;
}

function ScrollLooper(contentSize, limit, location, vectors) {
  const jointSafety = 0.1;
  const min = limit.min + jointSafety;
  const max = limit.max + jointSafety;
  const {
    reachedMin,
    reachedMax
  } = Limit(min, max);
  function shouldLoop(direction) {
    if (direction === 1) return reachedMax(location.get());
    if (direction === -1) return reachedMin(location.get());
    return false;
  }
  function loop(direction) {
    if (!shouldLoop(direction)) return;
    const loopDistance = contentSize * (direction * -1);
    vectors.forEach(v => v.add(loopDistance));
  }
  const self = {
    loop
  };
  return self;
}

function ScrollProgress(limit) {
  const {
    max,
    length
  } = limit;
  function get(n) {
    const currentLocation = n - max;
    return length ? currentLocation / -length : 0;
  }
  const self = {
    get
  };
  return self;
}

function ScrollSnaps(axis, alignment, containerRect, slideRects, slidesToScroll) {
  const {
    startEdge,
    endEdge
  } = axis;
  const {
    groupSlides
  } = slidesToScroll;
  const alignments = measureSizes().map(alignment.measure);
  const snaps = measureUnaligned();
  const snapsAligned = measureAligned();
  function measureSizes() {
    return groupSlides(slideRects).map(rects => arrayLast(rects)[endEdge] - rects[0][startEdge]).map(mathAbs);
  }
  function measureUnaligned() {
    return slideRects.map(rect => containerRect[startEdge] - rect[startEdge]).map(snap => -mathAbs(snap));
  }
  function measureAligned() {
    return groupSlides(snaps).map(g => g[0]).map((snap, index) => snap + alignments[index]);
  }
  const self = {
    snaps,
    snapsAligned
  };
  return self;
}

function SlideRegistry(containSnaps, containScroll, scrollSnaps, scrollContainLimit, slidesToScroll, slideIndexes) {
  const {
    groupSlides
  } = slidesToScroll;
  const {
    min,
    max
  } = scrollContainLimit;
  const slideRegistry = createSlideRegistry();
  function createSlideRegistry() {
    const groupedSlideIndexes = groupSlides(slideIndexes);
    const doNotContain = !containSnaps || containScroll === 'keepSnaps';
    if (scrollSnaps.length === 1) return [slideIndexes];
    if (doNotContain) return groupedSlideIndexes;
    return groupedSlideIndexes.slice(min, max).map((group, index, groups) => {
      const isFirst = !index;
      const isLast = arrayIsLastIndex(groups, index);
      if (isFirst) {
        const range = arrayLast(groups[0]) + 1;
        return arrayFromNumber(range);
      }
      if (isLast) {
        const range = arrayLastIndex(slideIndexes) - arrayLast(groups)[0] + 1;
        return arrayFromNumber(range, arrayLast(groups)[0]);
      }
      return group;
    });
  }
  const self = {
    slideRegistry
  };
  return self;
}

function ScrollTarget(loop, scrollSnaps, contentSize, limit, targetVector) {
  const {
    reachedAny,
    removeOffset,
    constrain
  } = limit;
  function minDistance(distances) {
    return distances.concat().sort((a, b) => mathAbs(a) - mathAbs(b))[0];
  }
  function findTargetSnap(target) {
    const distance = loop ? removeOffset(target) : constrain(target);
    const ascDiffsToSnaps = scrollSnaps.map((snap, index) => ({
      diff: shortcut(snap - distance, 0),
      index
    })).sort((d1, d2) => mathAbs(d1.diff) - mathAbs(d2.diff));
    const {
      index
    } = ascDiffsToSnaps[0];
    return {
      index,
      distance
    };
  }
  function shortcut(target, direction) {
    const targets = [target, target + contentSize, target - contentSize];
    if (!loop) return target;
    if (!direction) return minDistance(targets);
    const matchingTargets = targets.filter(t => mathSign(t) === direction);
    if (matchingTargets.length) return minDistance(matchingTargets);
    return arrayLast(targets) - contentSize;
  }
  function byIndex(index, direction) {
    const diffToSnap = scrollSnaps[index] - targetVector.get();
    const distance = shortcut(diffToSnap, direction);
    return {
      index,
      distance
    };
  }
  function byDistance(distance, snap) {
    const target = targetVector.get() + distance;
    const {
      index,
      distance: targetSnapDistance
    } = findTargetSnap(target);
    const reachedBound = !loop && reachedAny(target);
    if (!snap || reachedBound) return {
      index,
      distance
    };
    const diffToSnap = scrollSnaps[index] - targetSnapDistance;
    const snapDistance = distance + shortcut(diffToSnap, 0);
    return {
      index,
      distance: snapDistance
    };
  }
  const self = {
    byDistance,
    byIndex,
    shortcut
  };
  return self;
}

function ScrollTo(animation, indexCurrent, indexPrevious, scrollBody, scrollTarget, targetVector, eventHandler) {
  function scrollTo(target) {
    const distanceDiff = target.distance;
    const indexDiff = target.index !== indexCurrent.get();
    targetVector.add(distanceDiff);
    if (distanceDiff) {
      if (scrollBody.duration()) {
        animation.start();
      } else {
        animation.update();
        animation.render(1);
        animation.update();
      }
    }
    if (indexDiff) {
      indexPrevious.set(indexCurrent.get());
      indexCurrent.set(target.index);
      eventHandler.emit('select');
    }
  }
  function distance(n, snap) {
    const target = scrollTarget.byDistance(n, snap);
    scrollTo(target);
  }
  function index(n, direction) {
    const targetIndex = indexCurrent.clone().set(n);
    const target = scrollTarget.byIndex(targetIndex.get(), direction);
    scrollTo(target);
  }
  const self = {
    distance,
    index
  };
  return self;
}

function SlideFocus(root, slides, slideRegistry, scrollTo, scrollBody, eventStore, eventHandler, watchFocus) {
  const focusListenerOptions = {
    passive: true,
    capture: true
  };
  let lastTabPressTime = 0;
  function init(emblaApi) {
    if (!watchFocus) return;
    function defaultCallback(index) {
      const nowTime = new Date().getTime();
      const diffTime = nowTime - lastTabPressTime;
      if (diffTime > 10) return;
      eventHandler.emit('slideFocusStart');
      root.scrollLeft = 0;
      const group = slideRegistry.findIndex(group => group.includes(index));
      if (!isNumber(group)) return;
      scrollBody.useDuration(0);
      scrollTo.index(group, 0);
      eventHandler.emit('slideFocus');
    }
    eventStore.add(document, 'keydown', registerTabPress, false);
    slides.forEach((slide, slideIndex) => {
      eventStore.add(slide, 'focus', evt => {
        if (isBoolean(watchFocus) || watchFocus(emblaApi, evt)) {
          defaultCallback(slideIndex);
        }
      }, focusListenerOptions);
    });
  }
  function registerTabPress(event) {
    if (event.code === 'Tab') lastTabPressTime = new Date().getTime();
  }
  const self = {
    init
  };
  return self;
}

function Vector1D(initialValue) {
  let value = initialValue;
  function get() {
    return value;
  }
  function set(n) {
    value = normalizeInput(n);
  }
  function add(n) {
    value += normalizeInput(n);
  }
  function subtract(n) {
    value -= normalizeInput(n);
  }
  function normalizeInput(n) {
    return isNumber(n) ? n : n.get();
  }
  const self = {
    get,
    set,
    add,
    subtract
  };
  return self;
}

function Translate(axis, container) {
  const translate = axis.scroll === 'x' ? x : y;
  const containerStyle = container.style;
  let previousTarget = null;
  let disabled = false;
  function x(n) {
    return `translate3d(${n}px,0px,0px)`;
  }
  function y(n) {
    return `translate3d(0px,${n}px,0px)`;
  }
  function to(target) {
    if (disabled) return;
    const newTarget = roundToTwoDecimals(axis.direction(target));
    if (newTarget === previousTarget) return;
    containerStyle.transform = translate(newTarget);
    previousTarget = newTarget;
  }
  function toggleActive(active) {
    disabled = !active;
  }
  function clear() {
    if (disabled) return;
    containerStyle.transform = '';
    if (!container.getAttribute('style')) container.removeAttribute('style');
  }
  const self = {
    clear,
    to,
    toggleActive
  };
  return self;
}

function SlideLooper(axis, viewSize, contentSize, slideSizes, slideSizesWithGaps, snaps, scrollSnaps, location, slides) {
  const roundingSafety = 0.5;
  const ascItems = arrayKeys(slideSizesWithGaps);
  const descItems = arrayKeys(slideSizesWithGaps).reverse();
  const loopPoints = startPoints().concat(endPoints());
  function removeSlideSizes(indexes, from) {
    return indexes.reduce((a, i) => {
      return a - slideSizesWithGaps[i];
    }, from);
  }
  function slidesInGap(indexes, gap) {
    return indexes.reduce((a, i) => {
      const remainingGap = removeSlideSizes(a, gap);
      return remainingGap > 0 ? a.concat([i]) : a;
    }, []);
  }
  function findSlideBounds(offset) {
    return snaps.map((snap, index) => ({
      start: snap - slideSizes[index] + roundingSafety + offset,
      end: snap + viewSize - roundingSafety + offset
    }));
  }
  function findLoopPoints(indexes, offset, isEndEdge) {
    const slideBounds = findSlideBounds(offset);
    return indexes.map(index => {
      const initial = isEndEdge ? 0 : -contentSize;
      const altered = isEndEdge ? contentSize : 0;
      const boundEdge = isEndEdge ? 'end' : 'start';
      const loopPoint = slideBounds[index][boundEdge];
      return {
        index,
        loopPoint,
        slideLocation: Vector1D(-1),
        translate: Translate(axis, slides[index]),
        target: () => location.get() > loopPoint ? initial : altered
      };
    });
  }
  function startPoints() {
    const gap = scrollSnaps[0];
    const indexes = slidesInGap(descItems, gap);
    return findLoopPoints(indexes, contentSize, false);
  }
  function endPoints() {
    const gap = viewSize - scrollSnaps[0] - 1;
    const indexes = slidesInGap(ascItems, gap);
    return findLoopPoints(indexes, -contentSize, true);
  }
  function canLoop() {
    return loopPoints.every(({
      index
    }) => {
      const otherIndexes = ascItems.filter(i => i !== index);
      return removeSlideSizes(otherIndexes, viewSize) <= 0.1;
    });
  }
  function loop() {
    loopPoints.forEach(loopPoint => {
      const {
        target,
        translate,
        slideLocation
      } = loopPoint;
      const shiftLocation = target();
      if (shiftLocation === slideLocation.get()) return;
      translate.to(shiftLocation);
      slideLocation.set(shiftLocation);
    });
  }
  function clear() {
    loopPoints.forEach(loopPoint => loopPoint.translate.clear());
  }
  const self = {
    canLoop,
    clear,
    loop,
    loopPoints
  };
  return self;
}

function SlidesHandler(container, eventHandler, watchSlides) {
  let mutationObserver;
  let destroyed = false;
  function init(emblaApi) {
    if (!watchSlides) return;
    function defaultCallback(mutations) {
      for (const mutation of mutations) {
        if (mutation.type === 'childList') {
          emblaApi.reInit();
          eventHandler.emit('slidesChanged');
          break;
        }
      }
    }
    mutationObserver = new MutationObserver(mutations => {
      if (destroyed) return;
      if (isBoolean(watchSlides) || watchSlides(emblaApi, mutations)) {
        defaultCallback(mutations);
      }
    });
    mutationObserver.observe(container, {
      childList: true
    });
  }
  function destroy() {
    if (mutationObserver) mutationObserver.disconnect();
    destroyed = true;
  }
  const self = {
    init,
    destroy
  };
  return self;
}

function SlidesInView(container, slides, eventHandler, threshold) {
  const intersectionEntryMap = {};
  let inViewCache = null;
  let notInViewCache = null;
  let intersectionObserver;
  let destroyed = false;
  function init() {
    intersectionObserver = new IntersectionObserver(entries => {
      if (destroyed) return;
      entries.forEach(entry => {
        const index = slides.indexOf(entry.target);
        intersectionEntryMap[index] = entry;
      });
      inViewCache = null;
      notInViewCache = null;
      eventHandler.emit('slidesInView');
    }, {
      root: container.parentElement,
      threshold
    });
    slides.forEach(slide => intersectionObserver.observe(slide));
  }
  function destroy() {
    if (intersectionObserver) intersectionObserver.disconnect();
    destroyed = true;
  }
  function createInViewList(inView) {
    return objectKeys(intersectionEntryMap).reduce((list, slideIndex) => {
      const index = parseInt(slideIndex);
      const {
        isIntersecting
      } = intersectionEntryMap[index];
      const inViewMatch = inView && isIntersecting;
      const notInViewMatch = !inView && !isIntersecting;
      if (inViewMatch || notInViewMatch) list.push(index);
      return list;
    }, []);
  }
  function get(inView = true) {
    if (inView && inViewCache) return inViewCache;
    if (!inView && notInViewCache) return notInViewCache;
    const slideIndexes = createInViewList(inView);
    if (inView) inViewCache = slideIndexes;
    if (!inView) notInViewCache = slideIndexes;
    return slideIndexes;
  }
  const self = {
    init,
    destroy,
    get
  };
  return self;
}

function SlideSizes(axis, containerRect, slideRects, slides, readEdgeGap, ownerWindow) {
  const {
    measureSize,
    startEdge,
    endEdge
  } = axis;
  const withEdgeGap = slideRects[0] && readEdgeGap;
  const startGap = measureStartGap();
  const endGap = measureEndGap();
  const slideSizes = slideRects.map(measureSize);
  const slideSizesWithGaps = measureWithGaps();
  function measureStartGap() {
    if (!withEdgeGap) return 0;
    const slideRect = slideRects[0];
    return mathAbs(containerRect[startEdge] - slideRect[startEdge]);
  }
  function measureEndGap() {
    if (!withEdgeGap) return 0;
    const style = ownerWindow.getComputedStyle(arrayLast(slides));
    return parseFloat(style.getPropertyValue(`margin-${endEdge}`));
  }
  function measureWithGaps() {
    return slideRects.map((rect, index, rects) => {
      const isFirst = !index;
      const isLast = arrayIsLastIndex(rects, index);
      if (isFirst) return slideSizes[index] + startGap;
      if (isLast) return slideSizes[index] + endGap;
      return rects[index + 1][startEdge] - rect[startEdge];
    }).map(mathAbs);
  }
  const self = {
    slideSizes,
    slideSizesWithGaps,
    startGap,
    endGap
  };
  return self;
}

function SlidesToScroll(axis, viewSize, slidesToScroll, loop, containerRect, slideRects, startGap, endGap, pixelTolerance) {
  const {
    startEdge,
    endEdge,
    direction
  } = axis;
  const groupByNumber = isNumber(slidesToScroll);
  function byNumber(array, groupSize) {
    return arrayKeys(array).filter(i => i % groupSize === 0).map(i => array.slice(i, i + groupSize));
  }
  function bySize(array) {
    if (!array.length) return [];
    return arrayKeys(array).reduce((groups, rectB, index) => {
      const rectA = arrayLast(groups) || 0;
      const isFirst = rectA === 0;
      const isLast = rectB === arrayLastIndex(array);
      const edgeA = containerRect[startEdge] - slideRects[rectA][startEdge];
      const edgeB = containerRect[startEdge] - slideRects[rectB][endEdge];
      const gapA = !loop && isFirst ? direction(startGap) : 0;
      const gapB = !loop && isLast ? direction(endGap) : 0;
      const chunkSize = mathAbs(edgeB - gapB - (edgeA + gapA));
      if (index && chunkSize > viewSize + pixelTolerance) groups.push(rectB);
      if (isLast) groups.push(array.length);
      return groups;
    }, []).map((currentSize, index, groups) => {
      const previousSize = Math.max(groups[index - 1] || 0);
      return array.slice(previousSize, currentSize);
    });
  }
  function groupSlides(array) {
    return groupByNumber ? byNumber(array, slidesToScroll) : bySize(array);
  }
  const self = {
    groupSlides
  };
  return self;
}

function Engine(root, container, slides, ownerDocument, ownerWindow, options, eventHandler) {
  // Options
  const {
    align,
    axis: scrollAxis,
    direction,
    startIndex,
    loop,
    duration,
    dragFree,
    dragThreshold,
    inViewThreshold,
    slidesToScroll: groupSlides,
    skipSnaps,
    containScroll,
    watchResize,
    watchSlides,
    watchDrag,
    watchFocus
  } = options;
  // Measurements
  const pixelTolerance = 2;
  const nodeRects = NodeRects();
  const containerRect = nodeRects.measure(container);
  const slideRects = slides.map(nodeRects.measure);
  const axis = Axis(scrollAxis, direction);
  const viewSize = axis.measureSize(containerRect);
  const percentOfView = PercentOfView(viewSize);
  const alignment = Alignment(align, viewSize);
  const containSnaps = !loop && !!containScroll;
  const readEdgeGap = loop || !!containScroll;
  const {
    slideSizes,
    slideSizesWithGaps,
    startGap,
    endGap
  } = SlideSizes(axis, containerRect, slideRects, slides, readEdgeGap, ownerWindow);
  const slidesToScroll = SlidesToScroll(axis, viewSize, groupSlides, loop, containerRect, slideRects, startGap, endGap, pixelTolerance);
  const {
    snaps,
    snapsAligned
  } = ScrollSnaps(axis, alignment, containerRect, slideRects, slidesToScroll);
  const contentSize = -arrayLast(snaps) + arrayLast(slideSizesWithGaps);
  const {
    snapsContained,
    scrollContainLimit
  } = ScrollContain(viewSize, contentSize, snapsAligned, containScroll, pixelTolerance);
  const scrollSnaps = containSnaps ? snapsContained : snapsAligned;
  const {
    limit
  } = ScrollLimit(contentSize, scrollSnaps, loop);
  // Indexes
  const index = Counter(arrayLastIndex(scrollSnaps), startIndex, loop);
  const indexPrevious = index.clone();
  const slideIndexes = arrayKeys(slides);
  // Animation
  const update = ({
    dragHandler,
    scrollBody,
    scrollBounds,
    options: {
      loop
    }
  }) => {
    if (!loop) scrollBounds.constrain(dragHandler.pointerDown());
    scrollBody.seek();
  };
  const render = ({
    scrollBody,
    translate,
    location,
    offsetLocation,
    previousLocation,
    scrollLooper,
    slideLooper,
    dragHandler,
    animation,
    eventHandler,
    scrollBounds,
    options: {
      loop
    }
  }, alpha) => {
    const shouldSettle = scrollBody.settled();
    const withinBounds = !scrollBounds.shouldConstrain();
    const hasSettled = loop ? shouldSettle : shouldSettle && withinBounds;
    const hasSettledAndIdle = hasSettled && !dragHandler.pointerDown();
    if (hasSettledAndIdle) animation.stop();
    const interpolatedLocation = location.get() * alpha + previousLocation.get() * (1 - alpha);
    offsetLocation.set(interpolatedLocation);
    if (loop) {
      scrollLooper.loop(scrollBody.direction());
      slideLooper.loop();
    }
    translate.to(offsetLocation.get());
    if (hasSettledAndIdle) eventHandler.emit('settle');
    if (!hasSettled) eventHandler.emit('scroll');
  };
  const animation = Animations(ownerDocument, ownerWindow, () => update(engine), alpha => render(engine, alpha));
  // Shared
  const friction = 0.68;
  const startLocation = scrollSnaps[index.get()];
  const location = Vector1D(startLocation);
  const previousLocation = Vector1D(startLocation);
  const offsetLocation = Vector1D(startLocation);
  const target = Vector1D(startLocation);
  const scrollBody = ScrollBody(location, offsetLocation, previousLocation, target, duration, friction);
  const scrollTarget = ScrollTarget(loop, scrollSnaps, contentSize, limit, target);
  const scrollTo = ScrollTo(animation, index, indexPrevious, scrollBody, scrollTarget, target, eventHandler);
  const scrollProgress = ScrollProgress(limit);
  const eventStore = EventStore();
  const slidesInView = SlidesInView(container, slides, eventHandler, inViewThreshold);
  const {
    slideRegistry
  } = SlideRegistry(containSnaps, containScroll, scrollSnaps, scrollContainLimit, slidesToScroll, slideIndexes);
  const slideFocus = SlideFocus(root, slides, slideRegistry, scrollTo, scrollBody, eventStore, eventHandler, watchFocus);
  // Engine
  const engine = {
    ownerDocument,
    ownerWindow,
    eventHandler,
    containerRect,
    slideRects,
    animation,
    axis,
    dragHandler: DragHandler(axis, root, ownerDocument, ownerWindow, target, DragTracker(axis, ownerWindow), location, animation, scrollTo, scrollBody, scrollTarget, index, eventHandler, percentOfView, dragFree, dragThreshold, skipSnaps, friction, watchDrag),
    eventStore,
    percentOfView,
    index,
    indexPrevious,
    limit,
    location,
    offsetLocation,
    previousLocation,
    options,
    resizeHandler: ResizeHandler(container, eventHandler, ownerWindow, slides, axis, watchResize, nodeRects),
    scrollBody,
    scrollBounds: ScrollBounds(limit, offsetLocation, target, scrollBody, percentOfView),
    scrollLooper: ScrollLooper(contentSize, limit, offsetLocation, [location, offsetLocation, previousLocation, target]),
    scrollProgress,
    scrollSnapList: scrollSnaps.map(scrollProgress.get),
    scrollSnaps,
    scrollTarget,
    scrollTo,
    slideLooper: SlideLooper(axis, viewSize, contentSize, slideSizes, slideSizesWithGaps, snaps, scrollSnaps, offsetLocation, slides),
    slideFocus,
    slidesHandler: SlidesHandler(container, eventHandler, watchSlides),
    slidesInView,
    slideIndexes,
    slideRegistry,
    slidesToScroll,
    target,
    translate: Translate(axis, container)
  };
  return engine;
}

function EventHandler() {
  let listeners = {};
  let api;
  function init(emblaApi) {
    api = emblaApi;
  }
  function getListeners(evt) {
    return listeners[evt] || [];
  }
  function emit(evt) {
    getListeners(evt).forEach(e => e(api, evt));
    return self;
  }
  function on(evt, cb) {
    listeners[evt] = getListeners(evt).concat([cb]);
    return self;
  }
  function off(evt, cb) {
    listeners[evt] = getListeners(evt).filter(e => e !== cb);
    return self;
  }
  function clear() {
    listeners = {};
  }
  const self = {
    init,
    emit,
    off,
    on,
    clear
  };
  return self;
}

const defaultOptions = {
  align: 'center',
  axis: 'x',
  container: null,
  slides: null,
  containScroll: 'trimSnaps',
  direction: 'ltr',
  slidesToScroll: 1,
  inViewThreshold: 0,
  breakpoints: {},
  dragFree: false,
  dragThreshold: 10,
  loop: false,
  skipSnaps: false,
  duration: 25,
  startIndex: 0,
  active: true,
  watchDrag: true,
  watchResize: true,
  watchSlides: true,
  watchFocus: true
};

function OptionsHandler(ownerWindow) {
  function mergeOptions(optionsA, optionsB) {
    return objectsMergeDeep(optionsA, optionsB || {});
  }
  function optionsAtMedia(options) {
    const optionsAtMedia = options.breakpoints || {};
    const matchedMediaOptions = objectKeys(optionsAtMedia).filter(media => ownerWindow.matchMedia(media).matches).map(media => optionsAtMedia[media]).reduce((a, mediaOption) => mergeOptions(a, mediaOption), {});
    return mergeOptions(options, matchedMediaOptions);
  }
  function optionsMediaQueries(optionsList) {
    return optionsList.map(options => objectKeys(options.breakpoints || {})).reduce((acc, mediaQueries) => acc.concat(mediaQueries), []).map(ownerWindow.matchMedia);
  }
  const self = {
    mergeOptions,
    optionsAtMedia,
    optionsMediaQueries
  };
  return self;
}

function PluginsHandler(optionsHandler) {
  let activePlugins = [];
  function init(emblaApi, plugins) {
    activePlugins = plugins.filter(({
      options
    }) => optionsHandler.optionsAtMedia(options).active !== false);
    activePlugins.forEach(plugin => plugin.init(emblaApi, optionsHandler));
    return plugins.reduce((map, plugin) => Object.assign(map, {
      [plugin.name]: plugin
    }), {});
  }
  function destroy() {
    activePlugins = activePlugins.filter(plugin => plugin.destroy());
  }
  const self = {
    init,
    destroy
  };
  return self;
}

function EmblaCarousel(root, userOptions, userPlugins) {
  const ownerDocument = root.ownerDocument;
  const ownerWindow = ownerDocument.defaultView;
  const optionsHandler = OptionsHandler(ownerWindow);
  const pluginsHandler = PluginsHandler(optionsHandler);
  const mediaHandlers = EventStore();
  const eventHandler = EventHandler();
  const {
    mergeOptions,
    optionsAtMedia,
    optionsMediaQueries
  } = optionsHandler;
  const {
    on,
    off,
    emit
  } = eventHandler;
  const reInit = reActivate;
  let destroyed = false;
  let engine;
  let optionsBase = mergeOptions(defaultOptions, EmblaCarousel.globalOptions);
  let options = mergeOptions(optionsBase);
  let pluginList = [];
  let pluginApis;
  let container;
  let slides;
  function storeElements() {
    const {
      container: userContainer,
      slides: userSlides
    } = options;
    const customContainer = isString(userContainer) ? root.querySelector(userContainer) : userContainer;
    container = customContainer || root.children[0];
    const customSlides = isString(userSlides) ? container.querySelectorAll(userSlides) : userSlides;
    slides = [].slice.call(customSlides || container.children);
  }
  function createEngine(options) {
    const engine = Engine(root, container, slides, ownerDocument, ownerWindow, options, eventHandler);
    if (options.loop && !engine.slideLooper.canLoop()) {
      const optionsWithoutLoop = Object.assign({}, options, {
        loop: false
      });
      return createEngine(optionsWithoutLoop);
    }
    return engine;
  }
  function activate(withOptions, withPlugins) {
    if (destroyed) return;
    optionsBase = mergeOptions(optionsBase, withOptions);
    options = optionsAtMedia(optionsBase);
    pluginList = withPlugins || pluginList;
    storeElements();
    engine = createEngine(options);
    optionsMediaQueries([optionsBase, ...pluginList.map(({
      options
    }) => options)]).forEach(query => mediaHandlers.add(query, 'change', reActivate));
    if (!options.active) return;
    engine.translate.to(engine.location.get());
    engine.animation.init();
    engine.slidesInView.init();
    engine.slideFocus.init(self);
    engine.eventHandler.init(self);
    engine.resizeHandler.init(self);
    engine.slidesHandler.init(self);
    if (engine.options.loop) engine.slideLooper.loop();
    if (container.offsetParent && slides.length) engine.dragHandler.init(self);
    pluginApis = pluginsHandler.init(self, pluginList);
  }
  function reActivate(withOptions, withPlugins) {
    const startIndex = selectedScrollSnap();
    deActivate();
    activate(mergeOptions({
      startIndex
    }, withOptions), withPlugins);
    eventHandler.emit('reInit');
  }
  function deActivate() {
    engine.dragHandler.destroy();
    engine.eventStore.clear();
    engine.translate.clear();
    engine.slideLooper.clear();
    engine.resizeHandler.destroy();
    engine.slidesHandler.destroy();
    engine.slidesInView.destroy();
    engine.animation.destroy();
    pluginsHandler.destroy();
    mediaHandlers.clear();
  }
  function destroy() {
    if (destroyed) return;
    destroyed = true;
    mediaHandlers.clear();
    deActivate();
    eventHandler.emit('destroy');
    eventHandler.clear();
  }
  function scrollTo(index, jump, direction) {
    if (!options.active || destroyed) return;
    engine.scrollBody.useBaseFriction().useDuration(jump === true ? 0 : options.duration);
    engine.scrollTo.index(index, direction || 0);
  }
  function scrollNext(jump) {
    const next = engine.index.add(1).get();
    scrollTo(next, jump, -1);
  }
  function scrollPrev(jump) {
    const prev = engine.index.add(-1).get();
    scrollTo(prev, jump, 1);
  }
  function canScrollNext() {
    const next = engine.index.add(1).get();
    return next !== selectedScrollSnap();
  }
  function canScrollPrev() {
    const prev = engine.index.add(-1).get();
    return prev !== selectedScrollSnap();
  }
  function scrollSnapList() {
    return engine.scrollSnapList;
  }
  function scrollProgress() {
    return engine.scrollProgress.get(engine.offsetLocation.get());
  }
  function selectedScrollSnap() {
    return engine.index.get();
  }
  function previousScrollSnap() {
    return engine.indexPrevious.get();
  }
  function slidesInView() {
    return engine.slidesInView.get();
  }
  function slidesNotInView() {
    return engine.slidesInView.get(false);
  }
  function plugins() {
    return pluginApis;
  }
  function internalEngine() {
    return engine;
  }
  function rootNode() {
    return root;
  }
  function containerNode() {
    return container;
  }
  function slideNodes() {
    return slides;
  }
  const self = {
    canScrollNext,
    canScrollPrev,
    containerNode,
    internalEngine,
    destroy,
    off,
    on,
    emit,
    plugins,
    previousScrollSnap,
    reInit,
    rootNode,
    scrollNext,
    scrollPrev,
    scrollProgress,
    scrollSnapList,
    scrollTo,
    selectedScrollSnap,
    slideNodes,
    slidesInView,
    slidesNotInView
  };
  activate(userOptions, userPlugins);
  setTimeout(() => eventHandler.emit('init'), 0);
  return self;
}
EmblaCarousel.globalOptions = undefined;


//# sourceMappingURL=embla-carousel.esm.js.map

;// ./src/scripts/components/algoliaProductCard.js
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12, _templateObject13, _templateObject14, _templateObject15, _templateObject16, _templateObject17, _templateObject18, _templateObject19;
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// Utility functions





/**
 * Utility class providing helper methods for string manipulation and badge creation.
 */
var Utils = /*#__PURE__*/function () {
  function Utils() {
    _classCallCheck(this, Utils);
  }
  return _createClass(Utils, null, [{
    key: "classSafeProductType",
    value:
    /**
     * Converts a product type string to a class-safe format.
     * Replaces spaces with hyphens and converts to lowercase.
     * @param {string} productType - The product type string to convert.
     * @returns {string} - The class-safe product type string.
     */
    function classSafeProductType(productType) {
      return productType ? productType.toLowerCase().replace(/\s+/g, '-') : 'unknown-product-type';
    }

    /**
     * Creates a badge object based on a given prefix.
     * Extracts the badge information from the badges object using the prefix.
     * @param {Object} badges - An object containing badge information.
     * @param {string} prefix - The prefix to use when creating the badge object.
     * @returns {string} - The badge object corresponding to the prefix.
     */
  }, {
    key: "createBadgeObject",
    value: function createBadgeObject(badges, prefix) {
      return badges[prefix] || '';
    }

    /**
     * Checks if a product is a merch product.
     * @param {Object} hit - The product hit data.
     * @returns {boolean} - True if the product is a merch product, false otherwise.
     */
  }, {
    key: "isMerchProduct",
    value: function isMerchProduct(hit) {
      return hit.named_tags && hit.named_tags.primary_collection && (hit.named_tags.primary_collection.includes('Clothing & Apparel') || hit.tags.includes('new_merch_product') || hit.tags.includes('non_merged_merch_product'));
    }

    /**
     * Checks if a product has the gibsonxcollab tag.
     * @param {Object} hit - The product hit data.
     * @returns {boolean} - True if the product has the gibsonxcollab tag, false otherwise.
     */
  }, {
    key: "isGibsonCollabProduct",
    value: function isGibsonCollabProduct(hit) {
      return hit.tags && hit.tags.includes('gibsonxcollab');
    }
  }]);
}(); // Badge handling
/**
 * Class responsible for handling badge creation and styles.
 */
var BadgeHandler = /*#__PURE__*/function () {
  /**
   * Creates an instance of BadgeHandler.
   * Initializes badge groups based on product metadata.
   * @param {Object} namedTags - The named tags associated with the hit.
   * @param {Object} hit - The product hit data.
   */
  function BadgeHandler(namedTags, hit) {
    _classCallCheck(this, BadgeHandler);
    // Custom badges from the product hit metadata.
    this.badges = hit.meta ? hit.meta.custom || [] : [];
    if (this.badges && this.badges.length > 0) {
      // Badge group 1, typically labels.
      this.badgeGroup1 = Utils.createBadgeObject(this.badges, 'label');

      // Badge group 2, typically badges.
      this.badgeGroup2 = Utils.createBadgeObject(this.badges, 'badge');
    }
  }

  /**
   * Creates badge styles for the specified group.
   * Generates CSS styles for badges based on group number.
   * @param {number} group - The badge group number (1 or 2).
   * @param {Function} html - The HTML template function.
   * @returns {TemplateResult} - The HTML template for the badge styles.
   */
  return _createClass(BadgeHandler, [{
    key: "createBadgeStyles",
    value: function createBadgeStyles(group, html) {
      var obj = group === 1 ? this.badgeGroup1 : this.badgeGroup2;
      return html(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n      <style scoped>\n        #Badge--", " {\n          background: linear-gradient(\n            90deg,\n            ", " 0%,\n            ", " 100%\n          );\n          color: ", ";\n        }\n      </style>\n    "])), group, obj.badge_background, obj["".concat(group === 2 ? '1_' : '', "badge_background")] || obj.badge_background, obj.badge_text_color);
    }

    /**
     * Creates badge elements for the specified group.
     * Generates HTML for badges based on group number.
     * @param {number} group - The badge group number (1 or 2).
     * @param {Function} html - The HTML template function.
     * @returns {TemplateResult} - The HTML template for the badge elements.
     */
  }, {
    key: "createBadgeElements",
    value: function createBadgeElements(group, html) {
      if (!this.badgeGroup1 && !this.badgeGroup2) return html(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["<div></div>"])));
      var obj = group === 1 ? this.badgeGroup1 : this.badgeGroup2;
      if (obj.length <= 0) return html(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["<div></div>"])));
      if (group === 1) {
        return html(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n        <div class=\"alt-card__labels\">\n          <span\n            class=\"alt-card__label label\"\n            style=\"color: ", ";\"\n            aria-label=\"", "\"\n          >\n            ", "\n          </span>\n        </div>\n      "])), obj.card_badge_text_color || obj.badge_text_color, obj.toLowerCase().replace(' ', '-'), obj);
      } else {
        return html(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n        <div class=\"badges__badge badge desktop--position--bottom\" id=\"Badge--2\">\n          <span class=\"badges__text\">", "</span>\n        </div>\n      "])), obj);
      }
    }
  }]);
}(); // Image handling
/**
 * Class responsible for handling image creation for products.
 */
var ImageHandler = /*#__PURE__*/function () {
  /**
   * Creates an instance of ImageHandler.
   * @param {Object} algoliaHelpers - Helper functions provided by Algolia.
   */
  function ImageHandler(algoliaHelpers) {
    _classCallCheck(this, ImageHandler);
    /**
     * Helper functions provided by Algolia.
     * @type {Object}
     */
    this.helpers = algoliaHelpers;
  }

  /**
   * Creates thumbnail images for the product.
   * Generates HTML for product image thumbnails.
   * @param {Object} hit - The product hit data.
   * @returns {string} - HTML string containing the thumbnails.
   */
  return _createClass(ImageHandler, [{
    key: "createThumbnails",
    value: function createThumbnails(hit) {
      var _this = this;
      if (!hit.images) return '';
      return hit.images.map(function (image, index) {
        var isActive = index === 0 ? 'card__thumbnail--active' : '';
        if (typeof _this.helpers.imageSrcset === 'function') {
          return "\n            <a href=\"".concat(_this.helpers.instantsearchLink(hit), "\"\n               class=\"card__thumbnail ").concat(isActive, "\"\n               data-thumbnail-index=\"").concat(index, "\"\n               data-image-src=\"").concat(_this.helpers.largeImage(image), "\"\n               data-image-srcset=\"").concat(_this.helpers.imageSrcset(image), "\"\n               onclick=\"event.preventDefault();\">\n              <img\n                src=\"").concat(_this.helpers.smallImage(image), "\"\n                alt=\"").concat(hit.title, "\"\n                srcset=\"").concat(_this.helpers.imageSrcset(image), "\"\n                width=\"60\"\n                height=\"3.75rem\"\n                class=\"object-contain object-position-center\"\n              />\n            </a>\n          ");
        }
        return '';
      }).join('');
    }

    /**
     * Creates the main image element for the product.
     * Generates HTML for the main product image.
     * @param {Object} hit - The product hit data.
     * @param {Function} html - The HTML template function.
     * @returns {TemplateResult} - The HTML template for the main image.
     */
  }, {
    key: "createMainImage",
    value: function createMainImage(hit, html) {
      var imageSrcSet = this.helpers.imageSrcset ? this.helpers.imageSrcset(hit) : '';
      var hasNoBodyImage = hit.tags && hit.tags.includes('no_body_image_shot');
      var brand = hit.vendor ? hit.vendor.toLowerCase().replace(/\//g, '-') : '';
      var brandGradient = "var(--color-background-".concat(brand, ")");
      if (hit.meta && hit.meta.custom && hit.meta.custom.has_serialized_variants) {
        hit.image = hit.product_image;
      }
      var imageUrl = this.getImageWithWidth(hit.image, 720);
      if (imageUrl === '') {
        imageUrl = this.helpers.largeImage(hit);
      }
      return html(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n      <img\n        srcset=\"", "\"\n        src=\"", "\"\n        sizes=\"(min-width: 1440px) 327px, (min-width: 990px) calc((100vw - 130px) / 4), (min-width: 750px) calc((100vw - 120px) / 3), calc((100vw - 35px) / 2)\"\n        alt=\"", "\"\n        class=\"motion-reduce ", "\"\n        loading=\"lazy\"\n        width=\"720\"\n        height=\"900\"\n        style=\"background: ", " !important;\"\n      />\n    "])), imageSrcSet, imageUrl, hit.title, hasNoBodyImage ? 'no-body-image' : '', brandGradient);
    }

    /**
     * Gets a Shopify CDN image URL with specified width
     * @param {string} imageUrl - Original image URL
     * @param {number} width - Desired width in pixels
     * @returns {string} - Transformed URL with width parameter
     */
  }, {
    key: "getImageWithWidth",
    value: function getImageWithWidth(imageUrl, width) {
      if (!imageUrl) return '';
      try {
        var url = new URL(imageUrl);
        if (!url.hostname.includes('cdn.shopify.com')) {
          return imageUrl;
        }
        url.searchParams.delete('width');
        url.searchParams.delete('w');
        url.searchParams.set('width', width);
        return url.toString();
      } catch (e) {
        console.warn('Invalid image URL:', e);
        return imageUrl;
      }
    }
  }]);
}(); // Price handling
/**
 * Class responsible for handling price display logic for products.
 */
var PriceHandler = /*#__PURE__*/function () {
  /**
   * Creates an instance of PriceHandler.
   * @param {Object} algoliaHelpers - Helper functions provided by Algolia.
   */
  function PriceHandler(algoliaHelpers) {
    _classCallCheck(this, PriceHandler);
    /**
     * Helper functions provided by Algolia.
     * @type {Object}
     */
    this.helpers = algoliaHelpers;
  }

  /**
   * Determines if the product is on sale.
   * Checks if the compare at price is greater than the current price.
   * @param {Object} hit - The product hit data.
   * @returns {boolean} - True if the product is on sale, false otherwise.
   */
  return _createClass(PriceHandler, [{
    key: "isOnSale",
    value: function isOnSale(hit, differentCurrency) {
      if (differentCurrency && hit.currency) {
        var marketPricingKey = "market_pricing_".concat(hit.currency.toLowerCase());
        if (hit[marketPricingKey] && hit[marketPricingKey].compare_at_price) {
          return hit[marketPricingKey].compare_at_price > hit[marketPricingKey].price;
        } else {
          return false;
        }
      } else {
        return hit.compare_at_price && hit.compare_at_price > hit.price;
      }
    }

    /**
     * Creates the price element for the product.
     * Generates HTML for the product price, including sale price if applicable.
     * @param {Object} hit - The product hit data.
     * @param {Function} html - The HTML template function.
     * @returns {TemplateResult} - The HTML template for the price element.
     */
  }, {
    key: "createPriceElement",
    value: function createPriceElement(hit, html) {
      // Hide price based on metafield

      if (hit.meta && hit.meta.sku && hit.meta.sku.hide_price === 'true' || hit.meta && hit.meta.sku && hit.meta.sku.hide_price === true) {
        return html(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral([""])));
      }
      var activeCurrencyCode = this.helpers.activeCurrencyCode().toUpperCase();
      var defaultCurrencyCode = window.algoliaShopify.config.store_currency;
      var differentCurrency = activeCurrencyCode !== defaultCurrencyCode;
      var localizedHit = hit;
      var isOnSale = this.isOnSale(hit, differentCurrency);
      var marketPrice = hit.price;
      if (differentCurrency) {
        var marketPricingKey = "market_pricing_".concat(activeCurrencyCode.toLowerCase());
        localizedHit = typeof window.algoliaShopify.helpers.localizedHit === 'undefined' ? window.algoliaShopify.helpers.localizeHitData(hit) : window.algoliaShopify.helpers.localizedHit(hit);
        if (hit[marketPricingKey] && hit[marketPricingKey].price) {
          marketPrice = hit[marketPricingKey].price;
        }
      }

      // Get color styles from metadata view
      var colorStyles = this.getColorStylesFromMetadata(hit);
      return html(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n      <div class=\"price\" style=\"", "\">\n        <div class=\"price__container\">\n          <div class=\"price__regular\" data-is-on-sale=\"", "\">\n            <span class=\"visually-hidden visually-hidden--inline\"> ", " </span>\n            <span class=\"price-item price-item--regular\">\n              <span>", "</span>\n            </span>\n\n            <span class=\"price-item price-item--sale ", "\">\n              <span>", "</span>\n            </span>\n          </div>\n          ", "\n        </div>\n      </div>\n    "])), colorStyles, isOnSale, algoliaShopify.translations.regularPrice, this.helpers.displayPrice({
        price: marketPrice
      }).replace(/([.,])00$/, ''), isOnSale ? '' : 'hidden', this.helpers.displayStrikedPrice(marketPrice, hit.compare_at_price).replace(/([.,])00$/, ''), isOnSale ? this.createSalePricePercentage(localizedHit, html) : '');
    }

    /**
     * Calculates and displays the discount percentage.
     * Computes the percentage off between the original and current price.
     * @param {number} compareAtPrice - The original price of the product.
     * @param {number} price - The current price of the product.
     * @returns {string} - The discount percentage as a string.
     */
  }, {
    key: "displayDiscount",
    value: function displayDiscount(compareAtPrice, price) {
      var ratio = price / compareAtPrice;

      // Round the discount fraction to 4 decimal places to avoid floating point precision issues
      var discountFraction = Number((1 - ratio).toFixed(4));
      var discountPercentage = Math.round(100 * discountFraction);
      var roundedPercentage = discountPercentage < 1 ? Math.ceil(discountPercentage) : Math.floor(discountPercentage);
      var calculatedPercentage = Number(price) && Number(compareAtPrice) > Number(price) ? "".concat(roundedPercentage, "% ").concat(algoliaShopify.translations.off) : '';
      return calculatedPercentage;
    }

    /**
     * Creates the sale price percentage element.
     * Generates HTML for the sale discount percentage display.
     * @param {Object} hit - The product hit data.
     * @param {Function} html - The HTML template function.
     * @returns {TemplateResult} - The HTML template for the sale price percentage.
     */
  }, {
    key: "createSalePricePercentage",
    value: function createSalePricePercentage(hit, html) {
      var percentagePrice = this.displayDiscount(hit.compare_at_price, hit.price);
      return html(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n      <div class=\"price__sale--discount\">\n        <span class=\"visually-hidden visually-hidden--inline\"> ", " </span>\n        <span class=\"price-item price-item--percentage\"> ", " </span>\n      </div>\n    "])), algoliaShopify.translations.salePrice, percentagePrice);
    }

    /**
     * Gets color styles from the metadata view for the pricing div.
     * Extracts text color and background color from the text-color-styles div.
     * @param {Object} _hit - The product hit data (unused but kept for consistency).
     * @returns {string} - CSS style string with color properties.
     */
  }, {
    key: "getColorStylesFromMetadata",
    value: function getColorStylesFromMetadata(_hit) {
      try {
        // Look for the text-color-styles div in the metadata view
        var textColorStylesDiv = document.querySelector('.text-color-styles');
        if (!textColorStylesDiv) {
          return '';
        }
        var textColor = textColorStylesDiv.dataset.textColorStyles;
        var bgColor = textColorStylesDiv.dataset.textBgColorStyles;
        var styles = '';
        if (textColor && textColor.trim()) {
          styles += "color: ".concat(textColor, ";");
        }
        if (bgColor && bgColor.trim()) {
          styles += "background-color: ".concat(bgColor, ";");
        }
        return styles;
      } catch (error) {
        console.warn('Error getting color styles from metadata:', error);
        return '';
      }
    }
  }]);
}(); // Main product template class
/**
 * Class responsible for creating the product template used in the product listing.
 */
var ProductTemplate = /*#__PURE__*/function () {
  /**
   * Creates an instance of ProductTemplate.
   * Initializes handlers and helpers for building the product template.
   * @param {Object} algoliaHelpers - Helper functions provided by Algolia.
   * @param {Object} components - Components provided by Algolia InstantSearch.
   * @param {Function} html - The HTML template function.
   */
  function ProductTemplate(algoliaHelpers, components, html) {
    _classCallCheck(this, ProductTemplate);
    if (!window.EmblaCarousel) {
      window.EmblaCarousel = EmblaCarousel;
    }
    /**
     * Helper functions provided by Algolia.
     * @type {Object}
     */
    this.helpers = algoliaHelpers;
    /**
     * Components provided by Algolia InstantSearch.
     * @type {Object}
     */
    this.components = components;
    /**
     * HTML template function.
     * @type {Function}
     */
    this.html = html;
    /**
     * ImageHandler instance for managing images.
     * @type {ImageHandler}
     */
    this.imageHandler = new ImageHandler(algoliaHelpers);
    /**
     * PriceHandler instance for managing prices.
     * @type {PriceHandler}
     */
    this.priceHandler = new PriceHandler(algoliaHelpers);
  }

  /**
   * Creates the product template for a given product hit.
   * Assembles the entire product card HTML.
   * @param {Object} hit - The product hit data.
   * @param {Function} _defaultTemplate - The default template function.
   * @returns {TemplateResult} - The HTML template for the product.
   */
  return _createClass(ProductTemplate, [{
    key: "createTemplate",
    value: function createTemplate(hit, _defaultTemplate) {
      var _this2 = this;
      var brandUrlParams = '';
      if (window.location.href.indexOf('?view=kramer') > -1 || hit.vendor === 'Kramer') {
        brandUrlParams = '?view=kramer';
      } else if (window.location.href.indexOf('?view=epiphone') > -1 || hit.vendor === 'Epiphone') {
        brandUrlParams = '?view=epiphone';
      } else if (window.location.href.indexOf('?view=mesa/boogie') > -1 || hit.vendor === 'Mesa/Boogie') {
        brandUrlParams = '?view=mesa';
      }

      // Initialize BadgeHandler for the product.
      var badgeHandler = new BadgeHandler(hit.named_tags, hit);

      // Get a class-safe version of the product type.
      var classSafeProductType = Utils.classSafeProductType(hit.product_type);
      var createdCompareButtons = this.createCompareButtons(hit, this.html);
      var createdMediaTemplate = this.createMediaTemplate(hit, this.html);
      var isMerchProduct = hit.named_tags && hit.named_tags.primary_collection && (hit.named_tags.primary_collection.includes('Clothing & Apparel') || hit.tags.includes('new_merch_product') || hit.tags.includes('non_merged_merch_product'));
      var templateToRender = this.html(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n      <div\n        class=\"card-wrapper alt-card-wrapper product-card-wrapper card-type--", "\"\n        id=\"Card--", "\"\n        data-algolia-index=\"", "\"\n        data-algolia-position=\"", "\"\n        data-algolia-queryid=\"", "\"\n        data-algolia-objectid=\"", "\"\n        data-handle=\"", "\"\n        data-variant-id=\"", "\"\n        data-distinct=\"", "\"\n        data-product-id=\"", "\"\n      >\n        <div class=\"card card--standard alt-card card--media\" style=\"--ratio-percent: 100.0%;\">\n          ", "\n          <div class=\"card__inner alt-card__inner color-scheme-1 ratio\" style=\"--ratio-percent: 100.0%;\">\n            <div class=\"card__media alt-card__media\">\n              ", "\n              <div class=\"media media--transparent media--hover-effect\">\n                <a\n                  href=\"", "", "\"\n                  class=\"full-unstyled-link product-card-link\"\n                  onClick=\"", "\"\n                >\n                  ", "\n                  <span class=\"product-card-link__exclusive hidden\">Only at Gibson</span>\n                </a>\n              </div>\n            </div>\n            ", "\n          </div>\n          ", "\n        </div>\n      </div>\n    "])), classSafeProductType, hit.id, hit.index, hit.productPosition, hit.__queryID, hit.objectID, hit.handle, hit.objectID, hit._distinct, hit.id, !isMerchProduct ? createdCompareButtons : '', badgeHandler.createBadgeElements(2, this.html), this.helpers.instantsearchLink(hit), brandUrlParams, function () {
        return algoliaShopify.helpers.handleItemClick(hit);
      }, createdMediaTemplate, this.createCardContent(hit, this.html, brandUrlParams), this.createCardContentExtended(hit, badgeHandler, brandUrlParams));

      // Initialize thumbnail listeners after the template is rendered
      setTimeout(function () {
        _this2.createLinkedProduct(hit, _this2.html);
        _this2.initializeThumbnailListeners(hit);
      }, 10);
      return templateToRender;
    }

    /**
     * Creates the compare buttons for the product.
     * Generates HTML for the "Compare" and "Remove" buttons.
     * @param {Object} hit - The product hit data.
     * @param {Function} html - The HTML template function.
     * @returns {TemplateResult} - The HTML template for the compare buttons.
     */
  }, {
    key: "createCompareButtons",
    value: function createCompareButtons(hit, html) {
      try {
        var compareButton = html(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["\n        <button\n          class=\"button button--primary card__compare hidden algolia-compare-products-buttons\"\n          aria-label=\"Compare ", " ", "\"\n          data-action=\"compare\"\n          data-product-handle=\"", "\"\n          data-product-type=\"", "\"\n          disabled=\"disabled\"\n        >\n          ", "\n        </button>\n        <button\n          class=\"button button--primary card__compare card__compare--remove algolia-compare-products-buttons\"\n          aria-label=\"Remove ", " ", "\"\n          data-action=\"remove\"\n          data-product-handle=\"", "\"\n          data-product-type=\"", "\"\n        >\n          ", "\n        </button>\n      "])), hit.product_type, hit.title, hit.handle, hit.product_type ? hit.product_type.toLowerCase().replace(/\s+/g, '-') : '', algoliaShopify.translations.compare, hit.product_type, hit.title, hit.handle, hit.product_type ? hit.product_type.toLowerCase().replace(/\s+/g, '-') : '', algoliaShopify.translations.remove);
        return compareButton;
      } catch (error) {
        return '';
      }
    }

    /**
     * Creates the media template for the product.
     * Generates HTML for the product's main media section.
     * @param {Object} hit - The product hit data.
     * @param {Function} html - The HTML template function.
     * @returns {TemplateResult} - The HTML template for the media.
     */
  }, {
    key: "createMediaTemplate",
    value: function createMediaTemplate(hit, html) {
      var hasNoBodyImage = hit.tags && hit.tags.includes('no_body_image_shot');
      var isExclusive = this.checkIfExclusive(hit.handle);
      var brand = hit.vendor ? hit.vendor.toLowerCase().replace(/\s+/g, '-') : '';
      var brandGradient = !hasNoBodyImage ? "var(--color-background-".concat(brand, ")") : '';
      return html(_templateObject12 || (_templateObject12 = _taggedTemplateLiteral(["\n      <div\n        id=\"media-template--", "\"\n        class=\"media media--transparent ", "\"\n        role=\"group\"\n        data-main-media-id=\"", "\"\n        aria-labelledby=\"title-template--", "\"\n        style=\"background: ", " !important;\"\n      >\n        ", "\n        ", "\n      </div>\n    "])), hit.id, hasNoBodyImage ? 'no-body-image' : '', hit.media_id || hit.objectID, hit.id, brandGradient, this.imageHandler.createMainImage(hit, html), isExclusive ? html(_templateObject13 || (_templateObject13 = _taggedTemplateLiteral(["<span class=\"product-card-link__exclusive hidden\">Only at Gibson</span>"]))) : '');
    }

    /**
     * Checks if a product handle matches any linked products with exclusive class
     * @param {string} handle - The product handle to check
     * @param {Object} hit - The product hit data (optional, for initial load)
     * @returns {boolean} - Whether the product is exclusive
     */
  }, {
    key: "checkIfExclusive",
    value: function checkIfExclusive(handle) {
      var hit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      // First, try to find the linked product element that matches the handle
      var linkedProductLink = document.querySelector("[data-product-handle=\"".concat(handle, "\"]"));
      if (linkedProductLink) {
        // Check if the linked product has the exclusive class
        var linkedProduct = linkedProductLink.closest('.linked-product');
        if (linkedProduct) {
          return linkedProduct.classList.contains('exclusive') || linkedProduct.hasAttribute('data-exclusive-product');
        }
      }

      // If no linked product found and we have hit data, check the product flags
      if (hit && hit.meta) {
        var currentMarket = window.Shopify && window.Shopify.market_handle ? window.Shopify.market_handle : 'us';
        var productFlags = null;
        if (currentMarket === 'us' && hit.meta.product_flags && hit.meta.product_flags.us_product_flags) {
          productFlags = hit.meta.product_flags.us_product_flags;
        } else if ((currentMarket === 'europe' || currentMarket === 'united-kingdom') && hit.meta.product_flags && hit.meta.product_flags.eu_product_flags) {
          productFlags = hit.meta.product_flags.eu_product_flags;
        } else if (currentMarket === 'japan' && hit.meta.product_flags && hit.meta.product_flags.jp_product_flags) {
          productFlags = hit.meta.product_flags.jp_product_flags;
        }
        if (productFlags && Array.isArray(productFlags)) {
          return productFlags.some(function (flag) {
            return flag.name === 'Exclusive';
          });
        }
      }

      // Fallback: check if the main product card has exclusive class
      var cardElement = document.querySelector("[data-handle=\"".concat(handle, "\"]"));
      if (cardElement) {
        var exclusiveProducts = cardElement.querySelectorAll('.linked-product.exclusive, [data-exclusive-product="true"]');
        return Array.from(exclusiveProducts).some(function (product) {
          var link = product.querySelector('.linked-product__link') || product;
          return link && link.dataset.productHandle === handle;
        });
      }
      return false;
    }

    /**
     * Creates the card content for the product.
     * Generates HTML for the basic card content including the product title.
     * @param {Object} hit - The product hit data.
     * @param {Function} html - The HTML template function.
     * @param {String} brandUrlParams - The brand url params if they exist
     * @returns {TemplateResult} - The HTML template for the card content.
     */
  }, {
    key: "createCardContent",
    value: function createCardContent(hit, html, brandUrlParams) {
      // Format title - skip vendor removal for merch products and gibsonxcollab products
      var formattedTitle = Utils.isMerchProduct(hit) || Utils.isGibsonCollabProduct(hit) ? hit.title : hit.title.replace(new RegExp("".concat(hit.vendor, "\\s*"), 'gi'), '').replace(new RegExp("\\s*,\\s*".concat(hit.meta && hit.meta.finish && hit.meta.finish.name ? hit.meta.finish.name.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') : '', "\\s*"), 'gi'), hit.meta && hit.meta.finish && hit.meta.finish.name ? '' : '$&');
      return html(_templateObject14 || (_templateObject14 = _taggedTemplateLiteral(["\n      <div class=\"card__content alt-card__content\">\n        <div class=\"card__information alt-card__information\">\n          <h3 class=\"card__heading alt-card__heading\">\n            <a\n              href=\"", "", "\"\n              id=\"StandardCardNoMediaLink-template--", "\"\n              class=\"full-unstyled-link product-card-link\"\n              aria-labelledby=\"StandardCardNoMediaLink-template--", "\"\n              onClick=\"", "\"\n            >\n              ", "\n              <span class=\"vendor-name\">", "</span>\n            </a>\n          </h3>\n        </div>\n      </div>\n    "])), this.helpers.instantsearchLink(hit), brandUrlParams, hit.id, hit.id, function () {
        return algoliaShopify.helpers.handleItemClick(hit);
      }, formattedTitle, hit.vendor);
    }

    /**
     * Creates extended card content for the product, including thumbnails and price.
     * Adds additional product details to the card.
     * @param {Object} hit - The product hit data.
     * @param {BadgeHandler} badgeHandler - The BadgeHandler instance.
     * @param {String} brandUrlParams - The brand url params if they exist
     * @returns {TemplateResult} - The HTML template for the extended card content.
     */
  }, {
    key: "createCardContentExtended",
    value: function createCardContentExtended(hit, badgeHandler, brandUrlParams) {
      // const hasImages = hit?.images?.length > 0 && hit?.images[0]?.url;
      var hasImages = true;
      return this.html(_templateObject15 || (_templateObject15 = _taggedTemplateLiteral(["\n      <div class=\"card__content alt-card__content\">\n        <div class=\"card__thumbnails\">", "</div>\n        <div class=\"card__information alt-card__information\">\n        <div class=\"product-flags\"></div>\n          ", "\n          ", "\n          <div class=\"card-information\">\n            ", "\n            ", "\n            ", "\n          </div>\n        </div>\n        <div class=\"card__badge bottom left\"></div>\n      </div>\n    "])), this.imageHandler.createThumbnails(hit), badgeHandler.createBadgeElements(1, this.html), this.createProductTitle(hit, brandUrlParams), this.priceHandler.createPriceElement(hit, this.html), this.createSoldoutInfo(hit, this.html), this.createSerializedInfo(hit, this.html));
    }

    /**
     * Creates the product title element.
     * Generates HTML for the product title within the card.
     * @param {Object} hit - The product hit data.
     * @param {String} brandUrlParams - The brand url params if they exist
     * @returns {TemplateResult} - The HTML template for the product title.
     */
  }, {
    key: "createProductTitle",
    value: function createProductTitle(hit, brandUrlParams) {
      var _hit$meta;
      // Format title - skip vendor removal for merch products and gibsonxcollab products
      var formattedTitle = Utils.isMerchProduct(hit) || Utils.isGibsonCollabProduct(hit) ? hit.title : hit.title.replace(new RegExp("".concat(hit.vendor, "\\s*"), 'gi'), '').replace(new RegExp("\\s*,\\s*".concat(hit.meta && hit.meta.finish && hit.meta.finish.name || ''), 'gi'), hit.meta && hit.meta.finish && hit.meta.finish.name ? '' : '$&');
      return this.html(_templateObject16 || (_templateObject16 = _taggedTemplateLiteral(["\n      <h3 class=\"card__heading h5\" id=\"title-template--", "\">\n        <a\n          href=\"", "", "\"\n          id=\"CardLink-template--", "\"\n          class=\"full-unstyled-link product-card-link\"\n          aria-labelledby=\"CardLink-template--", "\"\n        >\n        ", "\n        <span class=\"vendor-name\">", "</span>\n        </a>\n        <a\n          href=\"", "", "\"\n          class=\"product-card-link meta-finish-name\"\n        >\n          ", "\n        </a>\n      </h3>\n    "])), hit.id, this.helpers.instantsearchLink(hit), brandUrlParams, hit.id, hit.id, formattedTitle, hit.vendor, this.helpers.instantsearchLink(hit), brandUrlParams, hit === null || hit === void 0 || (_hit$meta = hit.meta) === null || _hit$meta === void 0 || (_hit$meta = _hit$meta.finish) === null || _hit$meta === void 0 ? void 0 : _hit$meta.name);
    }

    /**
     * Creates the vendor information element.
     * Generates HTML for displaying the product vendor.
     * @param {Object} hit - The product hit data.
     * @returns {TemplateResult} - The HTML template for the vendor information.
     */
  }, {
    key: "createVendorInfo",
    value: function createVendorInfo(hit) {
      return this.html(_templateObject17 || (_templateObject17 = _taggedTemplateLiteral(["\n      <span class=\"caption-large light\">\n        ", "\n      </span>\n    "])), this.components.Highlight({
        attribute: 'vendor',
        hit: hit
      }));
    }

    /**
     * Updates the product flags display with only non-overlay flags.
     * @param {Array} nonOverlayFlags - Array of non-overlay flag objects
     * @param {Array} nonOverlayColors - Array of colors corresponding to non-overlay flags
     * @param {HTMLElement} hitsItemParent - Parent element containing the flags container
     */
  }, {
    key: "updateNonOverlayBadges",
    value: function updateNonOverlayBadges(nonOverlayFlags, nonOverlayColors, hitsItemParent) {
      if (!hitsItemParent) {
        return;
      }
      var flagsContainer = hitsItemParent.querySelector('.product-flags');
      if (!flagsContainer) {
        return;
      }

      // Clear container if no flags are provided
      if (!nonOverlayFlags || nonOverlayFlags.length === 0) {
        flagsContainer.innerHTML = '';
        return;
      }

      // Update the DOM with only non-overlay flags and their colors
      flagsContainer.innerHTML = "\n      <div class=\"product-flags-inner\">\n        <ul>".concat(nonOverlayFlags.map(function (flag, index) {
        var color = nonOverlayColors && nonOverlayColors[index] ? nonOverlayColors[index] : '';
        return "<li class=\"product-flag\" style=\"color: ".concat(color, ";\">").concat(flag.label, "</li>");
      }).join(''), "</ul>\n      </div>\n    ");
    }

    /**
     * Updates the product flags display with the provided flags and colors.
     * @param {string} productFlags - Base64 encoded JSON string of product flags
     * @param {string} productFlagsColors - Base64 encoded JSON string of flag colors
     * @param {HTMLElement} hitsItemParent - Parent element containing the flags container
     */
  }, {
    key: "updateBadges",
    value: function updateBadges(productFlags, productFlagsColors, hitsItemParent) {
      if (!hitsItemParent) {
        return;
      }
      var flagsContainer = hitsItemParent.querySelector('.product-flags');
      if (!flagsContainer) {
        return;
      }

      // Clear container if no flags or colors are provided
      if (!productFlags || !productFlags.trim() || !productFlagsColors || !productFlagsColors.trim()) {
        flagsContainer.innerHTML = '';
        return;
      }
      var productFlagsArray = [];
      var productFlagsColorsArray = [];

      // Parse product flags
      try {
        var decodedFlags = decodeURIComponent(productFlags);
        // Try to parse as JSON first, if that fails, treat as comma-separated string
        try {
          productFlagsArray = JSON.parse(decodedFlags);
          if (Array.isArray(productFlagsArray)) {
            // It's already an array, no need to split
          } else {
            // It's a single string, split by comma
            productFlagsArray = productFlagsArray.split(',');
          }
        } catch (jsonError) {
          // Not JSON, treat as comma-separated string
          productFlagsArray = decodedFlags.split(',');
        }
      } catch (e) {
        flagsContainer.innerHTML = '';
        return;
      }

      // Parse flag colors
      try {
        var decodedColorsRaw = decodeURIComponent(productFlagsColors);
        // Some sources wrap the entire string in quotes; strip them if present
        var decodedColors = decodedColorsRaw.replace(/^"([\s\S]*)"$/, '$1');

        // Try to parse as JSON first
        try {
          var maybeParsed = JSON.parse(decodedColors);
          if (Array.isArray(maybeParsed)) {
            productFlagsColorsArray = maybeParsed;
          } else if (typeof maybeParsed === 'string') {
            // Extract complete rgb(...) tokens from the string
            productFlagsColorsArray = maybeParsed.match(/rgb\(\s*\d+\s*,\s*\d+\s*,\s*\d+\s*\)/g) || [];
          } else {
            productFlagsColorsArray = [];
          }
        } catch (jsonError) {
          // Not JSON; extract complete rgb(...) tokens from the string
          productFlagsColorsArray = decodedColors.match(/rgb\(\s*\d+\s*,\s*\d+\s*,\s*\d+\s*\)/g) || [];
        }
      } catch (e) {
        console.warn('[updateBadges] Failed to parse product flags colors:', e);
        flagsContainer.innerHTML = '';
        return;
      }

      // Only proceed if we have both flags and colors
      if (productFlagsArray.length > 0 && productFlagsColorsArray.length > 0) {
        // Ensure arrays are aligned in length
        var minLength = Math.min(productFlagsArray.length, productFlagsColorsArray.length);
        productFlagsArray = productFlagsArray.slice(0, minLength);
        productFlagsColorsArray = productFlagsColorsArray.slice(0, minLength);
        // Create combined flags array with complete objects
        var combinedFlags = productFlagsArray.map(function (flag, index) {
          var _flag$label;
          return {
            label: (flag === null || flag === void 0 || (_flag$label = flag.label) === null || _flag$label === void 0 ? void 0 : _flag$label.replace(/\+/g, ' ')) || (flag === null || flag === void 0 ? void 0 : flag.replace(/\+/g, ' ')),
            color: productFlagsColorsArray[index] || ''
          };
        });

        // Update the DOM
        flagsContainer.innerHTML = "\n        <div class=\"product-flags-inner\">\n          <ul>".concat(combinedFlags.map(function (flag) {
          return "<li class=\"product-flag\" style=\"color: ".concat(flag.color, ";\">").concat(flag.label, "</li>");
        }).join(''), "</ul>\n        </div>\n      ");
      } else {
        flagsContainer.innerHTML = '';
      }
    }

    /**
     * Asynchronously creates a linked product if applicable.
     * Fetches and appends product metadata to the card if available.
     * @param {Object} hit - The product hit data.
     * @param {Function} html - The HTML template function.
     */
  }, {
    key: "createLinkedProduct",
    value: (function () {
      var _createLinkedProduct = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(hit, html) {
        var hasLinkedProducts, cardSelector, cardElement, _hit$named_tags, _hit$tags, _hit$tags2, cardThumbnails, existingMetadata, metadataElement, merchVariants, productComparisonHTML, selectedVariant, newlySelectedVariant, hasSerializedVariants, serializedVariantsCount, emblaNode;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              // Flag indicating whether the product has a linked product.
              this.hasLinkedProduct = false;
              this.isMerchProductWithColorVariants = false;
              hasLinkedProducts = hit.meta && Object.keys(hit.meta).length > 0;
              if (hasLinkedProducts) {
                _context.next = 5;
                break;
              }
              return _context.abrupt("return");
            case 5:
              // CARD SELECTORS
              cardSelector = "#Card--".concat(hit.id);
              cardElement = document.querySelector(cardSelector);
              if (cardElement) {
                _context.next = 9;
                break;
              }
              return _context.abrupt("return");
            case 9:
              if (document.querySelector(".ais-Hits #Card--".concat(hit.id, " .card__thumbnails .product-metadata"))) {
                _context.next = 54;
                break;
              }
              cardThumbnails = cardElement.querySelector('.card__thumbnails');
              if (cardThumbnails) {
                _context.next = 13;
                break;
              }
              return _context.abrupt("return");
            case 13:
              // If product metadata has already been appended, do nothing further.
              existingMetadata = cardThumbnails.querySelector('.product-metadata');
              if (!existingMetadata) {
                _context.next = 16;
                break;
              }
              return _context.abrupt("return");
            case 16:
              if (!document.querySelector(".ais-Hits #Card--".concat(hit.id, " .card__thumbnails .product-metadata"))) {
                _context.next = 18;
                break;
              }
              return _context.abrupt("return");
            case 18:
              _context.prev = 18;
              _context.next = 21;
              return this._fetchProductComparisonHTML(hit.handle);
            case 21:
              productComparisonHTML = _context.sent;
              metadataElement = this._extractProductMetadata(productComparisonHTML);
              merchVariants = this._extractMerchVariants(productComparisonHTML);
              _context.next = 31;
              break;
            case 26:
              _context.prev = 26;
              _context.t0 = _context["catch"](18);
              console.error('Failed to fetch or parse product comparison HTML:', _context.t0);
              cardThumbnails.classList.add('no-metadata');
              return _context.abrupt("return");
            case 31:
              if (!(merchVariants && merchVariants.querySelector('.swatch-option') && merchVariants.querySelectorAll('.swatch-option').length > 0 || (_hit$named_tags = hit.named_tags) !== null && _hit$named_tags !== void 0 && (_hit$named_tags = _hit$named_tags.primary_collection) !== null && _hit$named_tags !== void 0 && _hit$named_tags.includes('Clothing & Apparel') || (_hit$tags = hit.tags) !== null && _hit$tags !== void 0 && _hit$tags.includes('non_merged_merch_product') || (_hit$tags2 = hit.tags) !== null && _hit$tags2 !== void 0 && _hit$tags2.includes('new_merch_product'))) {
                _context.next = 41;
                break;
              }
              selectedVariant = merchVariants.querySelector('.swatch-option__button.selected');
              if (selectedVariant) {
                selectedVariant.classList.remove('selected');
              }
              newlySelectedVariant = merchVariants.querySelector(".swatch-option[data-variant-id=\"".concat(hit.objectID, "\"] .swatch-option__button"));
              if (newlySelectedVariant) {
                newlySelectedVariant.classList.add('selected');
              }
              cardThumbnails.appendChild(merchVariants);
              // If product is exclusive, show exclusive UI
              this._handleExclusiveProduct(hit.handle, cardElement);
              this._initMerchVariantColorSelector(merchVariants, hit);

              // Initialize product flags for merch products
              this._initBadgesFromMerchVariants(merchVariants, cardThumbnails, hit);
              return _context.abrupt("return");
            case 41:
              if (!(!metadataElement || !metadataElement.querySelector('.linked-product'))) {
                _context.next = 44;
                break;
              }
              cardThumbnails.classList.add('no-metadata');
              return _context.abrupt("return");
            case 44:
              hasSerializedVariants = metadataElement.dataset.hasSerializedVariants;
              if (hasSerializedVariants === 'true') {
                serializedVariantsCount = metadataElement.dataset.serializedVariantsCount;
                cardElement.querySelector('[js-serial-count]').innerHTML = "".concat(algoliaShopify.translations.selectFrom, " ").concat(serializedVariantsCount);
                if (serializedVariantsCount < 1) {
                  cardElement.querySelector('[js-serial-count]').classList.add('hidden');
                  cardElement.querySelector('[js-serial-count]').style.display = 'none !important';
                }
              }
              if (!cardThumbnails.querySelector('.product-metadata')) {
                _context.next = 48;
                break;
              }
              return _context.abrupt("return");
            case 48:
              cardThumbnails.appendChild(metadataElement);

              // Initialize badges from the first linked product, if present
              this._initBadgesFromLinkedProduct(metadataElement, cardThumbnails);

              // Mark that we do have a linked product
              this.hasLinkedProduct = true;

              // If product is exclusive, show exclusive UI
              this._handleExclusiveProduct(hit.handle, cardElement);

              // Initialize Embla carousel if present
              emblaNode = metadataElement.querySelector('.embla');
              if (emblaNode && window.EmblaCarousel) {
                try {
                  this._initEmblaCarousel(emblaNode, cardSelector, hit);
                } catch (emblaError) {
                  console.error('Error initializing Embla:', emblaError);
                }
              }
            case 54:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[18, 26]]);
      }));
      function createLinkedProduct(_x, _x2) {
        return _createLinkedProduct.apply(this, arguments);
      }
      return createLinkedProduct;
    }()
    /**
     * Fetches product comparison HTML from the server.
     * @private
     * @param {string} handle - The product handle.
     * @returns {Promise<string>} The fetched HTML string.
     * @throws Will throw an error if the fetch fails.
     */
    )
  }, {
    key: "_fetchProductComparisonHTML",
    value: (function () {
      var _fetchProductComparisonHTML2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2(handle) {
        var _window$Shopify;
        var region, endpoint, response;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              region = ((_window$Shopify = window.Shopify) === null || _window$Shopify === void 0 || (_window$Shopify = _window$Shopify.routes) === null || _window$Shopify === void 0 ? void 0 : _window$Shopify.root) || '/';
              endpoint = "".concat(region, "products/").concat(handle, "?view=metaobjects");
              _context2.next = 4;
              return fetch(endpoint, {
                method: 'GET',
                headers: {
                  'Content-Type': 'application/json'
                }
              });
            case 4:
              response = _context2.sent;
              if (response.ok) {
                _context2.next = 7;
                break;
              }
              throw new Error("Failed to fetch product HTML. Status: ".concat(response.status));
            case 7:
              return _context2.abrupt("return", response.text());
            case 8:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      function _fetchProductComparisonHTML(_x3) {
        return _fetchProductComparisonHTML2.apply(this, arguments);
      }
      return _fetchProductComparisonHTML;
    }() //
    /**
     * Parses the fetched product comparison HTML and extracts the .product-metadata element if present.
     * @private
     * @param {string} htmlString - The raw HTML string.
     * @returns {Element|null} The .product-metadata element or null if not found.
     */
    )
  }, {
    key: "_extractProductMetadata",
    value: function _extractProductMetadata(htmlString) {
      var parsedDocument = new DOMParser().parseFromString(htmlString, 'text/html');
      var mainMetadata = parsedDocument.querySelector('.main-product-metadata');
      if (!mainMetadata) return null;
      return mainMetadata.querySelector('.product-metadata');
    }

    /**
     * Parses the fetched product comparison HTML and extracts the .merch-variants element if present.
     * @private
     * @param {string} htmlString - The raw HTML string.
     * @returns {Element|null} The .merch-variants element or null if not found.
     */
  }, {
    key: "_extractMerchVariants",
    value: function _extractMerchVariants(htmlString) {
      var parsedDocument = new DOMParser().parseFromString(htmlString, 'text/html');
      var merchVariants = parsedDocument.querySelector('.merch-variants');
      if (!merchVariants) return null;
      return merchVariants;
    }
  }, {
    key: "_initMerchVariantColorSelector",
    value: function _initMerchVariantColorSelector(merchVariants, hit) {
      var _this3 = this;
      var colorButtons = merchVariants.querySelectorAll('.merch-variant-color-selector .swatch-option__button');
      if (!colorButtons) return;
      colorButtons.forEach(function (colorButton) {
        colorButton.addEventListener('click', function (ev) {
          ev.preventDefault();
          ev.stopPropagation();

          // Update image
          var cardElement = document.querySelector("#Card--".concat(hit.id));
          var mediaElement = cardElement.querySelector('.media');
          mediaElement.querySelector('img').src = colorButton.dataset.image;

          // Clear selected class
          colorButtons.forEach(function (button) {
            button.classList.remove('selected');
          });

          // Add selected class
          colorButton.classList.add('selected');

          // Update card links
          var cardLinks = cardElement.querySelectorAll('.product-card-link');
          cardLinks.forEach(function (link) {
            link.href = "/products/".concat(hit.handle, "?variant=").concat(colorButton.dataset.variantId);
          });

          // Format prices using active currency
          var price = parseFloat(colorButton.dataset.price) / 100;
          var compareAtPrice = parseFloat(colorButton.dataset.compareAtPrice) / 100;
          var isOnSale = compareAtPrice > price;

          // Format price using active currency
          var formattedPrice = new Intl.NumberFormat(window.Shopify.locale, {
            style: 'currency',
            currency: window.Shopify.currency.active
          }).format(price).replace(/\.00/g, '');

          // Update price display
          var priceElement = cardElement.querySelector('.price');
          var priceRegular = priceElement.querySelector('.price-item--regular span');
          var priceSale = priceElement.querySelector('.price-item--sale');
          var priceContainer = priceElement.querySelector('.price__regular');

          // Update regular price
          priceRegular.textContent = formattedPrice;

          // Handle compare at price
          if (isOnSale) {
            var formattedComparePrice = new Intl.NumberFormat(window.Shopify.locale, {
              style: 'currency',
              currency: window.Shopify.currency.active
            }).format(compareAtPrice).replace(/\.00/g, '');
            priceSale.classList.remove('hidden');
            priceSale.querySelector('span').textContent = formattedComparePrice;
            priceContainer.setAttribute('data-is-on-sale', 'true');

            // Calculate and display discount percentage
            var percentageOff = Math.round((1 - price / compareAtPrice) * 100);
            var percentageElement = priceElement.querySelector('.price-item--percentage');
            if (percentageElement) {
              percentageElement.textContent = "".concat(percentageOff, "% ").concat(algoliaShopify.translations.off);
              percentageElement.style.display = 'block';
            }
          } else {
            priceSale.classList.add('hidden');
            priceContainer.setAttribute('data-is-on-sale', 'false');
            var _percentageElement = priceElement.querySelector('.price-item--percentage');
            if (_percentageElement) {
              _percentageElement.style.display = 'none';
            }
          }

          // Update product flags for merch products
          _this3._updateMerchProductFlags(cardElement, colorButton);
        });
      });
    }

    /**
     * Splits product flags into overlay and non-overlay arrays based on the overlay attribute.
     * @private
     * @param {string} productFlags - Base64 encoded JSON string of product flags
     * @param {string} productFlagsOverlay - Base64 encoded JSON string of overlay flags
     * @param {string} productFlagsColors - Base64 encoded JSON string of flag colors
     * @param {string} productFlagsBackgroundColors - Base64 encoded JSON string of flag background colors
     */
  }, {
    key: "splitFlagsByOverlay",
    value: function splitFlagsByOverlay(productFlags, productFlagsOverlay, productFlagsColors, productFlagsBackgroundColors) {
      if (!productFlags || !productFlagsOverlay) {
        return {
          overlayFlags: [],
          nonOverlayFlags: [],
          overlayColors: [],
          nonOverlayColors: [],
          overlayBackgroundColors: [],
          nonOverlayBackgroundColors: []
        };
      }
      var productFlagsArray = [];
      var overlayFlagsArray = [];
      var productFlagsColorsArray = [];
      var productFlagsBackgroundColorsArray = [];

      // Parse product flags
      try {
        var decodedFlags = decodeURIComponent(productFlags);
        try {
          productFlagsArray = JSON.parse(decodedFlags);
          if (!Array.isArray(productFlagsArray)) {
            productFlagsArray = productFlagsArray.split(',');
          }
        } catch (jsonError) {
          productFlagsArray = decodedFlags.split(',');
        }
      } catch (e) {
        console.warn('Failed to parse product flags:', e);
        return {
          overlayFlags: [],
          nonOverlayFlags: [],
          overlayColors: [],
          nonOverlayColors: [],
          overlayBackgroundColors: [],
          nonOverlayBackgroundColors: []
        };
      }

      // Parse overlay flags
      try {
        var decodedOverlay = decodeURIComponent(productFlagsOverlay);
        try {
          var parsed = JSON.parse(decodedOverlay);

          // If it's an array of booleans, use it directly
          if (Array.isArray(parsed)) {
            overlayFlagsArray = parsed;
          }
          // If it's a string (comma-separated booleans), split it
          else if (typeof parsed === 'string') {
            overlayFlagsArray = parsed.split(',').map(function (flag) {
              return flag.trim() === 'true';
            });
          }
          // If it's a single boolean, wrap it in an array
          else if (typeof parsed === 'boolean') {
            overlayFlagsArray = [parsed];
          }
          // Fallback: treat as comma-separated string
          else {
            overlayFlagsArray = decodedOverlay.split(',').map(function (flag) {
              return flag.trim() === 'true';
            });
          }
        } catch (jsonError) {
          // If JSON parsing fails, treat as comma-separated string
          overlayFlagsArray = decodedOverlay.split(',').map(function (flag) {
            return flag.trim() === 'true';
          });
        }
      } catch (e) {
        console.warn('Failed to parse overlay flags:', e);
        return {
          overlayFlags: [],
          nonOverlayFlags: [],
          overlayColors: [],
          nonOverlayColors: [],
          overlayBackgroundColors: [],
          nonOverlayBackgroundColors: []
        };
      }

      // Parse flag colors if provided
      if (productFlagsColors) {
        try {
          var decodedColorsRaw = decodeURIComponent(productFlagsColors);
          var decodedColors = decodedColorsRaw.replace(/^"([\s\S]*)"$/, '$1');
          try {
            var maybeParsed = JSON.parse(decodedColors);
            if (Array.isArray(maybeParsed)) {
              productFlagsColorsArray = maybeParsed;
            } else if (typeof maybeParsed === 'string') {
              productFlagsColorsArray = maybeParsed.match(/rgb\(\s*\d+\s*,\s*\d+\s*,\s*\d+\s*\)/g) || [];
            } else {
              productFlagsColorsArray = [];
            }
          } catch (jsonError) {
            productFlagsColorsArray = decodedColors.match(/rgb\(\s*\d+\s*,\s*\d+\s*,\s*\d+\s*\)/g) || [];
          }
        } catch (e) {
          console.warn('Failed to parse product flags colors:', e);
          productFlagsColorsArray = [];
        }
      }

      // Parse flag background colors if provided
      if (productFlagsBackgroundColors) {
        try {
          var decodedBackgroundColorsRaw = decodeURIComponent(productFlagsBackgroundColors);
          var decodedBackgroundColors = decodedBackgroundColorsRaw.replace(/^"([\s\S]*)"$/, '$1');
          try {
            var _maybeParsed = JSON.parse(decodedBackgroundColors);
            if (Array.isArray(_maybeParsed)) {
              productFlagsBackgroundColorsArray = _maybeParsed;
            } else if (typeof _maybeParsed === 'string') {
              // For background colors, we might have hex colors or color names
              productFlagsBackgroundColorsArray = _maybeParsed.split(',').map(function (color) {
                return color.trim();
              });
            } else {
              productFlagsBackgroundColorsArray = [];
            }
          } catch (jsonError) {
            productFlagsBackgroundColorsArray = decodedBackgroundColors.split(',').map(function (color) {
              return color.trim();
            });
          }
        } catch (e) {
          console.warn('Failed to parse product flags background colors:', e);
          productFlagsBackgroundColorsArray = [];
        }
      }

      // Ensure arrays are aligned in length
      var minLength = Math.min(productFlagsArray.length, overlayFlagsArray.length);
      productFlagsArray = productFlagsArray.slice(0, minLength);
      overlayFlagsArray = overlayFlagsArray.slice(0, minLength);
      productFlagsColorsArray = productFlagsColorsArray.slice(0, minLength);
      productFlagsBackgroundColorsArray = productFlagsBackgroundColorsArray.slice(0, minLength);

      // Split flags into overlay and non-overlay arrays
      var overlayFlags = [];
      var nonOverlayFlags = [];
      var overlayColors = [];
      var nonOverlayColors = [];
      var overlayBackgroundColors = [];
      var nonOverlayBackgroundColors = [];
      productFlagsArray.forEach(function (flag, index) {
        var _flag$label2;
        var isOverlay = overlayFlagsArray[index];
        var color = productFlagsColorsArray[index] || '';
        var backgroundColor = productFlagsBackgroundColorsArray[index] || '';
        var flagObj = {
          label: (flag === null || flag === void 0 || (_flag$label2 = flag.label) === null || _flag$label2 === void 0 ? void 0 : _flag$label2.replace(/\+/g, ' ')) || (flag === null || flag === void 0 ? void 0 : flag.replace(/\+/g, ' ')),
          isOverlay: isOverlay
        };
        if (isOverlay) {
          overlayFlags.push(flagObj);
          overlayColors.push(color);
          overlayBackgroundColors.push(backgroundColor);
        } else {
          nonOverlayFlags.push(flagObj);
          nonOverlayColors.push(color);
          nonOverlayBackgroundColors.push(backgroundColor);
        }
      });
      return {
        overlayFlags: overlayFlags,
        nonOverlayFlags: nonOverlayFlags,
        overlayColors: overlayColors,
        nonOverlayColors: nonOverlayColors,
        overlayBackgroundColors: overlayBackgroundColors,
        nonOverlayBackgroundColors: nonOverlayBackgroundColors
      };
    }

    /**
     * Renders overlay flags in the card media div.
     * @private
     * @param {Array} overlayFlags - Array of overlay flag objects
     * @param {Array} overlayColors - Array of colors for overlay flags
     * @param {Array} overlayBackgroundColors - Array of background colors for overlay flags
     * @param {Element} cardElement - The card element containing the media div
     */
  }, {
    key: "renderOverlayFlags",
    value: function renderOverlayFlags(overlayFlags, overlayColors, overlayBackgroundColors, cardElement) {
      var mediaElement = cardElement.querySelector('.media');
      if (!mediaElement) return;

      // Remove existing overlay flags container if it exists
      var existingOverlayFlags = mediaElement.querySelector('.overlay-product-flags');
      if (existingOverlayFlags) {
        existingOverlayFlags.remove();
      }

      // Only create overlay flags container if there are overlay flags
      if (overlayFlags && overlayFlags.length > 0) {
        var overlayFlagsContainer = document.createElement('ul');
        overlayFlagsContainer.className = 'overlay-product-flags plp-overlay-flags';
        overlayFlags.forEach(function (flag, index) {
          var flagElement = document.createElement('li');
          flagElement.className = 'product-flag overlay-flag';
          flagElement.textContent = flag.label;

          // Apply text color
          var color = overlayColors && overlayColors[index] ? overlayColors[index] : '';
          if (color) {
            flagElement.style.color = color;
          }

          // Apply background color (only for overlay flags)
          var backgroundColor = overlayBackgroundColors && overlayBackgroundColors[index] ? overlayBackgroundColors[index] : '';
          if (backgroundColor && backgroundColor !== 'transparent') {
            flagElement.style.backgroundColor = backgroundColor;
          }
          overlayFlagsContainer.appendChild(flagElement);
        });
        mediaElement.appendChild(overlayFlagsContainer);
      }
    }

    /**
     * Initializes product badges if there's a linked product with appropriate flags.
     * @private
     * @param {Element} metadataElement - The metadata container that may contain product flags.
     * @param {Element} thumbnailsContainer - The thumbnails container in the card.
     */
  }, {
    key: "_initBadgesFromLinkedProduct",
    value: function _initBadgesFromLinkedProduct(metadataElement, thumbnailsContainer) {
      var firstLinkedProduct = metadataElement.querySelector('.linked-product__link');
      if (!firstLinkedProduct) return;
      var hitsItemParent = thumbnailsContainer.closest('.ais-Hits-item');
      var cardElement = hitsItemParent.querySelector('.card');
      var productFlags = firstLinkedProduct.dataset.productFlags;
      var productFlagsColors = firstLinkedProduct.dataset.productFlagsColors;
      var productFlagsBackgroundColors = firstLinkedProduct.dataset.productFlagsBackgroundColors;
      var productFlagsOverlay = firstLinkedProduct.dataset.productFlagsOverlay;

      // Split flags by overlay attribute
      var _this$splitFlagsByOve = this.splitFlagsByOverlay(productFlags, productFlagsOverlay, productFlagsColors, productFlagsBackgroundColors),
        overlayFlags = _this$splitFlagsByOve.overlayFlags,
        nonOverlayFlags = _this$splitFlagsByOve.nonOverlayFlags,
        overlayColors = _this$splitFlagsByOve.overlayColors,
        nonOverlayColors = _this$splitFlagsByOve.nonOverlayColors,
        overlayBackgroundColors = _this$splitFlagsByOve.overlayBackgroundColors;

      // Render overlay flags in the media div
      this.renderOverlayFlags(overlayFlags, overlayColors, overlayBackgroundColors, cardElement);

      // Render non-overlay flags in the product flags container
      this.updateNonOverlayBadges(nonOverlayFlags, nonOverlayColors, hitsItemParent);

      // Check the first linked product's sold out status and update the out of stock display
      var isFirstProductSoldOut = this.determineSoldOutStatusFromLink(firstLinkedProduct);
      var outOfStockElement = hitsItemParent.querySelector('.alt-card--oos__item');
      if (outOfStockElement) {
        if (isFirstProductSoldOut) {
          outOfStockElement.classList.remove('hidden');
        } else {
          outOfStockElement.classList.add('hidden');
        }
      }
    }

    /**
     * Initializes product badges for merch products using the hit data directly.
     * @private
     * @param {Element} merchVariants - The merch variants container.
     * @param {Element} thumbnailsContainer - The thumbnails container in the card.
     * @param {Object} hit - The product hit data.
     */
  }, {
    key: "_initBadgesFromMerchVariants",
    value: function _initBadgesFromMerchVariants(merchVariants, thumbnailsContainer, hit) {
      var hitsItemParent = thumbnailsContainer.closest('.ais-Hits-item');
      if (!hitsItemParent) {
        return;
      }

      // Get the selected color button which should have the product flags data
      var selectedColorButton = merchVariants.querySelector('.swatch-option__button.selected');
      if (!selectedColorButton) {
        return;
      }
      var cardElement = hitsItemParent.querySelector('.card');
      var productFlags = selectedColorButton.dataset.productFlags;
      var productFlagsColors = selectedColorButton.dataset.productFlagsColors;
      var productFlagsBackgroundColors = selectedColorButton.dataset.productFlagsBackgroundColors;
      var productFlagsOverlay = selectedColorButton.dataset.productFlagsOverlay;

      // Split flags by overlay attribute
      var _this$splitFlagsByOve2 = this.splitFlagsByOverlay(productFlags, productFlagsOverlay, productFlagsColors, productFlagsBackgroundColors),
        overlayFlags = _this$splitFlagsByOve2.overlayFlags,
        nonOverlayFlags = _this$splitFlagsByOve2.nonOverlayFlags,
        overlayColors = _this$splitFlagsByOve2.overlayColors,
        nonOverlayColors = _this$splitFlagsByOve2.nonOverlayColors,
        overlayBackgroundColors = _this$splitFlagsByOve2.overlayBackgroundColors;

      // Render overlay flags in the media div
      this.renderOverlayFlags(overlayFlags, overlayColors, overlayBackgroundColors, cardElement);

      // Render non-overlay flags in the product flags container
      this.updateNonOverlayBadges(nonOverlayFlags, nonOverlayColors, hitsItemParent);

      // Check the selected color button's sold out status and update the out of stock display
      var isSelectedVariantSoldOut = this.determineSoldOutStatusFromLink(selectedColorButton);
      var outOfStockElement = hitsItemParent.querySelector('.alt-card--oos__item');
      if (outOfStockElement) {
        if (isSelectedVariantSoldOut) {
          outOfStockElement.classList.remove('hidden');
        } else {
          outOfStockElement.classList.add('hidden');
        }
      }
    }

    /**
     * Checks for exclusivity on the product and, if exclusive, updates the UI accordingly.
     * @private
     * @param {string} handle - The product handle to check for exclusivity.
     * @param {Element} cardElement - The root element of the card.
     */
  }, {
    key: "_handleExclusiveProduct",
    value: function _handleExclusiveProduct(handle, cardElement) {
      // Assumes checkIfExclusive is defined in your class.
      var isExclusive = this.checkIfExclusive(handle);
      if (!isExclusive) return;
      var exclusiveNode = cardElement.querySelector('.product-card-link__exclusive');
      var mediaElement = cardElement.querySelector('.media');
      if (exclusiveNode) {
        exclusiveNode.classList.remove('hidden');
      }
      if (mediaElement) {
        mediaElement.classList.add('exclusive-media');
      }
    }

    /**
     * Updates the product flags display for merch products using data attributes from the color button.
     * @private
     * @param {Element} cardElement - The root element of the card.
     * @param {Element} colorButton - The selected color button with product flags data.
     */
  }, {
    key: "_updateMerchProductFlags",
    value: function _updateMerchProductFlags(cardElement, colorButton) {
      var hitsItemParent = cardElement.closest('.ais-Hits-item');
      if (!hitsItemParent) {
        return;
      }
      var productFlags = colorButton.dataset.productFlags;
      var productFlagsColors = colorButton.dataset.productFlagsColors;
      var productFlagsBackgroundColors = colorButton.dataset.productFlagsBackgroundColors;
      var productFlagsOverlay = colorButton.dataset.productFlagsOverlay;

      // Split flags by overlay attribute
      var _this$splitFlagsByOve3 = this.splitFlagsByOverlay(productFlags, productFlagsOverlay, productFlagsColors, productFlagsBackgroundColors),
        overlayFlags = _this$splitFlagsByOve3.overlayFlags,
        nonOverlayFlags = _this$splitFlagsByOve3.nonOverlayFlags,
        overlayColors = _this$splitFlagsByOve3.overlayColors,
        nonOverlayColors = _this$splitFlagsByOve3.nonOverlayColors,
        overlayBackgroundColors = _this$splitFlagsByOve3.overlayBackgroundColors;

      // Render overlay flags in the media div
      this.renderOverlayFlags(overlayFlags, overlayColors, overlayBackgroundColors, cardElement);

      // Render non-overlay flags in the product flags container
      this.updateNonOverlayBadges(nonOverlayFlags, nonOverlayColors, hitsItemParent);
    }

    /**
     * Initializes the Embla carousel, sets up event listeners, and handles resizing/mutation updates.
     * @private
     * @param {Element} emblaNode - The root element of the Embla carousel markup.
     * @param {string} cardSelector - The CSS selector for the card element.
     * @param {Object} hit - The product hit data.
     */
  }, {
    key: "_initEmblaCarousel",
    value: (function () {
      var _initEmblaCarousel2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3(emblaNode, cardSelector, hit) {
        var _this4 = this;
        var container, viewport, options, emblaCarousel, prevButton, nextButton, reinitEmbla, updateButtonStates, images, facetsElement, observer, cardNodes, infoNodes;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              // Ensure proper structure: create .embla__viewport if it doesn't exist.
              container = emblaNode.querySelector('.embla__container');
              if (container) {
                _context3.next = 3;
                break;
              }
              return _context3.abrupt("return");
            case 3:
              viewport = emblaNode.querySelector('.embla__viewport');
              if (!viewport) {
                viewport = document.createElement('div');
                viewport.className = 'embla__viewport';
                container.parentNode.insertBefore(viewport, container);
                viewport.appendChild(container);
              }

              // Embla options
              options = {
                align: 'start',
                containScroll: true,
                dragFree: true,
                slidesToScroll: 1,
                speed: 20,
                skipSnaps: true,
                inViewThreshold: 1,
                startIndex: 0
              };
              emblaCarousel = window.EmblaCarousel(viewport, options); // Add navigation button functionality
              prevButton = emblaNode.querySelector('.embla__prev');
              nextButton = emblaNode.querySelector('.embla__next');
              reinitEmbla = function reinitEmbla() {
                emblaCarousel.reInit();
                updateButtonStates();
              };
              updateButtonStates = function updateButtonStates() {
                var slides = container.children;
                if (!slides.length) return;
                var scrollProgress = emblaCarousel.scrollProgress();
                var canScrollPrev = emblaCarousel.canScrollPrev();
                // Account for floating point precision near the end
                var canScrollNext = scrollProgress < 0.98 && emblaCarousel.canScrollNext();
                if (prevButton) {
                  prevButton.disabled = !canScrollPrev;
                  prevButton.classList.toggle('is-disabled', !canScrollPrev);
                }
                if (nextButton) {
                  nextButton.disabled = !canScrollNext;
                  nextButton.classList.toggle('is-disabled', !canScrollNext);
                }
              }; // Hook up prev/next buttons
              if (prevButton && nextButton) {
                prevButton.addEventListener('click', function (e) {
                  e.preventDefault();
                  e.stopPropagation();
                  updateButtonStates();
                  emblaCarousel.scrollPrev();
                });
                nextButton.addEventListener('click', function (e) {
                  e.preventDefault();
                  e.stopPropagation();
                  updateButtonStates();
                  emblaCarousel.scrollNext();
                });
              }

              // Wait for all images to load before we finalize
              images = emblaNode.querySelectorAll('img');
              Promise.all(Array.from(images).map(function (img) {
                if (img.complete) return Promise.resolve();
                return new Promise(function (resolve) {
                  img.onload = resolve;
                  img.onerror = resolve;
                });
              })).then(function () {
                reinitEmbla();
              });

              // Re-init on window resize
              window.addEventListener('resize', function () {
                requestAnimationFrame(function () {
                  reinitEmbla();
                });
              });

              // Observe for .ais-facets class changes to adjust layout
              facetsElement = document.querySelector('.ais-facets');
              if (facetsElement) {
                observer = new MutationObserver(function (mutations) {
                  var _iterator = _createForOfIteratorHelper(mutations),
                    _step;
                  try {
                    for (_iterator.s(); !(_step = _iterator.n()).done;) {
                      var mutation = _step.value;
                      if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
                        requestAnimationFrame(function () {
                          reinitEmbla();
                        });
                      }
                    }
                  } catch (err) {
                    _iterator.e(err);
                  } finally {
                    _iterator.f();
                  }
                });
                observer.observe(facetsElement, {
                  attributes: true,
                  attributeFilter: ['class']
                });
              }

              // Add event listeners for swatches inside the card
              cardNodes = document.querySelectorAll(cardSelector);
              cardNodes.forEach(function (node) {
                var links = node.querySelectorAll('.linked-product__link');
                links.forEach(function (link) {
                  link.addEventListener('click', function (ev) {
                    _this4.handleCardSwatchLinkClick(hit, ev, link);
                  });
                });
              });

              // Add a class to the .card__information to indicate presence of linked product

              /* card--compare-modal */
              infoNodes = document.querySelectorAll("".concat(cardSelector, ":not(:has(.card--compare-modal)) .card__information"));
              infoNodes.forEach(function (infoNode) {
                infoNode.classList.add('has-linked-product');
              });

              // Store carousel instance on DOM node if needed
              emblaNode.emblaCarousel = emblaCarousel;
            case 22:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }));
      function _initEmblaCarousel(_x4, _x5, _x6) {
        return _initEmblaCarousel2.apply(this, arguments);
      }
      return _initEmblaCarousel;
    }() /** Sets up event listeners for swatch interactions. */)
  }, {
    key: "setupSwatchEventListeners",
    value: function setupSwatchEventListeners(cardSelector, hit) {
      var _this5 = this;
      document.querySelectorAll("".concat(cardSelector, " .linked-product__link")).forEach(function (link) {
        link.addEventListener('click', function (ev) {
          _this5.handleCardSwatchLinkClick(hit, ev, link);
        });
      });
    }

    /**
     * @description Safely queries for a single DOM element. Throws an error if not found.
     * @param {string} selector - The selector string.
     * @param {ParentNode} [root=document] - Optional root element for the query.
     * @returns {Element} The matching DOM element.
     * @throws {Error} If the element is not found.
     */
  }, {
    key: "safeQuerySelector",
    value: function safeQuerySelector(selector) {
      var root = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : document;
      var element = root.querySelector(selector);
      if (!element) {
        throw new Error("Element not found for selector: ".concat(selector));
      }
      return element;
    }

    /**
     * @description Safely queries for multiple DOM elements. Returns an empty array if none are found.
     * @param {string} selector - The selector string.
     * @param {ParentNode} [root=document] - Optional root element for the query.
     * @returns {Element[]} An array of matching DOM elements.
     */
  }, {
    key: "safeQuerySelectorAll",
    value: function safeQuerySelectorAll(selector) {
      var root = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : document;
      var elements = root.querySelectorAll(selector);
      return elements ? Array.from(elements) : [];
    }

    /**
     * @description Sets the text content and href for a link element.
     * @param {Element} element - The link element.
     * @param {string} text - The text content to set.
     * @param {string} url - The URL to set for the href.
     */
  }, {
    key: "setLinkContentAndHref",
    value: function setLinkContentAndHref(element, text, url) {
      if (!element) return;
      element.textContent = text;
      element.href = url;
    }

    /**
     * @description Updates a list of elements by applying the provided callback.
     * @param {string} selector - Selector for the elements to update.
     * @param {Function} callback - Function to call for each element.
     * @param {ParentNode} [root=document] - Optional root element.
     */
  }, {
    key: "updateElements",
    value: function updateElements(selector, callback) {
      var root = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : document;
      var elements = this.safeQuerySelectorAll(selector, root);
      if (!elements.length) return;
      elements.forEach(callback);
    }

    /**
     * @description Handles the click event for a card swatch link. Updates product data in the card with the newly selected product variant.
     * @param {Object} hit - The original product/variant data object.
     * @param {Event} event - The DOM click event object.
     * @param {HTMLElement} link - The clicked link element (if needed).
     * @throws {Error} Will throw an error if required DOM elements or JSON data are not found or invalid.
     */
  }, {
    key: "handleCardSwatchLinkClick",
    value: function handleCardSwatchLinkClick(hit, event, link) {
      try {
        var _link$closest, _link$closest2;
        event.preventDefault();
        event.stopPropagation();
        var hitsItemParent = link.closest('.ais-Hits-item');
        if (!hitsItemParent) return;
        var imageReference = link.dataset.productImage;
        var productHandle = link.dataset.productHandle;
        var productTitle = link.dataset.productTitle;
        var vendor = link.dataset.vendor;
        var productFinishName = link.dataset.productFinishName;

        // Format title - skip vendor removal for merch products and gibsonxcollab products
        var productTitleWithoutVendorAndFinishName = Utils.isMerchProduct(hit) || Utils.isGibsonCollabProduct(hit) ? productTitle : productTitle.replace(new RegExp("".concat(vendor, "\\s*"), 'gi'), '').replace(new RegExp("\\s*,\\s*".concat(productFinishName || ''), 'gi'), productFinishName ? '' : '$&');
        var brandUrlParams = '';
        if (window.location.href.indexOf('?view=kramer') > -1 || hit.vendor === 'Kramer') {
          brandUrlParams = '?view=kramer';
        } else if (window.location.href.indexOf('?view=epiphone') > -1 || hit.vendor === 'Epiphone') {
          brandUrlParams = '?view=epiphone';
        } else if (window.location.href.indexOf('?view=mesa/boogie') > -1 || hit.vendor === 'Mesa/Boogie') {
          brandUrlParams = '?view=mesa';
        }
        var productHtml = "\n      ".concat(productTitleWithoutVendorAndFinishName, "\n        <span class=\"vendor-name\">").concat(vendor, "</span>\n      ");
        var hasBodyImage = link.dataset.hasBodyImage;
        var productPrice = parseFloat(link.dataset.productPrice) / 100;
        var compareAtPrice = parseFloat(link.dataset.compareAtPrice) / 100;

        // Use Algolia's built-in price formatting helpers
        var productPriceText = this.helpers.displayPrice({
          price: productPrice
        }).replace(/([.,])00$/, '');
        var compareAtPriceText = link.dataset.compareAtPrice ? this.helpers.displayPrice({
          price: compareAtPrice
        }).replace(/([.,])00$/, '') : null;

        // Update the image, text, and links
        hitsItemParent.querySelector('.media img').src = imageReference;
        if (hasBodyImage === 'false') {
          hitsItemParent.querySelector('.media').classList.add('no-body-image');
        } else {
          hitsItemParent.querySelector('.media').classList.remove('no-body-image');
        }

        // Check if the new product is exclusive using the link's data attributes
        var isExclusive = link.dataset.isExclusive === 'true' || ((_link$closest = link.closest('.linked-product')) === null || _link$closest === void 0 ? void 0 : _link$closest.classList.contains('exclusive')) || ((_link$closest2 = link.closest('.linked-product')) === null || _link$closest2 === void 0 ? void 0 : _link$closest2.hasAttribute('data-exclusive-product'));
        var exclusiveNode = hitsItemParent.querySelector('.product-card-link__exclusive');
        var mediaElement = hitsItemParent.querySelector('.media');
        if (isExclusive) {
          if (exclusiveNode) {
            exclusiveNode.classList.remove('hidden');
          }
          if (mediaElement) {
            mediaElement.classList.add('exclusive-media');
          }
        } else {
          if (exclusiveNode) {
            exclusiveNode.classList.add('hidden');
          }
          if (mediaElement) {
            mediaElement.classList.remove('exclusive-media');
          }
        }
        hitsItemParent.querySelector('.card__heading.h5 a').innerHTML = productHtml;
        hitsItemParent.querySelector('.card__heading.h5 a.meta-finish-name').innerHTML = productFinishName;
        hitsItemParent.querySelector('.price-item--regular span').textContent = productPriceText;
        if (compareAtPrice && compareAtPrice !== productPrice) {
          // Calculate the percentage directly instead of using the template
          var percentageOff = this.priceHandler.displayDiscount(compareAtPrice, productPrice);
          hitsItemParent.querySelector('.price-item--sale').style.display = 'block';
          hitsItemParent.querySelector('.price-item--sale span').textContent = compareAtPriceText;
          if (hitsItemParent.querySelector('.price-item--percentage')) {
            hitsItemParent.querySelector('.price-item--percentage').style.display = 'block';
            hitsItemParent.querySelector('.price-item--percentage').textContent = percentageOff;
          }
        } else {
          hitsItemParent.querySelector('.price-item--sale').style.display = 'none';
          if (hitsItemParent.querySelector('.price-item--percentage')) {
            hitsItemParent.querySelector('.price-item--percentage').style.display = 'none';
          }
        }
        var region = window.Shopify.routes.root;

        // update product card link
        hitsItemParent.querySelectorAll('.product-card-link').forEach(function (el) {
          el.href = "".concat(region, "products/").concat(productHandle);
        });

        // update compare button
        var compareButton = document.querySelector("#Card--".concat(hit.id, " .card__compare"));
        if (compareButton) {
          compareButton.dataset.productHandle = productHandle;
        }

        // Update product flags
        var productFlags = link.dataset.productFlags;
        var productFlagsColors = link.dataset.productFlagsColors;
        var productFlagsBackgroundColors = link.dataset.productFlagsBackgroundColors;
        var productFlagsOverlay = link.dataset.productFlagsOverlay;
        var cardElement = hitsItemParent.querySelector('.card');

        // Split flags by overlay attribute
        var _this$splitFlagsByOve4 = this.splitFlagsByOverlay(productFlags, productFlagsOverlay, productFlagsColors, productFlagsBackgroundColors),
          overlayFlags = _this$splitFlagsByOve4.overlayFlags,
          nonOverlayFlags = _this$splitFlagsByOve4.nonOverlayFlags,
          overlayColors = _this$splitFlagsByOve4.overlayColors,
          nonOverlayColors = _this$splitFlagsByOve4.nonOverlayColors,
          overlayBackgroundColors = _this$splitFlagsByOve4.overlayBackgroundColors;

        // Render overlay flags in the media div
        this.renderOverlayFlags(overlayFlags, overlayColors, overlayBackgroundColors, cardElement);

        // Render non-overlay flags in the product flags container
        this.updateNonOverlayBadges(nonOverlayFlags, nonOverlayColors, hitsItemParent);

        // Use the complex inventory logic to determine if the product is sold out
        var isSoldOut = this.determineSoldOutStatusFromLink(link);
        if (isSoldOut) {
          hitsItemParent.querySelector('.alt-card--oos__item').classList.remove('hidden');
        } else {
          hitsItemParent.querySelector('.alt-card--oos__item').classList.add('hidden');
        }

        // update active thumbnail

        _toConsumableArray(hitsItemParent.querySelectorAll('.linked-product.active')).forEach(function (el) {
          el.classList.remove('active');
          el.querySelectorAll('a').forEach(function (link) {
            link.removeAttribute('aria-selected');
          });
        });
        link.parentElement.classList.add('active');
        link.setAttribute('aria-selected', 'true');
      } catch (error) {
        console.error('Error in handleCardSwatchLinkClick:', error);
      }
    }

    /**
     * Creates serialized information element if the product has multiple variants.
     * Displays a link to select from additional product variants.
     * @param {Object} hit - The product hit data.
     * @param {Function} html - The HTML template function.
     * @returns {TemplateResult|string} - The HTML template for serialized info or an empty string.
     */
  }, {
    key: "createSerializedInfo",
    value: function createSerializedInfo(hit, html) {
      if (this.isSoldOut) {}
      // Calculate the number of additional variants.
      hit.serialized_count = hit.variants_count > 1 ? hit.variants_count - 1 : null;
      var isMerchProduct = hit.named_tags && hit.named_tags.primary_collection && (hit.named_tags.primary_collection.includes('Clothing & Apparel') || hit.tags.includes('new_merch_product'));
      if (!hit.serialized_count || isMerchProduct) return '';
      if (hit.meta && hit.meta.custom && hit.meta.custom.has_serialized_variants && hit.variants_count == 2) {
        hit.serialized_count = 2;
      } else if (hit.meta && hit.meta.custom && hit.meta.custom.has_serialized_variants && hit.variants_count == 3) {
        hit.serialized_count = 3;
      } else if (hit.meta && hit.meta.custom && hit.meta.custom.has_serialized_variants && hit.variants_count >= 4) {
        hit.serialized_count = 4;
      }
      return html(_templateObject18 || (_templateObject18 = _taggedTemplateLiteral(["\n      <div class=\"alt-card-is-serialized ", "\">\n        <div class=\"alt-card-is-serialized__item\">\n          <a\n            class=\"alt-card-is-serialized__caption\"\n            href=\"", "\"\n            aria-label=\"", "\"\n            tabindex=\"0\"\n            js-serial-count\n          >\n            ", "\n          </a>\n        </div>\n      </div>\n    "])), this.isSoldOut ? 'hidden' : '', this.helpers.instantsearchLink(hit), algoliaShopify.translations.selectFrom, algoliaShopify.translations.selectFrom);
    }

    /**
     * Determines if a product is sold out based on complex inventory logic from link data attributes.
     * This method handles both linked product links and merch color buttons.
     * @param {HTMLElement} link - The linked product link element or merch color button.
     * @returns {boolean} - True if the product is sold out, false otherwise.
     */
  }, {
    key: "determineSoldOutStatusFromLink",
    value: function determineSoldOutStatusFromLink(link) {
      // For linked product links, use the complex inventory logic
      if (link.dataset.productAvailable !== undefined) {
        var productAvailable = link.dataset.productAvailable === 'true';
        var inventoryUnavailableWarehouses = link.dataset.inventoryUnavailableWarehouses === 'true';

        // A product is sold out if it's not available OR if warehouses are unavailable
        return !productAvailable || inventoryUnavailableWarehouses;
      }

      // For merch color buttons, check if they have the sold-out class
      if (link.classList.contains('sold-out')) {
        return true;
      }
      if (link.dataset.ukAvailability === 'false' && (window.Shopify.market_handle === 'europe' || window.Shopify.market_handle === 'united-kingdom')) {
        return true;
      }
      if (link.dataset.usAvailability === 'false' && window.Shopify.market_handle === 'us') {
        return true;
      }
      // Default to not sold out if we can't determine the status
      return false;
    }

    /**
     * Determines if a product is sold out based on complex inventory logic.
     * This method considers basic inventory availability, market-specific warehouse availability,
     * and garage availability to make a comprehensive sold out determination.
     * @param {Object} hit - The product hit data.
     * @returns {boolean} - True if the product is sold out, false otherwise.
     */
  }, {
    key: "determineSoldOutStatus",
    value: function determineSoldOutStatus(hit) {
      var isSoldOut = (hit.inventory_available === false || hit.inventory_quantity === 0) && hit.variants_inventory_count <= 0;

      // Parse inventory available tags to get counts
      var gOpsAvailable = true;
      var gOpsEpiAvailable = true;
      var mainFreightAvailable = true;
      var hasGarageNashville = true;
      var hasGarageLondon = true;
      if (hit.named_tags && hit.named_tags['inventory-unavailable']) {
        var inventoryUnavailableTags = Array.isArray(hit.named_tags['inventory-unavailable']) ? hit.named_tags['inventory-unavailable'] : [hit.named_tags['inventory-unavailable']];
        inventoryUnavailableTags.forEach(function (tag) {
          if (tag === ' g-ops') {
            gOpsAvailable = false;
          } else if (tag === ' g-ops-epi') {
            gOpsEpiAvailable = false;
          } else if (tag === ' mainfreight') {
            mainFreightAvailable = false;
          } else if (tag === ' nashville') {
            hasGarageNashville = false;
          } else if (tag === ' london') {
            hasGarageLondon = false;
          }
        });
      }
      if (window.Shopify.market_handle === 'us') {
        // For US market, check if any US warehouse has inventory OR if garage is available
        var usWarehouseAvailable = gOpsAvailable || gOpsEpiAvailable;
        var garageAvailable = hasGarageNashville;
        if (!usWarehouseAvailable && !garageAvailable) {
          isSoldOut = true;
        }
      } else if (window.Shopify.market_handle === 'europe' || window.Shopify.market_handle === 'united-kingdom') {
        // For EU/UK market, check if Mainfreight has inventory OR if London garage is available
        var euWarehouseAvailable = mainFreightAvailable;
        var _garageAvailable = hasGarageLondon;
        if (!euWarehouseAvailable && !_garageAvailable) {
          isSoldOut = true;
        }
      }
      return isSoldOut;
    }
  }, {
    key: "createSoldoutInfo",
    value: function createSoldoutInfo(hit, html) {
      var isSoldOut = this.determineSoldOutStatus(hit);
      this.isSoldOut = isSoldOut;

      /* if NOT soldout then class of hidden should be added to the alt-card--oos__item */
      return html(_templateObject19 || (_templateObject19 = _taggedTemplateLiteral(["\n      <div class=\"alt-card-is-serialized alt-card--oos\">\n        <div class=\"alt-card-is-serialized__item alt-card--oos__item ", "\">\n          <p class=\"alt-card-is-serialized__caption alt-card--oos__caption\">\n            ", "\n          </p>\n        </div>\n      </div>\n    "])), isSoldOut ? '' : 'hidden', algoliaShopify.translations.outOfStock);
    }
  }, {
    key: "initializeThumbnailListeners",
    value: function initializeThumbnailListeners(hit) {
      var cardElement = document.querySelector("#Card--".concat(hit.id));
      if (!cardElement) return;
      var thumbnails = cardElement.querySelectorAll('.card__thumbnail');
      var mainImage = cardElement.querySelector('[data-main-media-id] img');
      thumbnails.forEach(function (thumbnail) {
        thumbnail.addEventListener('click', function (e) {
          e.preventDefault();

          // Remove active class from all thumbnails
          thumbnails.forEach(function (t) {
            return t.classList.remove('card__thumbnail--active');
          });

          // Add active class to clicked thumbnail
          thumbnail.classList.add('card__thumbnail--active');

          // Update main image
          if (mainImage) {
            mainImage.src = thumbnail.dataset.imageSrc;
            mainImage.srcset = thumbnail.dataset.imageSrcset;
          }
        });
      });
    }
  }]);
}();
/**
 * Timer for debouncing events.
 * @type {number}
 */
var debounceTimer;

/**
 * Initializes the product template by registering a hook with Algolia Shopify.
 * Sets up the custom product template rendering.
 * @param {Object} algoliaShopify - The Algolia Shopify integration object.
 */
function initializeProductTemplate(algoliaShopify) {
  algoliaShopify.hooks.registerHook('beforeInstantSearchProductTemplate', function (_defaultTemplate, hit, html, components) {
    // Update translations.
    for (var key in languageStrings) {
      if (Object.hasOwnProperty.call(languageStrings, key)) {
        algoliaShopify.translations[key] = languageStrings[key];
      }
    }
    // Create a new ProductTemplate instance.
    var productTemplate = new ProductTemplate(algoliaShopify.helpers, components, html);
    // Update refined values.

    // Clear and reset the debounce timer.

    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(function () {
      // Dispatch an event indicating that Algolia has finished initialization.
      window.dispatchEvent(new Event('algolia.finishedInitialization'));
    }, 100);
    productTemplate.clonedTemplate = _defaultTemplate;
    productTemplate.clonedComponents = components;
    return productTemplate.createTemplate(hit, _defaultTemplate);
  });
}

// Initialize the product template when Algolia hooks are initialized.
document.addEventListener('algolia.hooks.initialize', function () {
  initializeProductTemplate(algoliaShopify);
});
;// ./src/scripts/components/algoliaFacetRenderer.js
var algoliaFacetRenderer_templateObject, algoliaFacetRenderer_templateObject2, algoliaFacetRenderer_templateObject3, algoliaFacetRenderer_templateObject4, algoliaFacetRenderer_templateObject5, algoliaFacetRenderer_templateObject6;
function algoliaFacetRenderer_taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
function algoliaFacetRenderer_typeof(o) { "@babel/helpers - typeof"; return algoliaFacetRenderer_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, algoliaFacetRenderer_typeof(o); }
function algoliaFacetRenderer_classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function algoliaFacetRenderer_defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, algoliaFacetRenderer_toPropertyKey(o.key), o); } }
function algoliaFacetRenderer_createClass(e, r, t) { return r && algoliaFacetRenderer_defineProperties(e.prototype, r), t && algoliaFacetRenderer_defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function algoliaFacetRenderer_toPropertyKey(t) { var i = algoliaFacetRenderer_toPrimitive(t, "string"); return "symbol" == algoliaFacetRenderer_typeof(i) ? i : i + ""; }
function algoliaFacetRenderer_toPrimitive(t, r) { if ("object" != algoliaFacetRenderer_typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != algoliaFacetRenderer_typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * Represents a renderer for individual facets in a search interface.
 * This class is responsible for rendering facet dropdowns with labels, inputs, and icons.
 */
var FacetRenderer = /*#__PURE__*/function () {
  /**
   * Creates an instance of FacetRenderer.
   * @param {Object} facet - The facet object containing properties like escapedName, title, and type.
   * @param {number} index - The index of the facet in the list of facets.
   * @param {Function} html - A template literal tag function for creating HTML.
   * @param {Object[]} allFacets - An array of all facets in the search interface.
   */
  function FacetRenderer(facet, index, html, allFacets) {
    algoliaFacetRenderer_classCallCheck(this, FacetRenderer);
    this.facet = facet;
    this.index = index;
    this.html = html;
    this.allFacets = allFacets;
    this.validateFacet();
  }

  /**
   * Validates the facet object passed to the constructor.
   * @throws {Error} If the facet object is invalid or missing required properties.
   */
  return algoliaFacetRenderer_createClass(FacetRenderer, [{
    key: "validateFacet",
    value: function validateFacet() {
      if (!this.facet || algoliaFacetRenderer_typeof(this.facet) !== 'object') {
        throw new Error('Invalid facet object.');
      }
      if (!this.facet.escapedName || !this.facet.title || !this.facet.type) {
        throw new Error('Facet is missing required properties.');
      }
    }

    /**
     * Renders the entire facet dropdown.
     * @returns {string} The HTML string of the rendered facet dropdown.
     */
  }, {
    key: "render",
    value: function render() {
      var _this$facet = this.facet,
        escapedName = _this$facet.escapedName,
        title = _this$facet.title,
        type = _this$facet.type;
      var _title = title;
      if (window.translations && Array.isArray(window.translations)) {
        var matchingTranslation = window.translations.find(function (translation) {
          return (translation.guitar_spec || translation.amp_spec || translation.pedal_spec || translation.other_spec) && (translation.guitar_spec === escapedName || translation.amp_spec === escapedName || translation.pedal_spec === escapedName || translation.other_spec && translation.key === escapedName || translation.key === _title.toLowerCase() || translation.key.replace('pdp-', '') === _title.toLowerCase() || translation.key.replace(' ', '-') === _title.toLowerCase().replace(' ', '-'));
        });
        if (matchingTranslation) {
          _title = matchingTranslation.value;
        }
      }

      // Special handling for price range slider
      if (type === 'slider') {
        return this.renderRangeSlider(escapedName, _title);
      }
      var _this$checkIfFacetIsE = this.checkIfFacetIsExclusive(escapedName, this.facet),
        isExclusive = _this$checkIfFacetIsE.isExclusive,
        market = _this$checkIfFacetIsE.market;

      // Original render code for other facet types
      var isChecked = this.index > 3 ? true : false;
      var _escapedName = escapedName;
      if (isExclusive) {
        _escapedName = "meta--product_flags--".concat(market.toLowerCase(), "_product_flags");
      }
      var hideEuFacet = false;
      var hideUsFacet = false;
      if (escapedName === 'meta.product_flags.eu_product_flags' && window.Shopify.country === 'US') {
        hideEuFacet = true;
      }
      if (escapedName === 'meta.product_flags.us_product_flags' && window.Shopify.country !== 'US') {
        hideUsFacet = true;
      }
      return this.html(algoliaFacetRenderer_templateObject || (algoliaFacetRenderer_templateObject = algoliaFacetRenderer_taggedTemplateLiteral(["\n      <div\n        class=\"ais-facet-dropdown-wrapper ais-facet-", " ais-facet-", " ais-facet-", " ", " ", " ", "\"\n        data-index=\"", "\"\n        data-facet=\"", "\"\n      >\n        ", "\n  \n        ", "\n        ", "\n      </div>\n    "])), type, escapedName, _escapedName, this.allFacets.length - 1 === this.index ? 'ais-facet-last' : '', hideEuFacet ? 'hidden' : '', hideUsFacet ? 'hidden' : '', this.index, escapedName, this.renderLabel(escapedName, _title), this.renderInput(escapedName, isChecked), this.renderFacetContainer(escapedName));
    }
  }, {
    key: "renderRangeSlider",
    value: function renderRangeSlider(escapedName, title) {
      return this.html(algoliaFacetRenderer_templateObject2 || (algoliaFacetRenderer_templateObject2 = algoliaFacetRenderer_taggedTemplateLiteral(["\n      <div \n        class=\"ais-facet-dropdown-wrapper ais-RefinementList ais-facet-", "\"\n        data-index=\"", "\"\n        data-facet=\"", "\"\n      >\n      ", "\n      ", "\n          <div class=\"ais-RefinementList-body ais-facet-dropdown-container\">\n          <div class=\"ais-facet-price-container\"></div>\n        </div>\n      </div>\n    "])), escapedName, this.index, escapedName, this.renderLabel(escapedName, title), this.renderInput(escapedName, false));
    }
  }, {
    key: "checkIfFacetIsExclusive",
    value: function checkIfFacetIsExclusive(escapedName, facet) {
      if (escapedName === 'meta.product_flags.us_product_flags') {
        return {
          isExclusive: true,
          market: 'US'
        };
      } else if (escapedName === 'meta.product_flags.eu_product_flags') {
        return {
          isExclusive: true,
          market: 'EU'
        };
      } else {
        return {
          isExclusive: false,
          market: null
        };
      }
    }

    /**
     * Renders the label for the facet dropdown.
     * @param {string} escapedName - The escaped name of the facet.
     * @param {string} title - The display title of the facet.
     * @returns {string} The HTML string of the rendered label.
     */
  }, {
    key: "renderLabel",
    value: function renderLabel(escapedName, title) {
      var _title = title;
      var _isInventoryAvailable = escapedName === 'inventory_available';
      var _isExclusive = escapedName === 'meta.product_flags.us_product_flags' || escapedName === 'meta.product_flags.eu_product_flags';
      var _labelClassList = _isInventoryAvailable ? 'ais-range-slider--header ais-facet__header ais-header inventory-available-label' : _isExclusive ? 'ais-range-slider--header ais-facet__header ais-header exclusive-flag-label ' : 'ais-range-slider--header ais-facet__header ais-header';
      return this.html(algoliaFacetRenderer_templateObject3 || (algoliaFacetRenderer_templateObject3 = algoliaFacetRenderer_taggedTemplateLiteral(["\n      <label for=\"", "\" class=\"", "\">\n        ", "\n        ", "\n      </label>\n    "])), escapedName, _labelClassList, _title, !_isInventoryAvailable && !_isExclusive ? this.renderIcons() : '');
    }

    /**
     * Renders the input checkbox for the facet dropdown.
     * @param {string} escapedName - The escaped name of the facet.
     * @param {boolean} isChecked - Whether the checkbox should be checked by default.
     * @returns {string} The HTML string of the rendered input checkbox.
     */
  }, {
    key: "renderInput",
    value: function renderInput(escapedName, isChecked) {
      if (escapedName === 'inventory_available' || escapedName === 'meta.product_flags.us_product_flags' || escapedName === 'meta.product_flags.eu_product_flags') return '';
      return this.html(algoliaFacetRenderer_templateObject4 || (algoliaFacetRenderer_templateObject4 = algoliaFacetRenderer_taggedTemplateLiteral(["\n      <input\n        class=\"ais-dropdown-checkbox\"\n        type=\"checkbox\"\n        id=\"", "\"\n        name=\"dropdown\"\n        data-is-checked=\"", "\"\n        checked=\"", "\"\n      />\n    "])), escapedName, isChecked, isChecked);
    }

    /**
     * Renders the container for the facet content.
     * @param {string} escapedName - The escaped name of the facet.
     * @returns {string} The HTML string of the rendered facet container.
     */
  }, {
    key: "renderFacetContainer",
    value: function renderFacetContainer(escapedName) {
      var additionalClassList = '';
      if (escapedName === 'inventory_available') {
        additionalClassList = 'hidden';
      }
      return this.html(algoliaFacetRenderer_templateObject5 || (algoliaFacetRenderer_templateObject5 = algoliaFacetRenderer_taggedTemplateLiteral(["<div class=\"ais-facet-", "-container  ais-facet-dropdown-container ", "\"></div>"])), escapedName, additionalClassList);
    }

    /**
     * Renders the plus and minus icons for the facet dropdown.
     * @returns {string} The HTML string of the rendered icons.
     */
  }, {
    key: "renderIcons",
    value: function renderIcons() {
      return this.html(algoliaFacetRenderer_templateObject6 || (algoliaFacetRenderer_templateObject6 = algoliaFacetRenderer_taggedTemplateLiteral(["\n      <svg\n        width=\"24\"\n        height=\"24\"\n        viewBox=\"0 0 24 24\"\n        fill=\"none\"\n        xmlns=\"http://www.w3.org/2000/svg\"\n        class=\"icon icon-plus\"\n      >\n        <rect x=\"12\" y=\"5\" width=\"1\" height=\"15\" rx=\"0.5\" fill=\"black\" stroke=\"black\" stroke-width=\"0.5\" />\n        <rect x=\"5\" y=\"12\" width=\"15\" height=\"1\" rx=\"0.5\" fill=\"black\" stroke=\"black\" stroke-width=\"0.5\" />\n      </svg>\n      <svg\n        width=\"24\"\n        height=\"24\"\n        viewBox=\"0 0 24 24\"\n        fill=\"none\"\n        xmlns=\"http://www.w3.org/2000/svg\"\n        class=\"icon icon-minus\"\n      >\n        <rect\n          opacity=\"0.01\"\n          x=\"12\"\n          y=\"5\"\n          width=\"1\"\n          height=\"15\"\n          rx=\"0.5\"\n          fill=\"black\"\n          stroke=\"black\"\n          stroke-width=\"0.5\"\n        />\n        <rect x=\"5\" y=\"12\" width=\"15\" height=\"1\" rx=\"0.5\" fill=\"black\" stroke=\"black\" stroke-width=\"0.5\" />\n      </svg>\n    "])));
    }
  }]);
}();
/* harmony default export */ var algoliaFacetRenderer = (FacetRenderer);
;// ./src/scripts/utils/debounce.js
var Debounce = function Debounce(fn, delay) {
  var timeout;
  return function () {
    var context = this;
    var args = arguments;
    clearTimeout(timeout);
    timeout = setTimeout(function () {
      return fn.apply(context, args);
    }, delay);
  };
};
var debounce = function debounce(func, wait, immediate) {
  var timeout;
  return function () {
    var context = this,
      args = arguments;
    var later = function later() {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };
    var callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(context, args);
  };
};

;// ./src/scripts/utils/updateRefinedValues.js
function updateRefinedValues_typeof(o) { "@babel/helpers - typeof"; return updateRefinedValues_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, updateRefinedValues_typeof(o); }
function updateRefinedValues_toConsumableArray(r) { return updateRefinedValues_arrayWithoutHoles(r) || updateRefinedValues_iterableToArray(r) || updateRefinedValues_unsupportedIterableToArray(r) || updateRefinedValues_nonIterableSpread(); }
function updateRefinedValues_nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function updateRefinedValues_unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return updateRefinedValues_arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? updateRefinedValues_arrayLikeToArray(r, a) : void 0; } }
function updateRefinedValues_iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function updateRefinedValues_arrayWithoutHoles(r) { if (Array.isArray(r)) return updateRefinedValues_arrayLikeToArray(r); }
function updateRefinedValues_arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function updateRefinedValues_regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ updateRefinedValues_regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == updateRefinedValues_typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(updateRefinedValues_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function updateRefinedValues_asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function updateRefinedValues_asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { updateRefinedValues_asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { updateRefinedValues_asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function updateRefinedValues_classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function updateRefinedValues_defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, updateRefinedValues_toPropertyKey(o.key), o); } }
function updateRefinedValues_createClass(e, r, t) { return r && updateRefinedValues_defineProperties(e.prototype, r), t && updateRefinedValues_defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function updateRefinedValues_toPropertyKey(t) { var i = updateRefinedValues_toPrimitive(t, "string"); return "symbol" == updateRefinedValues_typeof(i) ? i : i + ""; }
function updateRefinedValues_toPrimitive(t, r) { if ("object" != updateRefinedValues_typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != updateRefinedValues_typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

var RefinedValuesUpdater = /*#__PURE__*/function () {
  /**
   * @constructor
   * @description Initializes the RefinedValuesUpdater with the loading SVG markup
   * and an empty Map for facet color mapping.
   */
  function RefinedValuesUpdater() {
    updateRefinedValues_classCallCheck(this, RefinedValuesUpdater);
    /**
     * @private
     * @type {string}
     * @description SVG markup for the loading indicator.
     */
    this.loadingSVGMarkup = "\n      <svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\">\n        <path d=\"M12,1A11,11,0,1,0,23,12,11,11,0,0,0,12,1Zm0,19a8,8,0,1,1,8-8A8,8,0,0,1,12,20Z\" opacity=\".25\" fill=\"#fff\" />\n        <path\n          d=\"M10.14,1.16a11,11,0,0,0-9,8.92A1.59,1.59,0,0,0,2.46,12,1.52,1.52,0,0,0,4.11,10.7a8,8,0,0,1,6.66-6.61A1.42,1.42,0,0,0,12,2.69h0A1.57,1.57,0,0,0,10.14,1.16Z\"\n          fill=\"#fff\"\n          class=\"spinner_ajPY\"\n        />\n      </svg>\n    ";

    /**
     * @private
     * @type {Map<string, string>}
     * @description Map to store facet color names keyed by their values.
     */
    this.facetColorMap = new Map();
  }

  /**
   * @public
   * @method updateRefinedValues
   * @description Main method to update refined values. It orchestrates the entire update process.
   *
   */
  return updateRefinedValues_createClass(RefinedValuesUpdater, [{
    key: "updateRefinedValues",
    value: (function () {
      var _updateRefinedValues = updateRefinedValues_asyncToGenerator(/*#__PURE__*/updateRefinedValues_regeneratorRuntime().mark(function _callee() {
        var refinedValueDivs, refinementParent, parentHasBrandRefinement, loadingSVGs;
        return updateRefinedValues_regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              refinedValueDivs = this.getRefinedValueDivs();
              refinementParent = document.querySelector('.ais-refinements-parent-container');
              parentHasBrandRefinement = Boolean(refinementParent.getAttribute('js-has-brand-refinement'));
              refinedValueDivs.length > 0 && !parentHasBrandRefinement ? refinementParent.setAttribute('toggle-status', 'open') : refinementParent.setAttribute('toggle-status', 'closed');
              if (!(refinedValueDivs.length === 0)) {
                _context.next = 7;
                break;
              }
              return _context.abrupt("return");
            case 7:
              debounce(this.ensureOnlyOneClickEventListener(refinedValueDivs), 200);
              this.buildFacetColorMap();
              loadingSVGs = this.processRefinedValues(refinedValueDivs);
              this.scheduleCleanup(refinedValueDivs, loadingSVGs);
              _context.next = 16;
              break;
            case 13:
              _context.prev = 13;
              _context.t0 = _context["catch"](0);
              console.error('Error updating refined values :( :', _context.t0);
            case 16:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[0, 13]]);
      }));
      function updateRefinedValues() {
        return _updateRefinedValues.apply(this, arguments);
      }
      return updateRefinedValues;
    }()
    /**
     * @private
     * @method getRefinedValueDivs
     * @returns {Array<Element>} An array of DOM elements representing refined values.
     * @description Retrieves all DOM elements that represent refined values.
     */
    )
  }, {
    key: "getRefinedValueDivs",
    value: function getRefinedValueDivs() {
      return Array.from(document.querySelectorAll('.ais-current-refined-values--link > div'));
    }

    /**
     * @private
     * @method buildFacetColorMap
     * @description Builds a map of facet colors to their names based on DOM elements.
     */
  }, {
    key: "buildFacetColorMap",
    value: function buildFacetColorMap() {
      var _this = this;
      var colorLabels = Array.from(document.querySelectorAll('.color-label'));
      colorLabels.forEach(function (el) {
        var facetColor = el.dataset.facetColor;
        var facetColorName = el.innerText.trim().split(' ')[0].replace(/\d/g, '');
        if (facetColor) {
          _this.facetColorMap.set(facetColor, facetColorName);
        }
      });
    }

    /**
     * @private
     * @method processRefinedValues
     * @param {Array<Element>} refinedValueDivs - Array of DOM elements representing refined values.
     * @returns {Array<Element>} An array of created loading SVG elements.
     * @description Processes each refined value div, adding loading SVGs and updating text.
     */
  }, {
    key: "processRefinedValues",
    value: function processRefinedValues(refinedValueDivs) {
      var _this2 = this;
      var loadingSVGs = [];
      var refinedValueDivsLength = refinedValueDivs.length;
      var refinementParent = document.querySelector('.ais-refinements-parent-container');
      refinedValueDivsLength > 0 ? refinementParent.setAttribute('toggle-status', 'open') : refinementParent.setAttribute('toggle-status', 'closed');
      document.querySelectorAll('.ais-current-refined-values--list').forEach(function (el) {
        return el.classList.add('loading');
      });
      refinedValueDivs.forEach(function (el) {
        try {
          var svgDiv = _this2.createLoadingSVG();
          _this2.insertLoadingSVG(el, svgDiv, refinedValueDivsLength);
          loadingSVGs.push(svgDiv);
          _this2.hideElement(el);
          _this2.processInnerText(el);
        } catch (error) {
          console.error('Error processing element:', error);
        }
      });
      return loadingSVGs;
    }

    /**
     * @private
     * @method createLoadingSVG
     * @returns {Element} A new div element containing the loading SVG.
     * @description Creates a new DOM element for the loading SVG.
     */
  }, {
    key: "createLoadingSVG",
    value: function createLoadingSVG() {
      var svgDiv = document.createElement('div');
      svgDiv.classList.add('loading-svg');
      svgDiv.innerHTML = this.loadingSVGMarkup;
      return svgDiv;
    }

    /**
     * @private
     * @method insertLoadingSVG
     * @param {Element} el - The refined value element.
     * @param {Element} svgDiv - The loading SVG element to insert.
     * @description Inserts the loading SVG before the refined value element.
     */
  }, {
    key: "insertLoadingSVG",
    value: function insertLoadingSVG(el, svgDiv, refinedValueDivsLength) {
      var _el$parentElement;
      var parentElement = (_el$parentElement = el.parentElement) === null || _el$parentElement === void 0 ? void 0 : _el$parentElement.parentElement;
      if (parentElement) {
        if (parentElement.parentElement.querySelectorAll('.loading-svg').length >= refinedValueDivsLength) return;
        parentElement.parentElement.insertAdjacentElement('afterbegin', svgDiv);
      }
    }

    /**
     * @private
     * @method hideElement
     * @param {Element} el - The element to hide.
     * @description Sets the opacity of the given element to 0, effectively hiding it.
     */
  }, {
    key: "hideElement",
    value: function hideElement(el) {
      el.style.opacity = '0';
      el.style.visibility = 'hidden';
    }

    /**
     * @private
     * @method processInnerText
     * @param {Element} el - The element whose inner text needs to be processed.
     * @description Processes and updates the inner text of the given element.
     */
  }, {
    key: "processInnerText",
    value: function processInnerText(el) {
      if (el.innerHTML) {
        // Remove HTML tags and excessive whitespace
        var text = el.innerHTML.replace(/(<([^>]+)>)/gi, '').replace(/\s+/g, ' ').replace(/\["/g, '').replace(/"\]/g, '').replace(/"/g, '').replace(/\[/g, '').replace(/\]/g, '').replace(/&amp;/g, '&').trim();
        var elParentAttribute = el.parentElement.dataset.attribute;
        var isInventoryAvailable = elParentAttribute === 'inventory_available';
        var isLeftHanded = elParentAttribute === 'meta.sku.left_handed';
        // Remove space before colon and trim
        text = text.replace(' :', ':').trim();
        if (isInventoryAvailable) {
          text = 'In Stock';
        }

        // If text contains colon, take the part after it
        if (text.includes(':') && !text.includes(':::name:')) {
          text = text.split(':')[1].trim();
          if (isLeftHanded) {
            if (text === 'false') {
              text = 'Right';
              var matchingTranslation = window.translations && window.translations.find(function (translation) {
                return translation.key === 'right';
              });
              if (matchingTranslation) {
                text = matchingTranslation.value;
              }
            } else {
              text = 'Left';
              var _matchingTranslation = window.translations && window.translations.find(function (translation) {
                return translation.key === 'left';
              });
              if (_matchingTranslation) {
                text = _matchingTranslation.value;
              }
            }
          }
        } else if (text.includes(':::name:')) {
          text = text.split(':::name:')[1].trim();
        }
        var colMap = this.facetColorMap.get(text);

        // Update text with facet color name if available, otherwise clean up the text
        el.innerText = colMap || text.replace(':', '').trim();
      }
    }
  }, {
    key: "ensureOnlyOneClickEventListener",
    value: function ensureOnlyOneClickEventListener(refinedValueDivs) {
      try {
        updateRefinedValues_toConsumableArray(document.querySelectorAll('.ais-current-refined-values--link > div')).forEach(function (el) {
          if (!el.closest('.ais-Panel-body')) {
            return;
          }
          var divToLook = el.closest('.ais-Panel-body').querySelector('div:first-of-type');
          var removedListeners = getAndRemoveClickEventListeners(divToLook);
          var remainingListeners = getRemainingClickEventListeners(divToLook);
        });
      } catch (error) {
        console.error('Error removing click listeners maaan:', error);
      }
    }

    /**
     * @private
     * @method scheduleCleanup
     * @param {Array<Element>} refinedValueDivs - Array of refined value elements.
     * @param {Array<Element>} loadingSVGs - Array of loading SVG elements.
     * @description Schedules the removal of loading SVGs and restoration of refined value visibility.
     */
  }, {
    key: "scheduleCleanup",
    value: function scheduleCleanup(refinedValueDivs, loadingSVGs) {
      var _this3 = this;
      setTimeout(function () {
        _this3.restoreVisibility(refinedValueDivs);
        _this3.removeLoadingSVGs(loadingSVGs);
        _this3.removeLoadingOnParent();
      }, 200);
    }
  }, {
    key: "removeLoadingOnParent",
    value: function removeLoadingOnParent() {
      document.querySelectorAll('.ais-current-refined-values--list').forEach(function (el) {
        return el.classList.remove('loading');
      });
    }

    /**
     * @private
     * @method restoreVisibility
     * @param {Array<Element>} elements - Array of elements to restore visibility.
     * @description Sets the opacity of given elements back to 1, making them visible.
     */
  }, {
    key: "restoreVisibility",
    value: function restoreVisibility(elements) {
      elements.forEach(function (el) {
        try {
          el.style.opacity = '1';
          el.style.visibility = 'visible';
        } catch (error) {
          console.error('Error setting opacity:', error);
        }
      });
    }

    /**
     * @private
     * @method removeLoadingSVGs
     * @param {Array<Element>} svgElements - Array of loading SVG elements to remove.
     * @description Removes the loading SVG elements from the DOM.
     */
  }, {
    key: "removeLoadingSVGs",
    value: function removeLoadingSVGs(svgElements) {
      svgElements.forEach(function (svgEl) {
        try {
          svgEl.remove();
        } catch (error) {
          console.error('Error removing loading SVG:', error);
        }
      });
    }
  }]);
}();
/* harmony default export */ var updateRefinedValues = (RefinedValuesUpdater);
;// ./node_modules/redux/dist/redux.mjs
// src/utils/formatProdErrorMessage.ts
function formatProdErrorMessage(code) {
  return `Minified Redux error #${code}; visit https://redux.js.org/Errors?code=${code} for the full message or use the non-minified dev environment for full errors. `;
}

// src/utils/symbol-observable.ts
var $$observable = /* @__PURE__ */ (() => typeof Symbol === "function" && Symbol.observable || "@@observable")();
var symbol_observable_default = $$observable;

// src/utils/actionTypes.ts
var randomString = () => Math.random().toString(36).substring(7).split("").join(".");
var ActionTypes = {
  INIT: `@@redux/INIT${/* @__PURE__ */ randomString()}`,
  REPLACE: `@@redux/REPLACE${/* @__PURE__ */ randomString()}`,
  PROBE_UNKNOWN_ACTION: () => `@@redux/PROBE_UNKNOWN_ACTION${randomString()}`
};
var actionTypes_default = ActionTypes;

// src/utils/isPlainObject.ts
function redux_isPlainObject(obj) {
  if (typeof obj !== "object" || obj === null)
    return false;
  let proto = obj;
  while (Object.getPrototypeOf(proto) !== null) {
    proto = Object.getPrototypeOf(proto);
  }
  return Object.getPrototypeOf(obj) === proto || Object.getPrototypeOf(obj) === null;
}

// src/utils/kindOf.ts
function miniKindOf(val) {
  if (val === void 0)
    return "undefined";
  if (val === null)
    return "null";
  const type = typeof val;
  switch (type) {
    case "boolean":
    case "string":
    case "number":
    case "symbol":
    case "function": {
      return type;
    }
  }
  if (Array.isArray(val))
    return "array";
  if (isDate(val))
    return "date";
  if (isError(val))
    return "error";
  const constructorName = ctorName(val);
  switch (constructorName) {
    case "Symbol":
    case "Promise":
    case "WeakMap":
    case "WeakSet":
    case "Map":
    case "Set":
      return constructorName;
  }
  return Object.prototype.toString.call(val).slice(8, -1).toLowerCase().replace(/\s/g, "");
}
function ctorName(val) {
  return typeof val.constructor === "function" ? val.constructor.name : null;
}
function isError(val) {
  return val instanceof Error || typeof val.message === "string" && val.constructor && typeof val.constructor.stackTraceLimit === "number";
}
function isDate(val) {
  if (val instanceof Date)
    return true;
  return typeof val.toDateString === "function" && typeof val.getDate === "function" && typeof val.setDate === "function";
}
function kindOf(val) {
  let typeOfVal = typeof val;
  if (false) {}
  return typeOfVal;
}

// src/createStore.ts
function createStore(reducer, preloadedState, enhancer) {
  if (typeof reducer !== "function") {
    throw new Error( true ? formatProdErrorMessage(2) : 0);
  }
  if (typeof preloadedState === "function" && typeof enhancer === "function" || typeof enhancer === "function" && typeof arguments[3] === "function") {
    throw new Error( true ? formatProdErrorMessage(0) : 0);
  }
  if (typeof preloadedState === "function" && typeof enhancer === "undefined") {
    enhancer = preloadedState;
    preloadedState = void 0;
  }
  if (typeof enhancer !== "undefined") {
    if (typeof enhancer !== "function") {
      throw new Error( true ? formatProdErrorMessage(1) : 0);
    }
    return enhancer(createStore)(reducer, preloadedState);
  }
  let currentReducer = reducer;
  let currentState = preloadedState;
  let currentListeners = /* @__PURE__ */ new Map();
  let nextListeners = currentListeners;
  let listenerIdCounter = 0;
  let isDispatching = false;
  function ensureCanMutateNextListeners() {
    if (nextListeners === currentListeners) {
      nextListeners = /* @__PURE__ */ new Map();
      currentListeners.forEach((listener, key) => {
        nextListeners.set(key, listener);
      });
    }
  }
  function getState() {
    if (isDispatching) {
      throw new Error( true ? formatProdErrorMessage(3) : 0);
    }
    return currentState;
  }
  function subscribe(listener) {
    if (typeof listener !== "function") {
      throw new Error( true ? formatProdErrorMessage(4) : 0);
    }
    if (isDispatching) {
      throw new Error( true ? formatProdErrorMessage(5) : 0);
    }
    let isSubscribed = true;
    ensureCanMutateNextListeners();
    const listenerId = listenerIdCounter++;
    nextListeners.set(listenerId, listener);
    return function unsubscribe() {
      if (!isSubscribed) {
        return;
      }
      if (isDispatching) {
        throw new Error( true ? formatProdErrorMessage(6) : 0);
      }
      isSubscribed = false;
      ensureCanMutateNextListeners();
      nextListeners.delete(listenerId);
      currentListeners = null;
    };
  }
  function dispatch(action) {
    if (!redux_isPlainObject(action)) {
      throw new Error( true ? formatProdErrorMessage(7) : 0);
    }
    if (typeof action.type === "undefined") {
      throw new Error( true ? formatProdErrorMessage(8) : 0);
    }
    if (typeof action.type !== "string") {
      throw new Error( true ? formatProdErrorMessage(17) : 0);
    }
    if (isDispatching) {
      throw new Error( true ? formatProdErrorMessage(9) : 0);
    }
    try {
      isDispatching = true;
      currentState = currentReducer(currentState, action);
    } finally {
      isDispatching = false;
    }
    const listeners = currentListeners = nextListeners;
    listeners.forEach((listener) => {
      listener();
    });
    return action;
  }
  function replaceReducer(nextReducer) {
    if (typeof nextReducer !== "function") {
      throw new Error( true ? formatProdErrorMessage(10) : 0);
    }
    currentReducer = nextReducer;
    dispatch({
      type: actionTypes_default.REPLACE
    });
  }
  function observable() {
    const outerSubscribe = subscribe;
    return {
      /**
       * The minimal observable subscription method.
       * @param observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */
      subscribe(observer) {
        if (typeof observer !== "object" || observer === null) {
          throw new Error( true ? formatProdErrorMessage(11) : 0);
        }
        function observeState() {
          const observerAsObserver = observer;
          if (observerAsObserver.next) {
            observerAsObserver.next(getState());
          }
        }
        observeState();
        const unsubscribe = outerSubscribe(observeState);
        return {
          unsubscribe
        };
      },
      [symbol_observable_default]() {
        return this;
      }
    };
  }
  dispatch({
    type: actionTypes_default.INIT
  });
  const store = {
    dispatch,
    subscribe,
    getState,
    replaceReducer,
    [symbol_observable_default]: observable
  };
  return store;
}
function legacy_createStore(reducer, preloadedState, enhancer) {
  return createStore(reducer, preloadedState, enhancer);
}

// src/utils/warning.ts
function warning(message) {
  if (typeof console !== "undefined" && typeof console.error === "function") {
    console.error(message);
  }
  try {
    throw new Error(message);
  } catch (e) {
  }
}

// src/combineReducers.ts
function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
  const reducerKeys = Object.keys(reducers);
  const argumentName = action && action.type === actionTypes_default.INIT ? "preloadedState argument passed to createStore" : "previous state received by the reducer";
  if (reducerKeys.length === 0) {
    return "Store does not have a valid reducer. Make sure the argument passed to combineReducers is an object whose values are reducers.";
  }
  if (!redux_isPlainObject(inputState)) {
    return `The ${argumentName} has unexpected type of "${kindOf(inputState)}". Expected argument to be an object with the following keys: "${reducerKeys.join('", "')}"`;
  }
  const unexpectedKeys = Object.keys(inputState).filter((key) => !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key]);
  unexpectedKeys.forEach((key) => {
    unexpectedKeyCache[key] = true;
  });
  if (action && action.type === actionTypes_default.REPLACE)
    return;
  if (unexpectedKeys.length > 0) {
    return `Unexpected ${unexpectedKeys.length > 1 ? "keys" : "key"} "${unexpectedKeys.join('", "')}" found in ${argumentName}. Expected to find one of the known reducer keys instead: "${reducerKeys.join('", "')}". Unexpected keys will be ignored.`;
  }
}
function assertReducerShape(reducers) {
  Object.keys(reducers).forEach((key) => {
    const reducer = reducers[key];
    const initialState = reducer(void 0, {
      type: actionTypes_default.INIT
    });
    if (typeof initialState === "undefined") {
      throw new Error( true ? formatProdErrorMessage(12) : 0);
    }
    if (typeof reducer(void 0, {
      type: actionTypes_default.PROBE_UNKNOWN_ACTION()
    }) === "undefined") {
      throw new Error( true ? formatProdErrorMessage(13) : 0);
    }
  });
}
function combineReducers(reducers) {
  const reducerKeys = Object.keys(reducers);
  const finalReducers = {};
  for (let i = 0; i < reducerKeys.length; i++) {
    const key = reducerKeys[i];
    if (false) {}
    if (typeof reducers[key] === "function") {
      finalReducers[key] = reducers[key];
    }
  }
  const finalReducerKeys = Object.keys(finalReducers);
  let unexpectedKeyCache;
  if (false) {}
  let shapeAssertionError;
  try {
    assertReducerShape(finalReducers);
  } catch (e) {
    shapeAssertionError = e;
  }
  return function combination(state = {}, action) {
    if (shapeAssertionError) {
      throw shapeAssertionError;
    }
    if (false) {}
    let hasChanged = false;
    const nextState = {};
    for (let i = 0; i < finalReducerKeys.length; i++) {
      const key = finalReducerKeys[i];
      const reducer = finalReducers[key];
      const previousStateForKey = state[key];
      const nextStateForKey = reducer(previousStateForKey, action);
      if (typeof nextStateForKey === "undefined") {
        const actionType = action && action.type;
        throw new Error( true ? formatProdErrorMessage(14) : 0);
      }
      nextState[key] = nextStateForKey;
      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
    }
    hasChanged = hasChanged || finalReducerKeys.length !== Object.keys(state).length;
    return hasChanged ? nextState : state;
  };
}

// src/bindActionCreators.ts
function bindActionCreator(actionCreator, dispatch) {
  return function(...args) {
    return dispatch(actionCreator.apply(this, args));
  };
}
function bindActionCreators(actionCreators, dispatch) {
  if (typeof actionCreators === "function") {
    return bindActionCreator(actionCreators, dispatch);
  }
  if (typeof actionCreators !== "object" || actionCreators === null) {
    throw new Error( true ? formatProdErrorMessage(16) : 0);
  }
  const boundActionCreators = {};
  for (const key in actionCreators) {
    const actionCreator = actionCreators[key];
    if (typeof actionCreator === "function") {
      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
    }
  }
  return boundActionCreators;
}

// src/compose.ts
function compose(...funcs) {
  if (funcs.length === 0) {
    return (arg) => arg;
  }
  if (funcs.length === 1) {
    return funcs[0];
  }
  return funcs.reduce((a, b) => (...args) => a(b(...args)));
}

// src/applyMiddleware.ts
function applyMiddleware(...middlewares) {
  return (createStore2) => (reducer, preloadedState) => {
    const store = createStore2(reducer, preloadedState);
    let dispatch = () => {
      throw new Error( true ? formatProdErrorMessage(15) : 0);
    };
    const middlewareAPI = {
      getState: store.getState,
      dispatch: (action, ...args) => dispatch(action, ...args)
    };
    const chain = middlewares.map((middleware) => middleware(middlewareAPI));
    dispatch = compose(...chain)(store.dispatch);
    return {
      ...store,
      dispatch
    };
  };
}

// src/utils/isAction.ts
function redux_isAction(action) {
  return redux_isPlainObject(action) && "type" in action && typeof action.type === "string";
}

//# sourceMappingURL=redux.mjs.map
;// ./node_modules/redux-thunk/dist/redux-thunk.mjs
// src/index.ts
function createThunkMiddleware(extraArgument) {
  const middleware = ({ dispatch, getState }) => (next) => (action) => {
    if (typeof action === "function") {
      return action(dispatch, getState, extraArgument);
    }
    return next(action);
  };
  return middleware;
}
var redux_thunk_thunk = createThunkMiddleware();
var withExtraArgument = createThunkMiddleware;


;// ./node_modules/immer/dist/immer.mjs
// src/utils/env.ts
var NOTHING = Symbol.for("immer-nothing");
var DRAFTABLE = Symbol.for("immer-draftable");
var DRAFT_STATE = Symbol.for("immer-state");

// src/utils/errors.ts
var errors =  false ? 0 : [];
function die(error, ...args) {
  if (false) {}
  throw new Error(
    `[Immer] minified error nr: ${error}. Full error at: https://bit.ly/3cXEKWf`
  );
}

// src/utils/common.ts
var getPrototypeOf = Object.getPrototypeOf;
function immer_isDraft(value) {
  return !!value && !!value[DRAFT_STATE];
}
function isDraftable(value) {
  if (!value)
    return false;
  return immer_isPlainObject(value) || Array.isArray(value) || !!value[DRAFTABLE] || !!value.constructor?.[DRAFTABLE] || isMap(value) || isSet(value);
}
var objectCtorString = Object.prototype.constructor.toString();
function immer_isPlainObject(value) {
  if (!value || typeof value !== "object")
    return false;
  const proto = getPrototypeOf(value);
  if (proto === null) {
    return true;
  }
  const Ctor = Object.hasOwnProperty.call(proto, "constructor") && proto.constructor;
  if (Ctor === Object)
    return true;
  return typeof Ctor == "function" && Function.toString.call(Ctor) === objectCtorString;
}
function original(value) {
  if (!immer_isDraft(value))
    die(15, value);
  return value[DRAFT_STATE].base_;
}
function each(obj, iter) {
  if (getArchtype(obj) === 0 /* Object */) {
    Reflect.ownKeys(obj).forEach((key) => {
      iter(key, obj[key], obj);
    });
  } else {
    obj.forEach((entry, index) => iter(index, entry, obj));
  }
}
function getArchtype(thing) {
  const state = thing[DRAFT_STATE];
  return state ? state.type_ : Array.isArray(thing) ? 1 /* Array */ : isMap(thing) ? 2 /* Map */ : isSet(thing) ? 3 /* Set */ : 0 /* Object */;
}
function has(thing, prop) {
  return getArchtype(thing) === 2 /* Map */ ? thing.has(prop) : Object.prototype.hasOwnProperty.call(thing, prop);
}
function get(thing, prop) {
  return getArchtype(thing) === 2 /* Map */ ? thing.get(prop) : thing[prop];
}
function set(thing, propOrOldValue, value) {
  const t = getArchtype(thing);
  if (t === 2 /* Map */)
    thing.set(propOrOldValue, value);
  else if (t === 3 /* Set */) {
    thing.add(value);
  } else
    thing[propOrOldValue] = value;
}
function is(x, y) {
  if (x === y) {
    return x !== 0 || 1 / x === 1 / y;
  } else {
    return x !== x && y !== y;
  }
}
function isMap(target) {
  return target instanceof Map;
}
function isSet(target) {
  return target instanceof Set;
}
function latest(state) {
  return state.copy_ || state.base_;
}
function shallowCopy(base, strict) {
  if (isMap(base)) {
    return new Map(base);
  }
  if (isSet(base)) {
    return new Set(base);
  }
  if (Array.isArray(base))
    return Array.prototype.slice.call(base);
  const isPlain = immer_isPlainObject(base);
  if (strict === true || strict === "class_only" && !isPlain) {
    const descriptors = Object.getOwnPropertyDescriptors(base);
    delete descriptors[DRAFT_STATE];
    let keys = Reflect.ownKeys(descriptors);
    for (let i = 0; i < keys.length; i++) {
      const key = keys[i];
      const desc = descriptors[key];
      if (desc.writable === false) {
        desc.writable = true;
        desc.configurable = true;
      }
      if (desc.get || desc.set)
        descriptors[key] = {
          configurable: true,
          writable: true,
          // could live with !!desc.set as well here...
          enumerable: desc.enumerable,
          value: base[key]
        };
    }
    return Object.create(getPrototypeOf(base), descriptors);
  } else {
    const proto = getPrototypeOf(base);
    if (proto !== null && isPlain) {
      return { ...base };
    }
    const obj = Object.create(proto);
    return Object.assign(obj, base);
  }
}
function freeze(obj, deep = false) {
  if (isFrozen(obj) || immer_isDraft(obj) || !isDraftable(obj))
    return obj;
  if (getArchtype(obj) > 1) {
    obj.set = obj.add = obj.clear = obj.delete = dontMutateFrozenCollections;
  }
  Object.freeze(obj);
  if (deep)
    Object.entries(obj).forEach(([key, value]) => freeze(value, true));
  return obj;
}
function dontMutateFrozenCollections() {
  die(2);
}
function isFrozen(obj) {
  return Object.isFrozen(obj);
}

// src/utils/plugins.ts
var plugins = {};
function getPlugin(pluginKey) {
  const plugin = plugins[pluginKey];
  if (!plugin) {
    die(0, pluginKey);
  }
  return plugin;
}
function loadPlugin(pluginKey, implementation) {
  if (!plugins[pluginKey])
    plugins[pluginKey] = implementation;
}

// src/core/scope.ts
var currentScope;
function getCurrentScope() {
  return currentScope;
}
function createScope(parent_, immer_) {
  return {
    drafts_: [],
    parent_,
    immer_,
    // Whenever the modified draft contains a draft from another scope, we
    // need to prevent auto-freezing so the unowned draft can be finalized.
    canAutoFreeze_: true,
    unfinalizedDrafts_: 0
  };
}
function usePatchesInScope(scope, patchListener) {
  if (patchListener) {
    getPlugin("Patches");
    scope.patches_ = [];
    scope.inversePatches_ = [];
    scope.patchListener_ = patchListener;
  }
}
function revokeScope(scope) {
  leaveScope(scope);
  scope.drafts_.forEach(revokeDraft);
  scope.drafts_ = null;
}
function leaveScope(scope) {
  if (scope === currentScope) {
    currentScope = scope.parent_;
  }
}
function enterScope(immer2) {
  return currentScope = createScope(currentScope, immer2);
}
function revokeDraft(draft) {
  const state = draft[DRAFT_STATE];
  if (state.type_ === 0 /* Object */ || state.type_ === 1 /* Array */)
    state.revoke_();
  else
    state.revoked_ = true;
}

// src/core/finalize.ts
function processResult(result, scope) {
  scope.unfinalizedDrafts_ = scope.drafts_.length;
  const baseDraft = scope.drafts_[0];
  const isReplaced = result !== void 0 && result !== baseDraft;
  if (isReplaced) {
    if (baseDraft[DRAFT_STATE].modified_) {
      revokeScope(scope);
      die(4);
    }
    if (isDraftable(result)) {
      result = finalize(scope, result);
      if (!scope.parent_)
        maybeFreeze(scope, result);
    }
    if (scope.patches_) {
      getPlugin("Patches").generateReplacementPatches_(
        baseDraft[DRAFT_STATE].base_,
        result,
        scope.patches_,
        scope.inversePatches_
      );
    }
  } else {
    result = finalize(scope, baseDraft, []);
  }
  revokeScope(scope);
  if (scope.patches_) {
    scope.patchListener_(scope.patches_, scope.inversePatches_);
  }
  return result !== NOTHING ? result : void 0;
}
function finalize(rootScope, value, path) {
  if (isFrozen(value))
    return value;
  const state = value[DRAFT_STATE];
  if (!state) {
    each(
      value,
      (key, childValue) => finalizeProperty(rootScope, state, value, key, childValue, path)
    );
    return value;
  }
  if (state.scope_ !== rootScope)
    return value;
  if (!state.modified_) {
    maybeFreeze(rootScope, state.base_, true);
    return state.base_;
  }
  if (!state.finalized_) {
    state.finalized_ = true;
    state.scope_.unfinalizedDrafts_--;
    const result = state.copy_;
    let resultEach = result;
    let isSet2 = false;
    if (state.type_ === 3 /* Set */) {
      resultEach = new Set(result);
      result.clear();
      isSet2 = true;
    }
    each(
      resultEach,
      (key, childValue) => finalizeProperty(rootScope, state, result, key, childValue, path, isSet2)
    );
    maybeFreeze(rootScope, result, false);
    if (path && rootScope.patches_) {
      getPlugin("Patches").generatePatches_(
        state,
        path,
        rootScope.patches_,
        rootScope.inversePatches_
      );
    }
  }
  return state.copy_;
}
function finalizeProperty(rootScope, parentState, targetObject, prop, childValue, rootPath, targetIsSet) {
  if (false)
    {}
  if (immer_isDraft(childValue)) {
    const path = rootPath && parentState && parentState.type_ !== 3 /* Set */ && // Set objects are atomic since they have no keys.
    !has(parentState.assigned_, prop) ? rootPath.concat(prop) : void 0;
    const res = finalize(rootScope, childValue, path);
    set(targetObject, prop, res);
    if (immer_isDraft(res)) {
      rootScope.canAutoFreeze_ = false;
    } else
      return;
  } else if (targetIsSet) {
    targetObject.add(childValue);
  }
  if (isDraftable(childValue) && !isFrozen(childValue)) {
    if (!rootScope.immer_.autoFreeze_ && rootScope.unfinalizedDrafts_ < 1) {
      return;
    }
    finalize(rootScope, childValue);
    if ((!parentState || !parentState.scope_.parent_) && typeof prop !== "symbol" && Object.prototype.propertyIsEnumerable.call(targetObject, prop))
      maybeFreeze(rootScope, childValue);
  }
}
function maybeFreeze(scope, value, deep = false) {
  if (!scope.parent_ && scope.immer_.autoFreeze_ && scope.canAutoFreeze_) {
    freeze(value, deep);
  }
}

// src/core/proxy.ts
function createProxyProxy(base, parent) {
  const isArray = Array.isArray(base);
  const state = {
    type_: isArray ? 1 /* Array */ : 0 /* Object */,
    // Track which produce call this is associated with.
    scope_: parent ? parent.scope_ : getCurrentScope(),
    // True for both shallow and deep changes.
    modified_: false,
    // Used during finalization.
    finalized_: false,
    // Track which properties have been assigned (true) or deleted (false).
    assigned_: {},
    // The parent draft state.
    parent_: parent,
    // The base state.
    base_: base,
    // The base proxy.
    draft_: null,
    // set below
    // The base copy with any updated values.
    copy_: null,
    // Called by the `produce` function.
    revoke_: null,
    isManual_: false
  };
  let target = state;
  let traps = objectTraps;
  if (isArray) {
    target = [state];
    traps = arrayTraps;
  }
  const { revoke, proxy } = Proxy.revocable(target, traps);
  state.draft_ = proxy;
  state.revoke_ = revoke;
  return proxy;
}
var objectTraps = {
  get(state, prop) {
    if (prop === DRAFT_STATE)
      return state;
    const source = latest(state);
    if (!has(source, prop)) {
      return readPropFromProto(state, source, prop);
    }
    const value = source[prop];
    if (state.finalized_ || !isDraftable(value)) {
      return value;
    }
    if (value === peek(state.base_, prop)) {
      prepareCopy(state);
      return state.copy_[prop] = createProxy(value, state);
    }
    return value;
  },
  has(state, prop) {
    return prop in latest(state);
  },
  ownKeys(state) {
    return Reflect.ownKeys(latest(state));
  },
  set(state, prop, value) {
    const desc = getDescriptorFromProto(latest(state), prop);
    if (desc?.set) {
      desc.set.call(state.draft_, value);
      return true;
    }
    if (!state.modified_) {
      const current2 = peek(latest(state), prop);
      const currentState = current2?.[DRAFT_STATE];
      if (currentState && currentState.base_ === value) {
        state.copy_[prop] = value;
        state.assigned_[prop] = false;
        return true;
      }
      if (is(value, current2) && (value !== void 0 || has(state.base_, prop)))
        return true;
      prepareCopy(state);
      markChanged(state);
    }
    if (state.copy_[prop] === value && // special case: handle new props with value 'undefined'
    (value !== void 0 || prop in state.copy_) || // special case: NaN
    Number.isNaN(value) && Number.isNaN(state.copy_[prop]))
      return true;
    state.copy_[prop] = value;
    state.assigned_[prop] = true;
    return true;
  },
  deleteProperty(state, prop) {
    if (peek(state.base_, prop) !== void 0 || prop in state.base_) {
      state.assigned_[prop] = false;
      prepareCopy(state);
      markChanged(state);
    } else {
      delete state.assigned_[prop];
    }
    if (state.copy_) {
      delete state.copy_[prop];
    }
    return true;
  },
  // Note: We never coerce `desc.value` into an Immer draft, because we can't make
  // the same guarantee in ES5 mode.
  getOwnPropertyDescriptor(state, prop) {
    const owner = latest(state);
    const desc = Reflect.getOwnPropertyDescriptor(owner, prop);
    if (!desc)
      return desc;
    return {
      writable: true,
      configurable: state.type_ !== 1 /* Array */ || prop !== "length",
      enumerable: desc.enumerable,
      value: owner[prop]
    };
  },
  defineProperty() {
    die(11);
  },
  getPrototypeOf(state) {
    return getPrototypeOf(state.base_);
  },
  setPrototypeOf() {
    die(12);
  }
};
var arrayTraps = {};
each(objectTraps, (key, fn) => {
  arrayTraps[key] = function() {
    arguments[0] = arguments[0][0];
    return fn.apply(this, arguments);
  };
});
arrayTraps.deleteProperty = function(state, prop) {
  if (false)
    {}
  return arrayTraps.set.call(this, state, prop, void 0);
};
arrayTraps.set = function(state, prop, value) {
  if (false)
    {}
  return objectTraps.set.call(this, state[0], prop, value, state[0]);
};
function peek(draft, prop) {
  const state = draft[DRAFT_STATE];
  const source = state ? latest(state) : draft;
  return source[prop];
}
function readPropFromProto(state, source, prop) {
  const desc = getDescriptorFromProto(source, prop);
  return desc ? `value` in desc ? desc.value : (
    // This is a very special case, if the prop is a getter defined by the
    // prototype, we should invoke it with the draft as context!
    desc.get?.call(state.draft_)
  ) : void 0;
}
function getDescriptorFromProto(source, prop) {
  if (!(prop in source))
    return void 0;
  let proto = getPrototypeOf(source);
  while (proto) {
    const desc = Object.getOwnPropertyDescriptor(proto, prop);
    if (desc)
      return desc;
    proto = getPrototypeOf(proto);
  }
  return void 0;
}
function markChanged(state) {
  if (!state.modified_) {
    state.modified_ = true;
    if (state.parent_) {
      markChanged(state.parent_);
    }
  }
}
function prepareCopy(state) {
  if (!state.copy_) {
    state.copy_ = shallowCopy(
      state.base_,
      state.scope_.immer_.useStrictShallowCopy_
    );
  }
}

// src/core/immerClass.ts
var Immer2 = class {
  constructor(config) {
    this.autoFreeze_ = true;
    this.useStrictShallowCopy_ = false;
    /**
     * The `produce` function takes a value and a "recipe function" (whose
     * return value often depends on the base state). The recipe function is
     * free to mutate its first argument however it wants. All mutations are
     * only ever applied to a __copy__ of the base state.
     *
     * Pass only a function to create a "curried producer" which relieves you
     * from passing the recipe function every time.
     *
     * Only plain objects and arrays are made mutable. All other objects are
     * considered uncopyable.
     *
     * Note: This function is __bound__ to its `Immer` instance.
     *
     * @param {any} base - the initial state
     * @param {Function} recipe - function that receives a proxy of the base state as first argument and which can be freely modified
     * @param {Function} patchListener - optional function that will be called with all the patches produced here
     * @returns {any} a new state, or the initial state if nothing was modified
     */
    this.produce = (base, recipe, patchListener) => {
      if (typeof base === "function" && typeof recipe !== "function") {
        const defaultBase = recipe;
        recipe = base;
        const self = this;
        return function curriedProduce(base2 = defaultBase, ...args) {
          return self.produce(base2, (draft) => recipe.call(this, draft, ...args));
        };
      }
      if (typeof recipe !== "function")
        die(6);
      if (patchListener !== void 0 && typeof patchListener !== "function")
        die(7);
      let result;
      if (isDraftable(base)) {
        const scope = enterScope(this);
        const proxy = createProxy(base, void 0);
        let hasError = true;
        try {
          result = recipe(proxy);
          hasError = false;
        } finally {
          if (hasError)
            revokeScope(scope);
          else
            leaveScope(scope);
        }
        usePatchesInScope(scope, patchListener);
        return processResult(result, scope);
      } else if (!base || typeof base !== "object") {
        result = recipe(base);
        if (result === void 0)
          result = base;
        if (result === NOTHING)
          result = void 0;
        if (this.autoFreeze_)
          freeze(result, true);
        if (patchListener) {
          const p = [];
          const ip = [];
          getPlugin("Patches").generateReplacementPatches_(base, result, p, ip);
          patchListener(p, ip);
        }
        return result;
      } else
        die(1, base);
    };
    this.produceWithPatches = (base, recipe) => {
      if (typeof base === "function") {
        return (state, ...args) => this.produceWithPatches(state, (draft) => base(draft, ...args));
      }
      let patches, inversePatches;
      const result = this.produce(base, recipe, (p, ip) => {
        patches = p;
        inversePatches = ip;
      });
      return [result, patches, inversePatches];
    };
    if (typeof config?.autoFreeze === "boolean")
      this.setAutoFreeze(config.autoFreeze);
    if (typeof config?.useStrictShallowCopy === "boolean")
      this.setUseStrictShallowCopy(config.useStrictShallowCopy);
  }
  createDraft(base) {
    if (!isDraftable(base))
      die(8);
    if (immer_isDraft(base))
      base = immer_current(base);
    const scope = enterScope(this);
    const proxy = createProxy(base, void 0);
    proxy[DRAFT_STATE].isManual_ = true;
    leaveScope(scope);
    return proxy;
  }
  finishDraft(draft, patchListener) {
    const state = draft && draft[DRAFT_STATE];
    if (!state || !state.isManual_)
      die(9);
    const { scope_: scope } = state;
    usePatchesInScope(scope, patchListener);
    return processResult(void 0, scope);
  }
  /**
   * Pass true to automatically freeze all copies created by Immer.
   *
   * By default, auto-freezing is enabled.
   */
  setAutoFreeze(value) {
    this.autoFreeze_ = value;
  }
  /**
   * Pass true to enable strict shallow copy.
   *
   * By default, immer does not copy the object descriptors such as getter, setter and non-enumrable properties.
   */
  setUseStrictShallowCopy(value) {
    this.useStrictShallowCopy_ = value;
  }
  applyPatches(base, patches) {
    let i;
    for (i = patches.length - 1; i >= 0; i--) {
      const patch = patches[i];
      if (patch.path.length === 0 && patch.op === "replace") {
        base = patch.value;
        break;
      }
    }
    if (i > -1) {
      patches = patches.slice(i + 1);
    }
    const applyPatchesImpl = getPlugin("Patches").applyPatches_;
    if (immer_isDraft(base)) {
      return applyPatchesImpl(base, patches);
    }
    return this.produce(
      base,
      (draft) => applyPatchesImpl(draft, patches)
    );
  }
};
function createProxy(value, parent) {
  const draft = isMap(value) ? getPlugin("MapSet").proxyMap_(value, parent) : isSet(value) ? getPlugin("MapSet").proxySet_(value, parent) : createProxyProxy(value, parent);
  const scope = parent ? parent.scope_ : getCurrentScope();
  scope.drafts_.push(draft);
  return draft;
}

// src/core/current.ts
function immer_current(value) {
  if (!immer_isDraft(value))
    die(10, value);
  return currentImpl(value);
}
function currentImpl(value) {
  if (!isDraftable(value) || isFrozen(value))
    return value;
  const state = value[DRAFT_STATE];
  let copy;
  if (state) {
    if (!state.modified_)
      return state.base_;
    state.finalized_ = true;
    copy = shallowCopy(value, state.scope_.immer_.useStrictShallowCopy_);
  } else {
    copy = shallowCopy(value, true);
  }
  each(copy, (key, childValue) => {
    set(copy, key, currentImpl(childValue));
  });
  if (state) {
    state.finalized_ = false;
  }
  return copy;
}

// src/plugins/patches.ts
function enablePatches() {
  const errorOffset = 16;
  if (false) {}
  const REPLACE = "replace";
  const ADD = "add";
  const REMOVE = "remove";
  function generatePatches_(state, basePath, patches, inversePatches) {
    switch (state.type_) {
      case 0 /* Object */:
      case 2 /* Map */:
        return generatePatchesFromAssigned(
          state,
          basePath,
          patches,
          inversePatches
        );
      case 1 /* Array */:
        return generateArrayPatches(state, basePath, patches, inversePatches);
      case 3 /* Set */:
        return generateSetPatches(
          state,
          basePath,
          patches,
          inversePatches
        );
    }
  }
  function generateArrayPatches(state, basePath, patches, inversePatches) {
    let { base_, assigned_ } = state;
    let copy_ = state.copy_;
    if (copy_.length < base_.length) {
      ;
      [base_, copy_] = [copy_, base_];
      [patches, inversePatches] = [inversePatches, patches];
    }
    for (let i = 0; i < base_.length; i++) {
      if (assigned_[i] && copy_[i] !== base_[i]) {
        const path = basePath.concat([i]);
        patches.push({
          op: REPLACE,
          path,
          // Need to maybe clone it, as it can in fact be the original value
          // due to the base/copy inversion at the start of this function
          value: clonePatchValueIfNeeded(copy_[i])
        });
        inversePatches.push({
          op: REPLACE,
          path,
          value: clonePatchValueIfNeeded(base_[i])
        });
      }
    }
    for (let i = base_.length; i < copy_.length; i++) {
      const path = basePath.concat([i]);
      patches.push({
        op: ADD,
        path,
        // Need to maybe clone it, as it can in fact be the original value
        // due to the base/copy inversion at the start of this function
        value: clonePatchValueIfNeeded(copy_[i])
      });
    }
    for (let i = copy_.length - 1; base_.length <= i; --i) {
      const path = basePath.concat([i]);
      inversePatches.push({
        op: REMOVE,
        path
      });
    }
  }
  function generatePatchesFromAssigned(state, basePath, patches, inversePatches) {
    const { base_, copy_ } = state;
    each(state.assigned_, (key, assignedValue) => {
      const origValue = get(base_, key);
      const value = get(copy_, key);
      const op = !assignedValue ? REMOVE : has(base_, key) ? REPLACE : ADD;
      if (origValue === value && op === REPLACE)
        return;
      const path = basePath.concat(key);
      patches.push(op === REMOVE ? { op, path } : { op, path, value });
      inversePatches.push(
        op === ADD ? { op: REMOVE, path } : op === REMOVE ? { op: ADD, path, value: clonePatchValueIfNeeded(origValue) } : { op: REPLACE, path, value: clonePatchValueIfNeeded(origValue) }
      );
    });
  }
  function generateSetPatches(state, basePath, patches, inversePatches) {
    let { base_, copy_ } = state;
    let i = 0;
    base_.forEach((value) => {
      if (!copy_.has(value)) {
        const path = basePath.concat([i]);
        patches.push({
          op: REMOVE,
          path,
          value
        });
        inversePatches.unshift({
          op: ADD,
          path,
          value
        });
      }
      i++;
    });
    i = 0;
    copy_.forEach((value) => {
      if (!base_.has(value)) {
        const path = basePath.concat([i]);
        patches.push({
          op: ADD,
          path,
          value
        });
        inversePatches.unshift({
          op: REMOVE,
          path,
          value
        });
      }
      i++;
    });
  }
  function generateReplacementPatches_(baseValue, replacement, patches, inversePatches) {
    patches.push({
      op: REPLACE,
      path: [],
      value: replacement === NOTHING ? void 0 : replacement
    });
    inversePatches.push({
      op: REPLACE,
      path: [],
      value: baseValue
    });
  }
  function applyPatches_(draft, patches) {
    patches.forEach((patch) => {
      const { path, op } = patch;
      let base = draft;
      for (let i = 0; i < path.length - 1; i++) {
        const parentType = getArchtype(base);
        let p = path[i];
        if (typeof p !== "string" && typeof p !== "number") {
          p = "" + p;
        }
        if ((parentType === 0 /* Object */ || parentType === 1 /* Array */) && (p === "__proto__" || p === "constructor"))
          die(errorOffset + 3);
        if (typeof base === "function" && p === "prototype")
          die(errorOffset + 3);
        base = get(base, p);
        if (typeof base !== "object")
          die(errorOffset + 2, path.join("/"));
      }
      const type = getArchtype(base);
      const value = deepClonePatchValue(patch.value);
      const key = path[path.length - 1];
      switch (op) {
        case REPLACE:
          switch (type) {
            case 2 /* Map */:
              return base.set(key, value);
            case 3 /* Set */:
              die(errorOffset);
            default:
              return base[key] = value;
          }
        case ADD:
          switch (type) {
            case 1 /* Array */:
              return key === "-" ? base.push(value) : base.splice(key, 0, value);
            case 2 /* Map */:
              return base.set(key, value);
            case 3 /* Set */:
              return base.add(value);
            default:
              return base[key] = value;
          }
        case REMOVE:
          switch (type) {
            case 1 /* Array */:
              return base.splice(key, 1);
            case 2 /* Map */:
              return base.delete(key);
            case 3 /* Set */:
              return base.delete(patch.value);
            default:
              return delete base[key];
          }
        default:
          die(errorOffset + 1, op);
      }
    });
    return draft;
  }
  function deepClonePatchValue(obj) {
    if (!isDraftable(obj))
      return obj;
    if (Array.isArray(obj))
      return obj.map(deepClonePatchValue);
    if (isMap(obj))
      return new Map(
        Array.from(obj.entries()).map(([k, v]) => [k, deepClonePatchValue(v)])
      );
    if (isSet(obj))
      return new Set(Array.from(obj).map(deepClonePatchValue));
    const cloned = Object.create(getPrototypeOf(obj));
    for (const key in obj)
      cloned[key] = deepClonePatchValue(obj[key]);
    if (has(obj, DRAFTABLE))
      cloned[DRAFTABLE] = obj[DRAFTABLE];
    return cloned;
  }
  function clonePatchValueIfNeeded(obj) {
    if (immer_isDraft(obj)) {
      return deepClonePatchValue(obj);
    } else
      return obj;
  }
  loadPlugin("Patches", {
    applyPatches_,
    generatePatches_,
    generateReplacementPatches_
  });
}

// src/plugins/mapset.ts
function enableMapSet() {
  class DraftMap extends Map {
    constructor(target, parent) {
      super();
      this[DRAFT_STATE] = {
        type_: 2 /* Map */,
        parent_: parent,
        scope_: parent ? parent.scope_ : getCurrentScope(),
        modified_: false,
        finalized_: false,
        copy_: void 0,
        assigned_: void 0,
        base_: target,
        draft_: this,
        isManual_: false,
        revoked_: false
      };
    }
    get size() {
      return latest(this[DRAFT_STATE]).size;
    }
    has(key) {
      return latest(this[DRAFT_STATE]).has(key);
    }
    set(key, value) {
      const state = this[DRAFT_STATE];
      assertUnrevoked(state);
      if (!latest(state).has(key) || latest(state).get(key) !== value) {
        prepareMapCopy(state);
        markChanged(state);
        state.assigned_.set(key, true);
        state.copy_.set(key, value);
        state.assigned_.set(key, true);
      }
      return this;
    }
    delete(key) {
      if (!this.has(key)) {
        return false;
      }
      const state = this[DRAFT_STATE];
      assertUnrevoked(state);
      prepareMapCopy(state);
      markChanged(state);
      if (state.base_.has(key)) {
        state.assigned_.set(key, false);
      } else {
        state.assigned_.delete(key);
      }
      state.copy_.delete(key);
      return true;
    }
    clear() {
      const state = this[DRAFT_STATE];
      assertUnrevoked(state);
      if (latest(state).size) {
        prepareMapCopy(state);
        markChanged(state);
        state.assigned_ = /* @__PURE__ */ new Map();
        each(state.base_, (key) => {
          state.assigned_.set(key, false);
        });
        state.copy_.clear();
      }
    }
    forEach(cb, thisArg) {
      const state = this[DRAFT_STATE];
      latest(state).forEach((_value, key, _map) => {
        cb.call(thisArg, this.get(key), key, this);
      });
    }
    get(key) {
      const state = this[DRAFT_STATE];
      assertUnrevoked(state);
      const value = latest(state).get(key);
      if (state.finalized_ || !isDraftable(value)) {
        return value;
      }
      if (value !== state.base_.get(key)) {
        return value;
      }
      const draft = createProxy(value, state);
      prepareMapCopy(state);
      state.copy_.set(key, draft);
      return draft;
    }
    keys() {
      return latest(this[DRAFT_STATE]).keys();
    }
    values() {
      const iterator = this.keys();
      return {
        [Symbol.iterator]: () => this.values(),
        next: () => {
          const r = iterator.next();
          if (r.done)
            return r;
          const value = this.get(r.value);
          return {
            done: false,
            value
          };
        }
      };
    }
    entries() {
      const iterator = this.keys();
      return {
        [Symbol.iterator]: () => this.entries(),
        next: () => {
          const r = iterator.next();
          if (r.done)
            return r;
          const value = this.get(r.value);
          return {
            done: false,
            value: [r.value, value]
          };
        }
      };
    }
    [(DRAFT_STATE, Symbol.iterator)]() {
      return this.entries();
    }
  }
  function proxyMap_(target, parent) {
    return new DraftMap(target, parent);
  }
  function prepareMapCopy(state) {
    if (!state.copy_) {
      state.assigned_ = /* @__PURE__ */ new Map();
      state.copy_ = new Map(state.base_);
    }
  }
  class DraftSet extends Set {
    constructor(target, parent) {
      super();
      this[DRAFT_STATE] = {
        type_: 3 /* Set */,
        parent_: parent,
        scope_: parent ? parent.scope_ : getCurrentScope(),
        modified_: false,
        finalized_: false,
        copy_: void 0,
        base_: target,
        draft_: this,
        drafts_: /* @__PURE__ */ new Map(),
        revoked_: false,
        isManual_: false
      };
    }
    get size() {
      return latest(this[DRAFT_STATE]).size;
    }
    has(value) {
      const state = this[DRAFT_STATE];
      assertUnrevoked(state);
      if (!state.copy_) {
        return state.base_.has(value);
      }
      if (state.copy_.has(value))
        return true;
      if (state.drafts_.has(value) && state.copy_.has(state.drafts_.get(value)))
        return true;
      return false;
    }
    add(value) {
      const state = this[DRAFT_STATE];
      assertUnrevoked(state);
      if (!this.has(value)) {
        prepareSetCopy(state);
        markChanged(state);
        state.copy_.add(value);
      }
      return this;
    }
    delete(value) {
      if (!this.has(value)) {
        return false;
      }
      const state = this[DRAFT_STATE];
      assertUnrevoked(state);
      prepareSetCopy(state);
      markChanged(state);
      return state.copy_.delete(value) || (state.drafts_.has(value) ? state.copy_.delete(state.drafts_.get(value)) : (
        /* istanbul ignore next */
        false
      ));
    }
    clear() {
      const state = this[DRAFT_STATE];
      assertUnrevoked(state);
      if (latest(state).size) {
        prepareSetCopy(state);
        markChanged(state);
        state.copy_.clear();
      }
    }
    values() {
      const state = this[DRAFT_STATE];
      assertUnrevoked(state);
      prepareSetCopy(state);
      return state.copy_.values();
    }
    entries() {
      const state = this[DRAFT_STATE];
      assertUnrevoked(state);
      prepareSetCopy(state);
      return state.copy_.entries();
    }
    keys() {
      return this.values();
    }
    [(DRAFT_STATE, Symbol.iterator)]() {
      return this.values();
    }
    forEach(cb, thisArg) {
      const iterator = this.values();
      let result = iterator.next();
      while (!result.done) {
        cb.call(thisArg, result.value, result.value, this);
        result = iterator.next();
      }
    }
  }
  function proxySet_(target, parent) {
    return new DraftSet(target, parent);
  }
  function prepareSetCopy(state) {
    if (!state.copy_) {
      state.copy_ = /* @__PURE__ */ new Set();
      state.base_.forEach((value) => {
        if (isDraftable(value)) {
          const draft = createProxy(value, state);
          state.drafts_.set(value, draft);
          state.copy_.add(draft);
        } else {
          state.copy_.add(value);
        }
      });
    }
  }
  function assertUnrevoked(state) {
    if (state.revoked_)
      die(3, JSON.stringify(latest(state)));
  }
  loadPlugin("MapSet", { proxyMap_, proxySet_ });
}

// src/immer.ts
var immer = new Immer2();
var produce = immer.produce;
var produceWithPatches = immer.produceWithPatches.bind(
  immer
);
var setAutoFreeze = immer.setAutoFreeze.bind(immer);
var setUseStrictShallowCopy = immer.setUseStrictShallowCopy.bind(immer);
var applyPatches = immer.applyPatches.bind(immer);
var createDraft = immer.createDraft.bind(immer);
var finishDraft = immer.finishDraft.bind(immer);
function castDraft(value) {
  return value;
}
function castImmutable(value) {
  return value;
}

//# sourceMappingURL=immer.mjs.map
;// ./node_modules/@reduxjs/toolkit/dist/redux-toolkit.modern.mjs
// src/index.ts




// src/createDraftSafeSelector.ts


var createDraftSafeSelectorCreator = (...args) => {
  const createSelector2 = createSelectorCreator(...args);
  const createDraftSafeSelector2 = Object.assign((...args2) => {
    const selector = createSelector2(...args2);
    const wrappedSelector = (value, ...rest) => selector(isDraft(value) ? current(value) : value, ...rest);
    Object.assign(wrappedSelector, selector);
    return wrappedSelector;
  }, {
    withTypes: () => createDraftSafeSelector2
  });
  return createDraftSafeSelector2;
};
var createDraftSafeSelector = /* @__PURE__ */ (/* unused pure expression or super */ null && (createDraftSafeSelectorCreator(weakMapMemoize)));

// src/configureStore.ts


// src/devtoolsExtension.ts

var composeWithDevTools = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : function() {
  if (arguments.length === 0) return void 0;
  if (typeof arguments[0] === "object") return compose;
  return compose.apply(null, arguments);
};
var devToolsEnhancer = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__ : function() {
  return function(noop3) {
    return noop3;
  };
};

// src/getDefaultMiddleware.ts


// src/createAction.ts


// src/tsHelpers.ts
var hasMatchFunction = (v) => {
  return v && typeof v.match === "function";
};

// src/createAction.ts
function createAction(type, prepareAction) {
  function actionCreator(...args) {
    if (prepareAction) {
      let prepared = prepareAction(...args);
      if (!prepared) {
        throw new Error( true ? redux_toolkit_modern_formatProdErrorMessage(0) : 0);
      }
      return {
        type,
        payload: prepared.payload,
        ..."meta" in prepared && {
          meta: prepared.meta
        },
        ..."error" in prepared && {
          error: prepared.error
        }
      };
    }
    return {
      type,
      payload: args[0]
    };
  }
  actionCreator.toString = () => `${type}`;
  actionCreator.type = type;
  actionCreator.match = (action) => redux_isAction(action) && action.type === type;
  return actionCreator;
}
function isActionCreator(action) {
  return typeof action === "function" && "type" in action && // hasMatchFunction only wants Matchers but I don't see the point in rewriting it
  hasMatchFunction(action);
}
function isFSA(action) {
  return isAction(action) && Object.keys(action).every(isValidKey);
}
function isValidKey(key) {
  return ["type", "payload", "error", "meta"].indexOf(key) > -1;
}

// src/actionCreatorInvariantMiddleware.ts
function getMessage(type) {
  const splitType = type ? `${type}`.split("/") : [];
  const actionName = splitType[splitType.length - 1] || "actionCreator";
  return `Detected an action creator with type "${type || "unknown"}" being dispatched. 
Make sure you're calling the action creator before dispatching, i.e. \`dispatch(${actionName}())\` instead of \`dispatch(${actionName})\`. This is necessary even if the action has no payload.`;
}
function createActionCreatorInvariantMiddleware(options = {}) {
  if (true) {
    return () => (next) => (action) => next(action);
  }
  const {
    isActionCreator: isActionCreator2 = isActionCreator
  } = options;
  return () => (next) => (action) => {
    if (isActionCreator2(action)) {
      console.warn(getMessage(action.type));
    }
    return next(action);
  };
}

// src/utils.ts

function getTimeMeasureUtils(maxDelay, fnName) {
  let elapsed = 0;
  return {
    measureTime(fn) {
      const started = Date.now();
      try {
        return fn();
      } finally {
        const finished = Date.now();
        elapsed += finished - started;
      }
    },
    warnIfExceeded() {
      if (elapsed > maxDelay) {
        console.warn(`${fnName} took ${elapsed}ms, which is more than the warning threshold of ${maxDelay}ms. 
If your state or actions are very large, you may want to disable the middleware as it might cause too much of a slowdown in development mode. See https://redux-toolkit.js.org/api/getDefaultMiddleware for instructions.
It is disabled in production builds, so you don't need to worry about that.`);
      }
    }
  };
}
var Tuple = class _Tuple extends Array {
  constructor(...items) {
    super(...items);
    Object.setPrototypeOf(this, _Tuple.prototype);
  }
  static get [Symbol.species]() {
    return _Tuple;
  }
  concat(...arr) {
    return super.concat.apply(this, arr);
  }
  prepend(...arr) {
    if (arr.length === 1 && Array.isArray(arr[0])) {
      return new _Tuple(...arr[0].concat(this));
    }
    return new _Tuple(...arr.concat(this));
  }
};
function freezeDraftable(val) {
  return isDraftable(val) ? produce(val, () => {
  }) : val;
}
function getOrInsertComputed(map, key, compute) {
  if (map.has(key)) return map.get(key);
  return map.set(key, compute(key)).get(key);
}

// src/immutableStateInvariantMiddleware.ts
function isImmutableDefault(value) {
  return typeof value !== "object" || value == null || Object.isFrozen(value);
}
function trackForMutations(isImmutable, ignorePaths, obj) {
  const trackedProperties = trackProperties(isImmutable, ignorePaths, obj);
  return {
    detectMutations() {
      return detectMutations(isImmutable, ignorePaths, trackedProperties, obj);
    }
  };
}
function trackProperties(isImmutable, ignorePaths = [], obj, path = "", checkedObjects = /* @__PURE__ */ new Set()) {
  const tracked = {
    value: obj
  };
  if (!isImmutable(obj) && !checkedObjects.has(obj)) {
    checkedObjects.add(obj);
    tracked.children = {};
    for (const key in obj) {
      const childPath = path ? path + "." + key : key;
      if (ignorePaths.length && ignorePaths.indexOf(childPath) !== -1) {
        continue;
      }
      tracked.children[key] = trackProperties(isImmutable, ignorePaths, obj[key], childPath);
    }
  }
  return tracked;
}
function detectMutations(isImmutable, ignoredPaths = [], trackedProperty, obj, sameParentRef = false, path = "") {
  const prevObj = trackedProperty ? trackedProperty.value : void 0;
  const sameRef = prevObj === obj;
  if (sameParentRef && !sameRef && !Number.isNaN(obj)) {
    return {
      wasMutated: true,
      path
    };
  }
  if (isImmutable(prevObj) || isImmutable(obj)) {
    return {
      wasMutated: false
    };
  }
  const keysToDetect = {};
  for (let key in trackedProperty.children) {
    keysToDetect[key] = true;
  }
  for (let key in obj) {
    keysToDetect[key] = true;
  }
  const hasIgnoredPaths = ignoredPaths.length > 0;
  for (let key in keysToDetect) {
    const nestedPath = path ? path + "." + key : key;
    if (hasIgnoredPaths) {
      const hasMatches = ignoredPaths.some((ignored) => {
        if (ignored instanceof RegExp) {
          return ignored.test(nestedPath);
        }
        return nestedPath === ignored;
      });
      if (hasMatches) {
        continue;
      }
    }
    const result = detectMutations(isImmutable, ignoredPaths, trackedProperty.children[key], obj[key], sameRef, nestedPath);
    if (result.wasMutated) {
      return result;
    }
  }
  return {
    wasMutated: false
  };
}
function createImmutableStateInvariantMiddleware(options = {}) {
  if (true) {
    return () => (next) => (action) => next(action);
  } else { var stringify, getSerialize; }
}

// src/serializableStateInvariantMiddleware.ts

function isPlain(val) {
  const type = typeof val;
  return val == null || type === "string" || type === "boolean" || type === "number" || Array.isArray(val) || isPlainObject(val);
}
function findNonSerializableValue(value, path = "", isSerializable = isPlain, getEntries, ignoredPaths = [], cache) {
  let foundNestedSerializable;
  if (!isSerializable(value)) {
    return {
      keyPath: path || "<root>",
      value
    };
  }
  if (typeof value !== "object" || value === null) {
    return false;
  }
  if (cache?.has(value)) return false;
  const entries = getEntries != null ? getEntries(value) : Object.entries(value);
  const hasIgnoredPaths = ignoredPaths.length > 0;
  for (const [key, nestedValue] of entries) {
    const nestedPath = path ? path + "." + key : key;
    if (hasIgnoredPaths) {
      const hasMatches = ignoredPaths.some((ignored) => {
        if (ignored instanceof RegExp) {
          return ignored.test(nestedPath);
        }
        return nestedPath === ignored;
      });
      if (hasMatches) {
        continue;
      }
    }
    if (!isSerializable(nestedValue)) {
      return {
        keyPath: nestedPath,
        value: nestedValue
      };
    }
    if (typeof nestedValue === "object") {
      foundNestedSerializable = findNonSerializableValue(nestedValue, nestedPath, isSerializable, getEntries, ignoredPaths, cache);
      if (foundNestedSerializable) {
        return foundNestedSerializable;
      }
    }
  }
  if (cache && isNestedFrozen(value)) cache.add(value);
  return false;
}
function isNestedFrozen(value) {
  if (!Object.isFrozen(value)) return false;
  for (const nestedValue of Object.values(value)) {
    if (typeof nestedValue !== "object" || nestedValue === null) continue;
    if (!isNestedFrozen(nestedValue)) return false;
  }
  return true;
}
function createSerializableStateInvariantMiddleware(options = {}) {
  if (true) {
    return () => (next) => (action) => next(action);
  } else {}
}

// src/getDefaultMiddleware.ts
function redux_toolkit_modern_isBoolean(x) {
  return typeof x === "boolean";
}
var buildGetDefaultMiddleware = () => function getDefaultMiddleware(options) {
  const {
    thunk = true,
    immutableCheck = true,
    serializableCheck = true,
    actionCreatorCheck = true
  } = options ?? {};
  let middlewareArray = new Tuple();
  if (thunk) {
    if (redux_toolkit_modern_isBoolean(thunk)) {
      middlewareArray.push(redux_thunk_thunk);
    } else {
      middlewareArray.push(withExtraArgument(thunk.extraArgument));
    }
  }
  if (false) {}
  return middlewareArray;
};

// src/autoBatchEnhancer.ts
var SHOULD_AUTOBATCH = "RTK_autoBatch";
var prepareAutoBatched = () => (payload) => ({
  payload,
  meta: {
    [SHOULD_AUTOBATCH]: true
  }
});
var createQueueWithTimer = (timeout) => {
  return (notify) => {
    setTimeout(notify, timeout);
  };
};
var autoBatchEnhancer = (options = {
  type: "raf"
}) => (next) => (...args) => {
  const store = next(...args);
  let notifying = true;
  let shouldNotifyAtEndOfTick = false;
  let notificationQueued = false;
  const listeners = /* @__PURE__ */ new Set();
  const queueCallback = options.type === "tick" ? queueMicrotask : options.type === "raf" ? (
    // requestAnimationFrame won't exist in SSR environments. Fall back to a vague approximation just to keep from erroring.
    typeof window !== "undefined" && window.requestAnimationFrame ? window.requestAnimationFrame : createQueueWithTimer(10)
  ) : options.type === "callback" ? options.queueNotification : createQueueWithTimer(options.timeout);
  const notifyListeners = () => {
    notificationQueued = false;
    if (shouldNotifyAtEndOfTick) {
      shouldNotifyAtEndOfTick = false;
      listeners.forEach((l) => l());
    }
  };
  return Object.assign({}, store, {
    // Override the base `store.subscribe` method to keep original listeners
    // from running if we're delaying notifications
    subscribe(listener2) {
      const wrappedListener = () => notifying && listener2();
      const unsubscribe = store.subscribe(wrappedListener);
      listeners.add(listener2);
      return () => {
        unsubscribe();
        listeners.delete(listener2);
      };
    },
    // Override the base `store.dispatch` method so that we can check actions
    // for the `shouldAutoBatch` flag and determine if batching is active
    dispatch(action) {
      try {
        notifying = !action?.meta?.[SHOULD_AUTOBATCH];
        shouldNotifyAtEndOfTick = !notifying;
        if (shouldNotifyAtEndOfTick) {
          if (!notificationQueued) {
            notificationQueued = true;
            queueCallback(notifyListeners);
          }
        }
        return store.dispatch(action);
      } finally {
        notifying = true;
      }
    }
  });
};

// src/getDefaultEnhancers.ts
var buildGetDefaultEnhancers = (middlewareEnhancer) => function getDefaultEnhancers(options) {
  const {
    autoBatch = true
  } = options ?? {};
  let enhancerArray = new Tuple(middlewareEnhancer);
  if (autoBatch) {
    enhancerArray.push(autoBatchEnhancer(typeof autoBatch === "object" ? autoBatch : void 0));
  }
  return enhancerArray;
};

// src/configureStore.ts
function configureStore(options) {
  const getDefaultMiddleware = buildGetDefaultMiddleware();
  const {
    reducer = void 0,
    middleware,
    devTools = true,
    preloadedState = void 0,
    enhancers = void 0
  } = options || {};
  let rootReducer;
  if (typeof reducer === "function") {
    rootReducer = reducer;
  } else if (redux_isPlainObject(reducer)) {
    rootReducer = combineReducers(reducer);
  } else {
    throw new Error( true ? redux_toolkit_modern_formatProdErrorMessage(1) : 0);
  }
  if (false) {}
  let finalMiddleware;
  if (typeof middleware === "function") {
    finalMiddleware = middleware(getDefaultMiddleware);
    if (false) {}
  } else {
    finalMiddleware = getDefaultMiddleware();
  }
  if (false) {}
  let finalCompose = compose;
  if (devTools) {
    finalCompose = composeWithDevTools({
      // Enable capture of stack traces for dispatched Redux actions
      trace: "production" !== "production",
      ...typeof devTools === "object" && devTools
    });
  }
  const middlewareEnhancer = applyMiddleware(...finalMiddleware);
  const getDefaultEnhancers = buildGetDefaultEnhancers(middlewareEnhancer);
  if (false) {}
  let storeEnhancers = typeof enhancers === "function" ? enhancers(getDefaultEnhancers) : getDefaultEnhancers();
  if (false) {}
  if (false) {}
  if (false) {}
  const composedEnhancer = finalCompose(...storeEnhancers);
  return createStore(rootReducer, preloadedState, composedEnhancer);
}

// src/createReducer.ts


// src/mapBuilders.ts
function executeReducerBuilderCallback(builderCallback) {
  const actionsMap = {};
  const actionMatchers = [];
  let defaultCaseReducer;
  const builder = {
    addCase(typeOrActionCreator, reducer) {
      if (false) {}
      const type = typeof typeOrActionCreator === "string" ? typeOrActionCreator : typeOrActionCreator.type;
      if (!type) {
        throw new Error( true ? redux_toolkit_modern_formatProdErrorMessage(28) : 0);
      }
      if (type in actionsMap) {
        throw new Error( true ? redux_toolkit_modern_formatProdErrorMessage(29) : 0);
      }
      actionsMap[type] = reducer;
      return builder;
    },
    addMatcher(matcher, reducer) {
      if (false) {}
      actionMatchers.push({
        matcher,
        reducer
      });
      return builder;
    },
    addDefaultCase(reducer) {
      if (false) {}
      defaultCaseReducer = reducer;
      return builder;
    }
  };
  builderCallback(builder);
  return [actionsMap, actionMatchers, defaultCaseReducer];
}

// src/createReducer.ts
function isStateFunction(x) {
  return typeof x === "function";
}
function createReducer(initialState, mapOrBuilderCallback) {
  if (false) {}
  let [actionsMap, finalActionMatchers, finalDefaultCaseReducer] = executeReducerBuilderCallback(mapOrBuilderCallback);
  let getInitialState;
  if (isStateFunction(initialState)) {
    getInitialState = () => freezeDraftable(initialState());
  } else {
    const frozenInitialState = freezeDraftable(initialState);
    getInitialState = () => frozenInitialState;
  }
  function reducer(state = getInitialState(), action) {
    let caseReducers = [actionsMap[action.type], ...finalActionMatchers.filter(({
      matcher
    }) => matcher(action)).map(({
      reducer: reducer2
    }) => reducer2)];
    if (caseReducers.filter((cr) => !!cr).length === 0) {
      caseReducers = [finalDefaultCaseReducer];
    }
    return caseReducers.reduce((previousState, caseReducer) => {
      if (caseReducer) {
        if (immer_isDraft(previousState)) {
          const draft = previousState;
          const result = caseReducer(draft, action);
          if (result === void 0) {
            return previousState;
          }
          return result;
        } else if (!isDraftable(previousState)) {
          const result = caseReducer(previousState, action);
          if (result === void 0) {
            if (previousState === null) {
              return previousState;
            }
            throw Error("A case reducer on a non-draftable value must not return undefined");
          }
          return result;
        } else {
          return produce(previousState, (draft) => {
            return caseReducer(draft, action);
          });
        }
      }
      return previousState;
    }, state);
  }
  reducer.getInitialState = getInitialState;
  return reducer;
}

// src/matchers.ts
var matches = (matcher, action) => {
  if (hasMatchFunction(matcher)) {
    return matcher.match(action);
  } else {
    return matcher(action);
  }
};
function isAnyOf(...matchers) {
  return (action) => {
    return matchers.some((matcher) => matches(matcher, action));
  };
}
function isAllOf(...matchers) {
  return (action) => {
    return matchers.every((matcher) => matches(matcher, action));
  };
}
function hasExpectedRequestMetadata(action, validStatus) {
  if (!action || !action.meta) return false;
  const hasValidRequestId = typeof action.meta.requestId === "string";
  const hasValidRequestStatus = validStatus.indexOf(action.meta.requestStatus) > -1;
  return hasValidRequestId && hasValidRequestStatus;
}
function isAsyncThunkArray(a) {
  return typeof a[0] === "function" && "pending" in a[0] && "fulfilled" in a[0] && "rejected" in a[0];
}
function isPending(...asyncThunks) {
  if (asyncThunks.length === 0) {
    return (action) => hasExpectedRequestMetadata(action, ["pending"]);
  }
  if (!isAsyncThunkArray(asyncThunks)) {
    return isPending()(asyncThunks[0]);
  }
  return isAnyOf(...asyncThunks.map((asyncThunk) => asyncThunk.pending));
}
function isRejected(...asyncThunks) {
  if (asyncThunks.length === 0) {
    return (action) => hasExpectedRequestMetadata(action, ["rejected"]);
  }
  if (!isAsyncThunkArray(asyncThunks)) {
    return isRejected()(asyncThunks[0]);
  }
  return isAnyOf(...asyncThunks.map((asyncThunk) => asyncThunk.rejected));
}
function isRejectedWithValue(...asyncThunks) {
  const hasFlag = (action) => {
    return action && action.meta && action.meta.rejectedWithValue;
  };
  if (asyncThunks.length === 0) {
    return isAllOf(isRejected(...asyncThunks), hasFlag);
  }
  if (!isAsyncThunkArray(asyncThunks)) {
    return isRejectedWithValue()(asyncThunks[0]);
  }
  return isAllOf(isRejected(...asyncThunks), hasFlag);
}
function isFulfilled(...asyncThunks) {
  if (asyncThunks.length === 0) {
    return (action) => hasExpectedRequestMetadata(action, ["fulfilled"]);
  }
  if (!isAsyncThunkArray(asyncThunks)) {
    return isFulfilled()(asyncThunks[0]);
  }
  return isAnyOf(...asyncThunks.map((asyncThunk) => asyncThunk.fulfilled));
}
function isAsyncThunkAction(...asyncThunks) {
  if (asyncThunks.length === 0) {
    return (action) => hasExpectedRequestMetadata(action, ["pending", "fulfilled", "rejected"]);
  }
  if (!isAsyncThunkArray(asyncThunks)) {
    return isAsyncThunkAction()(asyncThunks[0]);
  }
  return isAnyOf(...asyncThunks.flatMap((asyncThunk) => [asyncThunk.pending, asyncThunk.rejected, asyncThunk.fulfilled]));
}

// src/nanoid.ts
var urlAlphabet = "ModuleSymbhasOwnPr-0123456789ABCDEFGHNRVfgctiUvz_KqYTJkLxpZXIjQW";
var nanoid = (size = 21) => {
  let id = "";
  let i = size;
  while (i--) {
    id += urlAlphabet[Math.random() * 64 | 0];
  }
  return id;
};

// src/createAsyncThunk.ts
var commonProperties = ["name", "message", "stack", "code"];
var RejectWithValue = class {
  constructor(payload, meta) {
    this.payload = payload;
    this.meta = meta;
  }
  /*
  type-only property to distinguish between RejectWithValue and FulfillWithMeta
  does not exist at runtime
  */
  _type;
};
var FulfillWithMeta = class {
  constructor(payload, meta) {
    this.payload = payload;
    this.meta = meta;
  }
  /*
  type-only property to distinguish between RejectWithValue and FulfillWithMeta
  does not exist at runtime
  */
  _type;
};
var miniSerializeError = (value) => {
  if (typeof value === "object" && value !== null) {
    const simpleError = {};
    for (const property of commonProperties) {
      if (typeof value[property] === "string") {
        simpleError[property] = value[property];
      }
    }
    return simpleError;
  }
  return {
    message: String(value)
  };
};
var createAsyncThunk = /* @__PURE__ */ (() => {
  function createAsyncThunk2(typePrefix, payloadCreator, options) {
    const fulfilled = createAction(typePrefix + "/fulfilled", (payload, requestId, arg, meta) => ({
      payload,
      meta: {
        ...meta || {},
        arg,
        requestId,
        requestStatus: "fulfilled"
      }
    }));
    const pending = createAction(typePrefix + "/pending", (requestId, arg, meta) => ({
      payload: void 0,
      meta: {
        ...meta || {},
        arg,
        requestId,
        requestStatus: "pending"
      }
    }));
    const rejected = createAction(typePrefix + "/rejected", (error, requestId, arg, payload, meta) => ({
      payload,
      error: (options && options.serializeError || miniSerializeError)(error || "Rejected"),
      meta: {
        ...meta || {},
        arg,
        requestId,
        rejectedWithValue: !!payload,
        requestStatus: "rejected",
        aborted: error?.name === "AbortError",
        condition: error?.name === "ConditionError"
      }
    }));
    function actionCreator(arg) {
      return (dispatch, getState, extra) => {
        const requestId = options?.idGenerator ? options.idGenerator(arg) : nanoid();
        const abortController = new AbortController();
        let abortHandler;
        let abortReason;
        function abort(reason) {
          abortReason = reason;
          abortController.abort();
        }
        const promise = async function() {
          let finalAction;
          try {
            let conditionResult = options?.condition?.(arg, {
              getState,
              extra
            });
            if (isThenable(conditionResult)) {
              conditionResult = await conditionResult;
            }
            if (conditionResult === false || abortController.signal.aborted) {
              throw {
                name: "ConditionError",
                message: "Aborted due to condition callback returning false."
              };
            }
            const abortedPromise = new Promise((_, reject) => {
              abortHandler = () => {
                reject({
                  name: "AbortError",
                  message: abortReason || "Aborted"
                });
              };
              abortController.signal.addEventListener("abort", abortHandler);
            });
            dispatch(pending(requestId, arg, options?.getPendingMeta?.({
              requestId,
              arg
            }, {
              getState,
              extra
            })));
            finalAction = await Promise.race([abortedPromise, Promise.resolve(payloadCreator(arg, {
              dispatch,
              getState,
              extra,
              requestId,
              signal: abortController.signal,
              abort,
              rejectWithValue: (value, meta) => {
                return new RejectWithValue(value, meta);
              },
              fulfillWithValue: (value, meta) => {
                return new FulfillWithMeta(value, meta);
              }
            })).then((result) => {
              if (result instanceof RejectWithValue) {
                throw result;
              }
              if (result instanceof FulfillWithMeta) {
                return fulfilled(result.payload, requestId, arg, result.meta);
              }
              return fulfilled(result, requestId, arg);
            })]);
          } catch (err) {
            finalAction = err instanceof RejectWithValue ? rejected(null, requestId, arg, err.payload, err.meta) : rejected(err, requestId, arg);
          } finally {
            if (abortHandler) {
              abortController.signal.removeEventListener("abort", abortHandler);
            }
          }
          const skipDispatch = options && !options.dispatchConditionRejection && rejected.match(finalAction) && finalAction.meta.condition;
          if (!skipDispatch) {
            dispatch(finalAction);
          }
          return finalAction;
        }();
        return Object.assign(promise, {
          abort,
          requestId,
          arg,
          unwrap() {
            return promise.then(unwrapResult);
          }
        });
      };
    }
    return Object.assign(actionCreator, {
      pending,
      rejected,
      fulfilled,
      settled: isAnyOf(rejected, fulfilled),
      typePrefix
    });
  }
  createAsyncThunk2.withTypes = () => createAsyncThunk2;
  return createAsyncThunk2;
})();
function unwrapResult(action) {
  if (action.meta && action.meta.rejectedWithValue) {
    throw action.payload;
  }
  if (action.error) {
    throw action.error;
  }
  return action.payload;
}
function isThenable(value) {
  return value !== null && typeof value === "object" && typeof value.then === "function";
}

// src/createSlice.ts
var asyncThunkSymbol = /* @__PURE__ */ Symbol.for("rtk-slice-createasyncthunk");
var asyncThunkCreator = {
  [asyncThunkSymbol]: createAsyncThunk
};
var ReducerType = /* @__PURE__ */ ((ReducerType2) => {
  ReducerType2["reducer"] = "reducer";
  ReducerType2["reducerWithPrepare"] = "reducerWithPrepare";
  ReducerType2["asyncThunk"] = "asyncThunk";
  return ReducerType2;
})(ReducerType || {});
function getType(slice, actionKey) {
  return `${slice}/${actionKey}`;
}
function buildCreateSlice({
  creators
} = {}) {
  const cAT = creators?.asyncThunk?.[asyncThunkSymbol];
  return function createSlice2(options) {
    const {
      name,
      reducerPath = name
    } = options;
    if (!name) {
      throw new Error( true ? redux_toolkit_modern_formatProdErrorMessage(11) : 0);
    }
    if (typeof process !== "undefined" && "production" === "development") {}
    const reducers = (typeof options.reducers === "function" ? options.reducers(buildReducerCreators()) : options.reducers) || {};
    const reducerNames = Object.keys(reducers);
    const context = {
      sliceCaseReducersByName: {},
      sliceCaseReducersByType: {},
      actionCreators: {},
      sliceMatchers: []
    };
    const contextMethods = {
      addCase(typeOrActionCreator, reducer2) {
        const type = typeof typeOrActionCreator === "string" ? typeOrActionCreator : typeOrActionCreator.type;
        if (!type) {
          throw new Error( true ? redux_toolkit_modern_formatProdErrorMessage(12) : 0);
        }
        if (type in context.sliceCaseReducersByType) {
          throw new Error( true ? redux_toolkit_modern_formatProdErrorMessage(13) : 0);
        }
        context.sliceCaseReducersByType[type] = reducer2;
        return contextMethods;
      },
      addMatcher(matcher, reducer2) {
        context.sliceMatchers.push({
          matcher,
          reducer: reducer2
        });
        return contextMethods;
      },
      exposeAction(name2, actionCreator) {
        context.actionCreators[name2] = actionCreator;
        return contextMethods;
      },
      exposeCaseReducer(name2, reducer2) {
        context.sliceCaseReducersByName[name2] = reducer2;
        return contextMethods;
      }
    };
    reducerNames.forEach((reducerName) => {
      const reducerDefinition = reducers[reducerName];
      const reducerDetails = {
        reducerName,
        type: getType(name, reducerName),
        createNotation: typeof options.reducers === "function"
      };
      if (isAsyncThunkSliceReducerDefinition(reducerDefinition)) {
        handleThunkCaseReducerDefinition(reducerDetails, reducerDefinition, contextMethods, cAT);
      } else {
        handleNormalReducerDefinition(reducerDetails, reducerDefinition, contextMethods);
      }
    });
    function buildReducer() {
      if (false) {}
      const [extraReducers = {}, actionMatchers = [], defaultCaseReducer = void 0] = typeof options.extraReducers === "function" ? executeReducerBuilderCallback(options.extraReducers) : [options.extraReducers];
      const finalCaseReducers = {
        ...extraReducers,
        ...context.sliceCaseReducersByType
      };
      return createReducer(options.initialState, (builder) => {
        for (let key in finalCaseReducers) {
          builder.addCase(key, finalCaseReducers[key]);
        }
        for (let sM of context.sliceMatchers) {
          builder.addMatcher(sM.matcher, sM.reducer);
        }
        for (let m of actionMatchers) {
          builder.addMatcher(m.matcher, m.reducer);
        }
        if (defaultCaseReducer) {
          builder.addDefaultCase(defaultCaseReducer);
        }
      });
    }
    const selectSelf = (state) => state;
    const injectedSelectorCache = /* @__PURE__ */ new Map();
    let _reducer;
    function reducer(state, action) {
      if (!_reducer) _reducer = buildReducer();
      return _reducer(state, action);
    }
    function getInitialState() {
      if (!_reducer) _reducer = buildReducer();
      return _reducer.getInitialState();
    }
    function makeSelectorProps(reducerPath2, injected = false) {
      function selectSlice(state) {
        let sliceState = state[reducerPath2];
        if (typeof sliceState === "undefined") {
          if (injected) {
            sliceState = getInitialState();
          } else if (false) {}
        }
        return sliceState;
      }
      function getSelectors(selectState = selectSelf) {
        const selectorCache = getOrInsertComputed(injectedSelectorCache, injected, () => /* @__PURE__ */ new WeakMap());
        return getOrInsertComputed(selectorCache, selectState, () => {
          const map = {};
          for (const [name2, selector] of Object.entries(options.selectors ?? {})) {
            map[name2] = wrapSelector(selector, selectState, getInitialState, injected);
          }
          return map;
        });
      }
      return {
        reducerPath: reducerPath2,
        getSelectors,
        get selectors() {
          return getSelectors(selectSlice);
        },
        selectSlice
      };
    }
    const slice = {
      name,
      reducer,
      actions: context.actionCreators,
      caseReducers: context.sliceCaseReducersByName,
      getInitialState,
      ...makeSelectorProps(reducerPath),
      injectInto(injectable, {
        reducerPath: pathOpt,
        ...config
      } = {}) {
        const newReducerPath = pathOpt ?? reducerPath;
        injectable.inject({
          reducerPath: newReducerPath,
          reducer
        }, config);
        return {
          ...slice,
          ...makeSelectorProps(newReducerPath, true)
        };
      }
    };
    return slice;
  };
}
function wrapSelector(selector, selectState, getInitialState, injected) {
  function wrapper(rootState, ...args) {
    let sliceState = selectState(rootState);
    if (typeof sliceState === "undefined") {
      if (injected) {
        sliceState = getInitialState();
      } else if (false) {}
    }
    return selector(sliceState, ...args);
  }
  wrapper.unwrapped = selector;
  return wrapper;
}
var createSlice = /* @__PURE__ */ buildCreateSlice();
function buildReducerCreators() {
  function asyncThunk(payloadCreator, config) {
    return {
      _reducerDefinitionType: "asyncThunk" /* asyncThunk */,
      payloadCreator,
      ...config
    };
  }
  asyncThunk.withTypes = () => asyncThunk;
  return {
    reducer(caseReducer) {
      return Object.assign({
        // hack so the wrapping function has the same name as the original
        // we need to create a wrapper so the `reducerDefinitionType` is not assigned to the original
        [caseReducer.name](...args) {
          return caseReducer(...args);
        }
      }[caseReducer.name], {
        _reducerDefinitionType: "reducer" /* reducer */
      });
    },
    preparedReducer(prepare, reducer) {
      return {
        _reducerDefinitionType: "reducerWithPrepare" /* reducerWithPrepare */,
        prepare,
        reducer
      };
    },
    asyncThunk
  };
}
function handleNormalReducerDefinition({
  type,
  reducerName,
  createNotation
}, maybeReducerWithPrepare, context) {
  let caseReducer;
  let prepareCallback;
  if ("reducer" in maybeReducerWithPrepare) {
    if (createNotation && !isCaseReducerWithPrepareDefinition(maybeReducerWithPrepare)) {
      throw new Error( true ? redux_toolkit_modern_formatProdErrorMessage(17) : 0);
    }
    caseReducer = maybeReducerWithPrepare.reducer;
    prepareCallback = maybeReducerWithPrepare.prepare;
  } else {
    caseReducer = maybeReducerWithPrepare;
  }
  context.addCase(type, caseReducer).exposeCaseReducer(reducerName, caseReducer).exposeAction(reducerName, prepareCallback ? createAction(type, prepareCallback) : createAction(type));
}
function isAsyncThunkSliceReducerDefinition(reducerDefinition) {
  return reducerDefinition._reducerDefinitionType === "asyncThunk" /* asyncThunk */;
}
function isCaseReducerWithPrepareDefinition(reducerDefinition) {
  return reducerDefinition._reducerDefinitionType === "reducerWithPrepare" /* reducerWithPrepare */;
}
function handleThunkCaseReducerDefinition({
  type,
  reducerName
}, reducerDefinition, context, cAT) {
  if (!cAT) {
    throw new Error( true ? redux_toolkit_modern_formatProdErrorMessage(18) : 0);
  }
  const {
    payloadCreator,
    fulfilled,
    pending,
    rejected,
    settled,
    options
  } = reducerDefinition;
  const thunk = cAT(type, payloadCreator, options);
  context.exposeAction(reducerName, thunk);
  if (fulfilled) {
    context.addCase(thunk.fulfilled, fulfilled);
  }
  if (pending) {
    context.addCase(thunk.pending, pending);
  }
  if (rejected) {
    context.addCase(thunk.rejected, rejected);
  }
  if (settled) {
    context.addMatcher(thunk.settled, settled);
  }
  context.exposeCaseReducer(reducerName, {
    fulfilled: fulfilled || noop,
    pending: pending || noop,
    rejected: rejected || noop,
    settled: settled || noop
  });
}
function noop() {
}

// src/entities/entity_state.ts
function getInitialEntityState() {
  return {
    ids: [],
    entities: {}
  };
}
function createInitialStateFactory(stateAdapter) {
  function getInitialState(additionalState = {}, entities) {
    const state = Object.assign(getInitialEntityState(), additionalState);
    return entities ? stateAdapter.setAll(state, entities) : state;
  }
  return {
    getInitialState
  };
}

// src/entities/state_selectors.ts
function createSelectorsFactory() {
  function getSelectors(selectState, options = {}) {
    const {
      createSelector: createSelector2 = createDraftSafeSelector
    } = options;
    const selectIds = (state) => state.ids;
    const selectEntities = (state) => state.entities;
    const selectAll = createSelector2(selectIds, selectEntities, (ids, entities) => ids.map((id) => entities[id]));
    const selectId = (_, id) => id;
    const selectById = (entities, id) => entities[id];
    const selectTotal = createSelector2(selectIds, (ids) => ids.length);
    if (!selectState) {
      return {
        selectIds,
        selectEntities,
        selectAll,
        selectTotal,
        selectById: createSelector2(selectEntities, selectId, selectById)
      };
    }
    const selectGlobalizedEntities = createSelector2(selectState, selectEntities);
    return {
      selectIds: createSelector2(selectState, selectIds),
      selectEntities: selectGlobalizedEntities,
      selectAll: createSelector2(selectState, selectAll),
      selectTotal: createSelector2(selectState, selectTotal),
      selectById: createSelector2(selectGlobalizedEntities, selectId, selectById)
    };
  }
  return {
    getSelectors
  };
}

// src/entities/state_adapter.ts

var isDraftTyped = (/* unused pure expression or super */ null && (isDraft3));
function createSingleArgumentStateOperator(mutator) {
  const operator = createStateOperator((_, state) => mutator(state));
  return function operation(state) {
    return operator(state, void 0);
  };
}
function createStateOperator(mutator) {
  return function operation(state, arg) {
    function isPayloadActionArgument(arg2) {
      return isFSA(arg2);
    }
    const runMutator = (draft) => {
      if (isPayloadActionArgument(arg)) {
        mutator(arg.payload, draft);
      } else {
        mutator(arg, draft);
      }
    };
    if (isDraftTyped(state)) {
      runMutator(state);
      return state;
    }
    return createNextState3(state, runMutator);
  };
}

// src/entities/utils.ts

function selectIdValue(entity, selectId) {
  const key = selectId(entity);
  if (false) {}
  return key;
}
function ensureEntitiesArray(entities) {
  if (!Array.isArray(entities)) {
    entities = Object.values(entities);
  }
  return entities;
}
function getCurrent(value) {
  return isDraft4(value) ? current2(value) : value;
}
function splitAddedUpdatedEntities(newEntities, selectId, state) {
  newEntities = ensureEntitiesArray(newEntities);
  const existingIdsArray = getCurrent(state.ids);
  const existingIds = new Set(existingIdsArray);
  const added = [];
  const updated = [];
  for (const entity of newEntities) {
    const id = selectIdValue(entity, selectId);
    if (existingIds.has(id)) {
      updated.push({
        id,
        changes: entity
      });
    } else {
      added.push(entity);
    }
  }
  return [added, updated, existingIdsArray];
}

// src/entities/unsorted_state_adapter.ts
function createUnsortedStateAdapter(selectId) {
  function addOneMutably(entity, state) {
    const key = selectIdValue(entity, selectId);
    if (key in state.entities) {
      return;
    }
    state.ids.push(key);
    state.entities[key] = entity;
  }
  function addManyMutably(newEntities, state) {
    newEntities = ensureEntitiesArray(newEntities);
    for (const entity of newEntities) {
      addOneMutably(entity, state);
    }
  }
  function setOneMutably(entity, state) {
    const key = selectIdValue(entity, selectId);
    if (!(key in state.entities)) {
      state.ids.push(key);
    }
    ;
    state.entities[key] = entity;
  }
  function setManyMutably(newEntities, state) {
    newEntities = ensureEntitiesArray(newEntities);
    for (const entity of newEntities) {
      setOneMutably(entity, state);
    }
  }
  function setAllMutably(newEntities, state) {
    newEntities = ensureEntitiesArray(newEntities);
    state.ids = [];
    state.entities = {};
    addManyMutably(newEntities, state);
  }
  function removeOneMutably(key, state) {
    return removeManyMutably([key], state);
  }
  function removeManyMutably(keys, state) {
    let didMutate = false;
    keys.forEach((key) => {
      if (key in state.entities) {
        delete state.entities[key];
        didMutate = true;
      }
    });
    if (didMutate) {
      state.ids = state.ids.filter((id) => id in state.entities);
    }
  }
  function removeAllMutably(state) {
    Object.assign(state, {
      ids: [],
      entities: {}
    });
  }
  function takeNewKey(keys, update, state) {
    const original3 = state.entities[update.id];
    if (original3 === void 0) {
      return false;
    }
    const updated = Object.assign({}, original3, update.changes);
    const newKey = selectIdValue(updated, selectId);
    const hasNewKey = newKey !== update.id;
    if (hasNewKey) {
      keys[update.id] = newKey;
      delete state.entities[update.id];
    }
    ;
    state.entities[newKey] = updated;
    return hasNewKey;
  }
  function updateOneMutably(update, state) {
    return updateManyMutably([update], state);
  }
  function updateManyMutably(updates, state) {
    const newKeys = {};
    const updatesPerEntity = {};
    updates.forEach((update) => {
      if (update.id in state.entities) {
        updatesPerEntity[update.id] = {
          id: update.id,
          // Spreads ignore falsy values, so this works even if there isn't
          // an existing update already at this key
          changes: {
            ...updatesPerEntity[update.id]?.changes,
            ...update.changes
          }
        };
      }
    });
    updates = Object.values(updatesPerEntity);
    const didMutateEntities = updates.length > 0;
    if (didMutateEntities) {
      const didMutateIds = updates.filter((update) => takeNewKey(newKeys, update, state)).length > 0;
      if (didMutateIds) {
        state.ids = Object.values(state.entities).map((e) => selectIdValue(e, selectId));
      }
    }
  }
  function upsertOneMutably(entity, state) {
    return upsertManyMutably([entity], state);
  }
  function upsertManyMutably(newEntities, state) {
    const [added, updated] = splitAddedUpdatedEntities(newEntities, selectId, state);
    updateManyMutably(updated, state);
    addManyMutably(added, state);
  }
  return {
    removeAll: createSingleArgumentStateOperator(removeAllMutably),
    addOne: createStateOperator(addOneMutably),
    addMany: createStateOperator(addManyMutably),
    setOne: createStateOperator(setOneMutably),
    setMany: createStateOperator(setManyMutably),
    setAll: createStateOperator(setAllMutably),
    updateOne: createStateOperator(updateOneMutably),
    updateMany: createStateOperator(updateManyMutably),
    upsertOne: createStateOperator(upsertOneMutably),
    upsertMany: createStateOperator(upsertManyMutably),
    removeOne: createStateOperator(removeOneMutably),
    removeMany: createStateOperator(removeManyMutably)
  };
}

// src/entities/sorted_state_adapter.ts
function findInsertIndex(sortedItems, item, comparisonFunction) {
  let lowIndex = 0;
  let highIndex = sortedItems.length;
  while (lowIndex < highIndex) {
    let middleIndex = lowIndex + highIndex >>> 1;
    const currentItem = sortedItems[middleIndex];
    const res = comparisonFunction(item, currentItem);
    if (res >= 0) {
      lowIndex = middleIndex + 1;
    } else {
      highIndex = middleIndex;
    }
  }
  return lowIndex;
}
function insert(sortedItems, item, comparisonFunction) {
  const insertAtIndex = findInsertIndex(sortedItems, item, comparisonFunction);
  sortedItems.splice(insertAtIndex, 0, item);
  return sortedItems;
}
function createSortedStateAdapter(selectId, comparer) {
  const {
    removeOne,
    removeMany,
    removeAll
  } = createUnsortedStateAdapter(selectId);
  function addOneMutably(entity, state) {
    return addManyMutably([entity], state);
  }
  function addManyMutably(newEntities, state, existingIds) {
    newEntities = ensureEntitiesArray(newEntities);
    const existingKeys = new Set(existingIds ?? getCurrent(state.ids));
    const models = newEntities.filter((model) => !existingKeys.has(selectIdValue(model, selectId)));
    if (models.length !== 0) {
      mergeFunction(state, models);
    }
  }
  function setOneMutably(entity, state) {
    return setManyMutably([entity], state);
  }
  function setManyMutably(newEntities, state) {
    newEntities = ensureEntitiesArray(newEntities);
    if (newEntities.length !== 0) {
      for (const item of newEntities) {
        delete state.entities[selectId(item)];
      }
      mergeFunction(state, newEntities);
    }
  }
  function setAllMutably(newEntities, state) {
    newEntities = ensureEntitiesArray(newEntities);
    state.entities = {};
    state.ids = [];
    addManyMutably(newEntities, state, []);
  }
  function updateOneMutably(update, state) {
    return updateManyMutably([update], state);
  }
  function updateManyMutably(updates, state) {
    let appliedUpdates = false;
    let replacedIds = false;
    for (let update of updates) {
      const entity = state.entities[update.id];
      if (!entity) {
        continue;
      }
      appliedUpdates = true;
      Object.assign(entity, update.changes);
      const newId = selectId(entity);
      if (update.id !== newId) {
        replacedIds = true;
        delete state.entities[update.id];
        const oldIndex = state.ids.indexOf(update.id);
        state.ids[oldIndex] = newId;
        state.entities[newId] = entity;
      }
    }
    if (appliedUpdates) {
      mergeFunction(state, [], appliedUpdates, replacedIds);
    }
  }
  function upsertOneMutably(entity, state) {
    return upsertManyMutably([entity], state);
  }
  function upsertManyMutably(newEntities, state) {
    const [added, updated, existingIdsArray] = splitAddedUpdatedEntities(newEntities, selectId, state);
    if (updated.length) {
      updateManyMutably(updated, state);
    }
    if (added.length) {
      addManyMutably(added, state, existingIdsArray);
    }
  }
  function areArraysEqual(a, b) {
    if (a.length !== b.length) {
      return false;
    }
    for (let i = 0; i < a.length; i++) {
      if (a[i] === b[i]) {
        continue;
      }
      return false;
    }
    return true;
  }
  const mergeFunction = (state, addedItems, appliedUpdates, replacedIds) => {
    const currentEntities = getCurrent(state.entities);
    const currentIds = getCurrent(state.ids);
    const stateEntities = state.entities;
    let ids = currentIds;
    if (replacedIds) {
      ids = new Set(currentIds);
    }
    let sortedEntities = [];
    for (const id of ids) {
      const entity = currentEntities[id];
      if (entity) {
        sortedEntities.push(entity);
      }
    }
    const wasPreviouslyEmpty = sortedEntities.length === 0;
    for (const item of addedItems) {
      stateEntities[selectId(item)] = item;
      if (!wasPreviouslyEmpty) {
        insert(sortedEntities, item, comparer);
      }
    }
    if (wasPreviouslyEmpty) {
      sortedEntities = addedItems.slice().sort(comparer);
    } else if (appliedUpdates) {
      sortedEntities.sort(comparer);
    }
    const newSortedIds = sortedEntities.map(selectId);
    if (!areArraysEqual(currentIds, newSortedIds)) {
      state.ids = newSortedIds;
    }
  };
  return {
    removeOne,
    removeMany,
    removeAll,
    addOne: createStateOperator(addOneMutably),
    updateOne: createStateOperator(updateOneMutably),
    upsertOne: createStateOperator(upsertOneMutably),
    setOne: createStateOperator(setOneMutably),
    setMany: createStateOperator(setManyMutably),
    setAll: createStateOperator(setAllMutably),
    addMany: createStateOperator(addManyMutably),
    updateMany: createStateOperator(updateManyMutably),
    upsertMany: createStateOperator(upsertManyMutably)
  };
}

// src/entities/create_adapter.ts
function createEntityAdapter(options = {}) {
  const {
    selectId,
    sortComparer
  } = {
    sortComparer: false,
    selectId: (instance) => instance.id,
    ...options
  };
  const stateAdapter = sortComparer ? createSortedStateAdapter(selectId, sortComparer) : createUnsortedStateAdapter(selectId);
  const stateFactory = createInitialStateFactory(stateAdapter);
  const selectorsFactory = createSelectorsFactory();
  return {
    selectId,
    sortComparer,
    ...stateFactory,
    ...selectorsFactory,
    ...stateAdapter
  };
}

// src/listenerMiddleware/index.ts


// src/listenerMiddleware/exceptions.ts
var task = "task";
var listener = "listener";
var completed = "completed";
var cancelled = "cancelled";
var taskCancelled = (/* unused pure expression or super */ null && (`task-${cancelled}`));
var taskCompleted = (/* unused pure expression or super */ null && (`task-${completed}`));
var listenerCancelled = (/* unused pure expression or super */ null && (`${listener}-${cancelled}`));
var listenerCompleted = (/* unused pure expression or super */ null && (`${listener}-${completed}`));
var TaskAbortError = class {
  constructor(code) {
    this.code = code;
    this.message = `${task} ${cancelled} (reason: ${code})`;
  }
  name = "TaskAbortError";
  message;
};

// src/listenerMiddleware/utils.ts
var assertFunction = (func, expected) => {
  if (typeof func !== "function") {
    throw new TypeError( true ? redux_toolkit_modern_formatProdErrorMessage(32) : 0);
  }
};
var noop2 = () => {
};
var catchRejection = (promise, onError = noop2) => {
  promise.catch(onError);
  return promise;
};
var addAbortSignalListener = (abortSignal, callback) => {
  abortSignal.addEventListener("abort", callback, {
    once: true
  });
  return () => abortSignal.removeEventListener("abort", callback);
};
var abortControllerWithReason = (abortController, reason) => {
  const signal = abortController.signal;
  if (signal.aborted) {
    return;
  }
  if (!("reason" in signal)) {
    Object.defineProperty(signal, "reason", {
      enumerable: true,
      value: reason,
      configurable: true,
      writable: true
    });
  }
  ;
  abortController.abort(reason);
};

// src/listenerMiddleware/task.ts
var validateActive = (signal) => {
  if (signal.aborted) {
    const {
      reason
    } = signal;
    throw new TaskAbortError(reason);
  }
};
function raceWithSignal(signal, promise) {
  let cleanup = noop2;
  return new Promise((resolve, reject) => {
    const notifyRejection = () => reject(new TaskAbortError(signal.reason));
    if (signal.aborted) {
      notifyRejection();
      return;
    }
    cleanup = addAbortSignalListener(signal, notifyRejection);
    promise.finally(() => cleanup()).then(resolve, reject);
  }).finally(() => {
    cleanup = noop2;
  });
}
var runTask = async (task2, cleanUp) => {
  try {
    await Promise.resolve();
    const value = await task2();
    return {
      status: "ok",
      value
    };
  } catch (error) {
    return {
      status: error instanceof TaskAbortError ? "cancelled" : "rejected",
      error
    };
  } finally {
    cleanUp?.();
  }
};
var createPause = (signal) => {
  return (promise) => {
    return catchRejection(raceWithSignal(signal, promise).then((output) => {
      validateActive(signal);
      return output;
    }));
  };
};
var createDelay = (signal) => {
  const pause = createPause(signal);
  return (timeoutMs) => {
    return pause(new Promise((resolve) => setTimeout(resolve, timeoutMs)));
  };
};

// src/listenerMiddleware/index.ts
var {
  assign: redux_toolkit_modern_assign
} = Object;
var INTERNAL_NIL_TOKEN = {};
var alm = "listenerMiddleware";
var createFork = (parentAbortSignal, parentBlockingPromises) => {
  const linkControllers = (controller) => addAbortSignalListener(parentAbortSignal, () => abortControllerWithReason(controller, parentAbortSignal.reason));
  return (taskExecutor, opts) => {
    assertFunction(taskExecutor, "taskExecutor");
    const childAbortController = new AbortController();
    linkControllers(childAbortController);
    const result = runTask(async () => {
      validateActive(parentAbortSignal);
      validateActive(childAbortController.signal);
      const result2 = await taskExecutor({
        pause: createPause(childAbortController.signal),
        delay: createDelay(childAbortController.signal),
        signal: childAbortController.signal
      });
      validateActive(childAbortController.signal);
      return result2;
    }, () => abortControllerWithReason(childAbortController, taskCompleted));
    if (opts?.autoJoin) {
      parentBlockingPromises.push(result.catch(noop2));
    }
    return {
      result: createPause(parentAbortSignal)(result),
      cancel() {
        abortControllerWithReason(childAbortController, taskCancelled);
      }
    };
  };
};
var createTakePattern = (startListening, signal) => {
  const take = async (predicate, timeout) => {
    validateActive(signal);
    let unsubscribe = () => {
    };
    const tuplePromise = new Promise((resolve, reject) => {
      let stopListening = startListening({
        predicate,
        effect: (action, listenerApi) => {
          listenerApi.unsubscribe();
          resolve([action, listenerApi.getState(), listenerApi.getOriginalState()]);
        }
      });
      unsubscribe = () => {
        stopListening();
        reject();
      };
    });
    const promises = [tuplePromise];
    if (timeout != null) {
      promises.push(new Promise((resolve) => setTimeout(resolve, timeout, null)));
    }
    try {
      const output = await raceWithSignal(signal, Promise.race(promises));
      validateActive(signal);
      return output;
    } finally {
      unsubscribe();
    }
  };
  return (predicate, timeout) => catchRejection(take(predicate, timeout));
};
var getListenerEntryPropsFrom = (options) => {
  let {
    type,
    actionCreator,
    matcher,
    predicate,
    effect
  } = options;
  if (type) {
    predicate = createAction(type).match;
  } else if (actionCreator) {
    type = actionCreator.type;
    predicate = actionCreator.match;
  } else if (matcher) {
    predicate = matcher;
  } else if (predicate) {
  } else {
    throw new Error( true ? redux_toolkit_modern_formatProdErrorMessage(21) : 0);
  }
  assertFunction(effect, "options.listener");
  return {
    predicate,
    type,
    effect
  };
};
var createListenerEntry = /* @__PURE__ */ redux_toolkit_modern_assign((options) => {
  const {
    type,
    predicate,
    effect
  } = getListenerEntryPropsFrom(options);
  const entry = {
    id: nanoid(),
    effect,
    type,
    predicate,
    pending: /* @__PURE__ */ new Set(),
    unsubscribe: () => {
      throw new Error( true ? redux_toolkit_modern_formatProdErrorMessage(22) : 0);
    }
  };
  return entry;
}, {
  withTypes: () => createListenerEntry
});
var findListenerEntry = (listenerMap, options) => {
  const {
    type,
    effect,
    predicate
  } = getListenerEntryPropsFrom(options);
  return Array.from(listenerMap.values()).find((entry) => {
    const matchPredicateOrType = typeof type === "string" ? entry.type === type : entry.predicate === predicate;
    return matchPredicateOrType && entry.effect === effect;
  });
};
var cancelActiveListeners = (entry) => {
  entry.pending.forEach((controller) => {
    abortControllerWithReason(controller, listenerCancelled);
  });
};
var createClearListenerMiddleware = (listenerMap) => {
  return () => {
    listenerMap.forEach(cancelActiveListeners);
    listenerMap.clear();
  };
};
var safelyNotifyError = (errorHandler, errorToNotify, errorInfo) => {
  try {
    errorHandler(errorToNotify, errorInfo);
  } catch (errorHandlerError) {
    setTimeout(() => {
      throw errorHandlerError;
    }, 0);
  }
};
var addListener = /* @__PURE__ */ redux_toolkit_modern_assign(/* @__PURE__ */ createAction(`${alm}/add`), {
  withTypes: () => addListener
});
var clearAllListeners = /* @__PURE__ */ (/* unused pure expression or super */ null && (createAction(`${alm}/removeAll`)));
var removeListener = /* @__PURE__ */ redux_toolkit_modern_assign(/* @__PURE__ */ createAction(`${alm}/remove`), {
  withTypes: () => removeListener
});
var defaultErrorHandler = (...args) => {
  console.error(`${alm}/error`, ...args);
};
var createListenerMiddleware = (middlewareOptions = {}) => {
  const listenerMap = /* @__PURE__ */ new Map();
  const {
    extra,
    onError = defaultErrorHandler
  } = middlewareOptions;
  assertFunction(onError, "onError");
  const insertEntry = (entry) => {
    entry.unsubscribe = () => listenerMap.delete(entry.id);
    listenerMap.set(entry.id, entry);
    return (cancelOptions) => {
      entry.unsubscribe();
      if (cancelOptions?.cancelActive) {
        cancelActiveListeners(entry);
      }
    };
  };
  const startListening = (options) => {
    const entry = findListenerEntry(listenerMap, options) ?? createListenerEntry(options);
    return insertEntry(entry);
  };
  redux_toolkit_modern_assign(startListening, {
    withTypes: () => startListening
  });
  const stopListening = (options) => {
    const entry = findListenerEntry(listenerMap, options);
    if (entry) {
      entry.unsubscribe();
      if (options.cancelActive) {
        cancelActiveListeners(entry);
      }
    }
    return !!entry;
  };
  redux_toolkit_modern_assign(stopListening, {
    withTypes: () => stopListening
  });
  const notifyListener = async (entry, action, api, getOriginalState) => {
    const internalTaskController = new AbortController();
    const take = createTakePattern(startListening, internalTaskController.signal);
    const autoJoinPromises = [];
    try {
      entry.pending.add(internalTaskController);
      await Promise.resolve(entry.effect(
        action,
        // Use assign() rather than ... to avoid extra helper functions added to bundle
        redux_toolkit_modern_assign({}, api, {
          getOriginalState,
          condition: (predicate, timeout) => take(predicate, timeout).then(Boolean),
          take,
          delay: createDelay(internalTaskController.signal),
          pause: createPause(internalTaskController.signal),
          extra,
          signal: internalTaskController.signal,
          fork: createFork(internalTaskController.signal, autoJoinPromises),
          unsubscribe: entry.unsubscribe,
          subscribe: () => {
            listenerMap.set(entry.id, entry);
          },
          cancelActiveListeners: () => {
            entry.pending.forEach((controller, _, set) => {
              if (controller !== internalTaskController) {
                abortControllerWithReason(controller, listenerCancelled);
                set.delete(controller);
              }
            });
          },
          cancel: () => {
            abortControllerWithReason(internalTaskController, listenerCancelled);
            entry.pending.delete(internalTaskController);
          },
          throwIfCancelled: () => {
            validateActive(internalTaskController.signal);
          }
        })
      ));
    } catch (listenerError) {
      if (!(listenerError instanceof TaskAbortError)) {
        safelyNotifyError(onError, listenerError, {
          raisedBy: "effect"
        });
      }
    } finally {
      await Promise.all(autoJoinPromises);
      abortControllerWithReason(internalTaskController, listenerCompleted);
      entry.pending.delete(internalTaskController);
    }
  };
  const clearListenerMiddleware = createClearListenerMiddleware(listenerMap);
  const middleware = (api) => (next) => (action) => {
    if (!isAction3(action)) {
      return next(action);
    }
    if (addListener.match(action)) {
      return startListening(action.payload);
    }
    if (clearAllListeners.match(action)) {
      clearListenerMiddleware();
      return;
    }
    if (removeListener.match(action)) {
      return stopListening(action.payload);
    }
    let originalState = api.getState();
    const getOriginalState = () => {
      if (originalState === INTERNAL_NIL_TOKEN) {
        throw new Error( true ? redux_toolkit_modern_formatProdErrorMessage(23) : 0);
      }
      return originalState;
    };
    let result;
    try {
      result = next(action);
      if (listenerMap.size > 0) {
        const currentState = api.getState();
        const listenerEntries = Array.from(listenerMap.values());
        for (const entry of listenerEntries) {
          let runListener = false;
          try {
            runListener = entry.predicate(action, currentState, originalState);
          } catch (predicateError) {
            runListener = false;
            safelyNotifyError(onError, predicateError, {
              raisedBy: "predicate"
            });
          }
          if (!runListener) {
            continue;
          }
          notifyListener(entry, action, api, getOriginalState);
        }
      }
    } finally {
      originalState = INTERNAL_NIL_TOKEN;
    }
    return result;
  };
  return {
    middleware,
    startListening,
    stopListening,
    clearListeners: clearListenerMiddleware
  };
};

// src/dynamicMiddleware/index.ts

var createMiddlewareEntry = (middleware) => ({
  middleware,
  applied: /* @__PURE__ */ new Map()
});
var matchInstance = (instanceId) => (action) => action?.meta?.instanceId === instanceId;
var createDynamicMiddleware = () => {
  const instanceId = nanoid();
  const middlewareMap = /* @__PURE__ */ new Map();
  const withMiddleware = Object.assign(createAction("dynamicMiddleware/add", (...middlewares) => ({
    payload: middlewares,
    meta: {
      instanceId
    }
  })), {
    withTypes: () => withMiddleware
  });
  const addMiddleware = Object.assign(function addMiddleware2(...middlewares) {
    middlewares.forEach((middleware2) => {
      getOrInsertComputed(middlewareMap, middleware2, createMiddlewareEntry);
    });
  }, {
    withTypes: () => addMiddleware
  });
  const getFinalMiddleware = (api) => {
    const appliedMiddleware = Array.from(middlewareMap.values()).map((entry) => getOrInsertComputed(entry.applied, api, entry.middleware));
    return compose3(...appliedMiddleware);
  };
  const isWithMiddleware = isAllOf(withMiddleware, matchInstance(instanceId));
  const middleware = (api) => (next) => (action) => {
    if (isWithMiddleware(action)) {
      addMiddleware(...action.payload);
      return api.dispatch;
    }
    return getFinalMiddleware(api)(next)(action);
  };
  return {
    middleware,
    addMiddleware,
    withMiddleware,
    instanceId
  };
};

// src/combineSlices.ts

var isSliceLike = (maybeSliceLike) => "reducerPath" in maybeSliceLike && typeof maybeSliceLike.reducerPath === "string";
var getReducers = (slices) => slices.flatMap((sliceOrMap) => isSliceLike(sliceOrMap) ? [[sliceOrMap.reducerPath, sliceOrMap.reducer]] : Object.entries(sliceOrMap));
var ORIGINAL_STATE = Symbol.for("rtk-state-proxy-original");
var isStateProxy = (value) => !!value && !!value[ORIGINAL_STATE];
var stateProxyMap = /* @__PURE__ */ new WeakMap();
var createStateProxy = (state, reducerMap) => getOrInsertComputed(stateProxyMap, state, () => new Proxy(state, {
  get: (target, prop, receiver) => {
    if (prop === ORIGINAL_STATE) return target;
    const result = Reflect.get(target, prop, receiver);
    if (typeof result === "undefined") {
      const reducer = reducerMap[prop.toString()];
      if (reducer) {
        const reducerResult = reducer(void 0, {
          type: nanoid()
        });
        if (typeof reducerResult === "undefined") {
          throw new Error( true ? redux_toolkit_modern_formatProdErrorMessage(24) : 0);
        }
        return reducerResult;
      }
    }
    return result;
  }
}));
var redux_toolkit_modern_original = (state) => {
  if (!isStateProxy(state)) {
    throw new Error( true ? redux_toolkit_modern_formatProdErrorMessage(25) : 0);
  }
  return state[ORIGINAL_STATE];
};
var noopReducer = (state = {}) => state;
function combineSlices(...slices) {
  const reducerMap = Object.fromEntries(getReducers(slices));
  const getReducer = () => Object.keys(reducerMap).length ? combineReducers2(reducerMap) : noopReducer;
  let reducer = getReducer();
  function combinedReducer(state, action) {
    return reducer(state, action);
  }
  combinedReducer.withLazyLoadedSlices = () => combinedReducer;
  const inject = (slice, config = {}) => {
    const {
      reducerPath,
      reducer: reducerToInject
    } = slice;
    const currentReducer = reducerMap[reducerPath];
    if (!config.overrideExisting && currentReducer && currentReducer !== reducerToInject) {
      if (typeof process !== "undefined" && "production" === "development") {}
      return combinedReducer;
    }
    reducerMap[reducerPath] = reducerToInject;
    reducer = getReducer();
    return combinedReducer;
  };
  const selector = Object.assign(function makeSelector(selectorFn, selectState) {
    return function selector2(state, ...args) {
      return selectorFn(createStateProxy(selectState ? selectState(state, ...args) : state, reducerMap), ...args);
    };
  }, {
    original: redux_toolkit_modern_original
  });
  return Object.assign(combinedReducer, {
    inject,
    selector
  });
}

// src/formatProdErrorMessage.ts
function redux_toolkit_modern_formatProdErrorMessage(code) {
  return `Minified Redux Toolkit error #${code}; visit https://redux-toolkit.js.org/Errors?code=${code} for the full message or use the non-minified dev environment for full errors. `;
}

//# sourceMappingURL=redux-toolkit.modern.mjs.map
;// ./src/scripts/store.js
/**
 * @fileoverview Redux store configuration for managing the number of results.
 * @module ResultsStore
 */



/**
 * Redux slice for managing the number of results.
 * @type {import('@reduxjs/toolkit').Slice}
 */
var numberOfResultsSlice = createSlice({
  name: 'numberOfResults',
  initialState: {
    /** @type {number} The current number of results */
    value: 0
  },
  reducers: {
    /**
     * Updates the number of results.
     * @param {Object} state - The current state.
     * @param {import('@reduxjs/toolkit').PayloadAction<number>} action - The action containing the new value.
     */
    update: function update(state, action) {
      state.value = action.payload;
    }
  }
});

/**
 * Action creator for updating the number of results.
 * @type {import('@reduxjs/toolkit').ActionCreatorWithPayload<number>}
 */
var update = numberOfResultsSlice.actions.update;

/**
 * The configured Redux store.
 * @type {import('@reduxjs/toolkit').Store}
 */

var store = configureStore({
  reducer: numberOfResultsSlice.reducer
});
var searchQuerySlice = createSlice({
  name: 'searchQuery',
  initialState: {
    value: ''
  },
  reducers: {
    update: function update(state, action) {
      state.value = action.payload;
    }
  }
});
var updateSearchQuery = searchQuerySlice.actions.update;

var searchQueryStore = configureStore({
  reducer: searchQuerySlice.reducer
});
var numberOfFacetsSlice = createSlice({
  name: 'numberOfFacets',
  initialState: {
    value: 0
  },
  reducers: {
    update: function update(state, action) {
      state.value = action.payload;
    }
  }
});
var updateNumberOfFacets = numberOfFacetsSlice.actions.update;

var numberOfFacetsStore = configureStore({
  reducer: numberOfFacetsSlice.reducer
});
var statsRenderedSlice = createSlice({
  name: 'statsRendered',
  initialState: {
    value: false
  },
  reducers: {
    update: function update(state, action) {
      state.value = action.payload;
    }
  }
});
var updateStatsRendered = statsRenderedSlice.actions.update;

var statsRenderedStore = configureStore({
  reducer: statsRenderedSlice.reducer
});
;// ./src/scripts/services/algoliaStateHandler.js
function algoliaStateHandler_typeof(o) { "@babel/helpers - typeof"; return algoliaStateHandler_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, algoliaStateHandler_typeof(o); }
function algoliaStateHandler_classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function algoliaStateHandler_defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, algoliaStateHandler_toPropertyKey(o.key), o); } }
function algoliaStateHandler_createClass(e, r, t) { return r && algoliaStateHandler_defineProperties(e.prototype, r), t && algoliaStateHandler_defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function algoliaStateHandler_toPropertyKey(t) { var i = algoliaStateHandler_toPrimitive(t, "string"); return "symbol" == algoliaStateHandler_typeof(i) ? i : i + ""; }
function algoliaStateHandler_toPrimitive(t, r) { if ("object" != algoliaStateHandler_typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != algoliaStateHandler_typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * @fileoverview Manages UI updates based on store changes for search results, queries, and facets
 * @requires '../store.js'
 */



/**
 * Shared state object maintaining current values across different store updaters
 * @typedef {Object} SharedState
 * @property {Object} numberOfResults - Current number of search results
 * @property {string} searchQuery - Current search query value
 * @property {number} numberOfFacets - Current number of active facets
 */
var sharedState = {
  numberOfResults: store.getState(),
  searchQuery: searchQueryStore.getState().value,
  numberOfFacets: numberOfFacetsStore.getState().value
};

/**
 * Manages updates to the result count display in the UI
 */
var ResultCountUpdater = /*#__PURE__*/function () {
  /**
   * @param {Object} store - The store containing the number of results
   * @param {SharedState} sharedState - Shared state object for cross-updater communication
   * @param {Document} documentObj - DOM document object for UI updates
   */
  function ResultCountUpdater(store, sharedState, documentObj) {
    algoliaStateHandler_classCallCheck(this, ResultCountUpdater);
    this.store = store;
    this.sharedState = sharedState;
    this.document = documentObj;
    this.init();
  }

  /**
   * Initializes the store subscription
   * @private
   */
  return algoliaStateHandler_createClass(ResultCountUpdater, [{
    key: "init",
    value: function init() {
      var _this = this;
      this.store.subscribe(function () {
        try {
          _this.updateResults();
        } catch (error) {
          console.error('Error updating results:', error);
        }
      });
    }

    /**
     * Updates the result count in the UI when the store changes
     * Prevents unnecessary updates if the value hasn't changed
     * @private
     */
  }, {
    key: "updateResults",
    value: function updateResults() {
      var _this$sharedState$num, _this$sharedState$num2, _this$sharedState$num3;
      var previousResults = this.sharedState.numberOfResults;
      this.sharedState.numberOfResults = this.store.getState();

      // Skip update if value hasn't changed
      if ((previousResults === null || previousResults === void 0 ? void 0 : previousResults.value) === ((_this$sharedState$num = this.sharedState.numberOfResults) === null || _this$sharedState$num === void 0 ? void 0 : _this$sharedState$num.value)) return;
      var clearCountElement = this.document.querySelector('[js-clear-count]');
      if (!clearCountElement) return;
      clearCountElement.innerHTML = "&nbsp; (".concat((_this$sharedState$num2 = (_this$sharedState$num3 = this.sharedState.numberOfResults) === null || _this$sharedState$num3 === void 0 ? void 0 : _this$sharedState$num3.value) !== null && _this$sharedState$num2 !== void 0 ? _this$sharedState$num2 : 0, ")");
    }
  }]);
}();
/**
 * Manages updates to the search query display in the UI
 */
var SearchQueryUpdater = /*#__PURE__*/function () {
  /**
   * @param {Object} searchQueryStore - The store containing the search query
   * @param {SharedState} sharedState - Shared state object for cross-updater communication
   * @param {Window} windowObj - Window object for checking page context
   * @param {Document} documentObj - DOM document object for UI updates
   */
  function SearchQueryUpdater(searchQueryStore, sharedState, windowObj, documentObj) {
    algoliaStateHandler_classCallCheck(this, SearchQueryUpdater);
    this.searchQueryStore = searchQueryStore;
    this.sharedState = sharedState;
    this.window = windowObj;
    this.document = documentObj;
    this.init();
  }

  /**
   * Initializes the store subscription
   * @private
   */
  return algoliaStateHandler_createClass(SearchQueryUpdater, [{
    key: "init",
    value: function init() {
      var _this2 = this;
      this.searchQueryStore.subscribe(function () {
        try {
          _this2.updateSearchQuery();
        } catch (error) {
          console.error('Error updating search query:', error);
        }
      });
    }

    /**
     * Updates the search query display in the UI when the store changes
     * Skips updates on collection results pages or if value hasn't changed
     * @private
     */
  }, {
    key: "updateSearchQuery",
    value: function updateSearchQuery() {
      var _this$window$algoliaS;
      var previousQuery = this.sharedState.searchQuery;
      this.sharedState.searchQuery = this.searchQueryStore.getState().value;

      // Skip update if value hasn't changed
      if (previousQuery === this.sharedState.searchQuery) return;

      // Skip update if on collection results page
      if ((_this$window$algoliaS = this.window.algoliaShopify) !== null && _this$window$algoliaS !== void 0 && _this$window$algoliaS.is_collection_results_page) return;
      var queryTermElement = this.document.querySelector('[data-query-term]');
      if (!queryTermElement) return;
      queryTermElement.innerHTML = this.sharedState.searchQuery;
    }
  }]);
}();
/**
 * Manages updates to the facets count display in the UI
 */
var FacetsCountUpdater = /*#__PURE__*/function () {
  /**
   * @param {Object} numberOfFacetsStore - The store containing the number of facets
   * @param {SharedState} sharedState - Shared state object for cross-updater communication
   * @param {Window} windowObj - Window object for responsive design checks
   * @param {Document} documentObj - DOM document object for UI updates
   * @param {Object} algoliaShopify - Algolia Shopify integration object containing translations
   */
  function FacetsCountUpdater(numberOfFacetsStore, sharedState, windowObj, documentObj, algoliaShopify) {
    algoliaStateHandler_classCallCheck(this, FacetsCountUpdater);
    this.numberOfFacetsStore = numberOfFacetsStore;
    this.sharedState = sharedState;
    this.window = windowObj;
    this.document = documentObj;
    this.algoliaShopify = algoliaShopify;
    this.init();
  }

  /**
   * Initializes the store subscription
   * @private
   */
  return algoliaStateHandler_createClass(FacetsCountUpdater, [{
    key: "init",
    value: function init() {
      var _this3 = this;
      this.numberOfFacetsStore.subscribe(function () {
        try {
          _this3.updateFacets();
        } catch (error) {
          console.error('Error updating facets:', error);
        }
      });
    }

    /**
     * Updates the facets count display in the UI when the store changes
     * Handles both mobile and desktop displays differently
     * @private
     */
  }, {
    key: "updateFacets",
    value: function updateFacets() {
      var _this$algoliaShopify,
        _this4 = this;
      var previousFacets = this.sharedState.numberOfFacets;
      this.sharedState.numberOfFacets = this.numberOfFacetsStore.getState().value;

      // Skip update if value hasn't changed
      if (previousFacets === this.sharedState.numberOfFacets) return;
      var text = (_this$algoliaShopify = this.algoliaShopify) === null || _this$algoliaShopify === void 0 || (_this$algoliaShopify = _this$algoliaShopify.translations) === null || _this$algoliaShopify === void 0 ? void 0 : _this$algoliaShopify.filterPlusSort;
      if (!text) return;

      // Handle mobile view
      if (this.window.innerWidth < 1024) {
        var mobileToggleElement = this.document.querySelector('.ais-facets-button--mobile-toggle');
        if (mobileToggleElement) {
          mobileToggleElement.innerHTML = text.replace('Filter', "".concat(this.getFilterIcon(), " <span>Filter ").concat(this.getFacetsText(this.sharedState.numberOfFacets))).replace('Sort', 'Sort</span>');
        }
      }

      // Handle desktop view for filter toggle
      var desktopToggleElement = this.document.querySelector('.ais-facets-button');
      desktopToggleElement.addEventListener('click', function () {
        var isFacetSidebarOpen = _this4.document.querySelector('.ais-facets').classList.contains('ais-facets__shown');
        if (!isFacetSidebarOpen) {
          desktopToggleElement.innerHTML = "".concat(algoliaShopify.translations.showFilters, " ").concat(_this4.getFacetsText(_this4.sharedState.numberOfFacets));
        } else {
          desktopToggleElement.innerHTML = "".concat(algoliaShopify.translations.hideFilters);
        }
      });

      // Handle desktop view
      var searchButtonElement = this.document.querySelector('.ais-facets-button--search');
      if (!searchButtonElement) return;
      var currentHTML = searchButtonElement.innerHTML.replace(/\s*\(\d+\)/, '');
      searchButtonElement.innerHTML = "".concat(currentHTML, " ").concat(this.getFacetsText(this.sharedState.numberOfFacets));
    }

    /**
     * Formats the facets count for display
     * @param {number} number - Number of facets to display
     * @returns {string} Formatted facets count string
     * @private
     */
  }, {
    key: "getFacetsText",
    value: function getFacetsText(number) {
      return number > 0 ? "(".concat(number, ")") : '';
    }

    /**
     * Returns the SVG markup for the filter icon
     * @returns {string} SVG markup for the filter icon
     * @private
     */
  }, {
    key: "getFilterIcon",
    value: function getFilterIcon() {
      return "\n      <svg width=\"15\" height=\"12\" viewBox=\"0 0 15 12\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n        <rect y=\"2\" width=\"15\" height=\"1\" rx=\"0.5\" fill=\"black\"></rect>\n        <circle cx=\"10.5\" cy=\"2.5\" r=\"2\" fill=\"white\" stroke=\"black\"></circle>\n        <rect y=\"9\" width=\"15\" height=\"1\" rx=\"0.5\" fill=\"black\"></rect>\n        <circle cx=\"4.5\" cy=\"9.5\" r=\"2\" fill=\"white\" stroke=\"black\"></circle>\n      </svg>";
    }
  }]);
}(); // Initialize all updaters with shared state
new ResultCountUpdater(store, sharedState, document);
new SearchQueryUpdater(searchQueryStore, sharedState, window, document);
new FacetsCountUpdater(numberOfFacetsStore, sharedState, window, document, window.algoliaShopify);

;// ./node_modules/instantsearch-ui-components/dist/es/lib/cx.js
function cx() {
  for (var _len = arguments.length, classNames = new Array(_len), _key = 0; _key < _len; _key++) {
    classNames[_key] = arguments[_key];
  }
  return classNames.reduce(function (acc, className) {
    if (Array.isArray(className)) {
      return acc.concat(className);
    }
    return acc.concat([className]);
  }, []).filter(Boolean).join(' ');
}
;// ./node_modules/preact/dist/preact.module.js
var n,l,t,u,i,r,o,e,f,c,s,a,h,p={},v=[],y=/acit|ex(?:s|g|n|p|$)|rph|grid|ows|mnc|ntw|ine[ch]|zoo|^ord|itera/i,d=Array.isArray;function w(n,l){for(var t in l)n[t]=l[t];return n}function g(n){n&&n.parentNode&&n.parentNode.removeChild(n)}function _(l,t,u){var i,r,o,e={};for(o in t)"key"==o?i=t[o]:"ref"==o?r=t[o]:e[o]=t[o];if(arguments.length>2&&(e.children=arguments.length>3?n.call(arguments,2):u),"function"==typeof l&&null!=l.defaultProps)for(o in l.defaultProps)void 0===e[o]&&(e[o]=l.defaultProps[o]);return m(l,e,i,r,null)}function m(n,u,i,r,o){var e={type:n,props:u,key:i,ref:r,__k:null,__:null,__b:0,__e:null,__c:null,constructor:void 0,__v:null==o?++t:o,__i:-1,__u:0};return null==o&&null!=l.vnode&&l.vnode(e),e}function b(){return{current:null}}function k(n){return n.children}function x(n,l){this.props=n,this.context=l}function S(n,l){if(null==l)return n.__?S(n.__,n.__i+1):null;for(var t;l<n.__k.length;l++)if(null!=(t=n.__k[l])&&null!=t.__e)return t.__e;return"function"==typeof n.type?S(n):null}function C(n){var l,t;if(null!=(n=n.__)&&null!=n.__c){for(n.__e=n.__c.base=null,l=0;l<n.__k.length;l++)if(null!=(t=n.__k[l])&&null!=t.__e){n.__e=n.__c.base=t.__e;break}return C(n)}}function M(n){(!n.__d&&(n.__d=!0)&&i.push(n)&&!$.__r++||r!==l.debounceRendering)&&((r=l.debounceRendering)||o)($)}function $(){for(var n,t,u,r,o,f,c,s=1;i.length;)i.length>s&&i.sort(e),n=i.shift(),s=i.length,n.__d&&(u=void 0,o=(r=(t=n).__v).__e,f=[],c=[],t.__P&&((u=w({},r)).__v=r.__v+1,l.vnode&&l.vnode(u),O(t.__P,u,r,t.__n,t.__P.namespaceURI,32&r.__u?[o]:null,f,null==o?S(r):o,!!(32&r.__u),c),u.__v=r.__v,u.__.__k[u.__i]=u,z(f,u,c),u.__e!=o&&C(u)));$.__r=0}function I(n,l,t,u,i,r,o,e,f,c,s){var a,h,y,d,w,g,_=u&&u.__k||v,m=l.length;for(f=P(t,l,_,f,m),a=0;a<m;a++)null!=(y=t.__k[a])&&(h=-1===y.__i?p:_[y.__i]||p,y.__i=a,g=O(n,y,h,i,r,o,e,f,c,s),d=y.__e,y.ref&&h.ref!=y.ref&&(h.ref&&q(h.ref,null,y),s.push(y.ref,y.__c||d,y)),null==w&&null!=d&&(w=d),4&y.__u||h.__k===y.__k?f=A(y,f,n):"function"==typeof y.type&&void 0!==g?f=g:d&&(f=d.nextSibling),y.__u&=-7);return t.__e=w,f}function P(n,l,t,u,i){var r,o,e,f,c,s=t.length,a=s,h=0;for(n.__k=new Array(i),r=0;r<i;r++)null!=(o=l[r])&&"boolean"!=typeof o&&"function"!=typeof o?(f=r+h,(o=n.__k[r]="string"==typeof o||"number"==typeof o||"bigint"==typeof o||o.constructor==String?m(null,o,null,null,null):d(o)?m(k,{children:o},null,null,null):void 0===o.constructor&&o.__b>0?m(o.type,o.props,o.key,o.ref?o.ref:null,o.__v):o).__=n,o.__b=n.__b+1,e=null,-1!==(c=o.__i=L(o,t,f,a))&&(a--,(e=t[c])&&(e.__u|=2)),null==e||null===e.__v?(-1==c&&(i>s?h--:i<s&&h++),"function"!=typeof o.type&&(o.__u|=4)):c!=f&&(c==f-1?h--:c==f+1?h++:(c>f?h--:h++,o.__u|=4))):n.__k[r]=null;if(a)for(r=0;r<s;r++)null!=(e=t[r])&&0==(2&e.__u)&&(e.__e==u&&(u=S(e)),B(e,e));return u}function A(n,l,t){var u,i;if("function"==typeof n.type){for(u=n.__k,i=0;u&&i<u.length;i++)u[i]&&(u[i].__=n,l=A(u[i],l,t));return l}n.__e!=l&&(l&&n.type&&!t.contains(l)&&(l=S(n)),t.insertBefore(n.__e,l||null),l=n.__e);do{l=l&&l.nextSibling}while(null!=l&&8==l.nodeType);return l}function H(n,l){return l=l||[],null==n||"boolean"==typeof n||(d(n)?n.some(function(n){H(n,l)}):l.push(n)),l}function L(n,l,t,u){var i,r,o=n.key,e=n.type,f=l[t];if(null===f&&null==n.key||f&&o==f.key&&e===f.type&&0==(2&f.__u))return t;if(u>(null!=f&&0==(2&f.__u)?1:0))for(i=t-1,r=t+1;i>=0||r<l.length;){if(i>=0){if((f=l[i])&&0==(2&f.__u)&&o==f.key&&e===f.type)return i;i--}if(r<l.length){if((f=l[r])&&0==(2&f.__u)&&o==f.key&&e===f.type)return r;r++}}return-1}function T(n,l,t){"-"==l[0]?n.setProperty(l,null==t?"":t):n[l]=null==t?"":"number"!=typeof t||y.test(l)?t:t+"px"}function j(n,l,t,u,i){var r;n:if("style"==l)if("string"==typeof t)n.style.cssText=t;else{if("string"==typeof u&&(n.style.cssText=u=""),u)for(l in u)t&&l in t||T(n.style,l,"");if(t)for(l in t)u&&t[l]===u[l]||T(n.style,l,t[l])}else if("o"==l[0]&&"n"==l[1])r=l!=(l=l.replace(f,"$1")),l=l.toLowerCase()in n||"onFocusOut"==l||"onFocusIn"==l?l.toLowerCase().slice(2):l.slice(2),n.l||(n.l={}),n.l[l+r]=t,t?u?t.t=u.t:(t.t=c,n.addEventListener(l,r?a:s,r)):n.removeEventListener(l,r?a:s,r);else{if("http://www.w3.org/2000/svg"==i)l=l.replace(/xlink(H|:h)/,"h").replace(/sName$/,"s");else if("width"!=l&&"height"!=l&&"href"!=l&&"list"!=l&&"form"!=l&&"tabIndex"!=l&&"download"!=l&&"rowSpan"!=l&&"colSpan"!=l&&"role"!=l&&"popover"!=l&&l in n)try{n[l]=null==t?"":t;break n}catch(n){}"function"==typeof t||(null==t||!1===t&&"-"!=l[4]?n.removeAttribute(l):n.setAttribute(l,"popover"==l&&1==t?"":t))}}function F(n){return function(t){if(this.l){var u=this.l[t.type+n];if(null==t.u)t.u=c++;else if(t.u<u.t)return;return u(l.event?l.event(t):t)}}}function O(n,t,u,i,r,o,e,f,c,s){var a,h,p,v,y,_,m,b,S,C,M,$,P,A,H,L,T,j=t.type;if(void 0!==t.constructor)return null;128&u.__u&&(c=!!(32&u.__u),o=[f=t.__e=u.__e]),(a=l.__b)&&a(t);n:if("function"==typeof j)try{if(b=t.props,S="prototype"in j&&j.prototype.render,C=(a=j.contextType)&&i[a.__c],M=a?C?C.props.value:a.__:i,u.__c?m=(h=t.__c=u.__c).__=h.__E:(S?t.__c=h=new j(b,M):(t.__c=h=new x(b,M),h.constructor=j,h.render=D),C&&C.sub(h),h.props=b,h.state||(h.state={}),h.context=M,h.__n=i,p=h.__d=!0,h.__h=[],h._sb=[]),S&&null==h.__s&&(h.__s=h.state),S&&null!=j.getDerivedStateFromProps&&(h.__s==h.state&&(h.__s=w({},h.__s)),w(h.__s,j.getDerivedStateFromProps(b,h.__s))),v=h.props,y=h.state,h.__v=t,p)S&&null==j.getDerivedStateFromProps&&null!=h.componentWillMount&&h.componentWillMount(),S&&null!=h.componentDidMount&&h.__h.push(h.componentDidMount);else{if(S&&null==j.getDerivedStateFromProps&&b!==v&&null!=h.componentWillReceiveProps&&h.componentWillReceiveProps(b,M),!h.__e&&(null!=h.shouldComponentUpdate&&!1===h.shouldComponentUpdate(b,h.__s,M)||t.__v==u.__v)){for(t.__v!=u.__v&&(h.props=b,h.state=h.__s,h.__d=!1),t.__e=u.__e,t.__k=u.__k,t.__k.some(function(n){n&&(n.__=t)}),$=0;$<h._sb.length;$++)h.__h.push(h._sb[$]);h._sb=[],h.__h.length&&e.push(h);break n}null!=h.componentWillUpdate&&h.componentWillUpdate(b,h.__s,M),S&&null!=h.componentDidUpdate&&h.__h.push(function(){h.componentDidUpdate(v,y,_)})}if(h.context=M,h.props=b,h.__P=n,h.__e=!1,P=l.__r,A=0,S){for(h.state=h.__s,h.__d=!1,P&&P(t),a=h.render(h.props,h.state,h.context),H=0;H<h._sb.length;H++)h.__h.push(h._sb[H]);h._sb=[]}else do{h.__d=!1,P&&P(t),a=h.render(h.props,h.state,h.context),h.state=h.__s}while(h.__d&&++A<25);h.state=h.__s,null!=h.getChildContext&&(i=w(w({},i),h.getChildContext())),S&&!p&&null!=h.getSnapshotBeforeUpdate&&(_=h.getSnapshotBeforeUpdate(v,y)),L=a,null!=a&&a.type===k&&null==a.key&&(L=N(a.props.children)),f=I(n,d(L)?L:[L],t,u,i,r,o,e,f,c,s),h.base=t.__e,t.__u&=-161,h.__h.length&&e.push(h),m&&(h.__E=h.__=null)}catch(n){if(t.__v=null,c||null!=o)if(n.then){for(t.__u|=c?160:128;f&&8==f.nodeType&&f.nextSibling;)f=f.nextSibling;o[o.indexOf(f)]=null,t.__e=f}else for(T=o.length;T--;)g(o[T]);else t.__e=u.__e,t.__k=u.__k;l.__e(n,t,u)}else null==o&&t.__v==u.__v?(t.__k=u.__k,t.__e=u.__e):f=t.__e=V(u.__e,t,u,i,r,o,e,c,s);return(a=l.diffed)&&a(t),128&t.__u?void 0:f}function z(n,t,u){for(var i=0;i<u.length;i++)q(u[i],u[++i],u[++i]);l.__c&&l.__c(t,n),n.some(function(t){try{n=t.__h,t.__h=[],n.some(function(n){n.call(t)})}catch(n){l.__e(n,t.__v)}})}function N(n){return"object"!=typeof n||null==n?n:d(n)?n.map(N):w({},n)}function V(t,u,i,r,o,e,f,c,s){var a,h,v,y,w,_,m,b=i.props,k=u.props,x=u.type;if("svg"==x?o="http://www.w3.org/2000/svg":"math"==x?o="http://www.w3.org/1998/Math/MathML":o||(o="http://www.w3.org/1999/xhtml"),null!=e)for(a=0;a<e.length;a++)if((w=e[a])&&"setAttribute"in w==!!x&&(x?w.localName==x:3==w.nodeType)){t=w,e[a]=null;break}if(null==t){if(null==x)return document.createTextNode(k);t=document.createElementNS(o,x,k.is&&k),c&&(l.__m&&l.__m(u,e),c=!1),e=null}if(null===x)b===k||c&&t.data===k||(t.data=k);else{if(e=e&&n.call(t.childNodes),b=i.props||p,!c&&null!=e)for(b={},a=0;a<t.attributes.length;a++)b[(w=t.attributes[a]).name]=w.value;for(a in b)if(w=b[a],"children"==a);else if("dangerouslySetInnerHTML"==a)v=w;else if(!(a in k)){if("value"==a&&"defaultValue"in k||"checked"==a&&"defaultChecked"in k)continue;j(t,a,null,w,o)}for(a in k)w=k[a],"children"==a?y=w:"dangerouslySetInnerHTML"==a?h=w:"value"==a?_=w:"checked"==a?m=w:c&&"function"!=typeof w||b[a]===w||j(t,a,w,b[a],o);if(h)c||v&&(h.__html===v.__html||h.__html===t.innerHTML)||(t.innerHTML=h.__html),u.__k=[];else if(v&&(t.innerHTML=""),I("template"===u.type?t.content:t,d(y)?y:[y],u,i,r,"foreignObject"==x?"http://www.w3.org/1999/xhtml":o,e,f,e?e[0]:i.__k&&S(i,0),c,s),null!=e)for(a=e.length;a--;)g(e[a]);c||(a="value","progress"==x&&null==_?t.removeAttribute("value"):void 0!==_&&(_!==t[a]||"progress"==x&&!_||"option"==x&&_!==b[a])&&j(t,a,_,b[a],o),a="checked",void 0!==m&&m!==t[a]&&j(t,a,m,b[a],o))}return t}function q(n,t,u){try{if("function"==typeof n){var i="function"==typeof n.__u;i&&n.__u(),i&&null==t||(n.__u=n(t))}else n.current=t}catch(n){l.__e(n,u)}}function B(n,t,u){var i,r;if(l.unmount&&l.unmount(n),(i=n.ref)&&(i.current&&i.current!==n.__e||q(i,null,t)),null!=(i=n.__c)){if(i.componentWillUnmount)try{i.componentWillUnmount()}catch(n){l.__e(n,t)}i.base=i.__P=null}if(i=n.__k)for(r=0;r<i.length;r++)i[r]&&B(i[r],t,u||"function"!=typeof n.type);u||g(n.__e),n.__c=n.__=n.__e=void 0}function D(n,l,t){return this.constructor(n,t)}function E(t,u,i){var r,o,e,f;u==document&&(u=document.documentElement),l.__&&l.__(t,u),o=(r="function"==typeof i)?null:i&&i.__k||u.__k,e=[],f=[],O(u,t=(!r&&i||u).__k=_(k,null,[t]),o||p,p,u.namespaceURI,!r&&i?[i]:o?null:u.firstChild?n.call(u.childNodes):null,e,!r&&i?i:o?o.__e:u.firstChild,r,f),z(e,t,f)}function G(n,l){E(n,l,G)}function J(l,t,u){var i,r,o,e,f=w({},l.props);for(o in l.type&&l.type.defaultProps&&(e=l.type.defaultProps),t)"key"==o?i=t[o]:"ref"==o?r=t[o]:f[o]=void 0===t[o]&&void 0!==e?e[o]:t[o];return arguments.length>2&&(f.children=arguments.length>3?n.call(arguments,2):u),m(l.type,f,i||l.key,r||l.ref,null)}function K(n){function l(n){var t,u;return this.getChildContext||(t=new Set,(u={})[l.__c]=this,this.getChildContext=function(){return u},this.componentWillUnmount=function(){t=null},this.shouldComponentUpdate=function(n){this.props.value!==n.value&&t.forEach(function(n){n.__e=!0,M(n)})},this.sub=function(n){t.add(n);var l=n.componentWillUnmount;n.componentWillUnmount=function(){t&&t.delete(n),l&&l.call(n)}}),n.children}return l.__c="__cC"+h++,l.__=n,l.Provider=l.__l=(l.Consumer=function(n,l){return n.children(l)}).contextType=l,l}n=v.slice,l={__e:function(n,l,t,u){for(var i,r,o;l=l.__;)if((i=l.__c)&&!i.__)try{if((r=i.constructor)&&null!=r.getDerivedStateFromError&&(i.setState(r.getDerivedStateFromError(n)),o=i.__d),null!=i.componentDidCatch&&(i.componentDidCatch(n,u||{}),o=i.__d),o)return i.__E=i}catch(l){n=l}throw n}},t=0,u=function(n){return null!=n&&null==n.constructor},x.prototype.setState=function(n,l){var t;t=null!=this.__s&&this.__s!==this.state?this.__s:this.__s=w({},this.state),"function"==typeof n&&(n=n(w({},t),this.props)),n&&w(t,n),null!=n&&this.__v&&(l&&this._sb.push(l),M(this))},x.prototype.forceUpdate=function(n){this.__v&&(this.__e=!0,n&&this.__h.push(n),M(this))},x.prototype.render=k,i=[],o="function"==typeof Promise?Promise.prototype.then.bind(Promise.resolve()):setTimeout,e=function(n,l){return n.__v.__b-l.__v.__b},$.__r=0,f=/(PointerCapture)$|Capture$/i,c=0,s=F(!1),a=F(!0),h=0;
//# sourceMappingURL=preact.module.js.map

;// ./node_modules/instantsearch.js/es/lib/utils/isSpecialClick.js
function isSpecialClick(event) {
  var isMiddleClick = event.button === 1;
  return isMiddleClick || event.altKey || event.ctrlKey || event.metaKey || event.shiftKey;
}
;// ./node_modules/instantsearch.js/es/lib/utils/isEqual.js
function isPrimitive(obj) {
  return obj !== Object(obj);
}
function isEqual(first, second) {
  if (first === second) {
    return true;
  }
  if (isPrimitive(first) || isPrimitive(second) || typeof first === 'function' || typeof second === 'function') {
    return first === second;
  }
  if (Object.keys(first).length !== Object.keys(second).length) {
    return false;
  }

  // @TODO avoid for..of because of the large polyfill
  // eslint-disable-next-line no-restricted-syntax
  for (var _i = 0, _Object$keys = Object.keys(first); _i < _Object$keys.length; _i++) {
    var key = _Object$keys[_i];
    if (!(key in second)) {
      return false;
    }
    if (!isEqual(first[key], second[key])) {
      return false;
    }
  }
  return true;
}
;// ./node_modules/instantsearch.js/es/lib/utils/noop.js
function noop_noop() {}
// EXTERNAL MODULE: ./node_modules/hogan.js/lib/hogan.js
var hogan = __webpack_require__(4714);
;// ./node_modules/htm/dist/htm.module.js
var htm_module_n=function(t,s,r,e){var u;s[0]=0;for(var h=1;h<s.length;h++){var p=s[h++],a=s[h]?(s[0]|=p?1:2,r[s[h++]]):s[++h];3===p?e[0]=a:4===p?e[1]=Object.assign(e[1]||{},a):5===p?(e[1]=e[1]||{})[s[++h]]=a:6===p?e[1][s[++h]]+=a+"":p?(u=t.apply(a,htm_module_n(t,a,r,["",null])),e.push(u),a[0]?s[0]|=2:(s[h-2]=0,s[h]=u)):e.push(a)}return e},htm_module_t=new Map;/* harmony default export */ function htm_module(s){var r=htm_module_t.get(this);return r||(r=new Map,htm_module_t.set(this,r)),(r=htm_module_n(this,r.get(s)||(r.set(s,r=function(n){for(var t,s,r=1,e="",u="",h=[0],p=function(n){1===r&&(n||(e=e.replace(/^\s*\n\s*|\s*\n\s*$/g,"")))?h.push(0,n,e):3===r&&(n||e)?(h.push(3,n,e),r=2):2===r&&"..."===e&&n?h.push(4,n,0):2===r&&e&&!n?h.push(5,0,!0,e):r>=5&&((e||!n&&5===r)&&(h.push(r,0,e,s),r=6),n&&(h.push(r,n,0,s),r=6)),e=""},a=0;a<n.length;a++){a&&(1===r&&p(),p(a));for(var l=0;l<n[a].length;l++)t=n[a][l],1===r?"<"===t?(p(),h=[h],r=3):e+=t:4===r?"--"===e&&">"===t?(r=1,e=""):e=t+e[0]:u?t===u?u="":e+=t:'"'===t||"'"===t?u=t:">"===t?(p(),r=1):r&&("="===t?(r=5,s=e,e=""):"/"===t&&(r<5||">"===n[a][l+1])?(p(),3===r&&(h=h[0]),r=h,(h=h[0]).push(2,0,r),r=0):" "===t||"\t"===t||"\n"===t||"\r"===t?(p(),r=2):e+=t),3===r&&"!--"===e&&(r=4,h=h[0])}return p(),h}(s)),r),arguments,[])).length>1?r:r[0]}

;// ./node_modules/htm/preact/index.module.js
var index_module_m=htm_module.bind(_);

;// ./node_modules/@babel/runtime/helpers/esm/extends.js
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}

;// ./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (-1 !== e.indexOf(n)) continue;
    t[n] = r[n];
  }
  return t;
}

;// ./node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js

function _objectWithoutProperties(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose(e, t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}

;// ./node_modules/instantsearch-ui-components/dist/es/components/Highlight.js


var _excluded = ["parts", "highlightedTagName", "nonHighlightedTagName", "separator", "className", "classNames"];

function createHighlightPartComponent(_ref) {
  var createElement = _ref.createElement;
  return function HighlightPart(_ref2) {
    var classNames = _ref2.classNames,
      children = _ref2.children,
      highlightedTagName = _ref2.highlightedTagName,
      isHighlighted = _ref2.isHighlighted,
      nonHighlightedTagName = _ref2.nonHighlightedTagName;
    var TagName = isHighlighted ? highlightedTagName : nonHighlightedTagName;
    return createElement(TagName, {
      className: isHighlighted ? classNames.highlighted : classNames.nonHighlighted
    }, children);
  };
}
function createHighlightComponent(_ref3) {
  var createElement = _ref3.createElement,
    Fragment = _ref3.Fragment;
  var HighlightPart = createHighlightPartComponent({
    createElement: createElement,
    Fragment: Fragment
  });
  return function Highlight(userProps) {
    var parts = userProps.parts,
      _userProps$highlighte = userProps.highlightedTagName,
      highlightedTagName = _userProps$highlighte === void 0 ? 'mark' : _userProps$highlighte,
      _userProps$nonHighlig = userProps.nonHighlightedTagName,
      nonHighlightedTagName = _userProps$nonHighlig === void 0 ? 'span' : _userProps$nonHighlig,
      _userProps$separator = userProps.separator,
      separator = _userProps$separator === void 0 ? ', ' : _userProps$separator,
      className = userProps.className,
      _userProps$classNames = userProps.classNames,
      classNames = _userProps$classNames === void 0 ? {} : _userProps$classNames,
      props = _objectWithoutProperties(userProps, _excluded);
    return createElement("span", _extends({}, props, {
      className: cx(classNames.root, className)
    }), parts.map(function (part, partIndex) {
      var isLastPart = partIndex === parts.length - 1;
      return createElement(Fragment, {
        key: partIndex
      }, part.map(function (subPart, subPartIndex) {
        return createElement(HighlightPart, {
          key: subPartIndex,
          classNames: classNames,
          highlightedTagName: highlightedTagName,
          nonHighlightedTagName: nonHighlightedTagName,
          isHighlighted: subPart.isHighlighted
        }, subPart.value);
      }), !isLastPart && createElement("span", {
        className: classNames.separator
      }, separator));
    }));
  };
}
;// ./node_modules/instantsearch.js/es/components/InternalHighlight/InternalHighlight.js


var InternalHighlight = createHighlightComponent({
  createElement: _,
  Fragment: k
});
;// ./node_modules/instantsearch.js/es/components/Highlight/Highlight.js
var Highlight_excluded = ["classNames"];
function Highlight_extends() { Highlight_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return Highlight_extends.apply(this, arguments); }
function Highlight_objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = Highlight_objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function Highlight_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }



function Highlight(_ref) {
  var _ref$classNames = _ref.classNames,
    classNames = _ref$classNames === void 0 ? {} : _ref$classNames,
    props = Highlight_objectWithoutProperties(_ref, Highlight_excluded);
  return _(InternalHighlight, Highlight_extends({
    classNames: {
      root: cx('ais-Highlight', classNames.root),
      highlighted: cx('ais-Highlight-highlighted', classNames.highlighted),
      nonHighlighted: cx('ais-Highlight-nonHighlighted', classNames.nonHighlighted),
      separator: cx('ais-Highlight-separator', classNames.separator)
    }
  }, props));
}
;// ./node_modules/instantsearch.js/es/lib/utils/getPropertyByPath.js
function getPropertyByPath(object, path) {
  var parts = Array.isArray(path) ? path : path.split('.');
  return parts.reduce(function (current, key) {
    return current && current[key];
  }, object);
}
;// ./node_modules/instantsearch.js/es/lib/utils/toArray.js
function toArray(value) {
  return Array.isArray(value) ? value : [value];
}
;// ./node_modules/instantsearch.js/es/lib/utils/escape-html.js
/**
 * This implementation is taken from Lodash implementation.
 * See: https://github.com/lodash/lodash/blob/4.17.11-npm/escape.js
 */

// Used to map characters to HTML entities.
var htmlEntities = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  "'": '&#39;'
};

// Used to match HTML entities and HTML characters.
var regexUnescapedHtml = /[&<>"']/g;
var regexHasUnescapedHtml = RegExp(regexUnescapedHtml.source);

/**
 * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
 * corresponding HTML entities.
 */
function escape_html_escape(value) {
  return value && regexHasUnescapedHtml.test(value) ? value.replace(regexUnescapedHtml, function (character) {
    return htmlEntities[character];
  }) : value;
}

/**
 * This implementation is taken from Lodash implementation.
 * See: https://github.com/lodash/lodash/blob/4.17.11-npm/unescape.js
 */

// Used to map HTML entities to characters.
var htmlCharacters = {
  '&amp;': '&',
  '&lt;': '<',
  '&gt;': '>',
  '&quot;': '"',
  '&#39;': "'"
};

// Used to match HTML entities and HTML characters.
var regexEscapedHtml = /&(amp|quot|lt|gt|#39);/g;
var regexHasEscapedHtml = RegExp(regexEscapedHtml.source);

/**
 * Converts the HTML entities "&", "<", ">", '"', and "'" in `string` to their
 * characters.
 */
function escape_html_unescape(value) {
  return value && regexHasEscapedHtml.test(value) ? value.replace(regexEscapedHtml, function (character) {
    return htmlCharacters[character];
  }) : value;
}
;// ./node_modules/instantsearch.js/es/lib/utils/escape-highlight.js
function escape_highlight_typeof(o) { "@babel/helpers - typeof"; return escape_highlight_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, escape_highlight_typeof(o); }
function _objectDestructuringEmpty(obj) { if (obj == null) throw new TypeError("Cannot destructure " + obj); }
function escape_highlight_extends() { escape_highlight_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return escape_highlight_extends.apply(this, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = escape_highlight_toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function escape_highlight_toPropertyKey(t) { var i = escape_highlight_toPrimitive(t, "string"); return "symbol" == escape_highlight_typeof(i) ? i : String(i); }
function escape_highlight_toPrimitive(t, r) { if ("object" != escape_highlight_typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != escape_highlight_typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }


var TAG_PLACEHOLDER = {
  highlightPreTag: '__ais-highlight__',
  highlightPostTag: '__/ais-highlight__'
};
var TAG_REPLACEMENT = {
  highlightPreTag: '<mark>',
  highlightPostTag: '</mark>'
};

// @MAJOR: in the future, this should only escape, not replace
function replaceTagsAndEscape(value) {
  return escape_html_escape(value).replace(new RegExp(TAG_PLACEHOLDER.highlightPreTag, 'g'), TAG_REPLACEMENT.highlightPreTag).replace(new RegExp(TAG_PLACEHOLDER.highlightPostTag, 'g'), TAG_REPLACEMENT.highlightPostTag);
}
function recursiveEscape(input) {
  if (isPlainObject(input) && typeof input.value !== 'string') {
    return Object.keys(input).reduce(function (acc, key) {
      return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, key, recursiveEscape(input[key])));
    }, {});
  }
  if (Array.isArray(input)) {
    return input.map(recursiveEscape);
  }
  return _objectSpread(_objectSpread({}, input), {}, {
    value: replaceTagsAndEscape(input.value)
  });
}
function escapeHits(hits) {
  if (hits.__escaped === undefined) {
    // We don't override the value on hit because it will mutate the raw results
    // instead we make a shallow copy and we assign the escaped values on it.
    hits = hits.map(function (_ref) {
      var hit = escape_highlight_extends({}, (_objectDestructuringEmpty(_ref), _ref));
      if (hit._highlightResult) {
        hit._highlightResult = recursiveEscape(hit._highlightResult);
      }
      if (hit._snippetResult) {
        hit._snippetResult = recursiveEscape(hit._snippetResult);
      }
      return hit;
    });
    hits.__escaped = true;
  }
  return hits;
}
function escapeFacets(facetHits) {
  return facetHits.map(function (h) {
    return _objectSpread(_objectSpread({}, h), {}, {
      highlighted: replaceTagsAndEscape(h.highlighted)
    });
  });
}
;// ./node_modules/instantsearch.js/es/lib/utils/getHighlightedParts.js

function getHighlightedParts(highlightedValue) {
  // @MAJOR: this should use TAG_PLACEHOLDER
  var highlightPostTag = TAG_REPLACEMENT.highlightPostTag,
    highlightPreTag = TAG_REPLACEMENT.highlightPreTag;
  var splitByPreTag = highlightedValue.split(highlightPreTag);
  var firstValue = splitByPreTag.shift();
  var elements = !firstValue ? [] : [{
    value: firstValue,
    isHighlighted: false
  }];
  splitByPreTag.forEach(function (split) {
    var splitByPostTag = split.split(highlightPostTag);
    elements.push({
      value: splitByPostTag[0],
      isHighlighted: true
    });
    if (splitByPostTag[1] !== '') {
      elements.push({
        value: splitByPostTag[1],
        isHighlighted: false
      });
    }
  });
  return elements;
}
;// ./node_modules/instantsearch.js/es/helpers/components/Highlight.js
var components_Highlight_excluded = ["hit", "attribute", "cssClasses"];
function components_Highlight_extends() { components_Highlight_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return components_Highlight_extends.apply(this, arguments); }
function components_Highlight_objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = components_Highlight_objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function components_Highlight_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }



function Highlight_Highlight(_ref) {
  var hit = _ref.hit,
    attribute = _ref.attribute,
    cssClasses = _ref.cssClasses,
    props = components_Highlight_objectWithoutProperties(_ref, components_Highlight_excluded);
  var property = getPropertyByPath(hit._highlightResult, attribute) || [];
  var properties = toArray(property);
   false ? 0 : void 0;
  var parts = properties.map(function (_ref2) {
    var value = _ref2.value;
    return getHighlightedParts(escape_html_unescape(value || ''));
  });
  return _(Highlight, components_Highlight_extends({}, props, {
    parts: parts,
    classNames: cssClasses
  }));
}
;// ./node_modules/instantsearch.js/es/components/ReverseHighlight/ReverseHighlight.js
var ReverseHighlight_excluded = ["classNames"];
function ReverseHighlight_extends() { ReverseHighlight_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return ReverseHighlight_extends.apply(this, arguments); }
function ReverseHighlight_objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = ReverseHighlight_objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function ReverseHighlight_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }



function ReverseHighlight(_ref) {
  var _ref$classNames = _ref.classNames,
    classNames = _ref$classNames === void 0 ? {} : _ref$classNames,
    props = ReverseHighlight_objectWithoutProperties(_ref, ReverseHighlight_excluded);
  return _(InternalHighlight, ReverseHighlight_extends({
    classNames: {
      root: cx('ais-ReverseHighlight', classNames.root),
      highlighted: cx('ais-ReverseHighlight-highlighted', classNames.highlighted),
      nonHighlighted: cx('ais-ReverseHighlight-nonHighlighted', classNames.nonHighlighted),
      separator: cx('ais-ReverseHighlight-separator', classNames.separator)
    }
  }, props));
}
;// ./node_modules/instantsearch.js/es/helpers/components/ReverseHighlight.js
function ReverseHighlight_typeof(o) { "@babel/helpers - typeof"; return ReverseHighlight_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, ReverseHighlight_typeof(o); }
var components_ReverseHighlight_excluded = ["hit", "attribute", "cssClasses"],
  _excluded2 = ["isHighlighted"];
function components_ReverseHighlight_extends() { components_ReverseHighlight_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return components_ReverseHighlight_extends.apply(this, arguments); }
function ReverseHighlight_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function ReverseHighlight_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ReverseHighlight_ownKeys(Object(t), !0).forEach(function (r) { ReverseHighlight_defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ReverseHighlight_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function ReverseHighlight_defineProperty(obj, key, value) { key = ReverseHighlight_toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function ReverseHighlight_toPropertyKey(t) { var i = ReverseHighlight_toPrimitive(t, "string"); return "symbol" == ReverseHighlight_typeof(i) ? i : String(i); }
function ReverseHighlight_toPrimitive(t, r) { if ("object" != ReverseHighlight_typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != ReverseHighlight_typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function components_ReverseHighlight_objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = components_ReverseHighlight_objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function components_ReverseHighlight_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }



function ReverseHighlight_ReverseHighlight(_ref) {
  var hit = _ref.hit,
    attribute = _ref.attribute,
    cssClasses = _ref.cssClasses,
    props = components_ReverseHighlight_objectWithoutProperties(_ref, components_ReverseHighlight_excluded);
  var property = getPropertyByPath(hit._highlightResult, attribute) || [];
  var properties = toArray(property);
   false ? 0 : void 0;
  var parts = properties.map(function (_ref2) {
    var value = _ref2.value;
    return getHighlightedParts(escape_html_unescape(value || '')).map(function (_ref3) {
      var isHighlighted = _ref3.isHighlighted,
        rest = components_ReverseHighlight_objectWithoutProperties(_ref3, _excluded2);
      return ReverseHighlight_objectSpread(ReverseHighlight_objectSpread({}, rest), {}, {
        isHighlighted: !isHighlighted
      });
    });
  });
  return _(ReverseHighlight, components_ReverseHighlight_extends({}, props, {
    parts: parts,
    classNames: cssClasses
  }));
}
;// ./node_modules/instantsearch.js/es/components/Snippet/Snippet.js
var Snippet_excluded = ["classNames"];
function Snippet_extends() { Snippet_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return Snippet_extends.apply(this, arguments); }
function Snippet_objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = Snippet_objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function Snippet_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }



function Snippet(_ref) {
  var _ref$classNames = _ref.classNames,
    classNames = _ref$classNames === void 0 ? {} : _ref$classNames,
    props = Snippet_objectWithoutProperties(_ref, Snippet_excluded);
  return _(InternalHighlight, Snippet_extends({
    classNames: {
      root: cx('ais-Snippet', classNames.root),
      highlighted: cx('ais-Snippet-highlighted', classNames.highlighted),
      nonHighlighted: cx('ais-Snippet-nonHighlighted', classNames.nonHighlighted),
      separator: cx('ais-Snippet-separator', classNames.separator)
    }
  }, props));
}
;// ./node_modules/instantsearch.js/es/helpers/components/Snippet.js
var components_Snippet_excluded = ["hit", "attribute", "cssClasses"];
function components_Snippet_extends() { components_Snippet_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return components_Snippet_extends.apply(this, arguments); }
function components_Snippet_objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = components_Snippet_objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function components_Snippet_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }



function Snippet_Snippet(_ref) {
  var hit = _ref.hit,
    attribute = _ref.attribute,
    cssClasses = _ref.cssClasses,
    props = components_Snippet_objectWithoutProperties(_ref, components_Snippet_excluded);
  var property = getPropertyByPath(hit._snippetResult, attribute) || [];
  var properties = toArray(property);
   false ? 0 : void 0;
  var parts = properties.map(function (_ref2) {
    var value = _ref2.value;
    return getHighlightedParts(escape_html_unescape(value || ''));
  });
  return _(Snippet, components_Snippet_extends({}, props, {
    parts: parts,
    classNames: cssClasses
  }));
}
;// ./node_modules/instantsearch.js/es/components/ReverseSnippet/ReverseSnippet.js
var ReverseSnippet_excluded = ["classNames"];
function ReverseSnippet_extends() { ReverseSnippet_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return ReverseSnippet_extends.apply(this, arguments); }
function ReverseSnippet_objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = ReverseSnippet_objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function ReverseSnippet_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }



function ReverseSnippet(_ref) {
  var _ref$classNames = _ref.classNames,
    classNames = _ref$classNames === void 0 ? {} : _ref$classNames,
    props = ReverseSnippet_objectWithoutProperties(_ref, ReverseSnippet_excluded);
  return _(InternalHighlight, ReverseSnippet_extends({
    classNames: {
      root: cx('ais-ReverseSnippet', classNames.root),
      highlighted: cx('ais-ReverseSnippet-highlighted', classNames.highlighted),
      nonHighlighted: cx('ais-ReverseSnippet-nonHighlighted', classNames.nonHighlighted),
      separator: cx('ais-ReverseSnippet-separator', classNames.separator)
    }
  }, props));
}
;// ./node_modules/instantsearch.js/es/helpers/components/ReverseSnippet.js
function ReverseSnippet_typeof(o) { "@babel/helpers - typeof"; return ReverseSnippet_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, ReverseSnippet_typeof(o); }
var components_ReverseSnippet_excluded = ["hit", "attribute", "cssClasses"],
  ReverseSnippet_excluded2 = ["isHighlighted"];
function components_ReverseSnippet_extends() { components_ReverseSnippet_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return components_ReverseSnippet_extends.apply(this, arguments); }
function ReverseSnippet_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function ReverseSnippet_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ReverseSnippet_ownKeys(Object(t), !0).forEach(function (r) { ReverseSnippet_defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ReverseSnippet_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function ReverseSnippet_defineProperty(obj, key, value) { key = ReverseSnippet_toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function ReverseSnippet_toPropertyKey(t) { var i = ReverseSnippet_toPrimitive(t, "string"); return "symbol" == ReverseSnippet_typeof(i) ? i : String(i); }
function ReverseSnippet_toPrimitive(t, r) { if ("object" != ReverseSnippet_typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != ReverseSnippet_typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function components_ReverseSnippet_objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = components_ReverseSnippet_objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function components_ReverseSnippet_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }



function ReverseSnippet_ReverseSnippet(_ref) {
  var hit = _ref.hit,
    attribute = _ref.attribute,
    cssClasses = _ref.cssClasses,
    props = components_ReverseSnippet_objectWithoutProperties(_ref, components_ReverseSnippet_excluded);
  var property = getPropertyByPath(hit._snippetResult, attribute) || [];
  var properties = toArray(property);
   false ? 0 : void 0;
  var parts = properties.map(function (_ref2) {
    var value = _ref2.value;
    return getHighlightedParts(escape_html_unescape(value || '')).map(function (_ref3) {
      var isHighlighted = _ref3.isHighlighted,
        rest = components_ReverseSnippet_objectWithoutProperties(_ref3, ReverseSnippet_excluded2);
      return ReverseSnippet_objectSpread(ReverseSnippet_objectSpread({}, rest), {}, {
        isHighlighted: !isHighlighted
      });
    });
  });
  return _(ReverseSnippet, components_ReverseSnippet_extends({}, props, {
    parts: parts,
    classNames: cssClasses
  }));
}
;// ./node_modules/instantsearch.js/es/lib/templating/renderTemplate.js
function renderTemplate_typeof(o) { "@babel/helpers - typeof"; return renderTemplate_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, renderTemplate_typeof(o); }
function renderTemplate_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function renderTemplate_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? renderTemplate_ownKeys(Object(t), !0).forEach(function (r) { renderTemplate_defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : renderTemplate_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function renderTemplate_defineProperty(obj, key, value) { key = renderTemplate_toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function renderTemplate_toPropertyKey(t) { var i = renderTemplate_toPrimitive(t, "string"); return "symbol" == renderTemplate_typeof(i) ? i : String(i); }
function renderTemplate_toPrimitive(t, r) { if ("object" != renderTemplate_typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != renderTemplate_typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }



// We add all our template helper methods to the template as lambdas. Note
// that lambdas in Mustache are supposed to accept a second argument of
// `render` to get the rendered value, not the literal `{{value}}`. But
// this is currently broken (see https://github.com/twitter/hogan.js/issues/222).
function transformHelpersToHogan() {
  var helpers = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var compileOptions = arguments.length > 1 ? arguments[1] : undefined;
  var data = arguments.length > 2 ? arguments[2] : undefined;
  return Object.keys(helpers).reduce(function (acc, helperKey) {
    return renderTemplate_objectSpread(renderTemplate_objectSpread({}, acc), {}, renderTemplate_defineProperty({}, helperKey, function () {
      var _this = this;
      return function (text) {
        var render = function render(value) {
          return hogan.compile(value, compileOptions).render(_this);
        };
        return helpers[helperKey].call(data, text, render);
      };
    }));
  }, {});
}
function renderTemplate(_ref) {
  var templates = _ref.templates,
    templateKey = _ref.templateKey,
    compileOptions = _ref.compileOptions,
    helpers = _ref.helpers,
    data = _ref.data,
    bindEvent = _ref.bindEvent,
    sendEvent = _ref.sendEvent;
  var template = templates[templateKey];
  if (typeof template !== 'string' && typeof template !== 'function') {
    throw new Error("Template must be 'string' or 'function', was '".concat(renderTemplate_typeof(template), "' (key: ").concat(templateKey, ")"));
  }
  if (typeof template === 'function') {
    // @MAJOR no longer pass bindEvent when string templates are removed
    var params = bindEvent || {};
    params.html = index_module_m;
    params.sendEvent = sendEvent;
    params.components = {
      Highlight: Highlight_Highlight,
      ReverseHighlight: ReverseHighlight_ReverseHighlight,
      Snippet: Snippet_Snippet,
      ReverseSnippet: ReverseSnippet_ReverseSnippet
    };

    // @MAJOR remove the `as any` when string templates are removed
    // needed because not every template receives sendEvent
    return template(data, params);
  }
  var transformedHelpers = transformHelpersToHogan(helpers, compileOptions, data);
  return hogan.compile(template, compileOptions).render(renderTemplate_objectSpread(renderTemplate_objectSpread({}, data), {}, {
    helpers: transformedHelpers
  })).replace(/[ \n\r\t\f\xA0]+/g, function (spaces) {
    return spaces.replace(/(^|\xA0+)[^\xA0]+/g, '$1 ');
  }).trim();
}
;// ./node_modules/instantsearch.js/es/components/Template/Template.js
function Template_extends() { Template_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return Template_extends.apply(this, arguments); }
function Template_typeof(o) { "@babel/helpers - typeof"; return Template_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, Template_typeof(o); }
function Template_toConsumableArray(arr) { return Template_arrayWithoutHoles(arr) || Template_iterableToArray(arr) || Template_unsupportedIterableToArray(arr) || Template_nonIterableSpread(); }
function Template_nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function Template_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return Template_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return Template_arrayLikeToArray(o, minLen); }
function Template_iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function Template_arrayWithoutHoles(arr) { if (Array.isArray(arr)) return Template_arrayLikeToArray(arr); }
function Template_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function Template_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function Template_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, Template_toPropertyKey(descriptor.key), descriptor); } }
function Template_createClass(Constructor, protoProps, staticProps) { if (protoProps) Template_defineProperties(Constructor.prototype, protoProps); if (staticProps) Template_defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (Template_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function Template_defineProperty(obj, key, value) { key = Template_toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function Template_toPropertyKey(t) { var i = Template_toPrimitive(t, "string"); return "symbol" == Template_typeof(i) ? i : String(i); }
function Template_toPrimitive(t, r) { if ("object" != Template_typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != Template_typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }



var RawHtml = /*#__PURE__*/function (_Component) {
  _inherits(RawHtml, _Component);
  var _super = _createSuper(RawHtml);
  function RawHtml() {
    var _this;
    Template_classCallCheck(this, RawHtml);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    Template_defineProperty(_assertThisInitialized(_this), "ref", b());
    Template_defineProperty(_assertThisInitialized(_this), "nodes", []);
    return _this;
  }
  Template_createClass(RawHtml, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var fragment = new DocumentFragment();
      var root = document.createElement('div');
      root.innerHTML = this.props.content;
      this.nodes = Template_toConsumableArray(root.childNodes);
      this.nodes.forEach(function (node) {
        return fragment.appendChild(node);
      });
      this.ref.current.replaceWith(fragment);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.nodes.forEach(function (node) {
        if (node instanceof Element) {
          node.outerHTML = '';
          return;
        }
        node.nodeValue = '';
      });
      // if there is one TextNode first and one TextNode last, the
      // last one's nodeValue will be assigned to the first.
      if (this.nodes[0].nodeValue) {
        this.nodes[0].nodeValue = '';
      }
    }
  }, {
    key: "render",
    value: function render() {
      return _("div", {
        ref: this.ref
      });
    }
  }]);
  return RawHtml;
}(x);
var defaultProps = {
  data: {},
  rootTagName: 'div',
  useCustomCompileOptions: {},
  templates: {},
  templatesConfig: {}
};
// @TODO: Template should be a generic and receive TData to pass to Templates (to avoid TTemplateData to be set as `any`)
var Template = /*#__PURE__*/function (_Component2) {
  _inherits(Template, _Component2);
  var _super2 = _createSuper(Template);
  function Template() {
    Template_classCallCheck(this, Template);
    return _super2.apply(this, arguments);
  }
  Template_createClass(Template, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps) {
      return !isEqual(this.props.data, nextProps.data) || this.props.templateKey !== nextProps.templateKey || !isEqual(this.props.rootProps, nextProps.rootProps);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      if (false) { var nonFunctionTemplates; }
      var RootTagName = this.props.rootTagName === 'fragment' ? k : this.props.rootTagName;
      var useCustomCompileOptions = this.props.useCustomCompileOptions[this.props.templateKey];
      var compileOptions = useCustomCompileOptions ? this.props.templatesConfig.compileOptions : {};
      var content = renderTemplate({
        templates: this.props.templates,
        templateKey: this.props.templateKey,
        compileOptions: compileOptions,
        helpers: this.props.templatesConfig.helpers,
        data: this.props.data,
        bindEvent: this.props.bindEvent,
        sendEvent: this.props.sendEvent
      });
      if (content === null) {
        // Adds a noscript to the DOM but virtual DOM is null
        // See http://facebook.github.io/react/docs/component-specs.html#render
        return null;
      }
      if (Template_typeof(content) === 'object') {
        return _(RootTagName, this.props.rootProps, content);
      }

      // This is to handle Hogan templates with Fragment as rootTagName
      if (RootTagName === k) {
        return _(RawHtml, {
          content: content,
          key: Math.random()
        });
      }
      return _(RootTagName, Template_extends({}, this.props.rootProps, {
        dangerouslySetInnerHTML: {
          __html: content
        }
      }));
    }
  }]);
  return Template;
}(x);
Template_defineProperty(Template, "defaultProps", defaultProps);
/* harmony default export */ var Template_Template = (Template);
;// ./node_modules/instantsearch.js/es/components/SearchBox/SearchBox.js
function SearchBox_typeof(o) { "@babel/helpers - typeof"; return SearchBox_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, SearchBox_typeof(o); }
function SearchBox_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function SearchBox_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, SearchBox_toPropertyKey(descriptor.key), descriptor); } }
function SearchBox_createClass(Constructor, protoProps, staticProps) { if (protoProps) SearchBox_defineProperties(Constructor.prototype, protoProps); if (staticProps) SearchBox_defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function SearchBox_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) SearchBox_setPrototypeOf(subClass, superClass); }
function SearchBox_setPrototypeOf(o, p) { SearchBox_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return SearchBox_setPrototypeOf(o, p); }
function SearchBox_createSuper(Derived) { var hasNativeReflectConstruct = SearchBox_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = SearchBox_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = SearchBox_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return SearchBox_possibleConstructorReturn(this, result); }; }
function SearchBox_possibleConstructorReturn(self, call) { if (call && (SearchBox_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return SearchBox_assertThisInitialized(self); }
function SearchBox_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function SearchBox_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function SearchBox_getPrototypeOf(o) { SearchBox_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return SearchBox_getPrototypeOf(o); }
function SearchBox_defineProperty(obj, key, value) { key = SearchBox_toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function SearchBox_toPropertyKey(t) { var i = SearchBox_toPrimitive(t, "string"); return "symbol" == SearchBox_typeof(i) ? i : String(i); }
function SearchBox_toPrimitive(t, r) { if ("object" != SearchBox_typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != SearchBox_typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }



var SearchBox_defaultProps = {
  query: '',
  showSubmit: true,
  showReset: true,
  showLoadingIndicator: true,
  autofocus: false,
  searchAsYouType: true,
  ignoreCompositionEvents: false,
  isSearchStalled: false,
  disabled: false,
  ariaLabel: 'Search',
  onChange: noop_noop,
  onSubmit: noop_noop,
  onReset: noop_noop,
  refine: noop_noop
};
var SearchBox = /*#__PURE__*/function (_Component) {
  SearchBox_inherits(SearchBox, _Component);
  var _super = SearchBox_createSuper(SearchBox);
  function SearchBox() {
    var _this;
    SearchBox_classCallCheck(this, SearchBox);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    SearchBox_defineProperty(SearchBox_assertThisInitialized(_this), "state", {
      query: _this.props.query,
      focused: false
    });
    SearchBox_defineProperty(SearchBox_assertThisInitialized(_this), "input", b());
    SearchBox_defineProperty(SearchBox_assertThisInitialized(_this), "onInput", function (event) {
      var _this$props = _this.props,
        searchAsYouType = _this$props.searchAsYouType,
        refine = _this$props.refine,
        onChange = _this$props.onChange;
      var query = event.target.value;
      if (!(_this.props.ignoreCompositionEvents && event.isComposing)) {
        if (searchAsYouType) {
          refine(query);
        }
        _this.setState({
          query: query
        });
        onChange(event);
      }
    });
    SearchBox_defineProperty(SearchBox_assertThisInitialized(_this), "onSubmit", function (event) {
      var _this$props2 = _this.props,
        searchAsYouType = _this$props2.searchAsYouType,
        refine = _this$props2.refine,
        onSubmit = _this$props2.onSubmit;
      event.preventDefault();
      event.stopPropagation();
      if (_this.input.current) {
        _this.input.current.blur();
      }
      if (!searchAsYouType) {
        refine(_this.state.query);
      }
      onSubmit(event);
      return false;
    });
    SearchBox_defineProperty(SearchBox_assertThisInitialized(_this), "onReset", function (event) {
      var _this$props3 = _this.props,
        refine = _this$props3.refine,
        onReset = _this$props3.onReset;
      var query = '';
      if (_this.input.current) {
        _this.input.current.focus();
      }
      refine(query);
      _this.setState({
        query: query
      });
      onReset(event);
    });
    SearchBox_defineProperty(SearchBox_assertThisInitialized(_this), "onBlur", function () {
      _this.setState({
        focused: false
      });
    });
    SearchBox_defineProperty(SearchBox_assertThisInitialized(_this), "onFocus", function () {
      _this.setState({
        focused: true
      });
    });
    return _this;
  }
  SearchBox_createClass(SearchBox, [{
    key: "resetInput",
    value:
    /**
     * This public method is used in the RefinementList SFFV search box
     * to reset the input state when an item is selected.
     *
     * @see RefinementList#componentWillReceiveProps
     * @return {undefined}
     */
    function resetInput() {
      this.setState({
        query: ''
      });
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      /**
       * when the user is typing, we don't want to replace the query typed
       * by the user (state.query) with the query exposed by the connector (props.query)
       * see: https://github.com/algolia/instantsearch/issues/4141
       */
      if (!this.state.focused && nextProps.query !== this.state.query) {
        this.setState({
          query: nextProps.query
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props4 = this.props,
        cssClasses = _this$props4.cssClasses,
        placeholder = _this$props4.placeholder,
        autofocus = _this$props4.autofocus,
        showSubmit = _this$props4.showSubmit,
        showReset = _this$props4.showReset,
        showLoadingIndicator = _this$props4.showLoadingIndicator,
        templates = _this$props4.templates,
        isSearchStalled = _this$props4.isSearchStalled,
        ariaLabel = _this$props4.ariaLabel;
      return _("div", {
        className: cssClasses.root
      }, _("form", {
        action: "",
        role: "search",
        className: cssClasses.form,
        noValidate: true,
        onSubmit: this.onSubmit,
        onReset: this.onReset
      }, _("input", {
        ref: this.input,
        value: this.state.query,
        disabled: this.props.disabled,
        className: cssClasses.input,
        type: "search",
        placeholder: placeholder,
        autoFocus: autofocus,
        autoComplete: "off",
        autoCorrect: "off",
        autoCapitalize: "off"
        // @ts-expect-error `spellCheck` attribute is missing in preact JSX types
        ,
        spellCheck: "false",
        maxLength: 512,
        onInput: this.onInput
        // see: https://github.com/preactjs/preact/issues/1978
        // eslint-disable-next-line react/no-unknown-property
        ,
        oncompositionend: this.onInput,
        onBlur: this.onBlur,
        onFocus: this.onFocus,
        "aria-label": ariaLabel
      }), _(Template_Template, {
        templateKey: "submit",
        rootTagName: "button",
        rootProps: {
          className: cssClasses.submit,
          type: 'submit',
          title: 'Submit the search query',
          hidden: !showSubmit
        },
        templates: templates,
        data: {
          cssClasses: cssClasses
        }
      }), _(Template_Template, {
        templateKey: "reset",
        rootTagName: "button",
        rootProps: {
          className: cssClasses.reset,
          type: 'reset',
          title: 'Clear the search query',
          hidden: !(showReset && this.state.query.trim() && !isSearchStalled)
        },
        templates: templates,
        data: {
          cssClasses: cssClasses
        }
      }), showLoadingIndicator && _(Template_Template, {
        templateKey: "loadingIndicator",
        rootTagName: "span",
        rootProps: {
          className: cssClasses.loadingIndicator,
          hidden: !isSearchStalled
        },
        templates: templates,
        data: {
          cssClasses: cssClasses
        }
      })));
    }
  }]);
  return SearchBox;
}(x);
SearchBox_defineProperty(SearchBox, "defaultProps", SearchBox_defaultProps);
/* harmony default export */ var SearchBox_SearchBox = (SearchBox);
;// ./node_modules/instantsearch.js/es/components/RefinementList/RefinementListItem.js
function RefinementListItem_extends() { RefinementListItem_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return RefinementListItem_extends.apply(this, arguments); }


function RefinementListItem(_ref) {
  var className = _ref.className,
    handleClick = _ref.handleClick,
    facetValueToRefine = _ref.facetValueToRefine,
    isRefined = _ref.isRefined,
    templateProps = _ref.templateProps,
    templateKey = _ref.templateKey,
    templateData = _ref.templateData,
    subItems = _ref.subItems;
  return _("li", {
    className: className,
    onClick: function onClick(originalEvent) {
      handleClick({
        facetValueToRefine: facetValueToRefine,
        isRefined: isRefined,
        originalEvent: originalEvent
      });
    }
  }, _(Template_Template, RefinementListItem_extends({}, templateProps, {
    templateKey: templateKey,
    data: templateData
  })), subItems);
}
/* harmony default export */ var RefinementList_RefinementListItem = (RefinementListItem);
;// ./node_modules/instantsearch.js/es/components/RefinementList/RefinementList.js
var RefinementList_excluded = ["root"];
function RefinementList_typeof(o) { "@babel/helpers - typeof"; return RefinementList_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, RefinementList_typeof(o); }
function RefinementList_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function RefinementList_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? RefinementList_ownKeys(Object(t), !0).forEach(function (r) { RefinementList_defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : RefinementList_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function RefinementList_extends() { RefinementList_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return RefinementList_extends.apply(this, arguments); }
function RefinementList_objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = RefinementList_objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function RefinementList_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function RefinementList_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function RefinementList_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, RefinementList_toPropertyKey(descriptor.key), descriptor); } }
function RefinementList_createClass(Constructor, protoProps, staticProps) { if (protoProps) RefinementList_defineProperties(Constructor.prototype, protoProps); if (staticProps) RefinementList_defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function RefinementList_inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) RefinementList_setPrototypeOf(subClass, superClass); }
function RefinementList_setPrototypeOf(o, p) { RefinementList_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return RefinementList_setPrototypeOf(o, p); }
function RefinementList_createSuper(Derived) { var hasNativeReflectConstruct = RefinementList_isNativeReflectConstruct(); return function _createSuperInternal() { var Super = RefinementList_getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = RefinementList_getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return RefinementList_possibleConstructorReturn(this, result); }; }
function RefinementList_possibleConstructorReturn(self, call) { if (call && (RefinementList_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return RefinementList_assertThisInitialized(self); }
function RefinementList_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function RefinementList_isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function RefinementList_getPrototypeOf(o) { RefinementList_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return RefinementList_getPrototypeOf(o); }
function RefinementList_defineProperty(obj, key, value) { key = RefinementList_toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function RefinementList_toPropertyKey(t) { var i = RefinementList_toPrimitive(t, "string"); return "symbol" == RefinementList_typeof(i) ? i : String(i); }
function RefinementList_toPrimitive(t, r) { if ("object" != RefinementList_typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != RefinementList_typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }







// CSS types

var RefinementList_defaultProps = {
  cssClasses: {},
  depth: 0
};
function isHierarchicalMenuItem(facetValue) {
  return facetValue.data !== undefined;
}
var RefinementList = /*#__PURE__*/function (_Component) {
  RefinementList_inherits(RefinementList, _Component);
  var _super = RefinementList_createSuper(RefinementList);
  function RefinementList() {
    var _this;
    RefinementList_classCallCheck(this, RefinementList);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    RefinementList_defineProperty(RefinementList_assertThisInitialized(_this), "listRef", b());
    RefinementList_defineProperty(RefinementList_assertThisInitialized(_this), "searchBox", b());
    RefinementList_defineProperty(RefinementList_assertThisInitialized(_this), "lastRefinedValue", undefined);
    RefinementList_defineProperty(RefinementList_assertThisInitialized(_this), "_generateFacetItem", function (facetValue) {
      var subItems;
      if (isHierarchicalMenuItem(facetValue) && Array.isArray(facetValue.data) && facetValue.data.length > 0) {
        var _this$props$cssClasse = _this.props.cssClasses,
          root = _this$props$cssClasse.root,
          cssClasses = RefinementList_objectWithoutProperties(_this$props$cssClasse, RefinementList_excluded);
        subItems = _(RefinementList, RefinementList_extends({}, _this.props, {
          // We want to keep `root` required for external usage but not for the
          // sub items.
          cssClasses: cssClasses,
          depth: _this.props.depth + 1,
          facetValues: facetValue.data,
          showMore: false,
          className: _this.props.cssClasses.childList
        }));
      }
      var url = _this.props.createURL(facetValue.value);
      var templateData = RefinementList_objectSpread(RefinementList_objectSpread({}, facetValue), {}, {
        url: url,
        attribute: _this.props.attribute,
        cssClasses: _this.props.cssClasses,
        isFromSearch: _this.props.isFromSearch
      });
      var key = facetValue.value;
      if (facetValue.isRefined !== undefined) {
        key += "/".concat(facetValue.isRefined);
      }
      if (facetValue.count !== undefined) {
        key += "/".concat(facetValue.count);
      }
      var refinementListItemClassName = cx(_this.props.cssClasses.item, facetValue.isRefined && _this.props.cssClasses.selectedItem, !facetValue.count && _this.props.cssClasses.disabledItem, Boolean(isHierarchicalMenuItem(facetValue) && Array.isArray(facetValue.data) && facetValue.data.length > 0) && _this.props.cssClasses.parentItem);
      return _(RefinementList_RefinementListItem, {
        templateKey: "item",
        key: key,
        facetValueToRefine: facetValue.value,
        handleClick: _this.handleItemClick,
        isRefined: facetValue.isRefined,
        className: refinementListItemClassName,
        subItems: subItems,
        templateData: templateData,
        templateProps: _this.props.templateProps
      });
    });
    // Click events on DOM tree like LABEL > INPUT will result in two click events
    // instead of one.
    // No matter the framework, see https://www.google.com/search?q=click+label+twice
    //
    // Thus making it hard to distinguish activation from deactivation because both click events
    // are very close. Debounce is a solution but hacky.
    //
    // So the code here checks if the click was done on or in a LABEL. If this LABEL
    // has a checkbox inside, we ignore the first click event because we will get another one.
    //
    // We also check if the click was done inside a link and then e.preventDefault() because we already
    // handle the url
    //
    // Finally, we always stop propagation of the event to avoid multiple levels RefinementLists to fail: click
    // on child would click on parent also
    RefinementList_defineProperty(RefinementList_assertThisInitialized(_this), "handleItemClick", function (_ref) {
      var facetValueToRefine = _ref.facetValueToRefine,
        isRefined = _ref.isRefined,
        originalEvent = _ref.originalEvent;
      if (isSpecialClick(originalEvent)) {
        // do not alter the default browser behavior
        // if one special key is down
        return;
      }
      var parent = originalEvent.target;
      if (parent === null || parent.parentNode === null) {
        return;
      }
      if (isRefined && parent.parentNode.querySelector('input[type="radio"]:checked')) {
        // Prevent refinement for being reset if the user clicks on an already checked radio button
        return;
      }
      if (parent.tagName === 'INPUT') {
        _this.refine(facetValueToRefine);
        return;
      }
      while (parent !== originalEvent.currentTarget) {
        if (parent.tagName === 'LABEL' && (parent.querySelector('input[type="checkbox"]') || parent.querySelector('input[type="radio"]'))) {
          return;
        }
        if (parent.tagName === 'A' && parent.href) {
          originalEvent.preventDefault();
        }
        parent = parent.parentNode;
      }
      originalEvent.stopPropagation();
      _this.refine(facetValueToRefine);
    });
    return _this;
  }
  RefinementList_createClass(RefinementList, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps) {
      var areFacetValuesDifferent = !isEqual(this.props.facetValues, nextProps.facetValues);
      return areFacetValuesDifferent;
    }
  }, {
    key: "refine",
    value: function refine(facetValueToRefine) {
      this.lastRefinedValue = facetValueToRefine;
      this.props.toggleRefinement(facetValueToRefine);
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if (this.searchBox.current && !nextProps.isFromSearch) {
        this.searchBox.current.resetInput();
      }
    }

    /**
     * This sets focus on the last refined input element after a render
     * because Preact does not perform it automatically.
     * @see https://github.com/preactjs/preact/issues/3242
     */
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var _this$listRef$current, _this$listRef$current2, _this$lastRefinedValu;
      (_this$listRef$current = this.listRef.current) === null || _this$listRef$current === void 0 ? void 0 : (_this$listRef$current2 = _this$listRef$current.querySelector("input[value=\"".concat((_this$lastRefinedValu = this.lastRefinedValue) === null || _this$lastRefinedValu === void 0 ? void 0 : _this$lastRefinedValu.replace('"', '\\"'), "\"]"))) === null || _this$listRef$current2 === void 0 ? void 0 : _this$listRef$current2.focus();
      this.lastRefinedValue = undefined;
    }
  }, {
    key: "refineFirstValue",
    value: function refineFirstValue() {
      var firstValue = this.props.facetValues && this.props.facetValues[0];
      if (firstValue) {
        var actualValue = firstValue.value;
        this.props.toggleRefinement(actualValue);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var showMoreButtonClassName = cx(this.props.cssClasses.showMore, !(this.props.showMore === true && this.props.canToggleShowMore) && this.props.cssClasses.disabledShowMore);
      var showMoreButton = this.props.showMore === true && _(Template_Template, RefinementList_extends({}, this.props.templateProps, {
        templateKey: "showMoreText",
        rootTagName: "button",
        rootProps: {
          className: showMoreButtonClassName,
          disabled: !this.props.canToggleShowMore,
          onClick: this.props.toggleShowMore
        },
        data: {
          isShowingMore: this.props.isShowingMore
        }
      }));
      var shouldDisableSearchBox = this.props.searchIsAlwaysActive !== true && !(this.props.isFromSearch || !this.props.hasExhaustiveItems);
      var searchBox = this.props.searchFacetValues && _("div", {
        className: this.props.cssClasses.searchBox
      }, _(SearchBox_SearchBox, {
        ref: this.searchBox,
        placeholder: this.props.searchPlaceholder,
        disabled: shouldDisableSearchBox,
        cssClasses: this.props.cssClasses.searchable,
        templates: this.props.searchBoxTemplateProps.templates,
        onChange: function onChange(event) {
          return _this2.props.searchFacetValues(event.target.value);
        },
        onReset: function onReset() {
          return _this2.props.searchFacetValues('');
        },
        onSubmit: function onSubmit() {
          return _this2.refineFirstValue();
        }
        // This sets the search box to a controlled state because
        // we don't rely on the `refine` prop but on `onChange`.
        ,
        searchAsYouType: false,
        ariaLabel: "Search for filters"
      }));
      var facetValues = this.props.facetValues && this.props.facetValues.length > 0 && _("ul", {
        ref: this.listRef,
        className: this.props.cssClasses.list
      }, this.props.facetValues.map(this._generateFacetItem, this));
      var noResults = this.props.searchFacetValues && this.props.isFromSearch && (!this.props.facetValues || this.props.facetValues.length === 0) && _(Template_Template, RefinementList_extends({}, this.props.templateProps, {
        templateKey: "searchableNoResults",
        rootProps: {
          className: this.props.cssClasses.noResults
        }
      }));
      var rootClassName = cx(this.props.cssClasses.root, (!this.props.facetValues || this.props.facetValues.length === 0) && this.props.cssClasses.noRefinementRoot, this.props.className);
      return _("div", {
        className: rootClassName
      }, this.props.children, searchBox, facetValues, noResults, showMoreButton);
    }
  }]);
  return RefinementList;
}(x);
RefinementList_defineProperty(RefinementList, "defaultProps", RefinementList_defaultProps);
/* harmony default export */ var RefinementList_RefinementList = (RefinementList);
;// ./node_modules/instantsearch.js/es/lib/utils/documentation.js
function createDocumentationLink(_ref) {
  var name = _ref.name,
    _ref$connector = _ref.connector,
    connector = _ref$connector === void 0 ? false : _ref$connector;
  return ['https://www.algolia.com/doc/api-reference/widgets/', name, '/js/', connector ? '#connector' : ''].join('');
}
function createDocumentationMessageGenerator() {
  for (var _len = arguments.length, widgets = new Array(_len), _key = 0; _key < _len; _key++) {
    widgets[_key] = arguments[_key];
  }
  var links = widgets.map(function (widget) {
    return createDocumentationLink(widget);
  }).join(', ');
  return function (message) {
    return [message, "See documentation: ".concat(links)].filter(Boolean).join('\n\n');
  };
}
;// ./node_modules/instantsearch.js/es/lib/utils/getObjectType.js
function getObjectType(object) {
  return Object.prototype.toString.call(object).slice(8, -1);
}
;// ./node_modules/instantsearch.js/es/lib/utils/checkRendering.js

function checkRendering(rendering, usage) {
  if (rendering === undefined || typeof rendering !== 'function') {
    throw new Error("The render function is not valid (received type ".concat(getObjectType(rendering), ").\n\n").concat(usage));
  }
}
;// ./node_modules/instantsearch.js/es/lib/utils/isFacetRefined.js
function isFacetRefined(helper, facet, value) {
  if (helper.state.isHierarchicalFacet(facet)) {
    return helper.state.isHierarchicalFacetRefined(facet, value);
  } else if (helper.state.isConjunctiveFacet(facet)) {
    return helper.state.isFacetRefined(facet, value);
  } else {
    return helper.state.isDisjunctiveFacetRefined(facet, value);
  }
}
;// ./node_modules/instantsearch.js/es/lib/utils/createSendEventForFacet.js
function createSendEventForFacet_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function createSendEventForFacet_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? createSendEventForFacet_ownKeys(Object(t), !0).forEach(function (r) { createSendEventForFacet_defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : createSendEventForFacet_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function createSendEventForFacet_defineProperty(obj, key, value) { key = createSendEventForFacet_toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function createSendEventForFacet_toPropertyKey(t) { var i = createSendEventForFacet_toPrimitive(t, "string"); return "symbol" == createSendEventForFacet_typeof(i) ? i : String(i); }
function createSendEventForFacet_toPrimitive(t, r) { if ("object" != createSendEventForFacet_typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != createSendEventForFacet_typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function createSendEventForFacet_typeof(o) { "@babel/helpers - typeof"; return createSendEventForFacet_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, createSendEventForFacet_typeof(o); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || createSendEventForFacet_unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function createSendEventForFacet_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return createSendEventForFacet_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return createSendEventForFacet_arrayLikeToArray(o, minLen); }
function createSendEventForFacet_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function createSendEventForFacet(_ref) {
  var instantSearchInstance = _ref.instantSearchInstance,
    helper = _ref.helper,
    attr = _ref.attribute,
    widgetType = _ref.widgetType;
  var sendEventForFacet = function sendEventForFacet() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    var facetValue = args[1],
      _args$ = args[2],
      eventName = _args$ === void 0 ? 'Filter Applied' : _args$,
      _args$2 = args[3],
      additionalData = _args$2 === void 0 ? {} : _args$2;
    var _args$0$split = args[0].split(':'),
      _args$0$split2 = _slicedToArray(_args$0$split, 2),
      eventType = _args$0$split2[0],
      eventModifier = _args$0$split2[1];
    var attribute = typeof attr === 'string' ? attr : attr(facetValue);
    if (args.length === 1 && createSendEventForFacet_typeof(args[0]) === 'object') {
      instantSearchInstance.sendEventToInsights(args[0]);
    } else if (eventType === 'click' && args.length >= 2 && args.length <= 4) {
      if (!isFacetRefined(helper, attribute, facetValue)) {
        var _helper$lastResults;
        // send event only when the facet is being checked "ON"
        instantSearchInstance.sendEventToInsights({
          insightsMethod: 'clickedFilters',
          widgetType: widgetType,
          eventType: eventType,
          eventModifier: eventModifier,
          payload: createSendEventForFacet_objectSpread({
            eventName: eventName,
            index: ((_helper$lastResults = helper.lastResults) === null || _helper$lastResults === void 0 ? void 0 : _helper$lastResults.index) || helper.state.index,
            filters: ["".concat(attribute, ":").concat(facetValue)]
          }, additionalData),
          attribute: attribute
        });
      }
    } else if (false) {}
  };
  return sendEventForFacet;
}
;// ./node_modules/instantsearch.js/es/connectors/refinement-list/connectRefinementList.js
function connectRefinementList_typeof(o) { "@babel/helpers - typeof"; return connectRefinementList_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, connectRefinementList_typeof(o); }
var connectRefinementList_excluded = ["name", "escapedValue"],
  connectRefinementList_excluded2 = ["escapedValue", "value"];
function connectRefinementList_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function connectRefinementList_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? connectRefinementList_ownKeys(Object(t), !0).forEach(function (r) { connectRefinementList_defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : connectRefinementList_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function connectRefinementList_defineProperty(obj, key, value) { key = connectRefinementList_toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function connectRefinementList_toPropertyKey(t) { var i = connectRefinementList_toPrimitive(t, "string"); return "symbol" == connectRefinementList_typeof(i) ? i : String(i); }
function connectRefinementList_toPrimitive(t, r) { if ("object" != connectRefinementList_typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != connectRefinementList_typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function connectRefinementList_objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = connectRefinementList_objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function connectRefinementList_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var withUsage = createDocumentationMessageGenerator({
  name: 'refinement-list',
  connector: true
});
var DEFAULT_SORT = ['isRefined', 'count:desc', 'name:asc'];
/**
 * **RefinementList** connector provides the logic to build a custom widget that
 * will let the user filter the results based on the values of a specific facet.
 *
 * **Requirement:** the attribute passed as `attribute` must be present in
 * attributesForFaceting of the searched index.
 *
 * This connector provides:
 * - a `refine()` function to select an item.
 * - a `toggleShowMore()` function to display more or less items
 * - a `searchForItems()` function to search within the items.
 */
var connectRefinementList = function connectRefinementList(renderFn) {
  var unmountFn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : noop_noop;
  checkRendering(renderFn, withUsage());
  return function (widgetParams) {
    var _ref = widgetParams || {},
      attribute = _ref.attribute,
      _ref$operator = _ref.operator,
      operator = _ref$operator === void 0 ? 'or' : _ref$operator,
      _ref$limit = _ref.limit,
      limit = _ref$limit === void 0 ? 10 : _ref$limit,
      _ref$showMore = _ref.showMore,
      showMore = _ref$showMore === void 0 ? false : _ref$showMore,
      _ref$showMoreLimit = _ref.showMoreLimit,
      showMoreLimit = _ref$showMoreLimit === void 0 ? 20 : _ref$showMoreLimit,
      _ref$sortBy = _ref.sortBy,
      sortBy = _ref$sortBy === void 0 ? DEFAULT_SORT : _ref$sortBy,
      _ref$escapeFacetValue = _ref.escapeFacetValues,
      escapeFacetValues = _ref$escapeFacetValue === void 0 ? true : _ref$escapeFacetValue,
      _ref$transformItems = _ref.transformItems,
      transformItems = _ref$transformItems === void 0 ? function (items) {
        return items;
      } : _ref$transformItems;
    if (!attribute) {
      throw new Error(withUsage('The `attribute` option is required.'));
    }
    if (!/^(and|or)$/.test(operator)) {
      throw new Error(withUsage("The `operator` must one of: `\"and\"`, `\"or\"` (got \"".concat(operator, "\").")));
    }
    if (showMore === true && showMoreLimit <= limit) {
      throw new Error(withUsage('`showMoreLimit` should be greater than `limit`.'));
    }
    var formatItems = function formatItems(_ref2) {
      var label = _ref2.name,
        value = _ref2.escapedValue,
        item = connectRefinementList_objectWithoutProperties(_ref2, connectRefinementList_excluded);
      return connectRefinementList_objectSpread(connectRefinementList_objectSpread({}, item), {}, {
        value: value,
        label: label,
        highlighted: label
      });
    };
    var lastResultsFromMainSearch;
    var lastItemsFromMainSearch = [];
    var hasExhaustiveItems = true;
    var triggerRefine;
    var sendEvent;
    var isShowingMore = false;
    // Provide the same function to the `renderFn` so that way the user
    // has to only bind it once when `isFirstRendering` for instance
    var toggleShowMore = function toggleShowMore() {};
    function cachedToggleShowMore() {
      toggleShowMore();
    }
    function createToggleShowMore(renderOptions, widget) {
      return function () {
        isShowingMore = !isShowingMore;
        widget.render(renderOptions);
      };
    }
    function getLimit() {
      return isShowingMore ? showMoreLimit : limit;
    }
    var searchForFacetValues = function searchForFacetValues() {
      return function () {};
    };
    var createSearchForFacetValues = function createSearchForFacetValues(helper, widget) {
      return function (renderOptions) {
        return function (query) {
          var instantSearchInstance = renderOptions.instantSearchInstance,
            searchResults = renderOptions.results;
          if (query === '' && lastItemsFromMainSearch) {
            // render with previous data from the helper.
            renderFn(connectRefinementList_objectSpread(connectRefinementList_objectSpread({}, widget.getWidgetRenderState(connectRefinementList_objectSpread(connectRefinementList_objectSpread({}, renderOptions), {}, {
              results: lastResultsFromMainSearch
            }))), {}, {
              instantSearchInstance: instantSearchInstance
            }), false);
          } else {
            var tags = {
              highlightPreTag: escapeFacetValues ? TAG_PLACEHOLDER.highlightPreTag : TAG_REPLACEMENT.highlightPreTag,
              highlightPostTag: escapeFacetValues ? TAG_PLACEHOLDER.highlightPostTag : TAG_REPLACEMENT.highlightPostTag
            };
            helper.searchForFacetValues(attribute, query,
            // We cap the `maxFacetHits` value to 100 because the Algolia API
            // doesn't support a greater number.
            // See https://www.algolia.com/doc/api-reference/api-parameters/maxFacetHits/
            Math.min(getLimit(), 100), tags).then(function (results) {
              var facetValues = escapeFacetValues ? escapeFacets(results.facetHits) : results.facetHits;
              var normalizedFacetValues = transformItems(facetValues.map(function (_ref3) {
                var escapedValue = _ref3.escapedValue,
                  value = _ref3.value,
                  item = connectRefinementList_objectWithoutProperties(_ref3, connectRefinementList_excluded2);
                return connectRefinementList_objectSpread(connectRefinementList_objectSpread({}, item), {}, {
                  value: escapedValue,
                  label: value
                });
              }), {
                results: searchResults
              });
              renderFn(connectRefinementList_objectSpread(connectRefinementList_objectSpread({}, widget.getWidgetRenderState(connectRefinementList_objectSpread(connectRefinementList_objectSpread({}, renderOptions), {}, {
                results: lastResultsFromMainSearch
              }))), {}, {
                items: normalizedFacetValues,
                canToggleShowMore: false,
                canRefine: true,
                isFromSearch: true,
                instantSearchInstance: instantSearchInstance
              }), false);
            });
          }
        };
      };
    };
    return {
      $$type: 'ais.refinementList',
      init: function init(initOptions) {
        renderFn(connectRefinementList_objectSpread(connectRefinementList_objectSpread({}, this.getWidgetRenderState(initOptions)), {}, {
          instantSearchInstance: initOptions.instantSearchInstance
        }), true);
      },
      render: function render(renderOptions) {
        renderFn(connectRefinementList_objectSpread(connectRefinementList_objectSpread({}, this.getWidgetRenderState(renderOptions)), {}, {
          instantSearchInstance: renderOptions.instantSearchInstance
        }), false);
      },
      getRenderState: function getRenderState(renderState, renderOptions) {
        return connectRefinementList_objectSpread(connectRefinementList_objectSpread({}, renderState), {}, {
          refinementList: connectRefinementList_objectSpread(connectRefinementList_objectSpread({}, renderState.refinementList), {}, connectRefinementList_defineProperty({}, attribute, this.getWidgetRenderState(renderOptions)))
        });
      },
      getWidgetRenderState: function getWidgetRenderState(renderOptions) {
        var _this = this;
        var results = renderOptions.results,
          state = renderOptions.state,
          _createURL = renderOptions.createURL,
          instantSearchInstance = renderOptions.instantSearchInstance,
          helper = renderOptions.helper;
        var items = [];
        var facetValues = [];
        if (!sendEvent || !triggerRefine || !searchForFacetValues) {
          sendEvent = createSendEventForFacet({
            instantSearchInstance: instantSearchInstance,
            helper: helper,
            attribute: attribute,
            widgetType: this.$$type
          });
          triggerRefine = function triggerRefine(facetValue) {
            sendEvent('click:internal', facetValue);
            helper.toggleFacetRefinement(attribute, facetValue).search();
          };
          searchForFacetValues = createSearchForFacetValues(helper, this);
        }
        if (results) {
          var values = results.getFacetValues(attribute, {
            sortBy: sortBy,
            facetOrdering: sortBy === DEFAULT_SORT
          });
          facetValues = values && Array.isArray(values) ? values : [];
          items = transformItems(facetValues.slice(0, getLimit()).map(formatItems), {
            results: results
          });
          var maxValuesPerFacetConfig = state.maxValuesPerFacet;
          var currentLimit = getLimit();
          // If the limit is the max number of facet retrieved it is impossible to know
          // if the facets are exhaustive. The only moment we are sure it is exhaustive
          // is when it is strictly under the number requested unless we know that another
          // widget has requested more values (maxValuesPerFacet > getLimit()).
          // Because this is used for making the search of facets unable or not, it is important
          // to be conservative here.
          hasExhaustiveItems = maxValuesPerFacetConfig > currentLimit ? facetValues.length <= currentLimit : facetValues.length < currentLimit;
          lastResultsFromMainSearch = results;
          lastItemsFromMainSearch = items;
          if (renderOptions.results) {
            toggleShowMore = createToggleShowMore(renderOptions, this);
          }
        }

        // Do not mistake searchForFacetValues and searchFacetValues which is the actual search
        // function
        var searchFacetValues = searchForFacetValues && searchForFacetValues(renderOptions);
        var canShowLess = isShowingMore && lastItemsFromMainSearch.length > limit;
        var canShowMore = showMore && !hasExhaustiveItems;
        var canToggleShowMore = canShowLess || canShowMore;
        return {
          createURL: function createURL(facetValue) {
            return _createURL(function (uiState) {
              return _this.getWidgetUiState(uiState, {
                searchParameters: state.resetPage().toggleFacetRefinement(attribute, facetValue),
                helper: helper
              });
            });
          },
          items: items,
          refine: triggerRefine,
          searchForItems: searchFacetValues,
          isFromSearch: false,
          canRefine: items.length > 0,
          widgetParams: widgetParams,
          isShowingMore: isShowingMore,
          canToggleShowMore: canToggleShowMore,
          toggleShowMore: cachedToggleShowMore,
          sendEvent: sendEvent,
          hasExhaustiveItems: hasExhaustiveItems
        };
      },
      dispose: function dispose(_ref4) {
        var state = _ref4.state;
        unmountFn();
        var withoutMaxValuesPerFacet = state.setQueryParameter('maxValuesPerFacet', undefined);
        if (operator === 'and') {
          return withoutMaxValuesPerFacet.removeFacet(attribute);
        }
        return withoutMaxValuesPerFacet.removeDisjunctiveFacet(attribute);
      },
      getWidgetUiState: function getWidgetUiState(uiState, _ref5) {
        var searchParameters = _ref5.searchParameters;
        var values = operator === 'or' ? searchParameters.getDisjunctiveRefinements(attribute) : searchParameters.getConjunctiveRefinements(attribute);
        return removeEmptyRefinementsFromUiState(connectRefinementList_objectSpread(connectRefinementList_objectSpread({}, uiState), {}, {
          refinementList: connectRefinementList_objectSpread(connectRefinementList_objectSpread({}, uiState.refinementList), {}, connectRefinementList_defineProperty({}, attribute, values))
        }), attribute);
      },
      getWidgetSearchParameters: function getWidgetSearchParameters(searchParameters, _ref6) {
        var uiState = _ref6.uiState;
        var isDisjunctive = operator === 'or';
        if (searchParameters.isHierarchicalFacet(attribute)) {
           false ? 0 : void 0;
          return searchParameters;
        }
        if (isDisjunctive && searchParameters.isConjunctiveFacet(attribute) || !isDisjunctive && searchParameters.isDisjunctiveFacet(attribute)) {
           false ? 0 : void 0;
          return searchParameters;
        }
        var values = uiState.refinementList && uiState.refinementList[attribute];
        var withFacetConfiguration = isDisjunctive ? searchParameters.addDisjunctiveFacet(attribute).removeDisjunctiveFacetRefinement(attribute) : searchParameters.addFacet(attribute).removeFacetRefinement(attribute);
        var currentMaxValuesPerFacet = withFacetConfiguration.maxValuesPerFacet || 0;
        var nextMaxValuesPerFacet = Math.max(currentMaxValuesPerFacet, showMore ? showMoreLimit : limit);
        var withMaxValuesPerFacet = withFacetConfiguration.setQueryParameter('maxValuesPerFacet', nextMaxValuesPerFacet);
        if (!values) {
          var key = isDisjunctive ? 'disjunctiveFacetsRefinements' : 'facetsRefinements';
          return withMaxValuesPerFacet.setQueryParameters(connectRefinementList_defineProperty({}, key, connectRefinementList_objectSpread(connectRefinementList_objectSpread({}, withMaxValuesPerFacet[key]), {}, connectRefinementList_defineProperty({}, attribute, []))));
        }
        return values.reduce(function (parameters, value) {
          return isDisjunctive ? parameters.addDisjunctiveFacetRefinement(attribute, value) : parameters.addFacetRefinement(attribute, value);
        }, withMaxValuesPerFacet);
      }
    };
  };
};
function removeEmptyRefinementsFromUiState(indexUiState, attribute) {
  if (!indexUiState.refinementList) {
    return indexUiState;
  }
  if (!indexUiState.refinementList[attribute] || indexUiState.refinementList[attribute].length === 0) {
    delete indexUiState.refinementList[attribute];
  }
  if (Object.keys(indexUiState.refinementList).length === 0) {
    delete indexUiState.refinementList;
  }
  return indexUiState;
}
/* harmony default export */ var refinement_list_connectRefinementList = (connectRefinementList);
;// ./node_modules/instantsearch.js/es/lib/suit.js
var NAMESPACE = 'ais';
var component = function component(componentName) {
  return function () {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      descendantName = _ref.descendantName,
      modifierName = _ref.modifierName;
    var descendent = descendantName ? "-".concat(descendantName) : '';
    var modifier = modifierName ? "--".concat(modifierName) : '';
    return "".concat(NAMESPACE, "-").concat(componentName).concat(descendent).concat(modifier);
  };
};
;// ./node_modules/instantsearch.js/es/lib/utils/uniq.js
function uniq(array) {
  return array.filter(function (value, index, self) {
    return self.indexOf(value) === index;
  });
}
;// ./node_modules/instantsearch.js/es/lib/templating/prepareTemplateProps.js
function prepareTemplateProps_typeof(o) { "@babel/helpers - typeof"; return prepareTemplateProps_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, prepareTemplateProps_typeof(o); }
function prepareTemplateProps_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function prepareTemplateProps_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? prepareTemplateProps_ownKeys(Object(t), !0).forEach(function (r) { prepareTemplateProps_defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : prepareTemplateProps_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function prepareTemplateProps_defineProperty(obj, key, value) { key = prepareTemplateProps_toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function prepareTemplateProps_toPropertyKey(t) { var i = prepareTemplateProps_toPrimitive(t, "string"); return "symbol" == prepareTemplateProps_typeof(i) ? i : String(i); }
function prepareTemplateProps_toPrimitive(t, r) { if ("object" != prepareTemplateProps_typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != prepareTemplateProps_typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function prepareTemplateProps_toConsumableArray(arr) { return prepareTemplateProps_arrayWithoutHoles(arr) || prepareTemplateProps_iterableToArray(arr) || prepareTemplateProps_unsupportedIterableToArray(arr) || prepareTemplateProps_nonIterableSpread(); }
function prepareTemplateProps_nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function prepareTemplateProps_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return prepareTemplateProps_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return prepareTemplateProps_arrayLikeToArray(o, minLen); }
function prepareTemplateProps_iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function prepareTemplateProps_arrayWithoutHoles(arr) { if (Array.isArray(arr)) return prepareTemplateProps_arrayLikeToArray(arr); }
function prepareTemplateProps_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }

function prepareTemplates(
// can not use = {} here, since the template could have different constraints
defaultTemplates) {
  var templates = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var allKeys = uniq([].concat(prepareTemplateProps_toConsumableArray(Object.keys(defaultTemplates || {})), prepareTemplateProps_toConsumableArray(Object.keys(templates))));
  return allKeys.reduce(function (config, key) {
    var defaultTemplate = defaultTemplates ? defaultTemplates[key] : undefined;
    var customTemplate = templates[key];
    var isCustomTemplate = customTemplate !== undefined && customTemplate !== defaultTemplate;
    config.templates[key] = isCustomTemplate ? customTemplate : defaultTemplate;
    config.useCustomCompileOptions[key] = isCustomTemplate;
    return config;
  }, {
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    templates: {},
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    useCustomCompileOptions: {}
  });
}

/**
 * Prepares an object to be passed to the Template widget
 */
function prepareTemplateProps(_ref) {
  var defaultTemplates = _ref.defaultTemplates,
    templates = _ref.templates,
    templatesConfig = _ref.templatesConfig;
  var preparedTemplates = prepareTemplates(defaultTemplates, templates);
  return prepareTemplateProps_objectSpread({
    templatesConfig: templatesConfig
  }, preparedTemplates);
}
;// ./node_modules/instantsearch.js/es/lib/utils/isDomElement.js
function isDomElement(object) {
  return object instanceof HTMLElement || Boolean(object) && object.nodeType > 0;
}
;// ./node_modules/instantsearch.js/es/lib/utils/getContainerNode.js


/**
 * Return the container. If it's a string, it is considered a
 * css selector and retrieves the first matching element. Otherwise
 * test if it validates that it's a correct DOMElement.
 *
 * @param {string|HTMLElement} selectorOrHTMLElement CSS Selector or container node.
 * @return {HTMLElement} Container node
 * @throws Error when the type is not correct
 */
function getContainerNode(selectorOrHTMLElement) {
  var isSelectorString = typeof selectorOrHTMLElement === 'string';
  var domElement = isSelectorString ? document.querySelector(selectorOrHTMLElement) : selectorOrHTMLElement;
  if (!isDomElement(domElement)) {
    var errorMessage = 'Container must be `string` or `HTMLElement`.';
    if (isSelectorString) {
      errorMessage += " Unable to find ".concat(selectorOrHTMLElement);
    }
    throw new Error(errorMessage);
  }
  return domElement;
}
;// ./node_modules/instantsearch.js/es/widgets/search-box/defaultTemplates.js

var _ref2 = _("path", {
  d: "M8.114 10L.944 2.83 0 1.885 1.886 0l.943.943L10 8.113l7.17-7.17.944-.943L20 1.886l-.943.943-7.17 7.17 7.17 7.17.943.944L18.114 20l-.943-.943-7.17-7.17-7.17 7.17-.944.943L0 18.114l.943-.943L8.113 10z"
});
var _ref4 = _("path", {
  d: "M26.804 29.01c-2.832 2.34-6.465 3.746-10.426 3.746C7.333 32.756 0 25.424 0 16.378 0 7.333 7.333 0 16.378 0c9.046 0 16.378 7.333 16.378 16.378 0 3.96-1.406 7.594-3.746 10.426l10.534 10.534c.607.607.61 1.59-.004 2.202-.61.61-1.597.61-2.202.004L26.804 29.01zm-10.426.627c7.323 0 13.26-5.936 13.26-13.26 0-7.32-5.937-13.257-13.26-13.257C9.056 3.12 3.12 9.056 3.12 16.378c0 7.323 5.936 13.26 13.258 13.26z"
});
var _ref6 = _("g", {
  fill: "none",
  "fill-rule": "evenodd"
}, _("g", {
  transform: "translate(1 1)",
  "stroke-width": "2"
}, _("circle", {
  "stroke-opacity": ".5",
  cx: "18",
  cy: "18",
  r: "18"
}), _("path", {
  d: "M36 18c0-9.94-8.06-18-18-18"
}, _("animateTransform", {
  attributeName: "transform",
  type: "rotate",
  from: "0 18 18",
  to: "360 18 18",
  dur: "1s",
  repeatCount: "indefinite"
}))));
var defaultTemplate = {
  reset: function reset(_ref) {
    var cssClasses = _ref.cssClasses;
    return _("svg", {
      className: cssClasses.resetIcon,
      viewBox: "0 0 20 20",
      width: "10",
      height: "10",
      "aria-hidden": "true"
    }, _ref2);
  },
  submit: function submit(_ref3) {
    var cssClasses = _ref3.cssClasses;
    return _("svg", {
      className: cssClasses.submitIcon,
      width: "10",
      height: "10",
      viewBox: "0 0 40 40",
      "aria-hidden": "true"
    }, _ref4);
  },
  loadingIndicator: function loadingIndicator(_ref5) {
    var cssClasses = _ref5.cssClasses;
    /* eslint-disable react/no-unknown-property */
    // Preact supports kebab case attributes, and using camel case would
    // require using `preact/compat`.
    // @TODO: reconsider using the `react` ESLint preset
    return _("svg", {
      "aria-label": "Results are loading",
      className: cssClasses.loadingIcon,
      width: "16",
      height: "16",
      viewBox: "0 0 38 38",
      stroke: "#444",
      "aria-hidden": "true"
    }, _ref6);
    /* eslint-enable react/no-unknown-property */
  }
};
/* harmony default export */ var defaultTemplates = (defaultTemplate);
;// ./node_modules/instantsearch.js/es/lib/formatNumber.js
function formatNumber(value, numberLocale) {
  return value.toLocaleString(numberLocale);
}
;// ./node_modules/instantsearch.js/es/widgets/refinement-list/defaultTemplates.js



var defaultTemplates_defaultTemplates = {
  item: function item(_ref) {
    var cssClasses = _ref.cssClasses,
      count = _ref.count,
      value = _ref.value,
      highlighted = _ref.highlighted,
      isRefined = _ref.isRefined,
      isFromSearch = _ref.isFromSearch;
    return _("label", {
      className: cx(cssClasses.label)
    }, _("input", {
      type: "checkbox",
      className: cx(cssClasses.checkbox),
      value: value,
      defaultChecked: isRefined
    }), _("span", {
      className: cx(cssClasses.labelText),
      dangerouslySetInnerHTML: isFromSearch ? {
        __html: highlighted
      } : undefined
    }, !isFromSearch && highlighted), _("span", {
      className: cx(cssClasses.count)
    }, formatNumber(count)));
  },
  showMoreText: function showMoreText(_ref2) {
    var isShowingMore = _ref2.isShowingMore;
    return isShowingMore ? 'Show less' : 'Show more';
  },
  searchableNoResults: function searchableNoResults() {
    return 'No results';
  }
};
/* harmony default export */ var refinement_list_defaultTemplates = (defaultTemplates_defaultTemplates);
;// ./node_modules/instantsearch.js/es/widgets/refinement-list/refinement-list.js
function refinement_list_typeof(o) { "@babel/helpers - typeof"; return refinement_list_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, refinement_list_typeof(o); }
function refinement_list_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function refinement_list_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? refinement_list_ownKeys(Object(t), !0).forEach(function (r) { refinement_list_defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : refinement_list_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function refinement_list_defineProperty(obj, key, value) { key = refinement_list_toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function refinement_list_toPropertyKey(t) { var i = refinement_list_toPrimitive(t, "string"); return "symbol" == refinement_list_typeof(i) ? i : String(i); }
function refinement_list_toPrimitive(t, r) { if ("object" != refinement_list_typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != refinement_list_typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }









var refinement_list_withUsage = createDocumentationMessageGenerator({
  name: 'refinement-list'
});
var suit = component('RefinementList');
var searchBoxSuit = component('SearchBox');
var renderer = function renderer(_ref) {
  var containerNode = _ref.containerNode,
    cssClasses = _ref.cssClasses,
    templates = _ref.templates,
    searchBoxTemplates = _ref.searchBoxTemplates,
    renderState = _ref.renderState,
    showMore = _ref.showMore,
    searchable = _ref.searchable,
    searchablePlaceholder = _ref.searchablePlaceholder,
    searchableIsAlwaysActive = _ref.searchableIsAlwaysActive;
  return function (_ref2, isFirstRendering) {
    var refine = _ref2.refine,
      items = _ref2.items,
      createURL = _ref2.createURL,
      searchForItems = _ref2.searchForItems,
      isFromSearch = _ref2.isFromSearch,
      instantSearchInstance = _ref2.instantSearchInstance,
      toggleShowMore = _ref2.toggleShowMore,
      isShowingMore = _ref2.isShowingMore,
      hasExhaustiveItems = _ref2.hasExhaustiveItems,
      canToggleShowMore = _ref2.canToggleShowMore;
    if (isFirstRendering) {
      renderState.templateProps = prepareTemplateProps({
        defaultTemplates: refinement_list_defaultTemplates,
        templatesConfig: instantSearchInstance.templatesConfig,
        templates: templates
      });
      renderState.searchBoxTemplateProps = prepareTemplateProps({
        defaultTemplates: defaultTemplates,
        templatesConfig: instantSearchInstance.templatesConfig,
        templates: searchBoxTemplates
      });
      return;
    }
    E(_(RefinementList_RefinementList, {
      createURL: createURL,
      cssClasses: cssClasses,
      facetValues: items,
      templateProps: renderState.templateProps,
      searchBoxTemplateProps: renderState.searchBoxTemplateProps,
      toggleRefinement: refine,
      searchFacetValues: searchable ? searchForItems : undefined,
      searchPlaceholder: searchablePlaceholder,
      searchIsAlwaysActive: searchableIsAlwaysActive,
      isFromSearch: isFromSearch,
      showMore: showMore && !isFromSearch && items.length > 0,
      toggleShowMore: toggleShowMore,
      isShowingMore: isShowingMore,
      hasExhaustiveItems: hasExhaustiveItems,
      canToggleShowMore: canToggleShowMore
    }), containerNode);
  };
};
/**
 * The refinement list widget is one of the most common widget that you can find
 * in a search UI. With this widget, the user can filter the dataset based on facets.
 *
 * The refinement list displays only the most relevant facets for the current search
 * context. The sort option only affects the facet that are returned by the engine,
 * not which facets are returned.
 *
 * This widget also implements search for facet values, which is a mini search inside the
 * values of the facets. This makes easy to deal with uncommon facet values.
 *
 * @requirements
 *
 * The attribute passed to `attribute` must be declared as an
 * [attribute for faceting](https://www.algolia.com/doc/guides/searching/faceting/#declaring-attributes-for-faceting)
 * in your Algolia settings.
 *
 * If you also want to use search for facet values on this attribute, you need to make it searchable using the [dashboard](https://www.algolia.com/explorer/display/) or using the [API](https://www.algolia.com/doc/guides/searching/faceting/#search-for-facet-values).
 */
var refinementList = function refinementList(widgetParams) {
  var _ref3 = widgetParams || {},
    container = _ref3.container,
    attribute = _ref3.attribute,
    operator = _ref3.operator,
    sortBy = _ref3.sortBy,
    limit = _ref3.limit,
    showMore = _ref3.showMore,
    showMoreLimit = _ref3.showMoreLimit,
    _ref3$searchable = _ref3.searchable,
    searchable = _ref3$searchable === void 0 ? false : _ref3$searchable,
    _ref3$searchablePlace = _ref3.searchablePlaceholder,
    searchablePlaceholder = _ref3$searchablePlace === void 0 ? 'Search...' : _ref3$searchablePlace,
    _ref3$searchableEscap = _ref3.searchableEscapeFacetValues,
    searchableEscapeFacetValues = _ref3$searchableEscap === void 0 ? true : _ref3$searchableEscap,
    _ref3$searchableIsAlw = _ref3.searchableIsAlwaysActive,
    searchableIsAlwaysActive = _ref3$searchableIsAlw === void 0 ? true : _ref3$searchableIsAlw,
    _ref3$cssClasses = _ref3.cssClasses,
    userCssClasses = _ref3$cssClasses === void 0 ? {} : _ref3$cssClasses,
    _ref3$templates = _ref3.templates,
    templates = _ref3$templates === void 0 ? {} : _ref3$templates,
    transformItems = _ref3.transformItems;
  if (!container) {
    throw new Error(refinement_list_withUsage('The `container` option is required.'));
  }
  var escapeFacetValues = searchable ? Boolean(searchableEscapeFacetValues) : false;
  var containerNode = getContainerNode(container);
  var cssClasses = {
    root: cx(suit(), userCssClasses.root),
    noRefinementRoot: cx(suit({
      modifierName: 'noRefinement'
    }), userCssClasses.noRefinementRoot),
    list: cx(suit({
      descendantName: 'list'
    }), userCssClasses.list),
    item: cx(suit({
      descendantName: 'item'
    }), userCssClasses.item),
    selectedItem: cx(suit({
      descendantName: 'item',
      modifierName: 'selected'
    }), userCssClasses.selectedItem),
    searchBox: cx(suit({
      descendantName: 'searchBox'
    }), userCssClasses.searchBox),
    label: cx(suit({
      descendantName: 'label'
    }), userCssClasses.label),
    checkbox: cx(suit({
      descendantName: 'checkbox'
    }), userCssClasses.checkbox),
    labelText: cx(suit({
      descendantName: 'labelText'
    }), userCssClasses.labelText),
    count: cx(suit({
      descendantName: 'count'
    }), userCssClasses.count),
    noResults: cx(suit({
      descendantName: 'noResults'
    }), userCssClasses.noResults),
    showMore: cx(suit({
      descendantName: 'showMore'
    }), userCssClasses.showMore),
    disabledShowMore: cx(suit({
      descendantName: 'showMore',
      modifierName: 'disabled'
    }), userCssClasses.disabledShowMore),
    searchable: {
      root: cx(searchBoxSuit(), userCssClasses.searchableRoot),
      form: cx(searchBoxSuit({
        descendantName: 'form'
      }), userCssClasses.searchableForm),
      input: cx(searchBoxSuit({
        descendantName: 'input'
      }), userCssClasses.searchableInput),
      submit: cx(searchBoxSuit({
        descendantName: 'submit'
      }), userCssClasses.searchableSubmit),
      submitIcon: cx(searchBoxSuit({
        descendantName: 'submitIcon'
      }), userCssClasses.searchableSubmitIcon),
      reset: cx(searchBoxSuit({
        descendantName: 'reset'
      }), userCssClasses.searchableReset),
      resetIcon: cx(searchBoxSuit({
        descendantName: 'resetIcon'
      }), userCssClasses.searchableResetIcon),
      loadingIndicator: cx(searchBoxSuit({
        descendantName: 'loadingIndicator'
      }), userCssClasses.searchableLoadingIndicator),
      loadingIcon: cx(searchBoxSuit({
        descendantName: 'loadingIcon'
      }), userCssClasses.searchableLoadingIcon)
    }
  };
  var specializedRenderer = renderer({
    containerNode: containerNode,
    cssClasses: cssClasses,
    templates: templates,
    searchBoxTemplates: {
      submit: templates.searchableSubmit,
      reset: templates.searchableReset,
      loadingIndicator: templates.searchableLoadingIndicator
    },
    renderState: {},
    searchable: searchable,
    searchablePlaceholder: searchablePlaceholder,
    searchableIsAlwaysActive: searchableIsAlwaysActive,
    showMore: showMore
  });
  var makeWidget = refinement_list_connectRefinementList(specializedRenderer, function () {
    return E(null, containerNode);
  });
  return refinement_list_objectSpread(refinement_list_objectSpread({}, makeWidget({
    attribute: attribute,
    operator: operator,
    limit: limit,
    showMore: showMore,
    showMoreLimit: showMoreLimit,
    sortBy: sortBy,
    escapeFacetValues: escapeFacetValues,
    transformItems: transformItems
  })), {}, {
    $$widgetType: 'ais.refinementList'
  });
};
/* harmony default export */ var refinement_list = (refinementList);
;// ./node_modules/instantsearch.js/es/lib/utils/isFiniteNumber.js
// This is the `Number.isFinite()` polyfill recommended by MDN.
// We do not provide any tests for this function.
// See: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number/isFinite#Polyfill
// @MAJOR Replace with the native `Number.isFinite` method
function isFiniteNumber(value) {
  return typeof value === 'number' && isFinite(value);
}
;// ./node_modules/instantsearch.js/es/lib/utils/find.js
// We aren't using the native `Array.prototype.find` because the refactor away from Lodash is not
// published as a major version.
// Relying on the `find` polyfill on user-land, which before was only required for niche use-cases,
// was decided as too risky.
// @MAJOR Replace with the native `Array.prototype.find` method
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/find
function find(items, predicate) {
  var value;
  for (var i = 0; i < items.length; i++) {
    value = items[i];
    // inlined for performance: if (Call(predicate, thisArg, [value, i, list])) {
    if (predicate(value, i, items)) {
      return value;
    }
  }
  return undefined;
}
;// ./node_modules/instantsearch.js/es/connectors/range/connectRange.js
function connectRange_typeof(o) { "@babel/helpers - typeof"; return connectRange_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, connectRange_typeof(o); }
function connectRange_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function connectRange_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? connectRange_ownKeys(Object(t), !0).forEach(function (r) { connectRange_defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : connectRange_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function connectRange_defineProperty(obj, key, value) { key = connectRange_toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function connectRange_toPropertyKey(t) { var i = connectRange_toPrimitive(t, "string"); return "symbol" == connectRange_typeof(i) ? i : String(i); }
function connectRange_toPrimitive(t, r) { if ("object" != connectRange_typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != connectRange_typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function connectRange_slicedToArray(arr, i) { return connectRange_arrayWithHoles(arr) || connectRange_iterableToArrayLimit(arr, i) || connectRange_unsupportedIterableToArray(arr, i) || connectRange_nonIterableRest(); }
function connectRange_nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function connectRange_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return connectRange_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return connectRange_arrayLikeToArray(o, minLen); }
function connectRange_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function connectRange_iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function connectRange_arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var connectRange_withUsage = createDocumentationMessageGenerator({
  name: 'range-input',
  connector: true
}, {
  name: 'range-slider',
  connector: true
});
var $$type = 'ais.range';

// @MAJOR: potentially we should consolidate these types

function toPrecision(_ref) {
  var min = _ref.min,
    max = _ref.max,
    precision = _ref.precision;
  var pow = Math.pow(10, precision);
  return {
    min: min ? Math.floor(min * pow) / pow : min,
    max: max ? Math.ceil(max * pow) / pow : max
  };
}

/**
 * **Range** connector provides the logic to create custom widget that will let
 * the user refine results using a numeric range.
 *
 * This connectors provides a `refine()` function that accepts bounds. It will also provide
 * information about the min and max bounds for the current result set.
 */
var connectRange = function connectRange(renderFn) {
  var unmountFn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : noop_noop;
  checkRendering(renderFn, connectRange_withUsage());
  return function (widgetParams) {
    var _ref2 = widgetParams || {},
      _ref2$attribute = _ref2.attribute,
      attribute = _ref2$attribute === void 0 ? '' : _ref2$attribute,
      minBound = _ref2.min,
      maxBound = _ref2.max,
      _ref2$precision = _ref2.precision,
      precision = _ref2$precision === void 0 ? 0 : _ref2$precision;
    if (!attribute) {
      throw new Error(connectRange_withUsage('The `attribute` option is required.'));
    }
    if (isFiniteNumber(minBound) && isFiniteNumber(maxBound) && minBound > maxBound) {
      throw new Error(connectRange_withUsage("The `max` option can't be lower than `min`."));
    }
    var formatToNumber = function formatToNumber(v) {
      return Number(Number(v).toFixed(precision));
    };
    var rangeFormatter = {
      from: function from(v) {
        return v.toLocaleString();
      },
      to: function to(v) {
        return formatToNumber(v).toLocaleString();
      }
    };

    // eslint-disable-next-line complexity
    var getRefinedState = function getRefinedState(helper, currentRange, nextMin, nextMax) {
      var resolvedState = helper.state;
      var currentRangeMin = currentRange.min,
        currentRangeMax = currentRange.max;
      var _ref3 = resolvedState.getNumericRefinement(attribute, '>=') || [],
        _ref4 = connectRange_slicedToArray(_ref3, 1),
        min = _ref4[0];
      var _ref5 = resolvedState.getNumericRefinement(attribute, '<=') || [],
        _ref6 = connectRange_slicedToArray(_ref5, 1),
        max = _ref6[0];
      var isResetMin = nextMin === undefined || nextMin === '';
      var isResetMax = nextMax === undefined || nextMax === '';
      var _toPrecision = toPrecision({
          min: !isResetMin ? parseFloat(nextMin) : undefined,
          max: !isResetMax ? parseFloat(nextMax) : undefined,
          precision: precision
        }),
        nextMinAsNumber = _toPrecision.min,
        nextMaxAsNumber = _toPrecision.max;
      var newNextMin;
      if (!isFiniteNumber(minBound) && currentRangeMin === nextMinAsNumber) {
        newNextMin = undefined;
      } else if (isFiniteNumber(minBound) && isResetMin) {
        newNextMin = minBound;
      } else {
        newNextMin = nextMinAsNumber;
      }
      var newNextMax;
      if (!isFiniteNumber(maxBound) && currentRangeMax === nextMaxAsNumber) {
        newNextMax = undefined;
      } else if (isFiniteNumber(maxBound) && isResetMax) {
        newNextMax = maxBound;
      } else {
        newNextMax = nextMaxAsNumber;
      }
      var isResetNewNextMin = newNextMin === undefined;
      var isGreaterThanCurrentRange = isFiniteNumber(currentRangeMin) && currentRangeMin <= newNextMin;
      var isMinValid = isResetNewNextMin || isFiniteNumber(newNextMin) && (!isFiniteNumber(currentRangeMin) || isGreaterThanCurrentRange);
      var isResetNewNextMax = newNextMax === undefined;
      var isLowerThanRange = isFiniteNumber(newNextMax) && currentRangeMax >= newNextMax;
      var isMaxValid = isResetNewNextMax || isFiniteNumber(newNextMax) && (!isFiniteNumber(currentRangeMax) || isLowerThanRange);
      var hasMinChange = min !== newNextMin;
      var hasMaxChange = max !== newNextMax;
      if ((hasMinChange || hasMaxChange) && isMinValid && isMaxValid) {
        resolvedState = resolvedState.removeNumericRefinement(attribute);
        if (isFiniteNumber(newNextMin)) {
          resolvedState = resolvedState.addNumericRefinement(attribute, '>=', newNextMin);
        }
        if (isFiniteNumber(newNextMax)) {
          resolvedState = resolvedState.addNumericRefinement(attribute, '<=', newNextMax);
        }
        return resolvedState.resetPage();
      }
      return null;
    };
    var createSendEvent = function createSendEvent(instantSearchInstance) {
      return function () {
        if (arguments.length === 1) {
          instantSearchInstance.sendEventToInsights(arguments.length <= 0 ? undefined : arguments[0]);
          return;
        }
      };
    };
    function _getCurrentRange(stats) {
      var min;
      if (isFiniteNumber(minBound)) {
        min = minBound;
      } else if (isFiniteNumber(stats.min)) {
        min = stats.min;
      } else {
        min = 0;
      }
      var max;
      if (isFiniteNumber(maxBound)) {
        max = maxBound;
      } else if (isFiniteNumber(stats.max)) {
        max = stats.max;
      } else {
        max = 0;
      }
      return toPrecision({
        min: min,
        max: max,
        precision: precision
      });
    }
    function _getCurrentRefinement(helper) {
      var _ref7 = helper.getNumericRefinement(attribute, '>=') || [],
        _ref8 = connectRange_slicedToArray(_ref7, 1),
        minValue = _ref8[0];
      var _ref9 = helper.getNumericRefinement(attribute, '<=') || [],
        _ref10 = connectRange_slicedToArray(_ref9, 1),
        maxValue = _ref10[0];
      var min = isFiniteNumber(minValue) ? minValue : -Infinity;
      var max = isFiniteNumber(maxValue) ? maxValue : Infinity;
      return [min, max];
    }
    function _refine(helper, currentRange) {
      return function () {
        var _ref11 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [undefined, undefined],
          _ref12 = connectRange_slicedToArray(_ref11, 2),
          nextMin = _ref12[0],
          nextMax = _ref12[1];
        var refinedState = getRefinedState(helper, currentRange, nextMin, nextMax);
        if (refinedState) {
          helper.setState(refinedState).search();
        }
      };
    }
    return {
      $$type: $$type,
      init: function init(initOptions) {
        renderFn(connectRange_objectSpread(connectRange_objectSpread({}, this.getWidgetRenderState(initOptions)), {}, {
          instantSearchInstance: initOptions.instantSearchInstance
        }), true);
      },
      render: function render(renderOptions) {
        renderFn(connectRange_objectSpread(connectRange_objectSpread({}, this.getWidgetRenderState(renderOptions)), {}, {
          instantSearchInstance: renderOptions.instantSearchInstance
        }), false);
      },
      getRenderState: function getRenderState(renderState, renderOptions) {
        return connectRange_objectSpread(connectRange_objectSpread({}, renderState), {}, {
          range: connectRange_objectSpread(connectRange_objectSpread({}, renderState.range), {}, connectRange_defineProperty({}, attribute, this.getWidgetRenderState(renderOptions)))
        });
      },
      getWidgetRenderState: function getWidgetRenderState(_ref13) {
        var results = _ref13.results,
          helper = _ref13.helper,
          instantSearchInstance = _ref13.instantSearchInstance;
        var facetsFromResults = results && results.disjunctiveFacets || [];
        var facet = find(facetsFromResults, function (facetResult) {
          return facetResult.name === attribute;
        });
        var stats = facet && facet.stats || {
          min: undefined,
          max: undefined
        };
        var currentRange = _getCurrentRange(stats);
        var start = _getCurrentRefinement(helper);
        var refine;
        if (!results) {
          // On first render pass an empty range
          // to be able to bypass the validation
          // related to it
          refine = _refine(helper, {
            min: undefined,
            max: undefined
          });
        } else {
          refine = _refine(helper, currentRange);
        }
        return {
          refine: refine,
          canRefine: currentRange.min !== currentRange.max,
          format: rangeFormatter,
          range: currentRange,
          sendEvent: createSendEvent(instantSearchInstance),
          widgetParams: connectRange_objectSpread(connectRange_objectSpread({}, widgetParams), {}, {
            precision: precision
          }),
          start: start
        };
      },
      dispose: function dispose(_ref14) {
        var state = _ref14.state;
        unmountFn();
        return state.removeDisjunctiveFacet(attribute).removeNumericRefinement(attribute);
      },
      getWidgetUiState: function getWidgetUiState(uiState, _ref15) {
        var searchParameters = _ref15.searchParameters;
        var _searchParameters$get = searchParameters.getNumericRefinements(attribute),
          _searchParameters$get2 = _searchParameters$get['>='],
          min = _searchParameters$get2 === void 0 ? [] : _searchParameters$get2,
          _searchParameters$get3 = _searchParameters$get['<='],
          max = _searchParameters$get3 === void 0 ? [] : _searchParameters$get3;
        if (min.length === 0 && max.length === 0) {
          return uiState;
        }
        return connectRange_objectSpread(connectRange_objectSpread({}, uiState), {}, {
          range: connectRange_objectSpread(connectRange_objectSpread({}, uiState.range), {}, connectRange_defineProperty({}, attribute, "".concat(min, ":").concat(max)))
        });
      },
      getWidgetSearchParameters: function getWidgetSearchParameters(searchParameters, _ref16) {
        var uiState = _ref16.uiState;
        var widgetSearchParameters = searchParameters.addDisjunctiveFacet(attribute).setQueryParameters({
          numericRefinements: connectRange_objectSpread(connectRange_objectSpread({}, searchParameters.numericRefinements), {}, connectRange_defineProperty({}, attribute, {}))
        });
        if (isFiniteNumber(minBound)) {
          widgetSearchParameters = widgetSearchParameters.addNumericRefinement(attribute, '>=', minBound);
        }
        if (isFiniteNumber(maxBound)) {
          widgetSearchParameters = widgetSearchParameters.addNumericRefinement(attribute, '<=', maxBound);
        }
        var value = uiState.range && uiState.range[attribute];
        if (!value || value.indexOf(':') === -1) {
          return widgetSearchParameters;
        }
        var _value$split$map = value.split(':').map(parseFloat),
          _value$split$map2 = connectRange_slicedToArray(_value$split$map, 2),
          lowerBound = _value$split$map2[0],
          upperBound = _value$split$map2[1];
        if (isFiniteNumber(lowerBound) && (!isFiniteNumber(minBound) || minBound < lowerBound)) {
          widgetSearchParameters = widgetSearchParameters.removeNumericRefinement(attribute, '>=');
          widgetSearchParameters = widgetSearchParameters.addNumericRefinement(attribute, '>=', lowerBound);
        }
        if (isFiniteNumber(upperBound) && (!isFiniteNumber(maxBound) || upperBound < maxBound)) {
          widgetSearchParameters = widgetSearchParameters.removeNumericRefinement(attribute, '<=');
          widgetSearchParameters = widgetSearchParameters.addNumericRefinement(attribute, '<=', upperBound);
        }
        return widgetSearchParameters;
      }
    };
  };
};
/* harmony default export */ var range_connectRange = (connectRange);
;// ./node_modules/nouislider/dist/nouislider.mjs

var PipsMode;
(function (PipsMode) {
    PipsMode["Range"] = "range";
    PipsMode["Steps"] = "steps";
    PipsMode["Positions"] = "positions";
    PipsMode["Count"] = "count";
    PipsMode["Values"] = "values";
})(PipsMode || (PipsMode = {}));
var PipsType;
(function (PipsType) {
    PipsType[PipsType["None"] = -1] = "None";
    PipsType[PipsType["NoValue"] = 0] = "NoValue";
    PipsType[PipsType["LargeValue"] = 1] = "LargeValue";
    PipsType[PipsType["SmallValue"] = 2] = "SmallValue";
})(PipsType || (PipsType = {}));
//region Helper Methods
function isValidFormatter(entry) {
    return isValidPartialFormatter(entry) && typeof entry.from === "function";
}
function isValidPartialFormatter(entry) {
    // partial formatters only need a to function and not a from function
    return typeof entry === "object" && typeof entry.to === "function";
}
function removeElement(el) {
    el.parentElement.removeChild(el);
}
function nouislider_isSet(value) {
    return value !== null && value !== undefined;
}
// Bindable version
function preventDefault(e) {
    e.preventDefault();
}
// Removes duplicates from an array.
function unique(array) {
    return array.filter(function (a) {
        return !this[a] ? (this[a] = true) : false;
    }, {});
}
// Round a value to the closest 'to'.
function closest(value, to) {
    return Math.round(value / to) * to;
}
// Current position of an element relative to the document.
function offset(elem, orientation) {
    var rect = elem.getBoundingClientRect();
    var doc = elem.ownerDocument;
    var docElem = doc.documentElement;
    var pageOffset = getPageOffset(doc);
    // getBoundingClientRect contains left scroll in Chrome on Android.
    // I haven't found a feature detection that proves this. Worst case
    // scenario on mis-match: the 'tap' feature on horizontal sliders breaks.
    if (/webkit.*Chrome.*Mobile/i.test(navigator.userAgent)) {
        pageOffset.x = 0;
    }
    return orientation ? rect.top + pageOffset.y - docElem.clientTop : rect.left + pageOffset.x - docElem.clientLeft;
}
// Checks whether a value is numerical.
function isNumeric(a) {
    return typeof a === "number" && !isNaN(a) && isFinite(a);
}
// Sets a class and removes it after [duration] ms.
function addClassFor(element, className, duration) {
    if (duration > 0) {
        addClass(element, className);
        setTimeout(function () {
            removeClass(element, className);
        }, duration);
    }
}
// Limits a value to 0 - 100
function limit(a) {
    return Math.max(Math.min(a, 100), 0);
}
// Wraps a variable as an array, if it isn't one yet.
// Note that an input array is returned by reference!
function asArray(a) {
    return Array.isArray(a) ? a : [a];
}
// Counts decimals
function countDecimals(numStr) {
    numStr = String(numStr);
    var pieces = numStr.split(".");
    return pieces.length > 1 ? pieces[1].length : 0;
}
// http://youmightnotneedjquery.com/#add_class
function addClass(el, className) {
    if (el.classList && !/\s/.test(className)) {
        el.classList.add(className);
    }
    else {
        el.className += " " + className;
    }
}
// http://youmightnotneedjquery.com/#remove_class
function removeClass(el, className) {
    if (el.classList && !/\s/.test(className)) {
        el.classList.remove(className);
    }
    else {
        el.className = el.className.replace(new RegExp("(^|\\b)" + className.split(" ").join("|") + "(\\b|$)", "gi"), " ");
    }
}
// https://plainjs.com/javascript/attributes/adding-removing-and-testing-for-classes-9/
function hasClass(el, className) {
    return el.classList ? el.classList.contains(className) : new RegExp("\\b" + className + "\\b").test(el.className);
}
// https://developer.mozilla.org/en-US/docs/Web/API/Window/scrollY#Notes
function getPageOffset(doc) {
    var supportPageOffset = window.pageXOffset !== undefined;
    var isCSS1Compat = (doc.compatMode || "") === "CSS1Compat";
    var x = supportPageOffset
        ? window.pageXOffset
        : isCSS1Compat
            ? doc.documentElement.scrollLeft
            : doc.body.scrollLeft;
    var y = supportPageOffset
        ? window.pageYOffset
        : isCSS1Compat
            ? doc.documentElement.scrollTop
            : doc.body.scrollTop;
    return {
        x: x,
        y: y,
    };
}
// we provide a function to compute constants instead
// of accessing window.* as soon as the module needs it
// so that we do not compute anything if not needed
function getActions() {
    // Determine the events to bind. IE11 implements pointerEvents without
    // a prefix, which breaks compatibility with the IE10 implementation.
    return window.navigator.pointerEnabled
        ? {
            start: "pointerdown",
            move: "pointermove",
            end: "pointerup",
        }
        : window.navigator.msPointerEnabled
            ? {
                start: "MSPointerDown",
                move: "MSPointerMove",
                end: "MSPointerUp",
            }
            : {
                start: "mousedown touchstart",
                move: "mousemove touchmove",
                end: "mouseup touchend",
            };
}
// https://github.com/WICG/EventListenerOptions/blob/gh-pages/explainer.md
// Issue #785
function getSupportsPassive() {
    var supportsPassive = false;
    /* eslint-disable */
    try {
        var opts = Object.defineProperty({}, "passive", {
            get: function () {
                supportsPassive = true;
            },
        });
        // @ts-ignore
        window.addEventListener("test", null, opts);
    }
    catch (e) { }
    /* eslint-enable */
    return supportsPassive;
}
function getSupportsTouchActionNone() {
    return window.CSS && CSS.supports && CSS.supports("touch-action", "none");
}
//endregion
//region Range Calculation
// Determine the size of a sub-range in relation to a full range.
function subRangeRatio(pa, pb) {
    return 100 / (pb - pa);
}
// (percentage) How many percent is this value of this range?
function fromPercentage(range, value, startRange) {
    return (value * 100) / (range[startRange + 1] - range[startRange]);
}
// (percentage) Where is this value on this range?
function toPercentage(range, value) {
    return fromPercentage(range, range[0] < 0 ? value + Math.abs(range[0]) : value - range[0], 0);
}
// (value) How much is this percentage on this range?
function isPercentage(range, value) {
    return (value * (range[1] - range[0])) / 100 + range[0];
}
function getJ(value, arr) {
    var j = 1;
    while (value >= arr[j]) {
        j += 1;
    }
    return j;
}
// (percentage) Input a value, find where, on a scale of 0-100, it applies.
function toStepping(xVal, xPct, value) {
    if (value >= xVal.slice(-1)[0]) {
        return 100;
    }
    var j = getJ(value, xVal);
    var va = xVal[j - 1];
    var vb = xVal[j];
    var pa = xPct[j - 1];
    var pb = xPct[j];
    return pa + toPercentage([va, vb], value) / subRangeRatio(pa, pb);
}
// (value) Input a percentage, find where it is on the specified range.
function fromStepping(xVal, xPct, value) {
    // There is no range group that fits 100
    if (value >= 100) {
        return xVal.slice(-1)[0];
    }
    var j = getJ(value, xPct);
    var va = xVal[j - 1];
    var vb = xVal[j];
    var pa = xPct[j - 1];
    var pb = xPct[j];
    return isPercentage([va, vb], (value - pa) * subRangeRatio(pa, pb));
}
// (percentage) Get the step that applies at a certain value.
function getStep(xPct, xSteps, snap, value) {
    if (value === 100) {
        return value;
    }
    var j = getJ(value, xPct);
    var a = xPct[j - 1];
    var b = xPct[j];
    // If 'snap' is set, steps are used as fixed points on the slider.
    if (snap) {
        // Find the closest position, a or b.
        if (value - a > (b - a) / 2) {
            return b;
        }
        return a;
    }
    if (!xSteps[j - 1]) {
        return value;
    }
    return xPct[j - 1] + closest(value - xPct[j - 1], xSteps[j - 1]);
}
//endregion
//region Spectrum
var Spectrum = /** @class */ (function () {
    function Spectrum(entry, snap, singleStep) {
        this.xPct = [];
        this.xVal = [];
        this.xSteps = [];
        this.xNumSteps = [];
        this.xHighestCompleteStep = [];
        this.xSteps = [singleStep || false];
        this.xNumSteps = [false];
        this.snap = snap;
        var index;
        var ordered = [];
        // Map the object keys to an array.
        Object.keys(entry).forEach(function (index) {
            ordered.push([asArray(entry[index]), index]);
        });
        // Sort all entries by value (numeric sort).
        ordered.sort(function (a, b) {
            return a[0][0] - b[0][0];
        });
        // Convert all entries to subranges.
        for (index = 0; index < ordered.length; index++) {
            this.handleEntryPoint(ordered[index][1], ordered[index][0]);
        }
        // Store the actual step values.
        // xSteps is sorted in the same order as xPct and xVal.
        this.xNumSteps = this.xSteps.slice(0);
        // Convert all numeric steps to the percentage of the subrange they represent.
        for (index = 0; index < this.xNumSteps.length; index++) {
            this.handleStepPoint(index, this.xNumSteps[index]);
        }
    }
    Spectrum.prototype.getDistance = function (value) {
        var distances = [];
        for (var index = 0; index < this.xNumSteps.length - 1; index++) {
            distances[index] = fromPercentage(this.xVal, value, index);
        }
        return distances;
    };
    // Calculate the percentual distance over the whole scale of ranges.
    // direction: 0 = backwards / 1 = forwards
    Spectrum.prototype.getAbsoluteDistance = function (value, distances, direction) {
        var xPct_index = 0;
        // Calculate range where to start calculation
        if (value < this.xPct[this.xPct.length - 1]) {
            while (value > this.xPct[xPct_index + 1]) {
                xPct_index++;
            }
        }
        else if (value === this.xPct[this.xPct.length - 1]) {
            xPct_index = this.xPct.length - 2;
        }
        // If looking backwards and the value is exactly at a range separator then look one range further
        if (!direction && value === this.xPct[xPct_index + 1]) {
            xPct_index++;
        }
        if (distances === null) {
            distances = [];
        }
        var start_factor;
        var rest_factor = 1;
        var rest_rel_distance = distances[xPct_index];
        var range_pct = 0;
        var rel_range_distance = 0;
        var abs_distance_counter = 0;
        var range_counter = 0;
        // Calculate what part of the start range the value is
        if (direction) {
            start_factor = (value - this.xPct[xPct_index]) / (this.xPct[xPct_index + 1] - this.xPct[xPct_index]);
        }
        else {
            start_factor = (this.xPct[xPct_index + 1] - value) / (this.xPct[xPct_index + 1] - this.xPct[xPct_index]);
        }
        // Do until the complete distance across ranges is calculated
        while (rest_rel_distance > 0) {
            // Calculate the percentage of total range
            range_pct = this.xPct[xPct_index + 1 + range_counter] - this.xPct[xPct_index + range_counter];
            // Detect if the margin, padding or limit is larger then the current range and calculate
            if (distances[xPct_index + range_counter] * rest_factor + 100 - start_factor * 100 > 100) {
                // If larger then take the percentual distance of the whole range
                rel_range_distance = range_pct * start_factor;
                // Rest factor of relative percentual distance still to be calculated
                rest_factor = (rest_rel_distance - 100 * start_factor) / distances[xPct_index + range_counter];
                // Set start factor to 1 as for next range it does not apply.
                start_factor = 1;
            }
            else {
                // If smaller or equal then take the percentual distance of the calculate percentual part of that range
                rel_range_distance = ((distances[xPct_index + range_counter] * range_pct) / 100) * rest_factor;
                // No rest left as the rest fits in current range
                rest_factor = 0;
            }
            if (direction) {
                abs_distance_counter = abs_distance_counter - rel_range_distance;
                // Limit range to first range when distance becomes outside of minimum range
                if (this.xPct.length + range_counter >= 1) {
                    range_counter--;
                }
            }
            else {
                abs_distance_counter = abs_distance_counter + rel_range_distance;
                // Limit range to last range when distance becomes outside of maximum range
                if (this.xPct.length - range_counter >= 1) {
                    range_counter++;
                }
            }
            // Rest of relative percentual distance still to be calculated
            rest_rel_distance = distances[xPct_index + range_counter] * rest_factor;
        }
        return value + abs_distance_counter;
    };
    Spectrum.prototype.toStepping = function (value) {
        value = toStepping(this.xVal, this.xPct, value);
        return value;
    };
    Spectrum.prototype.fromStepping = function (value) {
        return fromStepping(this.xVal, this.xPct, value);
    };
    Spectrum.prototype.getStep = function (value) {
        value = getStep(this.xPct, this.xSteps, this.snap, value);
        return value;
    };
    Spectrum.prototype.getDefaultStep = function (value, isDown, size) {
        var j = getJ(value, this.xPct);
        // When at the top or stepping down, look at the previous sub-range
        if (value === 100 || (isDown && value === this.xPct[j - 1])) {
            j = Math.max(j - 1, 1);
        }
        return (this.xVal[j] - this.xVal[j - 1]) / size;
    };
    Spectrum.prototype.getNearbySteps = function (value) {
        var j = getJ(value, this.xPct);
        return {
            stepBefore: {
                startValue: this.xVal[j - 2],
                step: this.xNumSteps[j - 2],
                highestStep: this.xHighestCompleteStep[j - 2],
            },
            thisStep: {
                startValue: this.xVal[j - 1],
                step: this.xNumSteps[j - 1],
                highestStep: this.xHighestCompleteStep[j - 1],
            },
            stepAfter: {
                startValue: this.xVal[j],
                step: this.xNumSteps[j],
                highestStep: this.xHighestCompleteStep[j],
            },
        };
    };
    Spectrum.prototype.countStepDecimals = function () {
        var stepDecimals = this.xNumSteps.map(countDecimals);
        return Math.max.apply(null, stepDecimals);
    };
    Spectrum.prototype.hasNoSize = function () {
        return this.xVal[0] === this.xVal[this.xVal.length - 1];
    };
    // Outside testing
    Spectrum.prototype.convert = function (value) {
        return this.getStep(this.toStepping(value));
    };
    Spectrum.prototype.handleEntryPoint = function (index, value) {
        var percentage;
        // Covert min/max syntax to 0 and 100.
        if (index === "min") {
            percentage = 0;
        }
        else if (index === "max") {
            percentage = 100;
        }
        else {
            percentage = parseFloat(index);
        }
        // Check for correct input.
        if (!isNumeric(percentage) || !isNumeric(value[0])) {
            throw new Error("noUiSlider: 'range' value isn't numeric.");
        }
        // Store values.
        this.xPct.push(percentage);
        this.xVal.push(value[0]);
        var value1 = Number(value[1]);
        // NaN will evaluate to false too, but to keep
        // logging clear, set step explicitly. Make sure
        // not to override the 'step' setting with false.
        if (!percentage) {
            if (!isNaN(value1)) {
                this.xSteps[0] = value1;
            }
        }
        else {
            this.xSteps.push(isNaN(value1) ? false : value1);
        }
        this.xHighestCompleteStep.push(0);
    };
    Spectrum.prototype.handleStepPoint = function (i, n) {
        // Ignore 'false' stepping.
        if (!n) {
            return;
        }
        // Step over zero-length ranges (#948);
        if (this.xVal[i] === this.xVal[i + 1]) {
            this.xSteps[i] = this.xHighestCompleteStep[i] = this.xVal[i];
            return;
        }
        // Factor to range ratio
        this.xSteps[i] =
            fromPercentage([this.xVal[i], this.xVal[i + 1]], n, 0) / subRangeRatio(this.xPct[i], this.xPct[i + 1]);
        var totalSteps = (this.xVal[i + 1] - this.xVal[i]) / this.xNumSteps[i];
        var highestStep = Math.ceil(Number(totalSteps.toFixed(3)) - 1);
        var step = this.xVal[i] + this.xNumSteps[i] * highestStep;
        this.xHighestCompleteStep[i] = step;
    };
    return Spectrum;
}());
//endregion
//region Options
/*	Every input option is tested and parsed. This will prevent
    endless validation in internal methods. These tests are
    structured with an item for every option available. An
    option can be marked as required by setting the 'r' flag.
    The testing function is provided with three arguments:
        - The provided value for the option;
        - A reference to the options object;
        - The name for the option;

    The testing function returns false when an error is detected,
    or true when everything is OK. It can also modify the option
    object, to make sure all values can be correctly looped elsewhere. */
//region Defaults
var defaultFormatter = {
    to: function (value) {
        return value === undefined ? "" : value.toFixed(2);
    },
    from: Number,
};
var cssClasses = {
    target: "target",
    base: "base",
    origin: "origin",
    handle: "handle",
    handleLower: "handle-lower",
    handleUpper: "handle-upper",
    touchArea: "touch-area",
    horizontal: "horizontal",
    vertical: "vertical",
    background: "background",
    connect: "connect",
    connects: "connects",
    ltr: "ltr",
    rtl: "rtl",
    textDirectionLtr: "txt-dir-ltr",
    textDirectionRtl: "txt-dir-rtl",
    draggable: "draggable",
    drag: "state-drag",
    tap: "state-tap",
    active: "active",
    tooltip: "tooltip",
    pips: "pips",
    pipsHorizontal: "pips-horizontal",
    pipsVertical: "pips-vertical",
    marker: "marker",
    markerHorizontal: "marker-horizontal",
    markerVertical: "marker-vertical",
    markerNormal: "marker-normal",
    markerLarge: "marker-large",
    markerSub: "marker-sub",
    value: "value",
    valueHorizontal: "value-horizontal",
    valueVertical: "value-vertical",
    valueNormal: "value-normal",
    valueLarge: "value-large",
    valueSub: "value-sub",
};
// Namespaces of internal event listeners
var INTERNAL_EVENT_NS = {
    tooltips: ".__tooltips",
    aria: ".__aria",
};
//endregion
function testStep(parsed, entry) {
    if (!isNumeric(entry)) {
        throw new Error("noUiSlider: 'step' is not numeric.");
    }
    // The step option can still be used to set stepping
    // for linear sliders. Overwritten if set in 'range'.
    parsed.singleStep = entry;
}
function testKeyboardPageMultiplier(parsed, entry) {
    if (!isNumeric(entry)) {
        throw new Error("noUiSlider: 'keyboardPageMultiplier' is not numeric.");
    }
    parsed.keyboardPageMultiplier = entry;
}
function testKeyboardMultiplier(parsed, entry) {
    if (!isNumeric(entry)) {
        throw new Error("noUiSlider: 'keyboardMultiplier' is not numeric.");
    }
    parsed.keyboardMultiplier = entry;
}
function testKeyboardDefaultStep(parsed, entry) {
    if (!isNumeric(entry)) {
        throw new Error("noUiSlider: 'keyboardDefaultStep' is not numeric.");
    }
    parsed.keyboardDefaultStep = entry;
}
function testRange(parsed, entry) {
    // Filter incorrect input.
    if (typeof entry !== "object" || Array.isArray(entry)) {
        throw new Error("noUiSlider: 'range' is not an object.");
    }
    // Catch missing start or end.
    if (entry.min === undefined || entry.max === undefined) {
        throw new Error("noUiSlider: Missing 'min' or 'max' in 'range'.");
    }
    parsed.spectrum = new Spectrum(entry, parsed.snap || false, parsed.singleStep);
}
function testStart(parsed, entry) {
    entry = asArray(entry);
    // Validate input. Values aren't tested, as the public .val method
    // will always provide a valid location.
    if (!Array.isArray(entry) || !entry.length) {
        throw new Error("noUiSlider: 'start' option is incorrect.");
    }
    // Store the number of handles.
    parsed.handles = entry.length;
    // When the slider is initialized, the .val method will
    // be called with the start options.
    parsed.start = entry;
}
function testSnap(parsed, entry) {
    if (typeof entry !== "boolean") {
        throw new Error("noUiSlider: 'snap' option must be a boolean.");
    }
    // Enforce 100% stepping within subranges.
    parsed.snap = entry;
}
function testAnimate(parsed, entry) {
    if (typeof entry !== "boolean") {
        throw new Error("noUiSlider: 'animate' option must be a boolean.");
    }
    // Enforce 100% stepping within subranges.
    parsed.animate = entry;
}
function testAnimationDuration(parsed, entry) {
    if (typeof entry !== "number") {
        throw new Error("noUiSlider: 'animationDuration' option must be a number.");
    }
    parsed.animationDuration = entry;
}
function testConnect(parsed, entry) {
    var connect = [false];
    var i;
    // Map legacy options
    if (entry === "lower") {
        entry = [true, false];
    }
    else if (entry === "upper") {
        entry = [false, true];
    }
    // Handle boolean options
    if (entry === true || entry === false) {
        for (i = 1; i < parsed.handles; i++) {
            connect.push(entry);
        }
        connect.push(false);
    }
    // Reject invalid input
    else if (!Array.isArray(entry) || !entry.length || entry.length !== parsed.handles + 1) {
        throw new Error("noUiSlider: 'connect' option doesn't match handle count.");
    }
    else {
        connect = entry;
    }
    parsed.connect = connect;
}
function testOrientation(parsed, entry) {
    // Set orientation to an a numerical value for easy
    // array selection.
    switch (entry) {
        case "horizontal":
            parsed.ort = 0;
            break;
        case "vertical":
            parsed.ort = 1;
            break;
        default:
            throw new Error("noUiSlider: 'orientation' option is invalid.");
    }
}
function testMargin(parsed, entry) {
    if (!isNumeric(entry)) {
        throw new Error("noUiSlider: 'margin' option must be numeric.");
    }
    // Issue #582
    if (entry === 0) {
        return;
    }
    parsed.margin = parsed.spectrum.getDistance(entry);
}
function testLimit(parsed, entry) {
    if (!isNumeric(entry)) {
        throw new Error("noUiSlider: 'limit' option must be numeric.");
    }
    parsed.limit = parsed.spectrum.getDistance(entry);
    if (!parsed.limit || parsed.handles < 2) {
        throw new Error("noUiSlider: 'limit' option is only supported on linear sliders with 2 or more handles.");
    }
}
function testPadding(parsed, entry) {
    var index;
    if (!isNumeric(entry) && !Array.isArray(entry)) {
        throw new Error("noUiSlider: 'padding' option must be numeric or array of exactly 2 numbers.");
    }
    if (Array.isArray(entry) && !(entry.length === 2 || isNumeric(entry[0]) || isNumeric(entry[1]))) {
        throw new Error("noUiSlider: 'padding' option must be numeric or array of exactly 2 numbers.");
    }
    if (entry === 0) {
        return;
    }
    if (!Array.isArray(entry)) {
        entry = [entry, entry];
    }
    // 'getDistance' returns false for invalid values.
    parsed.padding = [parsed.spectrum.getDistance(entry[0]), parsed.spectrum.getDistance(entry[1])];
    for (index = 0; index < parsed.spectrum.xNumSteps.length - 1; index++) {
        // last "range" can't contain step size as it is purely an endpoint.
        if (parsed.padding[0][index] < 0 || parsed.padding[1][index] < 0) {
            throw new Error("noUiSlider: 'padding' option must be a positive number(s).");
        }
    }
    var totalPadding = entry[0] + entry[1];
    var firstValue = parsed.spectrum.xVal[0];
    var lastValue = parsed.spectrum.xVal[parsed.spectrum.xVal.length - 1];
    if (totalPadding / (lastValue - firstValue) > 1) {
        throw new Error("noUiSlider: 'padding' option must not exceed 100% of the range.");
    }
}
function testDirection(parsed, entry) {
    // Set direction as a numerical value for easy parsing.
    // Invert connection for RTL sliders, so that the proper
    // handles get the connect/background classes.
    switch (entry) {
        case "ltr":
            parsed.dir = 0;
            break;
        case "rtl":
            parsed.dir = 1;
            break;
        default:
            throw new Error("noUiSlider: 'direction' option was not recognized.");
    }
}
function testBehaviour(parsed, entry) {
    // Make sure the input is a string.
    if (typeof entry !== "string") {
        throw new Error("noUiSlider: 'behaviour' must be a string containing options.");
    }
    // Check if the string contains any keywords.
    // None are required.
    var tap = entry.indexOf("tap") >= 0;
    var drag = entry.indexOf("drag") >= 0;
    var fixed = entry.indexOf("fixed") >= 0;
    var snap = entry.indexOf("snap") >= 0;
    var hover = entry.indexOf("hover") >= 0;
    var unconstrained = entry.indexOf("unconstrained") >= 0;
    var invertConnects = entry.indexOf("invert-connects") >= 0;
    var dragAll = entry.indexOf("drag-all") >= 0;
    var smoothSteps = entry.indexOf("smooth-steps") >= 0;
    if (fixed) {
        if (parsed.handles !== 2) {
            throw new Error("noUiSlider: 'fixed' behaviour must be used with 2 handles");
        }
        // Use margin to enforce fixed state
        testMargin(parsed, parsed.start[1] - parsed.start[0]);
    }
    if (invertConnects && parsed.handles !== 2) {
        throw new Error("noUiSlider: 'invert-connects' behaviour must be used with 2 handles");
    }
    if (unconstrained && (parsed.margin || parsed.limit)) {
        throw new Error("noUiSlider: 'unconstrained' behaviour cannot be used with margin or limit");
    }
    parsed.events = {
        tap: tap || snap,
        drag: drag,
        dragAll: dragAll,
        smoothSteps: smoothSteps,
        fixed: fixed,
        snap: snap,
        hover: hover,
        unconstrained: unconstrained,
        invertConnects: invertConnects,
    };
}
function testTooltips(parsed, entry) {
    if (entry === false) {
        return;
    }
    if (entry === true || isValidPartialFormatter(entry)) {
        parsed.tooltips = [];
        for (var i = 0; i < parsed.handles; i++) {
            parsed.tooltips.push(entry);
        }
    }
    else {
        entry = asArray(entry);
        if (entry.length !== parsed.handles) {
            throw new Error("noUiSlider: must pass a formatter for all handles.");
        }
        entry.forEach(function (formatter) {
            if (typeof formatter !== "boolean" && !isValidPartialFormatter(formatter)) {
                throw new Error("noUiSlider: 'tooltips' must be passed a formatter or 'false'.");
            }
        });
        parsed.tooltips = entry;
    }
}
function testHandleAttributes(parsed, entry) {
    if (entry.length !== parsed.handles) {
        throw new Error("noUiSlider: must pass a attributes for all handles.");
    }
    parsed.handleAttributes = entry;
}
function testAriaFormat(parsed, entry) {
    if (!isValidPartialFormatter(entry)) {
        throw new Error("noUiSlider: 'ariaFormat' requires 'to' method.");
    }
    parsed.ariaFormat = entry;
}
function testFormat(parsed, entry) {
    if (!isValidFormatter(entry)) {
        throw new Error("noUiSlider: 'format' requires 'to' and 'from' methods.");
    }
    parsed.format = entry;
}
function testKeyboardSupport(parsed, entry) {
    if (typeof entry !== "boolean") {
        throw new Error("noUiSlider: 'keyboardSupport' option must be a boolean.");
    }
    parsed.keyboardSupport = entry;
}
function testDocumentElement(parsed, entry) {
    // This is an advanced option. Passed values are used without validation.
    parsed.documentElement = entry;
}
function testCssPrefix(parsed, entry) {
    if (typeof entry !== "string" && entry !== false) {
        throw new Error("noUiSlider: 'cssPrefix' must be a string or `false`.");
    }
    parsed.cssPrefix = entry;
}
function testCssClasses(parsed, entry) {
    if (typeof entry !== "object") {
        throw new Error("noUiSlider: 'cssClasses' must be an object.");
    }
    if (typeof parsed.cssPrefix === "string") {
        parsed.cssClasses = {};
        Object.keys(entry).forEach(function (key) {
            parsed.cssClasses[key] = parsed.cssPrefix + entry[key];
        });
    }
    else {
        parsed.cssClasses = entry;
    }
}
// Test all developer settings and parse to assumption-safe values.
function testOptions(options) {
    // To prove a fix for #537, freeze options here.
    // If the object is modified, an error will be thrown.
    // Object.freeze(options);
    var parsed = {
        margin: null,
        limit: null,
        padding: null,
        animate: true,
        animationDuration: 300,
        ariaFormat: defaultFormatter,
        format: defaultFormatter,
    };
    // Tests are executed in the order they are presented here.
    var tests = {
        step: { r: false, t: testStep },
        keyboardPageMultiplier: { r: false, t: testKeyboardPageMultiplier },
        keyboardMultiplier: { r: false, t: testKeyboardMultiplier },
        keyboardDefaultStep: { r: false, t: testKeyboardDefaultStep },
        start: { r: true, t: testStart },
        connect: { r: true, t: testConnect },
        direction: { r: true, t: testDirection },
        snap: { r: false, t: testSnap },
        animate: { r: false, t: testAnimate },
        animationDuration: { r: false, t: testAnimationDuration },
        range: { r: true, t: testRange },
        orientation: { r: false, t: testOrientation },
        margin: { r: false, t: testMargin },
        limit: { r: false, t: testLimit },
        padding: { r: false, t: testPadding },
        behaviour: { r: true, t: testBehaviour },
        ariaFormat: { r: false, t: testAriaFormat },
        format: { r: false, t: testFormat },
        tooltips: { r: false, t: testTooltips },
        keyboardSupport: { r: true, t: testKeyboardSupport },
        documentElement: { r: false, t: testDocumentElement },
        cssPrefix: { r: true, t: testCssPrefix },
        cssClasses: { r: true, t: testCssClasses },
        handleAttributes: { r: false, t: testHandleAttributes },
    };
    var defaults = {
        connect: false,
        direction: "ltr",
        behaviour: "tap",
        orientation: "horizontal",
        keyboardSupport: true,
        cssPrefix: "noUi-",
        cssClasses: cssClasses,
        keyboardPageMultiplier: 5,
        keyboardMultiplier: 1,
        keyboardDefaultStep: 10,
    };
    // AriaFormat defaults to regular format, if any.
    if (options.format && !options.ariaFormat) {
        options.ariaFormat = options.format;
    }
    // Run all options through a testing mechanism to ensure correct
    // input. It should be noted that options might get modified to
    // be handled properly. E.g. wrapping integers in arrays.
    Object.keys(tests).forEach(function (name) {
        // If the option isn't set, but it is required, throw an error.
        if (!nouislider_isSet(options[name]) && defaults[name] === undefined) {
            if (tests[name].r) {
                throw new Error("noUiSlider: '" + name + "' is required.");
            }
            return;
        }
        tests[name].t(parsed, !nouislider_isSet(options[name]) ? defaults[name] : options[name]);
    });
    // Forward pips options
    parsed.pips = options.pips;
    // All recent browsers accept unprefixed transform.
    // We need -ms- for IE9 and -webkit- for older Android;
    // Assume use of -webkit- if unprefixed and -ms- are not supported.
    // https://caniuse.com/#feat=transforms2d
    var d = document.createElement("div");
    var msPrefix = d.style.msTransform !== undefined;
    var noPrefix = d.style.transform !== undefined;
    parsed.transformRule = noPrefix ? "transform" : msPrefix ? "msTransform" : "webkitTransform";
    // Pips don't move, so we can place them using left/top.
    var styles = [
        ["left", "top"],
        ["right", "bottom"],
    ];
    parsed.style = styles[parsed.dir][parsed.ort];
    return parsed;
}
//endregion
function scope(target, options, originalOptions) {
    var actions = getActions();
    var supportsTouchActionNone = getSupportsTouchActionNone();
    var supportsPassive = supportsTouchActionNone && getSupportsPassive();
    // All variables local to 'scope' are prefixed with 'scope_'
    // Slider DOM Nodes
    var scope_Target = target;
    var scope_Base;
    var scope_ConnectBase;
    var scope_Handles;
    var scope_Connects;
    var scope_Pips;
    var scope_Tooltips;
    // Slider state values
    var scope_Spectrum = options.spectrum;
    var scope_Values = [];
    var scope_Locations = [];
    var scope_HandleNumbers = [];
    var scope_ActiveHandlesCount = 0;
    var scope_Events = {};
    var scope_ConnectsInverted = false;
    // Document Nodes
    var scope_Document = target.ownerDocument;
    var scope_DocumentElement = options.documentElement || scope_Document.documentElement;
    var scope_Body = scope_Document.body;
    // For horizontal sliders in standard ltr documents,
    // make .noUi-origin overflow to the left so the document doesn't scroll.
    var scope_DirOffset = scope_Document.dir === "rtl" || options.ort === 1 ? 0 : 100;
    // Creates a node, adds it to target, returns the new node.
    function addNodeTo(addTarget, className) {
        var div = scope_Document.createElement("div");
        if (className) {
            addClass(div, className);
        }
        addTarget.appendChild(div);
        return div;
    }
    // Append a origin to the base
    function addOrigin(base, handleNumber) {
        var origin = addNodeTo(base, options.cssClasses.origin);
        var handle = addNodeTo(origin, options.cssClasses.handle);
        addNodeTo(handle, options.cssClasses.touchArea);
        handle.setAttribute("data-handle", String(handleNumber));
        if (options.keyboardSupport) {
            // https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/tabindex
            // 0 = focusable and reachable
            handle.setAttribute("tabindex", "0");
            handle.addEventListener("keydown", function (event) {
                return eventKeydown(event, handleNumber);
            });
        }
        if (options.handleAttributes !== undefined) {
            var attributes_1 = options.handleAttributes[handleNumber];
            Object.keys(attributes_1).forEach(function (attribute) {
                handle.setAttribute(attribute, attributes_1[attribute]);
            });
        }
        handle.setAttribute("role", "slider");
        handle.setAttribute("aria-orientation", options.ort ? "vertical" : "horizontal");
        if (handleNumber === 0) {
            addClass(handle, options.cssClasses.handleLower);
        }
        else if (handleNumber === options.handles - 1) {
            addClass(handle, options.cssClasses.handleUpper);
        }
        origin.handle = handle;
        return origin;
    }
    // Insert nodes for connect elements
    function addConnect(base, add) {
        if (!add) {
            return false;
        }
        return addNodeTo(base, options.cssClasses.connect);
    }
    // Add handles to the slider base.
    function addElements(connectOptions, base) {
        scope_ConnectBase = addNodeTo(base, options.cssClasses.connects);
        scope_Handles = [];
        scope_Connects = [];
        scope_Connects.push(addConnect(scope_ConnectBase, connectOptions[0]));
        // [::::O====O====O====]
        // connectOptions = [0, 1, 1, 1]
        for (var i = 0; i < options.handles; i++) {
            // Keep a list of all added handles.
            scope_Handles.push(addOrigin(base, i));
            scope_HandleNumbers[i] = i;
            scope_Connects.push(addConnect(scope_ConnectBase, connectOptions[i + 1]));
        }
    }
    // Initialize a single slider.
    function addSlider(addTarget) {
        // Apply classes and data to the target.
        addClass(addTarget, options.cssClasses.target);
        if (options.dir === 0) {
            addClass(addTarget, options.cssClasses.ltr);
        }
        else {
            addClass(addTarget, options.cssClasses.rtl);
        }
        if (options.ort === 0) {
            addClass(addTarget, options.cssClasses.horizontal);
        }
        else {
            addClass(addTarget, options.cssClasses.vertical);
        }
        var textDirection = getComputedStyle(addTarget).direction;
        if (textDirection === "rtl") {
            addClass(addTarget, options.cssClasses.textDirectionRtl);
        }
        else {
            addClass(addTarget, options.cssClasses.textDirectionLtr);
        }
        return addNodeTo(addTarget, options.cssClasses.base);
    }
    function addTooltip(handle, handleNumber) {
        if (!options.tooltips || !options.tooltips[handleNumber]) {
            return false;
        }
        return addNodeTo(handle.firstChild, options.cssClasses.tooltip);
    }
    function isSliderDisabled() {
        return scope_Target.hasAttribute("disabled");
    }
    // Disable the slider dragging if any handle is disabled
    function isHandleDisabled(handleNumber) {
        var handleOrigin = scope_Handles[handleNumber];
        return handleOrigin.hasAttribute("disabled");
    }
    function disable(handleNumber) {
        if (handleNumber !== null && handleNumber !== undefined) {
            scope_Handles[handleNumber].setAttribute("disabled", "");
            scope_Handles[handleNumber].handle.removeAttribute("tabindex");
        }
        else {
            scope_Target.setAttribute("disabled", "");
            scope_Handles.forEach(function (handle) {
                handle.handle.removeAttribute("tabindex");
            });
        }
    }
    function enable(handleNumber) {
        if (handleNumber !== null && handleNumber !== undefined) {
            scope_Handles[handleNumber].removeAttribute("disabled");
            scope_Handles[handleNumber].handle.setAttribute("tabindex", "0");
        }
        else {
            scope_Target.removeAttribute("disabled");
            scope_Handles.forEach(function (handle) {
                handle.removeAttribute("disabled");
                handle.handle.setAttribute("tabindex", "0");
            });
        }
    }
    function removeTooltips() {
        if (scope_Tooltips) {
            removeEvent("update" + INTERNAL_EVENT_NS.tooltips);
            scope_Tooltips.forEach(function (tooltip) {
                if (tooltip) {
                    removeElement(tooltip);
                }
            });
            scope_Tooltips = null;
        }
    }
    // The tooltips option is a shorthand for using the 'update' event.
    function tooltips() {
        removeTooltips();
        // Tooltips are added with options.tooltips in original order.
        scope_Tooltips = scope_Handles.map(addTooltip);
        bindEvent("update" + INTERNAL_EVENT_NS.tooltips, function (values, handleNumber, unencoded) {
            if (!scope_Tooltips || !options.tooltips) {
                return;
            }
            if (scope_Tooltips[handleNumber] === false) {
                return;
            }
            var formattedValue = values[handleNumber];
            if (options.tooltips[handleNumber] !== true) {
                formattedValue = options.tooltips[handleNumber].to(unencoded[handleNumber]);
            }
            scope_Tooltips[handleNumber].innerHTML = formattedValue;
        });
    }
    function aria() {
        removeEvent("update" + INTERNAL_EVENT_NS.aria);
        bindEvent("update" + INTERNAL_EVENT_NS.aria, function (values, handleNumber, unencoded, tap, positions) {
            // Update Aria Values for all handles, as a change in one changes min and max values for the next.
            scope_HandleNumbers.forEach(function (index) {
                var handle = scope_Handles[index];
                var min = checkHandlePosition(scope_Locations, index, 0, true, true, true);
                var max = checkHandlePosition(scope_Locations, index, 100, true, true, true);
                var now = positions[index];
                // Formatted value for display
                var text = String(options.ariaFormat.to(unencoded[index]));
                // Map to slider range values
                min = scope_Spectrum.fromStepping(min).toFixed(1);
                max = scope_Spectrum.fromStepping(max).toFixed(1);
                now = scope_Spectrum.fromStepping(now).toFixed(1);
                handle.children[0].setAttribute("aria-valuemin", min);
                handle.children[0].setAttribute("aria-valuemax", max);
                handle.children[0].setAttribute("aria-valuenow", now);
                handle.children[0].setAttribute("aria-valuetext", text);
            });
        });
    }
    function getGroup(pips) {
        // Use the range.
        if (pips.mode === PipsMode.Range || pips.mode === PipsMode.Steps) {
            return scope_Spectrum.xVal;
        }
        if (pips.mode === PipsMode.Count) {
            if (pips.values < 2) {
                throw new Error("noUiSlider: 'values' (>= 2) required for mode 'count'.");
            }
            // Divide 0 - 100 in 'count' parts.
            var interval = pips.values - 1;
            var spread = 100 / interval;
            var values = [];
            // List these parts and have them handled as 'positions'.
            while (interval--) {
                values[interval] = interval * spread;
            }
            values.push(100);
            return mapToRange(values, pips.stepped);
        }
        if (pips.mode === PipsMode.Positions) {
            // Map all percentages to on-range values.
            return mapToRange(pips.values, pips.stepped);
        }
        if (pips.mode === PipsMode.Values) {
            // If the value must be stepped, it needs to be converted to a percentage first.
            if (pips.stepped) {
                return pips.values.map(function (value) {
                    // Convert to percentage, apply step, return to value.
                    return scope_Spectrum.fromStepping(scope_Spectrum.getStep(scope_Spectrum.toStepping(value)));
                });
            }
            // Otherwise, we can simply use the values.
            return pips.values;
        }
        return []; // pips.mode = never
    }
    function mapToRange(values, stepped) {
        return values.map(function (value) {
            return scope_Spectrum.fromStepping(stepped ? scope_Spectrum.getStep(value) : value);
        });
    }
    function generateSpread(pips) {
        function safeIncrement(value, increment) {
            // Avoid floating point variance by dropping the smallest decimal places.
            return Number((value + increment).toFixed(7));
        }
        var group = getGroup(pips);
        var indexes = {};
        var firstInRange = scope_Spectrum.xVal[0];
        var lastInRange = scope_Spectrum.xVal[scope_Spectrum.xVal.length - 1];
        var ignoreFirst = false;
        var ignoreLast = false;
        var prevPct = 0;
        // Create a copy of the group, sort it and filter away all duplicates.
        group = unique(group.slice().sort(function (a, b) {
            return a - b;
        }));
        // Make sure the range starts with the first element.
        if (group[0] !== firstInRange) {
            group.unshift(firstInRange);
            ignoreFirst = true;
        }
        // Likewise for the last one.
        if (group[group.length - 1] !== lastInRange) {
            group.push(lastInRange);
            ignoreLast = true;
        }
        group.forEach(function (current, index) {
            // Get the current step and the lower + upper positions.
            var step;
            var i;
            var q;
            var low = current;
            var high = group[index + 1];
            var newPct;
            var pctDifference;
            var pctPos;
            var type;
            var steps;
            var realSteps;
            var stepSize;
            var isSteps = pips.mode === PipsMode.Steps;
            // When using 'steps' mode, use the provided steps.
            // Otherwise, we'll step on to the next subrange.
            if (isSteps) {
                step = scope_Spectrum.xNumSteps[index];
            }
            // Default to a 'full' step.
            if (!step) {
                step = high - low;
            }
            // If high is undefined we are at the last subrange. Make sure it iterates once (#1088)
            if (high === undefined) {
                high = low;
            }
            // Make sure step isn't 0, which would cause an infinite loop (#654)
            step = Math.max(step, 0.0000001);
            // Find all steps in the subrange.
            for (i = low; i <= high; i = safeIncrement(i, step)) {
                // Get the percentage value for the current step,
                // calculate the size for the subrange.
                newPct = scope_Spectrum.toStepping(i);
                pctDifference = newPct - prevPct;
                steps = pctDifference / (pips.density || 1);
                realSteps = Math.round(steps);
                // This ratio represents the amount of percentage-space a point indicates.
                // For a density 1 the points/percentage = 1. For density 2, that percentage needs to be re-divided.
                // Round the percentage offset to an even number, then divide by two
                // to spread the offset on both sides of the range.
                stepSize = pctDifference / realSteps;
                // Divide all points evenly, adding the correct number to this subrange.
                // Run up to <= so that 100% gets a point, event if ignoreLast is set.
                for (q = 1; q <= realSteps; q += 1) {
                    // The ratio between the rounded value and the actual size might be ~1% off.
                    // Correct the percentage offset by the number of points
                    // per subrange. density = 1 will result in 100 points on the
                    // full range, 2 for 50, 4 for 25, etc.
                    pctPos = prevPct + q * stepSize;
                    indexes[pctPos.toFixed(5)] = [scope_Spectrum.fromStepping(pctPos), 0];
                }
                // Determine the point type.
                type = group.indexOf(i) > -1 ? PipsType.LargeValue : isSteps ? PipsType.SmallValue : PipsType.NoValue;
                // Enforce the 'ignoreFirst' option by overwriting the type for 0.
                if (!index && ignoreFirst && i !== high) {
                    type = 0;
                }
                if (!(i === high && ignoreLast)) {
                    // Mark the 'type' of this point. 0 = plain, 1 = real value, 2 = step value.
                    indexes[newPct.toFixed(5)] = [i, type];
                }
                // Update the percentage count.
                prevPct = newPct;
            }
        });
        return indexes;
    }
    function addMarking(spread, filterFunc, formatter) {
        var _a, _b;
        var element = scope_Document.createElement("div");
        var valueSizeClasses = (_a = {},
            _a[PipsType.None] = "",
            _a[PipsType.NoValue] = options.cssClasses.valueNormal,
            _a[PipsType.LargeValue] = options.cssClasses.valueLarge,
            _a[PipsType.SmallValue] = options.cssClasses.valueSub,
            _a);
        var markerSizeClasses = (_b = {},
            _b[PipsType.None] = "",
            _b[PipsType.NoValue] = options.cssClasses.markerNormal,
            _b[PipsType.LargeValue] = options.cssClasses.markerLarge,
            _b[PipsType.SmallValue] = options.cssClasses.markerSub,
            _b);
        var valueOrientationClasses = [options.cssClasses.valueHorizontal, options.cssClasses.valueVertical];
        var markerOrientationClasses = [options.cssClasses.markerHorizontal, options.cssClasses.markerVertical];
        addClass(element, options.cssClasses.pips);
        addClass(element, options.ort === 0 ? options.cssClasses.pipsHorizontal : options.cssClasses.pipsVertical);
        function getClasses(type, source) {
            var a = source === options.cssClasses.value;
            var orientationClasses = a ? valueOrientationClasses : markerOrientationClasses;
            var sizeClasses = a ? valueSizeClasses : markerSizeClasses;
            return source + " " + orientationClasses[options.ort] + " " + sizeClasses[type];
        }
        function addSpread(offset, value, type) {
            // Apply the filter function, if it is set.
            type = filterFunc ? filterFunc(value, type) : type;
            if (type === PipsType.None) {
                return;
            }
            // Add a marker for every point
            var node = addNodeTo(element, false);
            node.className = getClasses(type, options.cssClasses.marker);
            node.style[options.style] = offset + "%";
            // Values are only appended for points marked '1' or '2'.
            if (type > PipsType.NoValue) {
                node = addNodeTo(element, false);
                node.className = getClasses(type, options.cssClasses.value);
                node.setAttribute("data-value", String(value));
                node.style[options.style] = offset + "%";
                node.innerHTML = String(formatter.to(value));
            }
        }
        // Append all points.
        Object.keys(spread).forEach(function (offset) {
            addSpread(offset, spread[offset][0], spread[offset][1]);
        });
        return element;
    }
    function removePips() {
        if (scope_Pips) {
            removeElement(scope_Pips);
            scope_Pips = null;
        }
    }
    function pips(pips) {
        // Fix #669
        removePips();
        var spread = generateSpread(pips);
        var filter = pips.filter;
        var format = pips.format || {
            to: function (value) {
                return String(Math.round(value));
            },
        };
        scope_Pips = scope_Target.appendChild(addMarking(spread, filter, format));
        return scope_Pips;
    }
    // Shorthand for base dimensions.
    function baseSize() {
        var rect = scope_Base.getBoundingClientRect();
        var alt = ("offset" + ["Width", "Height"][options.ort]);
        return options.ort === 0 ? rect.width || scope_Base[alt] : rect.height || scope_Base[alt];
    }
    // Handler for attaching events trough a proxy.
    function attachEvent(events, element, callback, data) {
        // This function can be used to 'filter' events to the slider.
        // element is a node, not a nodeList
        var method = function (event) {
            var e = fixEvent(event, data.pageOffset, data.target || element);
            // fixEvent returns false if this event has a different target
            // when handling (multi-) touch events;
            if (!e) {
                return false;
            }
            // doNotReject is passed by all end events to make sure released touches
            // are not rejected, leaving the slider "stuck" to the cursor;
            if (isSliderDisabled() && !data.doNotReject) {
                return false;
            }
            // Stop if an active 'tap' transition is taking place.
            if (hasClass(scope_Target, options.cssClasses.tap) && !data.doNotReject) {
                return false;
            }
            // Ignore right or middle clicks on start #454
            if (events === actions.start && e.buttons !== undefined && e.buttons > 1) {
                return false;
            }
            // Ignore right or middle clicks on start #454
            if (data.hover && e.buttons) {
                return false;
            }
            // 'supportsPassive' is only true if a browser also supports touch-action: none in CSS.
            // iOS safari does not, so it doesn't get to benefit from passive scrolling. iOS does support
            // touch-action: manipulation, but that allows panning, which breaks
            // sliders after zooming/on non-responsive pages.
            // See: https://bugs.webkit.org/show_bug.cgi?id=133112
            if (!supportsPassive) {
                e.preventDefault();
            }
            e.calcPoint = e.points[options.ort];
            // Call the event handler with the event [ and additional data ].
            callback(e, data);
            return;
        };
        var methods = [];
        // Bind a closure on the target for every event type.
        events.split(" ").forEach(function (eventName) {
            element.addEventListener(eventName, method, supportsPassive ? { passive: true } : false);
            methods.push([eventName, method]);
        });
        return methods;
    }
    // Provide a clean event with standardized offset values.
    function fixEvent(e, pageOffset, eventTarget) {
        // Filter the event to register the type, which can be
        // touch, mouse or pointer. Offset changes need to be
        // made on an event specific basis.
        var touch = e.type.indexOf("touch") === 0;
        var mouse = e.type.indexOf("mouse") === 0;
        var pointer = e.type.indexOf("pointer") === 0;
        var x = 0;
        var y = 0;
        // IE10 implemented pointer events with a prefix;
        if (e.type.indexOf("MSPointer") === 0) {
            pointer = true;
        }
        // Erroneous events seem to be passed in occasionally on iOS/iPadOS after user finishes interacting with
        // the slider. They appear to be of type MouseEvent, yet they don't have usual properties set. Ignore
        // events that have no touches or buttons associated with them. (#1057, #1079, #1095)
        if (e.type === "mousedown" && !e.buttons && !e.touches) {
            return false;
        }
        // The only thing one handle should be concerned about is the touches that originated on top of it.
        if (touch) {
            // Returns true if a touch originated on the target.
            var isTouchOnTarget = function (checkTouch) {
                var target = checkTouch.target;
                return (target === eventTarget ||
                    eventTarget.contains(target) ||
                    (e.composed && e.composedPath().shift() === eventTarget));
            };
            // In the case of touchstart events, we need to make sure there is still no more than one
            // touch on the target so we look amongst all touches.
            if (e.type === "touchstart") {
                var targetTouches = Array.prototype.filter.call(e.touches, isTouchOnTarget);
                // Do not support more than one touch per handle.
                if (targetTouches.length > 1) {
                    return false;
                }
                x = targetTouches[0].pageX;
                y = targetTouches[0].pageY;
            }
            else {
                // In the other cases, find on changedTouches is enough.
                var targetTouch = Array.prototype.find.call(e.changedTouches, isTouchOnTarget);
                // Cancel if the target touch has not moved.
                if (!targetTouch) {
                    return false;
                }
                x = targetTouch.pageX;
                y = targetTouch.pageY;
            }
        }
        pageOffset = pageOffset || getPageOffset(scope_Document);
        if (mouse || pointer) {
            x = e.clientX + pageOffset.x;
            y = e.clientY + pageOffset.y;
        }
        e.pageOffset = pageOffset;
        e.points = [x, y];
        e.cursor = mouse || pointer; // Fix #435
        return e;
    }
    // Translate a coordinate in the document to a percentage on the slider
    function calcPointToPercentage(calcPoint) {
        var location = calcPoint - offset(scope_Base, options.ort);
        var proposal = (location * 100) / baseSize();
        // Clamp proposal between 0% and 100%
        // Out-of-bound coordinates may occur when .noUi-base pseudo-elements
        // are used (e.g. contained handles feature)
        proposal = limit(proposal);
        return options.dir ? 100 - proposal : proposal;
    }
    // Find handle closest to a certain percentage on the slider
    function getClosestHandle(clickedPosition) {
        var smallestDifference = 100;
        var handleNumber = false;
        scope_Handles.forEach(function (handle, index) {
            // Disabled handles are ignored
            if (isHandleDisabled(index)) {
                return;
            }
            var handlePosition = scope_Locations[index];
            var differenceWithThisHandle = Math.abs(handlePosition - clickedPosition);
            // Initial state
            var clickAtEdge = differenceWithThisHandle === 100 && smallestDifference === 100;
            // Difference with this handle is smaller than the previously checked handle
            var isCloser = differenceWithThisHandle < smallestDifference;
            var isCloserAfter = differenceWithThisHandle <= smallestDifference && clickedPosition > handlePosition;
            if (isCloser || isCloserAfter || clickAtEdge) {
                handleNumber = index;
                smallestDifference = differenceWithThisHandle;
            }
        });
        return handleNumber;
    }
    // Fire 'end' when a mouse or pen leaves the document.
    function documentLeave(event, data) {
        if (event.type === "mouseout" &&
            event.target.nodeName === "HTML" &&
            event.relatedTarget === null) {
            eventEnd(event, data);
        }
    }
    // Handle movement on document for handle and range drag.
    function eventMove(event, data) {
        // Fix #498
        // Check value of .buttons in 'start' to work around a bug in IE10 mobile (data.buttonsProperty).
        // https://connect.microsoft.com/IE/feedback/details/927005/mobile-ie10-windows-phone-buttons-property-of-pointermove-event-always-zero
        // IE9 has .buttons and .which zero on mousemove.
        // Firefox breaks the spec MDN defines.
        if (navigator.appVersion.indexOf("MSIE 9") === -1 && event.buttons === 0 && data.buttonsProperty !== 0) {
            return eventEnd(event, data);
        }
        // Check if we are moving up or down
        var movement = (options.dir ? -1 : 1) * (event.calcPoint - data.startCalcPoint);
        // Convert the movement into a percentage of the slider width/height
        var proposal = (movement * 100) / data.baseSize;
        moveHandles(movement > 0, proposal, data.locations, data.handleNumbers, data.connect);
    }
    // Unbind move events on document, call callbacks.
    function eventEnd(event, data) {
        // The handle is no longer active, so remove the class.
        if (data.handle) {
            removeClass(data.handle, options.cssClasses.active);
            scope_ActiveHandlesCount -= 1;
        }
        // Unbind the move and end events, which are added on 'start'.
        data.listeners.forEach(function (c) {
            scope_DocumentElement.removeEventListener(c[0], c[1]);
        });
        if (scope_ActiveHandlesCount === 0) {
            // Remove dragging class.
            removeClass(scope_Target, options.cssClasses.drag);
            setZindex();
            // Remove cursor styles and text-selection events bound to the body.
            if (event.cursor) {
                scope_Body.style.cursor = "";
                scope_Body.removeEventListener("selectstart", preventDefault);
            }
        }
        if (options.events.smoothSteps) {
            data.handleNumbers.forEach(function (handleNumber) {
                setHandle(handleNumber, scope_Locations[handleNumber], true, true, false, false);
            });
            data.handleNumbers.forEach(function (handleNumber) {
                fireEvent("update", handleNumber);
            });
        }
        data.handleNumbers.forEach(function (handleNumber) {
            fireEvent("change", handleNumber);
            fireEvent("set", handleNumber);
            fireEvent("end", handleNumber);
        });
    }
    // Bind move events on document.
    function eventStart(event, data) {
        // Ignore event if any handle is disabled
        if (data.handleNumbers.some(isHandleDisabled)) {
            return;
        }
        var handle;
        if (data.handleNumbers.length === 1) {
            var handleOrigin = scope_Handles[data.handleNumbers[0]];
            handle = handleOrigin.children[0];
            scope_ActiveHandlesCount += 1;
            // Mark the handle as 'active' so it can be styled.
            addClass(handle, options.cssClasses.active);
        }
        // A drag should never propagate up to the 'tap' event.
        event.stopPropagation();
        // Record the event listeners.
        var listeners = [];
        // Attach the move and end events.
        var moveEvent = attachEvent(actions.move, scope_DocumentElement, eventMove, {
            // The event target has changed so we need to propagate the original one so that we keep
            // relying on it to extract target touches.
            target: event.target,
            handle: handle,
            connect: data.connect,
            listeners: listeners,
            startCalcPoint: event.calcPoint,
            baseSize: baseSize(),
            pageOffset: event.pageOffset,
            handleNumbers: data.handleNumbers,
            buttonsProperty: event.buttons,
            locations: scope_Locations.slice(),
        });
        var endEvent = attachEvent(actions.end, scope_DocumentElement, eventEnd, {
            target: event.target,
            handle: handle,
            listeners: listeners,
            doNotReject: true,
            handleNumbers: data.handleNumbers,
        });
        var outEvent = attachEvent("mouseout", scope_DocumentElement, documentLeave, {
            target: event.target,
            handle: handle,
            listeners: listeners,
            doNotReject: true,
            handleNumbers: data.handleNumbers,
        });
        // We want to make sure we pushed the listeners in the listener list rather than creating
        // a new one as it has already been passed to the event handlers.
        listeners.push.apply(listeners, moveEvent.concat(endEvent, outEvent));
        // Text selection isn't an issue on touch devices,
        // so adding cursor styles can be skipped.
        if (event.cursor) {
            // Prevent the 'I' cursor and extend the range-drag cursor.
            scope_Body.style.cursor = getComputedStyle(event.target).cursor;
            // Mark the target with a dragging state.
            if (scope_Handles.length > 1) {
                addClass(scope_Target, options.cssClasses.drag);
            }
            // Prevent text selection when dragging the handles.
            // In noUiSlider <= 9.2.0, this was handled by calling preventDefault on mouse/touch start/move,
            // which is scroll blocking. The selectstart event is supported by FireFox starting from version 52,
            // meaning the only holdout is iOS Safari. This doesn't matter: text selection isn't triggered there.
            // The 'cursor' flag is false.
            // See: http://caniuse.com/#search=selectstart
            scope_Body.addEventListener("selectstart", preventDefault, false);
        }
        data.handleNumbers.forEach(function (handleNumber) {
            fireEvent("start", handleNumber);
        });
    }
    // Move closest handle to tapped location.
    function eventTap(event) {
        // The tap event shouldn't propagate up
        event.stopPropagation();
        var proposal = calcPointToPercentage(event.calcPoint);
        var handleNumber = getClosestHandle(proposal);
        // Tackle the case that all handles are 'disabled'.
        if (handleNumber === false) {
            return;
        }
        // Flag the slider as it is now in a transitional state.
        // Transition takes a configurable amount of ms (default 300). Re-enable the slider after that.
        if (!options.events.snap) {
            addClassFor(scope_Target, options.cssClasses.tap, options.animationDuration);
        }
        setHandle(handleNumber, proposal, true, true);
        setZindex();
        fireEvent("slide", handleNumber, true);
        fireEvent("update", handleNumber, true);
        if (!options.events.snap) {
            fireEvent("change", handleNumber, true);
            fireEvent("set", handleNumber, true);
        }
        else {
            eventStart(event, { handleNumbers: [handleNumber] });
        }
    }
    // Fires a 'hover' event for a hovered mouse/pen position.
    function eventHover(event) {
        var proposal = calcPointToPercentage(event.calcPoint);
        var to = scope_Spectrum.getStep(proposal);
        var value = scope_Spectrum.fromStepping(to);
        Object.keys(scope_Events).forEach(function (targetEvent) {
            if ("hover" === targetEvent.split(".")[0]) {
                scope_Events[targetEvent].forEach(function (callback) {
                    callback.call(scope_Self, value);
                });
            }
        });
    }
    // Handles keydown on focused handles
    // Don't move the document when pressing arrow keys on focused handles
    function eventKeydown(event, handleNumber) {
        if (isSliderDisabled() || isHandleDisabled(handleNumber)) {
            return false;
        }
        var horizontalKeys = ["Left", "Right"];
        var verticalKeys = ["Down", "Up"];
        var largeStepKeys = ["PageDown", "PageUp"];
        var edgeKeys = ["Home", "End"];
        if (options.dir && !options.ort) {
            // On an right-to-left slider, the left and right keys act inverted
            horizontalKeys.reverse();
        }
        else if (options.ort && !options.dir) {
            // On a top-to-bottom slider, the up and down keys act inverted
            verticalKeys.reverse();
            largeStepKeys.reverse();
        }
        // Strip "Arrow" for IE compatibility. https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/key
        var key = event.key.replace("Arrow", "");
        var isLargeDown = key === largeStepKeys[0];
        var isLargeUp = key === largeStepKeys[1];
        var isDown = key === verticalKeys[0] || key === horizontalKeys[0] || isLargeDown;
        var isUp = key === verticalKeys[1] || key === horizontalKeys[1] || isLargeUp;
        var isMin = key === edgeKeys[0];
        var isMax = key === edgeKeys[1];
        if (!isDown && !isUp && !isMin && !isMax) {
            return true;
        }
        event.preventDefault();
        var to;
        if (isUp || isDown) {
            var direction = isDown ? 0 : 1;
            var steps = getNextStepsForHandle(handleNumber);
            var step = steps[direction];
            // At the edge of a slider, do nothing
            if (step === null) {
                return false;
            }
            // No step set, use the default of 10% of the sub-range
            if (step === false) {
                step = scope_Spectrum.getDefaultStep(scope_Locations[handleNumber], isDown, options.keyboardDefaultStep);
            }
            if (isLargeUp || isLargeDown) {
                step *= options.keyboardPageMultiplier;
            }
            else {
                step *= options.keyboardMultiplier;
            }
            // Step over zero-length ranges (#948);
            step = Math.max(step, 0.0000001);
            // Decrement for down steps
            step = (isDown ? -1 : 1) * step;
            to = scope_Values[handleNumber] + step;
        }
        else if (isMax) {
            // End key
            to = options.spectrum.xVal[options.spectrum.xVal.length - 1];
        }
        else {
            // Home key
            to = options.spectrum.xVal[0];
        }
        setHandle(handleNumber, scope_Spectrum.toStepping(to), true, true);
        fireEvent("slide", handleNumber);
        fireEvent("update", handleNumber);
        fireEvent("change", handleNumber);
        fireEvent("set", handleNumber);
        return false;
    }
    // Attach events to several slider parts.
    function bindSliderEvents(behaviour) {
        // Attach the standard drag event to the handles.
        if (!behaviour.fixed) {
            scope_Handles.forEach(function (handle, index) {
                // These events are only bound to the visual handle
                // element, not the 'real' origin element.
                attachEvent(actions.start, handle.children[0], eventStart, {
                    handleNumbers: [index],
                });
            });
        }
        // Attach the tap event to the slider base.
        if (behaviour.tap) {
            attachEvent(actions.start, scope_Base, eventTap, {});
        }
        // Fire hover events
        if (behaviour.hover) {
            attachEvent(actions.move, scope_Base, eventHover, {
                hover: true,
            });
        }
        // Make the range draggable.
        if (behaviour.drag) {
            scope_Connects.forEach(function (connect, index) {
                if (connect === false || index === 0 || index === scope_Connects.length - 1) {
                    return;
                }
                var handleBefore = scope_Handles[index - 1];
                var handleAfter = scope_Handles[index];
                var eventHolders = [connect];
                var handlesToDrag = [handleBefore, handleAfter];
                var handleNumbersToDrag = [index - 1, index];
                addClass(connect, options.cssClasses.draggable);
                // When the range is fixed, the entire range can
                // be dragged by the handles. The handle in the first
                // origin will propagate the start event upward,
                // but it needs to be bound manually on the other.
                if (behaviour.fixed) {
                    eventHolders.push(handleBefore.children[0]);
                    eventHolders.push(handleAfter.children[0]);
                }
                if (behaviour.dragAll) {
                    handlesToDrag = scope_Handles;
                    handleNumbersToDrag = scope_HandleNumbers;
                }
                eventHolders.forEach(function (eventHolder) {
                    attachEvent(actions.start, eventHolder, eventStart, {
                        handles: handlesToDrag,
                        handleNumbers: handleNumbersToDrag,
                        connect: connect,
                    });
                });
            });
        }
    }
    // Attach an event to this slider, possibly including a namespace
    function bindEvent(namespacedEvent, callback) {
        scope_Events[namespacedEvent] = scope_Events[namespacedEvent] || [];
        scope_Events[namespacedEvent].push(callback);
        // If the event bound is 'update,' fire it immediately for all handles.
        if (namespacedEvent.split(".")[0] === "update") {
            scope_Handles.forEach(function (a, index) {
                fireEvent("update", index);
            });
        }
    }
    function isInternalNamespace(namespace) {
        return namespace === INTERNAL_EVENT_NS.aria || namespace === INTERNAL_EVENT_NS.tooltips;
    }
    // Undo attachment of event
    function removeEvent(namespacedEvent) {
        var event = namespacedEvent && namespacedEvent.split(".")[0];
        var namespace = event ? namespacedEvent.substring(event.length) : namespacedEvent;
        Object.keys(scope_Events).forEach(function (bind) {
            var tEvent = bind.split(".")[0];
            var tNamespace = bind.substring(tEvent.length);
            if ((!event || event === tEvent) && (!namespace || namespace === tNamespace)) {
                // only delete protected internal event if intentional
                if (!isInternalNamespace(tNamespace) || namespace === tNamespace) {
                    delete scope_Events[bind];
                }
            }
        });
    }
    // External event handling
    function fireEvent(eventName, handleNumber, tap) {
        Object.keys(scope_Events).forEach(function (targetEvent) {
            var eventType = targetEvent.split(".")[0];
            if (eventName === eventType) {
                scope_Events[targetEvent].forEach(function (callback) {
                    callback.call(
                    // Use the slider public API as the scope ('this')
                    scope_Self, 
                    // Return values as array, so arg_1[arg_2] is always valid.
                    scope_Values.map(options.format.to), 
                    // Handle index, 0 or 1
                    handleNumber, 
                    // Un-formatted slider values
                    scope_Values.slice(), 
                    // Event is fired by tap, true or false
                    tap || false, 
                    // Left offset of the handle, in relation to the slider
                    scope_Locations.slice(), 
                    // add the slider public API to an accessible parameter when this is unavailable
                    scope_Self);
                });
            }
        });
    }
    // Split out the handle positioning logic so the Move event can use it, too
    function checkHandlePosition(reference, handleNumber, to, lookBackward, lookForward, getValue, smoothSteps) {
        var distance;
        // For sliders with multiple handles, limit movement to the other handle.
        // Apply the margin option by adding it to the handle positions.
        if (scope_Handles.length > 1 && !options.events.unconstrained) {
            if (lookBackward && handleNumber > 0) {
                distance = scope_Spectrum.getAbsoluteDistance(reference[handleNumber - 1], options.margin, false);
                to = Math.max(to, distance);
            }
            if (lookForward && handleNumber < scope_Handles.length - 1) {
                distance = scope_Spectrum.getAbsoluteDistance(reference[handleNumber + 1], options.margin, true);
                to = Math.min(to, distance);
            }
        }
        // The limit option has the opposite effect, limiting handles to a
        // maximum distance from another. Limit must be > 0, as otherwise
        // handles would be unmovable.
        if (scope_Handles.length > 1 && options.limit) {
            if (lookBackward && handleNumber > 0) {
                distance = scope_Spectrum.getAbsoluteDistance(reference[handleNumber - 1], options.limit, false);
                to = Math.min(to, distance);
            }
            if (lookForward && handleNumber < scope_Handles.length - 1) {
                distance = scope_Spectrum.getAbsoluteDistance(reference[handleNumber + 1], options.limit, true);
                to = Math.max(to, distance);
            }
        }
        // The padding option keeps the handles a certain distance from the
        // edges of the slider. Padding must be > 0.
        if (options.padding) {
            if (handleNumber === 0) {
                distance = scope_Spectrum.getAbsoluteDistance(0, options.padding[0], false);
                to = Math.max(to, distance);
            }
            if (handleNumber === scope_Handles.length - 1) {
                distance = scope_Spectrum.getAbsoluteDistance(100, options.padding[1], true);
                to = Math.min(to, distance);
            }
        }
        if (!smoothSteps) {
            to = scope_Spectrum.getStep(to);
        }
        // Limit percentage to the 0 - 100 range
        to = limit(to);
        // Return false if handle can't move
        if (to === reference[handleNumber] && !getValue) {
            return false;
        }
        return to;
    }
    // Uses slider orientation to create CSS rules. a = base value;
    function inRuleOrder(v, a) {
        var o = options.ort;
        return (o ? a : v) + ", " + (o ? v : a);
    }
    // Moves handle(s) by a percentage
    // (bool, % to move, [% where handle started, ...], [index in scope_Handles, ...])
    function moveHandles(upward, proposal, locations, handleNumbers, connect) {
        var proposals = locations.slice();
        // Store first handle now, so we still have it in case handleNumbers is reversed
        var firstHandle = handleNumbers[0];
        var smoothSteps = options.events.smoothSteps;
        var b = [!upward, upward];
        var f = [upward, !upward];
        // Copy handleNumbers so we don't change the dataset
        handleNumbers = handleNumbers.slice();
        // Check to see which handle is 'leading'.
        // If that one can't move the second can't either.
        if (upward) {
            handleNumbers.reverse();
        }
        // Step 1: get the maximum percentage that any of the handles can move
        if (handleNumbers.length > 1) {
            handleNumbers.forEach(function (handleNumber, o) {
                var to = checkHandlePosition(proposals, handleNumber, proposals[handleNumber] + proposal, b[o], f[o], false, smoothSteps);
                // Stop if one of the handles can't move.
                if (to === false) {
                    proposal = 0;
                }
                else {
                    proposal = to - proposals[handleNumber];
                    proposals[handleNumber] = to;
                }
            });
        }
        // If using one handle, check backward AND forward
        else {
            b = f = [true];
        }
        var state = false;
        // Step 2: Try to set the handles with the found percentage
        handleNumbers.forEach(function (handleNumber, o) {
            state =
                setHandle(handleNumber, locations[handleNumber] + proposal, b[o], f[o], false, smoothSteps) || state;
        });
        // Step 3: If a handle moved, fire events
        if (state) {
            handleNumbers.forEach(function (handleNumber) {
                fireEvent("update", handleNumber);
                fireEvent("slide", handleNumber);
            });
            // If target is a connect, then fire drag event
            if (connect != undefined) {
                fireEvent("drag", firstHandle);
            }
        }
    }
    // Takes a base value and an offset. This offset is used for the connect bar size.
    // In the initial design for this feature, the origin element was 1% wide.
    // Unfortunately, a rounding bug in Chrome makes it impossible to implement this feature
    // in this manner: https://bugs.chromium.org/p/chromium/issues/detail?id=798223
    function transformDirection(a, b) {
        return options.dir ? 100 - a - b : a;
    }
    // Updates scope_Locations and scope_Values, updates visual state
    function updateHandlePosition(handleNumber, to) {
        // Update locations.
        scope_Locations[handleNumber] = to;
        // Convert the value to the slider stepping/range.
        scope_Values[handleNumber] = scope_Spectrum.fromStepping(to);
        var translation = transformDirection(to, 0) - scope_DirOffset;
        var translateRule = "translate(" + inRuleOrder(translation + "%", "0") + ")";
        scope_Handles[handleNumber].style[options.transformRule] = translateRule;
        // sanity check for at least 2 handles (e.g. during setup)
        if (options.events.invertConnects && scope_Locations.length > 1) {
            // check if handles passed each other, but don't match the ConnectsInverted state
            var handlesAreInOrder = scope_Locations.every(function (position, index, locations) {
                return index === 0 || position >= locations[index - 1];
            });
            if (scope_ConnectsInverted !== !handlesAreInOrder) {
                // invert connects when handles pass each other
                invertConnects();
                // invertConnects already updates all connect elements
                return;
            }
        }
        updateConnect(handleNumber);
        updateConnect(handleNumber + 1);
        if (scope_ConnectsInverted) {
            // When connects are inverted, we also have to update adjacent connects
            updateConnect(handleNumber - 1);
            updateConnect(handleNumber + 2);
        }
    }
    // Handles before the slider middle are stacked later = higher,
    // Handles after the middle later is lower
    // [[7] [8] .......... | .......... [5] [4]
    function setZindex() {
        scope_HandleNumbers.forEach(function (handleNumber) {
            var dir = scope_Locations[handleNumber] > 50 ? -1 : 1;
            var zIndex = 3 + (scope_Handles.length + dir * handleNumber);
            scope_Handles[handleNumber].style.zIndex = String(zIndex);
        });
    }
    // Test suggested values and apply margin, step.
    // if exactInput is true, don't run checkHandlePosition, then the handle can be placed in between steps (#436)
    function setHandle(handleNumber, to, lookBackward, lookForward, exactInput, smoothSteps) {
        if (!exactInput) {
            to = checkHandlePosition(scope_Locations, handleNumber, to, lookBackward, lookForward, false, smoothSteps);
        }
        if (to === false) {
            return false;
        }
        updateHandlePosition(handleNumber, to);
        return true;
    }
    // Updates style attribute for connect nodes
    function updateConnect(index) {
        // Skip connects set to false
        if (!scope_Connects[index]) {
            return;
        }
        // Create a copy of locations, so we can sort them for the local scope logic
        var locations = scope_Locations.slice();
        if (scope_ConnectsInverted) {
            locations.sort(function (a, b) {
                return a - b;
            });
        }
        var l = 0;
        var h = 100;
        if (index !== 0) {
            l = locations[index - 1];
        }
        if (index !== scope_Connects.length - 1) {
            h = locations[index];
        }
        // We use two rules:
        // 'translate' to change the left/top offset;
        // 'scale' to change the width of the element;
        // As the element has a width of 100%, a translation of 100% is equal to 100% of the parent (.noUi-base)
        var connectWidth = h - l;
        var translateRule = "translate(" + inRuleOrder(transformDirection(l, connectWidth) + "%", "0") + ")";
        var scaleRule = "scale(" + inRuleOrder(connectWidth / 100, "1") + ")";
        scope_Connects[index].style[options.transformRule] =
            translateRule + " " + scaleRule;
    }
    // Parses value passed to .set method. Returns current value if not parse-able.
    function resolveToValue(to, handleNumber) {
        // Setting with null indicates an 'ignore'.
        // Inputting 'false' is invalid.
        if (to === null || to === false || to === undefined) {
            return scope_Locations[handleNumber];
        }
        // If a formatted number was passed, attempt to decode it.
        if (typeof to === "number") {
            to = String(to);
        }
        to = options.format.from(to);
        if (to !== false) {
            to = scope_Spectrum.toStepping(to);
        }
        // If parsing the number failed, use the current value.
        if (to === false || isNaN(to)) {
            return scope_Locations[handleNumber];
        }
        return to;
    }
    // Set the slider value.
    function valueSet(input, fireSetEvent, exactInput) {
        var values = asArray(input);
        var isInit = scope_Locations[0] === undefined;
        // Event fires by default
        fireSetEvent = fireSetEvent === undefined ? true : fireSetEvent;
        // Animation is optional.
        // Make sure the initial values were set before using animated placement.
        if (options.animate && !isInit) {
            addClassFor(scope_Target, options.cssClasses.tap, options.animationDuration);
        }
        // First pass, without lookAhead but with lookBackward. Values are set from left to right.
        scope_HandleNumbers.forEach(function (handleNumber) {
            setHandle(handleNumber, resolveToValue(values[handleNumber], handleNumber), true, false, exactInput);
        });
        var i = scope_HandleNumbers.length === 1 ? 0 : 1;
        // Spread handles evenly across the slider if the range has no size (min=max)
        if (isInit && scope_Spectrum.hasNoSize()) {
            exactInput = true;
            scope_Locations[0] = 0;
            if (scope_HandleNumbers.length > 1) {
                var space_1 = 100 / (scope_HandleNumbers.length - 1);
                scope_HandleNumbers.forEach(function (handleNumber) {
                    scope_Locations[handleNumber] = handleNumber * space_1;
                });
            }
        }
        // Secondary passes. Now that all base values are set, apply constraints.
        // Iterate all handles to ensure constraints are applied for the entire slider (Issue #1009)
        for (; i < scope_HandleNumbers.length; ++i) {
            scope_HandleNumbers.forEach(function (handleNumber) {
                setHandle(handleNumber, scope_Locations[handleNumber], true, true, exactInput);
            });
        }
        setZindex();
        scope_HandleNumbers.forEach(function (handleNumber) {
            fireEvent("update", handleNumber);
            // Fire the event only for handles that received a new value, as per #579
            if (values[handleNumber] !== null && fireSetEvent) {
                fireEvent("set", handleNumber);
            }
        });
    }
    // Reset slider to initial values
    function valueReset(fireSetEvent) {
        valueSet(options.start, fireSetEvent);
    }
    // Set value for a single handle
    function valueSetHandle(handleNumber, value, fireSetEvent, exactInput) {
        // Ensure numeric input
        handleNumber = Number(handleNumber);
        if (!(handleNumber >= 0 && handleNumber < scope_HandleNumbers.length)) {
            throw new Error("noUiSlider: invalid handle number, got: " + handleNumber);
        }
        // Look both backward and forward, since we don't want this handle to "push" other handles (#960);
        // The exactInput argument can be used to ignore slider stepping (#436)
        setHandle(handleNumber, resolveToValue(value, handleNumber), true, true, exactInput);
        fireEvent("update", handleNumber);
        if (fireSetEvent) {
            fireEvent("set", handleNumber);
        }
    }
    // Get the slider value.
    function valueGet(unencoded) {
        if (unencoded === void 0) { unencoded = false; }
        if (unencoded) {
            // return a copy of the raw values
            return scope_Values.length === 1 ? scope_Values[0] : scope_Values.slice(0);
        }
        var values = scope_Values.map(options.format.to);
        // If only one handle is used, return a single value.
        if (values.length === 1) {
            return values[0];
        }
        return values;
    }
    // Removes classes from the root and empties it.
    function destroy() {
        // remove protected internal listeners
        removeEvent(INTERNAL_EVENT_NS.aria);
        removeEvent(INTERNAL_EVENT_NS.tooltips);
        Object.keys(options.cssClasses).forEach(function (key) {
            removeClass(scope_Target, options.cssClasses[key]);
        });
        while (scope_Target.firstChild) {
            scope_Target.removeChild(scope_Target.firstChild);
        }
        delete scope_Target.noUiSlider;
    }
    function getNextStepsForHandle(handleNumber) {
        var location = scope_Locations[handleNumber];
        var nearbySteps = scope_Spectrum.getNearbySteps(location);
        var value = scope_Values[handleNumber];
        var increment = nearbySteps.thisStep.step;
        var decrement = null;
        // If snapped, directly use defined step value
        if (options.snap) {
            return [
                value - nearbySteps.stepBefore.startValue || null,
                nearbySteps.stepAfter.startValue - value || null,
            ];
        }
        // If the next value in this step moves into the next step,
        // the increment is the start of the next step - the current value
        if (increment !== false) {
            if (value + increment > nearbySteps.stepAfter.startValue) {
                increment = nearbySteps.stepAfter.startValue - value;
            }
        }
        // If the value is beyond the starting point
        if (value > nearbySteps.thisStep.startValue) {
            decrement = nearbySteps.thisStep.step;
        }
        else if (nearbySteps.stepBefore.step === false) {
            decrement = false;
        }
        // If a handle is at the start of a step, it always steps back into the previous step first
        else {
            decrement = value - nearbySteps.stepBefore.highestStep;
        }
        // Now, if at the slider edges, there is no in/decrement
        if (location === 100) {
            increment = null;
        }
        else if (location === 0) {
            decrement = null;
        }
        // As per #391, the comparison for the decrement step can have some rounding issues.
        var stepDecimals = scope_Spectrum.countStepDecimals();
        // Round per #391
        if (increment !== null && increment !== false) {
            increment = Number(increment.toFixed(stepDecimals));
        }
        if (decrement !== null && decrement !== false) {
            decrement = Number(decrement.toFixed(stepDecimals));
        }
        return [decrement, increment];
    }
    // Get the current step size for the slider.
    function getNextSteps() {
        return scope_HandleNumbers.map(getNextStepsForHandle);
    }
    // Updatable: margin, limit, padding, step, range, animate, snap
    function updateOptions(optionsToUpdate, fireSetEvent) {
        // Spectrum is created using the range, snap, direction and step options.
        // 'snap' and 'step' can be updated.
        // If 'snap' and 'step' are not passed, they should remain unchanged.
        var v = valueGet();
        var updateAble = [
            "margin",
            "limit",
            "padding",
            "range",
            "animate",
            "snap",
            "step",
            "format",
            "pips",
            "tooltips",
            "connect",
        ];
        // Only change options that we're actually passed to update.
        updateAble.forEach(function (name) {
            // Check for undefined. null removes the value.
            if (optionsToUpdate[name] !== undefined) {
                originalOptions[name] = optionsToUpdate[name];
            }
        });
        var newOptions = testOptions(originalOptions);
        // Load new options into the slider state
        updateAble.forEach(function (name) {
            if (optionsToUpdate[name] !== undefined) {
                options[name] = newOptions[name];
            }
        });
        scope_Spectrum = newOptions.spectrum;
        // Limit, margin and padding depend on the spectrum but are stored outside of it. (#677)
        options.margin = newOptions.margin;
        options.limit = newOptions.limit;
        options.padding = newOptions.padding;
        // Update pips, removes existing.
        if (options.pips) {
            pips(options.pips);
        }
        else {
            removePips();
        }
        // Update tooltips, removes existing.
        if (options.tooltips) {
            tooltips();
        }
        else {
            removeTooltips();
        }
        // Invalidate the current positioning so valueSet forces an update.
        scope_Locations = [];
        valueSet(nouislider_isSet(optionsToUpdate.start) ? optionsToUpdate.start : v, fireSetEvent);
        // Update connects only if it was set
        if (optionsToUpdate.connect) {
            updateConnectOption();
        }
    }
    function updateConnectOption() {
        // IE supported way of removing children including event handlers
        while (scope_ConnectBase.firstChild) {
            scope_ConnectBase.removeChild(scope_ConnectBase.firstChild);
        }
        // Adding new connects according to the new connect options
        for (var i = 0; i <= options.handles; i++) {
            scope_Connects[i] = addConnect(scope_ConnectBase, options.connect[i]);
            updateConnect(i);
        }
        // re-adding drag events for the new connect elements
        // to ignore the other events we have to negate the 'if (!behaviour.fixed)' check
        bindSliderEvents({ drag: options.events.drag, fixed: true });
    }
    // Invert options for connect handles
    function invertConnects() {
        scope_ConnectsInverted = !scope_ConnectsInverted;
        testConnect(options, 
        // inverse the connect boolean array
        options.connect.map(function (b) { return !b; }));
        updateConnectOption();
    }
    // Initialization steps
    function setupSlider() {
        // Create the base element, initialize HTML and set classes.
        // Add handles and connect elements.
        scope_Base = addSlider(scope_Target);
        addElements(options.connect, scope_Base);
        // Attach user events.
        bindSliderEvents(options.events);
        // Use the public value method to set the start values.
        valueSet(options.start);
        if (options.pips) {
            pips(options.pips);
        }
        if (options.tooltips) {
            tooltips();
        }
        aria();
    }
    setupSlider();
    var scope_Self = {
        destroy: destroy,
        steps: getNextSteps,
        on: bindEvent,
        off: removeEvent,
        get: valueGet,
        set: valueSet,
        setHandle: valueSetHandle,
        reset: valueReset,
        disable: disable,
        enable: enable,
        // Exposed for unit testing, don't use this in your application.
        __moveHandles: function (upward, proposal, handleNumbers) {
            moveHandles(upward, proposal, scope_Locations, handleNumbers);
        },
        options: originalOptions,
        updateOptions: updateOptions,
        target: scope_Target,
        removePips: removePips,
        removeTooltips: removeTooltips,
        getPositions: function () {
            return scope_Locations.slice();
        },
        getTooltips: function () {
            return scope_Tooltips;
        },
        getOrigins: function () {
            return scope_Handles;
        },
        pips: pips, // Issue #594
    };
    return scope_Self;
}
// Run the standard initializer
function initialize(target, originalOptions) {
    if (!target || !target.nodeName) {
        throw new Error("noUiSlider: create requires a single element, got: " + target);
    }
    // Throw an error if the slider was already initialized.
    if (target.noUiSlider) {
        throw new Error("noUiSlider: Slider was already initialized.");
    }
    // Test the options and create the slider environment;
    var options = testOptions(originalOptions);
    var api = scope(target, options, originalOptions);
    target.noUiSlider = api;
    return api;
}


/* harmony default export */ var nouislider = ({
    // Exposed for unit testing, don't use this in your application.
    __spectrum: Spectrum,
    // A reference to the default classes, allows global changes.
    // Use the cssClasses option for changes to one slider.
    cssClasses: cssClasses,
    create: initialize,
});

;// ./src/scripts/components/algoliaSearchTemplate.js
var algoliaSearchTemplate_templateObject, algoliaSearchTemplate_templateObject2, algoliaSearchTemplate_templateObject3, algoliaSearchTemplate_templateObject4, algoliaSearchTemplate_templateObject5, algoliaSearchTemplate_templateObject6, algoliaSearchTemplate_templateObject7, algoliaSearchTemplate_templateObject8, algoliaSearchTemplate_templateObject9, algoliaSearchTemplate_templateObject10, algoliaSearchTemplate_templateObject11, algoliaSearchTemplate_templateObject12, algoliaSearchTemplate_templateObject13, algoliaSearchTemplate_templateObject14, algoliaSearchTemplate_templateObject15, algoliaSearchTemplate_templateObject16, algoliaSearchTemplate_templateObject17, algoliaSearchTemplate_templateObject18, algoliaSearchTemplate_templateObject19, _templateObject20, _templateObject21, _templateObject22, _templateObject23, _templateObject24, _templateObject25, _templateObject26, _templateObject27, _templateObject28, _templateObject29, _templateObject30;
function _readOnlyError(r) { throw new TypeError('"' + r + '" is read-only'); }
function algoliaSearchTemplate_taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
function algoliaSearchTemplate_typeof(o) { "@babel/helpers - typeof"; return algoliaSearchTemplate_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, algoliaSearchTemplate_typeof(o); }
function algoliaSearchTemplate_classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function algoliaSearchTemplate_defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, algoliaSearchTemplate_toPropertyKey(o.key), o); } }
function algoliaSearchTemplate_createClass(e, r, t) { return r && algoliaSearchTemplate_defineProperties(e.prototype, r), t && algoliaSearchTemplate_defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function algoliaSearchTemplate_toPropertyKey(t) { var i = algoliaSearchTemplate_toPrimitive(t, "string"); return "symbol" == algoliaSearchTemplate_typeof(i) ? i : i + ""; }
function algoliaSearchTemplate_toPrimitive(t, r) { if ("object" != algoliaSearchTemplate_typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != algoliaSearchTemplate_typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }








var numberOfResults = sharedState.numberOfResults;
var searchQuery = sharedState.searchQuery;
var numberOfFacets = sharedState.numberOfFacets;

/**
/**
 * Represents a template for Instant Search functionality.
 * This class is responsible for rendering the search interface including facets, input section, and results.
 */
var InstantSearchTemplate = /*#__PURE__*/function () {
  /**
   * Creates an instance of InstantSearchTemplate.
   * @param {Object} data - The data object containing search configuration.
   * @param {Function} html - A template literal tag function for creating HTML.
   */
  function InstantSearchTemplate(data, html, config) {
    algoliaSearchTemplate_classCallCheck(this, InstantSearchTemplate);
    // algoliaShopify.translations.selectedFilter = 'Applied filters';
    this.data = data;
    this.html = html;
    this.config = config;
    this.facetsShown = false;
    this.validateData();

    /* use matchMedia to check if the screen is mobile */
    this.isMobile = window.matchMedia('(max-width: 1024px)').matches;
    for (var key in languageStrings) {
      if (Object.hasOwnProperty.call(languageStrings, key)) {
        algoliaShopify.translations[key] = languageStrings[key];
      }
    }
    var toggleFilterPadding = this.toggleFilterBarPadding;
    var boundRenderBrandWidget = this.renderBrandWidget.bind(this);
    var boundRenderRangeSlider = this.renderRangeSlider.bind(this);
    document.addEventListener('algolia.instantSearch.afterInit', function () {
      var _window$collection_me,
        _this = this;
      var facetButton = document.querySelector('.ais-toggle-filters') || document.querySelector('.ais-facets-button');
      var hasReferrer = document.referrer && new URL(document.referrer).pathname !== window.location.pathname;
      var isPageRefresh = performance.getEntriesByType('navigation')[0].type === 'reload';
      var isBrandRefinement = sessionStorage.getItem('shopify_alternate_brand');
      var updater = new updateRefinedValues();
      updater.updateRefinedValues();
      boundRenderRangeSlider();
      var isCollectionResultsPage = window.algoliaShopify.is_collection_results_page;
      var showBrandFilters = isCollectionResultsPage ? (_window$collection_me = window.collection_metafields) === null || _window$collection_me === void 0 ? void 0 : _window$collection_me.show_brand_filters : false;
      if (isBrandRefinement) {
        if (isCollectionResultsPage && showBrandFilters) {
          boundRenderBrandWidget();
        } else if (!isCollectionResultsPage) {
          boundRenderBrandWidget();
        }
      }
      if (!window.toggleRefinementHasInitiallyRun) {
        var toggleRefinement = document.querySelector('.ais-custom-toggle-input');
        if (toggleRefinement && !(window.location.search.includes('toggle') && window.location.search.includes('inventory_available'))) {
          setTimeout(function () {
            // Leave comment out for now please.
            // toggleRefinement.click();

            window.toggleRefinementHasInitiallyRun = true;
          }, 10);
        }
      }
      if (facetButton) {
        facetButton.addEventListener('click', function (e) {
          _this.facetsShown = !_this.facetsShown;
          if (_this.facetsShown) {
            facetButton.innerHTML = facetButton.dataset.hideText;
          } else {
            facetButton.innerHTML = facetButton.dataset.showText;
          }
        });
      }

      // Open facets on init if the URL includes refinementList and coming from another page
      if (facetButton && window.location.href.includes('refinementList') && window.matchMedia('(min-width: 1024px)').matches) {
        facetButton.click();
        toggleFilterPadding();
        if (hasReferrer && !isPageRefresh) {
          var grid = document.querySelector('#algolia-shopify-instantsearch');
          grid.scrollIntoView({
            behavior: 'smooth'
          });
        }
      }
    });
  }

  /**
   * Validates the data object passed to the constructor.
   * @throws {Error} If the data object is invalid or facets are not an array.
   */
  return algoliaSearchTemplate_createClass(InstantSearchTemplate, [{
    key: "validateData",
    value: function validateData() {
      if (!this.data || algoliaSearchTemplate_typeof(this.data) !== 'object') {
        throw new Error('Invalid data object.');
      }
      if (!Array.isArray(this.data.facets)) {
        throw new Error('Data.facets must be an array.');
      }
    }
  }, {
    key: "resultsHeader",
    value: function resultsHeader() {
      return this.html(algoliaSearchTemplate_templateObject || (algoliaSearchTemplate_templateObject = algoliaSearchTemplate_taggedTemplateLiteral(["\n      <div class=\"ais-results-header\">\n        <h2 class=\"ais-search-results-title\">", "</h2> \n        <h4 data-query-term>", "</h4>\n      </div>\n    "])), algoliaShopify.translations.searchResultsFor, searchQuery);
    }
  }, {
    key: "renderBrandWidget",
    value: function renderBrandWidget() {
      var search = window.algoliaShopify.instantsearch.search;
      if (document.querySelector('.ais-brand-refinement-container')) return;
      var labelValuesToFilterFrom = window.Shopify.brand_filters_to_show;
      var newrefinementsList = refinement_list({
        container: document.querySelector('#refinement-list'),
        attribute: 'vendor',
        cssClasses: {
          root: 'ais-brand-refinement-container',
          list: ['ais-brand-refinement-list'],
          selectedItem: 'ais-brand-refinement-item--selected',
          item: 'ais-brand-refinement-item'
        },
        transformItems: function transformItems(items) {
          var filteredItems = items.filter(function (item) {
            return labelValuesToFilterFrom.includes(item.label);
          });
          var sortedItems = filteredItems.sort(function (a, b) {
            var order = ['Gibson', 'Gibson Custom', 'Epiphone', 'Mesa', 'Mesa/Boogie', 'Kramer', 'Lifton', 'KRK', 'Maestro', 'Gibson Certified Vintage', 'Gibson Mod™ Collection', 'Tobias'];
            return order.indexOf(a.label) - order.indexOf(b.label);
          });
          return sortedItems;
        },
        templates: {
          item: function item(_item, _ref) {
            var html = _ref.html;
            var url = _item.url,
              label = _item.label,
              count = _item.count,
              isRefined = _item.isRefined;
            return html(algoliaSearchTemplate_templateObject2 || (algoliaSearchTemplate_templateObject2 = algoliaSearchTemplate_taggedTemplateLiteral(["\n            <a\n              class=\"button button--tertiary ais-brand-refinement ", "\"\n              href=\"", "\"\n              data-value=\"", "\"\n              type=\"button\"\n              js-select-vendor=\"", "\"\n            >\n              ", "\n              ", "\n            </a>\n          "])), isRefined ? 'active' : 'not-active', url, label, label, label.includes('Mesa') ? 'Mesa' : label, isRefined ? html(algoliaSearchTemplate_templateObject3 || (algoliaSearchTemplate_templateObject3 = algoliaSearchTemplate_taggedTemplateLiteral(["<span class=\"ais-brand-refinement-item-close-icon\"\n                    ><svg width=\"16\" height=\"16\" viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n                      <rect\n                        x=\"4.11096\"\n                        y=\"3.23712\"\n                        width=\"12\"\n                        height=\"1\"\n                        rx=\"0.5\"\n                        transform=\"rotate(45 4.11096 3.23712)\"\n                        fill=\"white\"\n                      />\n                      <rect\n                        x=\"3.40381\"\n                        y=\"11.7224\"\n                        width=\"12\"\n                        height=\"1\"\n                        rx=\"0.5\"\n                        transform=\"rotate(-45 3.40381 11.7224)\"\n                        fill=\"white\"\n                      />\n                    </svg>\n                  </span>"]))) : '');
          }
        }
      });
      search.addWidgets([newrefinementsList]);
    }
  }, {
    key: "renderRangeSlider",
    value: function renderRangeSlider() {
      var search = window.algoliaShopify.instantsearch.search;
      var renderRangeSlider = function renderRangeSlider(renderOptions, isFirstRender) {
        var refine = renderOptions.refine,
          range = renderOptions.range,
          start = renderOptions.start;
        var formatPrice = function formatPrice(val) {
          return "$".concat(Number(val).toLocaleString());
        };
        if (isFirstRender) {
          var container = document.querySelector('.ais-facet-price-container');
          if (!container) return;
          var priceRange = document.createElement('div');
          priceRange.className = 'ais-RangeSlider';
          priceRange.innerHTML = "\n                <div class=\"ais-RangeSlider-wrapper\">\n                    <div class=\"ais-RangeSlider-container\">\n                    <div class=\"noUiSlider-container\"></div>\n                    <div class=\"ais-RangeSlider-input\">\n                        <span class=\"ais-RangeSlider-label\">".concat(formatPrice(start[0]), "</span>\n                        <span class=\"ais-RangeSlider-label\">").concat(formatPrice(start[1]), "</span>\n                    </div>\n                    </div>\n                </div>\n            ");
          container.appendChild(priceRange);

          // Initialize noUiSlider with improved configuration
          var slider = container.querySelector('.noUiSlider-container');
          nouislider.create(slider, {
            start: [start[0], start[1]],
            connect: true,
            range: {
              min: 0,
              max: range.max || 30000
            },
            step: 10,
            behaviour: 'tap-drag',
            cssPrefix: 'noUi-',
            cssClasses: {
              target: 'target',
              base: 'base',
              origin: 'origin',
              handle: 'handle',
              handleLower: 'handle-lower',
              handleUpper: 'handle-upper',
              touchArea: 'touch-area',
              horizontal: 'horizontal',
              vertical: 'vertical',
              background: 'background',
              connect: 'connect',
              connects: 'connects',
              ltr: 'ltr',
              rtl: 'rtl',
              draggable: 'draggable',
              drag: 'state-drag',
              tap: 'state-tap',
              active: 'active',
              tooltip: 'tooltip',
              pips: 'pips',
              pipsHorizontal: 'pips-horizontal',
              pipsVertical: 'pips-vertical',
              marker: 'marker',
              markerHorizontal: 'marker-horizontal',
              markerVertical: 'marker-vertical',
              markerNormal: 'marker-normal',
              markerLarge: 'marker-large',
              markerSub: 'marker-sub',
              value: 'value',
              valueHorizontal: 'value-horizontal',
              valueVertical: 'value-vertical',
              valueNormal: 'value-normal',
              valueLarge: 'value-large',
              valueSub: 'value-sub'
            }
          });

          // Update labels when sliding
          var minLabel = container.querySelector('.ais-RangeSlider-label:first-child');
          var maxLabel = container.querySelector('.ais-RangeSlider-label:last-child');

          // Changed to use both 'update' and 'slide' events
          slider.noUiSlider.on('update', function (values) {
            minLabel.textContent = formatPrice(values[0]);
            maxLabel.textContent = formatPrice(values[1]);
          });
          slider.noUiSlider.on('slide', function (values) {
            minLabel.textContent = formatPrice(values[0]);
            maxLabel.textContent = formatPrice(values[1]);
          });

          // Update slider when sliding ends
          slider.noUiSlider.on('change', function (values) {
            return refine([parseFloat(values[0]), parseFloat(values[1])]);
          });
        }
      };

      // Try using the stats widget to get price range
      var customRangeSlider = range_connectRange(renderRangeSlider);
      search.addWidgets([customRangeSlider({
        attribute: 'price',
        min: undefined,
        max: undefined,
        precision: 2
      })]);
    }
  }, {
    key: "renderBrandHeader",
    value: function renderBrandHeader() {
      var _window$Shopify$alter, _window$collection_me2;
      var brand = ((_window$Shopify$alter = window.Shopify.alternateBrand) === null || _window$Shopify$alter === void 0 ? void 0 : _window$Shopify$alter.brand) || sessionStorage.getItem('shopify_alternate_brand');
      this.brand = brand;
      this.allBrands = ['gibson', 'epiphone', 'kramer', 'mesa', 'krk', 'maestro', 'lifton', 'mesa/boogie'];
      var isCollectionResultsPage = window.algoliaShopify.is_collection_results_page;
      var showBrandFilters = isCollectionResultsPage ? (_window$collection_me2 = window.collection_metafields) === null || _window$collection_me2 === void 0 ? void 0 : _window$collection_me2.show_brand_filters : false;
      if (brand) {
        this.brandRefinement = true;
        return this.html(algoliaSearchTemplate_templateObject4 || (algoliaSearchTemplate_templateObject4 = algoliaSearchTemplate_taggedTemplateLiteral(["\n        <div class=\"ais-brand-header\">\n        <div class=\"w-full\" id=\"refinement-list\"></div>\n        </div>\n      "])));
      }
    }

    /**
     * Renders the entire search template.
     * @returns {string} The HTML string of the rendered template.
     */
  }, {
    key: "render",
    value: function render() {
      return this.html(algoliaSearchTemplate_templateObject5 || (algoliaSearchTemplate_templateObject5 = algoliaSearchTemplate_taggedTemplateLiteral(["\n      <div class=\"ais-page\">\n     \n        ", "\n\n        ", "\n\n      \n        ", "\n        ", "\n        <div class=\"ais-grid\">\n          ", "\n          ", "\n          ", "\n        </div>\n        <div class=\"ais-pagination-container\"></div>\n      </div>\n      ", "\n    "])), window.algoliaShopify.is_collection_results_page ? '' : this.resultsHeader(), this.renderInputSection(), this.renderSearchHeader(), this.renderBrandHeader(), this.isMobile ? this.renderMobileFacetsModal() : '', !this.isMobile ? this.renderFacets() : '', this.renderBlock(), this.renderStyles());
    }

    /**
     * Renders the input section of the search interface.
     * @returns {string} The HTML string of the input section.
     */
  }, {
    key: "renderInputSection",
    value: function renderInputSection() {
      var hiddenShowClass = 'hidden';
      return this.html(algoliaSearchTemplate_templateObject6 || (algoliaSearchTemplate_templateObject6 = algoliaSearchTemplate_taggedTemplateLiteral(["\n      <div class=\"ais-input ", "\">\n\n        <div class=\"ais-search-box-container ", "\"></div>\n     \n        <div class=\"ais-input-button\">\n          <div class=\"ais-clear-input-icon\"></div>\n        </div>\n      </div>\n    "])), hiddenShowClass, hiddenShowClass);
    }
  }, {
    key: "renderFilterSVG",
    value: function renderFilterSVG() {
      return this.html(algoliaSearchTemplate_templateObject7 || (algoliaSearchTemplate_templateObject7 = algoliaSearchTemplate_taggedTemplateLiteral(["\n    <svg width=\"15\" height=\"12\" viewBox=\"0 0 15 12\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<rect y=\"2\" width=\"15\" height=\"1\" rx=\"0.5\" fill=\"white\"/>\n<circle cx=\"10.5\" cy=\"2.5\" r=\"2\" fill=\"black\" stroke=\"white\"/>\n<rect y=\"9\" width=\"15\" height=\"1\" rx=\"0.5\" fill=\"white\"/>\n<circle cx=\"4.5\" cy=\"9.5\" r=\"2\" fill=\"black\" stroke=\"white\"/>\n</svg>\n    "])));
    }

    /**
     * Renders the button to show/hide facets.
     * @returns {string} The HTML string of the facets button.
     */
  }, {
    key: "renderFacetsButton",
    value: function renderFacetsButton() {
      var searchClass = algoliaShopify.is_collection_results_page ? '' : 'ais-facets-button--search';
      return this.html(algoliaSearchTemplate_templateObject8 || (algoliaSearchTemplate_templateObject8 = algoliaSearchTemplate_taggedTemplateLiteral(["<button type=\"button\" class=\"ais-toggle-filters button button--tertiary ais-facets-button ", "\" data-show-text=\"", "\" data-hide-text=\"", "\">\n      \n        ", "\n        ", "\n        ", "\n      </button>"])), searchClass, algoliaShopify.translations.showFilters, algoliaShopify.translations.hideFilters, algoliaShopify.is_collection_results_page ? '' : this.renderFilterSVG(), algoliaShopify.translations.showFilters, numberOfFacets ? '(' + numberOfFacets + ')' : '');
    }

    /**
     * Renders the facets section of the search interface.
     * @returns {string} The HTML string of the facets section.
     */
  }, {
    key: "renderFacets",
    value: function renderFacets() {
      var _this2 = this;
      var allFacets = this.data.facets;
      return this.html(algoliaSearchTemplate_templateObject9 || (algoliaSearchTemplate_templateObject9 = algoliaSearchTemplate_taggedTemplateLiteral(["\n      <div class=\"ais-facets\">\n        <div class=\"ais-refinements-parent-container\" js-has-brand-refinement=\"", "\" toggle-status=\"closed\">\n          <div class=\"ais-clear-refinements-container\"></div>\n          <div class=\"ais-current-refined-values-container\"></div>\n                      <div id=\"price-range-slider\"></div>\n\n        </div>\n        ", "\n    \n        ", "\n      \n      </div>\n    "])), this.brandRefinement ? 'true' : 'false', this.renderDesktopSortOptions(), this.data.facets.map(function (facet, index) {
        return new algoliaFacetRenderer(facet, index, _this2.html, allFacets).render();
      }));
    }

    /**
     * Renders the sort options for the search results.
     * @returns {string} The HTML string of the sort options.
     */
  }, {
    key: "renderDesktopSortOptions",
    value: function renderDesktopSortOptions() {
      var _sortOrders,
        _sortOrders2,
        _this3 = this;
      if (!algoliaShopify.collectionSortOrders && !algoliaShopify.sortOrders) return '';
      var sortOrders;
      if (window.Shopify.show_sort_panel_on_collection && algoliaShopify.is_collection_results_page) {
        sortOrders = algoliaShopify.collectionSortOrders;
      } else if (window.Shopify.show_sort_panel_on_search && !algoliaShopify.is_collection_results_page) {
        sortOrders = algoliaShopify.sortOrders;
      }
      if (!sortOrders) return '';
      var sortLabels = (_sortOrders = sortOrders) === null || _sortOrders === void 0 ? void 0 : _sortOrders.map(function (sortOrder) {
        return sortOrder.label;
      });
      var sortOptions = (_sortOrders2 = sortOrders) === null || _sortOrders2 === void 0 ? void 0 : _sortOrders2.map(function (sortOrder) {
        return sortOrder.value;
      });
      return this.html(algoliaSearchTemplate_templateObject10 || (algoliaSearchTemplate_templateObject10 = algoliaSearchTemplate_taggedTemplateLiteral(["\n      <div class=\"ais-facet-dropdown-wrapper ais-facet-sort-by ais-sort-orders\" js-sort-orders data-first-index>\n        <label class=\"ais-facet__header ais-header ais-sort-orders__title\">", "</label>\n        <div class=\"ais-facet-sort-by-container ais-facet-dropdown-container\">\n          <div class=\"ais-facet-sort-by__hidden-select hidden\">\n            <select class=\"ais-facet-sort-by__select ais-SortBy-select\">\n              ", "\n            </select>\n          </div>\n          <ul class=\"ais-RefinementList-list ais-sort-orders__list\">\n            ", "\n          </ul>\n        </div>\n      </div>\n    "])), algoliaShopify.translations.sortBy.replace(':', ''), sortLabels.map(function (label, index) {
        return _this3.html(algoliaSearchTemplate_templateObject11 || (algoliaSearchTemplate_templateObject11 = algoliaSearchTemplate_taggedTemplateLiteral(["\n                  <option\n                    data-index=\"", "\"\n                    class=\"ais-SortBy-option\"\n                    value=\"", "\"\n                  >\n                    ", "\n                  </option>\n                "])), index, sortOptions[index], label);
      }), sortLabels.map(function (label, index) {
        return _this3.html(algoliaSearchTemplate_templateObject12 || (algoliaSearchTemplate_templateObject12 = algoliaSearchTemplate_taggedTemplateLiteral(["\n                <li class=\"ais-sort-orders__item ais-RefinementList-item ais-facet--item\">\n                  <label for=\"sort-order-", "\" class=\"ais-sort-orders__label ais-facet-item__label\">\n                    ", "\n                    ", "\n                  </label>\n                </li>\n              "])), sortOptions[index], index === 0 ? _this3.html(algoliaSearchTemplate_templateObject13 || (algoliaSearchTemplate_templateObject13 = algoliaSearchTemplate_taggedTemplateLiteral(["\n                            <input\n                              type=\"radio\"\n                              data-index=\"", "\"\n                              class=\"ais-RefinementList-checkbox ais-facet--checkbox ais-facet-item__checkbox ais-sort-orders__radio\"\n                              name=\"sort-orders\"\n                              id=\"sort-order-", "\"\n                              value=\"", "\"\n                              checked=\"checked\"\n                              js-sort-order\n                            />\n                          "])), index, sortOptions[index], sortOptions[index]) : _this3.html(algoliaSearchTemplate_templateObject14 || (algoliaSearchTemplate_templateObject14 = algoliaSearchTemplate_taggedTemplateLiteral(["\n                            <input\n                              type=\"radio\"\n                              data-index=\"", "\"\n                              class=\"ais-RefinementList-checkbox ais-facet--checkbox ais-facet-item__checkbox ais-sort-orders__radio\"\n                              name=\"sort-orders\"\n                              id=\"sort-order-", "\"\n                              value=\"", "\"\n                              js-sort-order\n                            />\n                          "])), index, sortOptions[index], sortOptions[index]), label);
      }));
    }

    /**
     * Renders the mobile sort options for the search results.
     * @returns {string} The HTML string of the mobile sort options.
     */
  }, {
    key: "renderMobileSortOptions",
    value: function renderMobileSortOptions() {
      var _this4 = this;
      var sortLabels;
      var sortOptions;
      if (!algoliaShopify.collectionSortOrders) {
        sortLabels = algoliaShopify.sortOrders.map(function (sortOrder) {
          return sortOrder.label;
        });
        sortOptions = algoliaShopify.sortOrders.map(function (sortOrder) {
          return sortOrder.value;
        });
      } else {
        sortLabels = algoliaShopify.collectionSortOrders.map(function (sortOrder) {
          return sortOrder.label;
        });
        sortOptions = algoliaShopify.collectionSortOrders.map(function (sortOrder) {
          return sortOrder.value;
        });
      }
      return this.html(algoliaSearchTemplate_templateObject15 || (algoliaSearchTemplate_templateObject15 = algoliaSearchTemplate_taggedTemplateLiteral(["\n \n        <div class=\"ais-facet-dropdown-wrapper ais-facet-sort-by ais-sort-orders\" js-sort-orders data-first-index>\n          <label class=\"ais-facet__header ais-header ais-sort-orders__title\">", "</label>\n          <div class=\"ais-facet-sort-by-container ais-facet-dropdown-container\">\n          <div class=\"ais-facet-sort-by__hidden-select hidden\">\n            <select class=\"ais-facet-sort-by__select ais-SortBy-select\">\n              ", "\n            </select>\n          </div>\n          <ul class=\"ais-RefinementList-list ais-sort-orders__list\">\n            ", "\n          </ul>\n          </div>\n        </div>\n\n    "])), algoliaShopify.translations.sortBy.replace(':', ''), sortLabels.map(function (label, index) {
        return _this4.html(algoliaSearchTemplate_templateObject16 || (algoliaSearchTemplate_templateObject16 = algoliaSearchTemplate_taggedTemplateLiteral(["\n                <option\n                  data-index=\"", "\"\n                  class=\"ais-SortBy-option\"\n                  value=\"", "\"\n                >\n                  ", "\n                </option>\n              "])), index, sortOptions[index], label);
      }), sortLabels.map(function (label, index) {
        return _this4.html(algoliaSearchTemplate_templateObject17 || (algoliaSearchTemplate_templateObject17 = algoliaSearchTemplate_taggedTemplateLiteral(["\n              <li class=\"ais-sort-orders__item ais-RefinementList-item ais-facet--item\">\n               <label for=\"sort-order-", "\" class=\"ais-sort-orders__label ais-facet-item__label\">\n                    ", "\n               \n                  ", "\n                </label>\n              </li>\n            "])), sortOptions[index], index === 0 ? _this4.html(algoliaSearchTemplate_templateObject18 || (algoliaSearchTemplate_templateObject18 = algoliaSearchTemplate_taggedTemplateLiteral(["\n                <input\n                  type=\"radio\"\n                  data-index=\"", "\" \n                  class=\"ais-RefinementList-checkbox ais-facet--checkbox ais-facet-item__checkbox ais-sort-orders__radio\"\n                  name=\"sort-orders\"\n                  id=\"sort-order-", "\"\n                  value=\"", "\"\n                  checked=\"checked\"\n                  js-sort-order\n                />\n                "])), index, sortOptions[index], sortOptions[index]) : _this4.html(algoliaSearchTemplate_templateObject19 || (algoliaSearchTemplate_templateObject19 = algoliaSearchTemplate_taggedTemplateLiteral(["\n                <input\n                  type=\"radio\"\n                  data-index=\"", "\"\n                  class=\"ais-RefinementList-checkbox ais-facet--checkbox ais-facet-item__checkbox ais-sort-orders__radio\"\n                  name=\"sort-orders\"\n                  id=\"sort-order-", "\"\n                  value=\"", "\"\n                  js-sort-order\n                />\n                "])), index, sortOptions[index], sortOptions[index]), label);
      }));
    }

    /**
     * Renders the mobile facets modal for the search interface.
     * @returns {string} The HTML string of the mobile facets modal.
     */
  }, {
    key: "renderMobileFacetsModal",
    value: function renderMobileFacetsModal() {
      var _this5 = this;
      return this.html(_templateObject20 || (_templateObject20 = algoliaSearchTemplate_taggedTemplateLiteral(["\n      <div class=\"ais-facets ais-facets--mobile closed\">\n      <div class=\"ais-facets__mobile-container\">\n      <div class=\"ais-facets__mobile-header\">\n      <h5 class=\"ais-facets__mobile-title\">", "</h5>\n                <div class=\"ais-facets-button--mobile\"\n          js-toggle-filters\n                >\n          <svg width=\"36\" height=\"36\" viewBox=\"0 0 36 36\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<rect x=\"0.5\" y=\"0.5\" width=\"35\" height=\"35\" rx=\"17.5\" fill=\"white\" stroke=\"black\"/>\n<rect x=\"11.8231\" y=\"10.4355\" width=\"19.0588\" height=\"1.58824\" rx=\"0.794118\" transform=\"rotate(45 11.8231 10.4355)\" fill=\"black\"/>\n<rect x=\"10.7001\" y=\"23.9116\" width=\"19.0588\" height=\"1.58824\" rx=\"0.794118\" transform=\"rotate(-45 10.7001 23.9116)\" fill=\"black\"/>\n</svg>\n\n        </div>\n      </div>\n        <div class=\"ais-refinements-parent-container\">\n          <div class=\"ais-clear-refinements-container\"></div>\n          <div class=\"ais-current-refined-values-container\"></div>\n        </div>\n          ", "\n        ", "\n        <div class=\"ais-facets__mobile-footer\">\n\n        <button class=\"ais-facets__mobile-clear-button button button--primary\" js-clear-all>", "\n          <span js-clear-count>(", ")</span>\n        </button>\n                <button class=\"ais-facets__mobile-apply-button button button--primary\" js-close-modal>\n          ", "\n                </button>\n        </div>\n        </div>\n      </div>\n    "])), algoliaShopify.translations.filterAndSort, this.renderMobileSortOptions(), this.data.facets.map(function (facet, index) {
        return new algoliaFacetRenderer(facet, index, _this5.html, _this5.data.facets).render();
      }), algoliaShopify.translations.clearAll, numberOfResults !== null && numberOfResults !== void 0 && numberOfResults.value ? numberOfResults === null || numberOfResults === void 0 ? void 0 : numberOfResults.value : 0, algoliaShopify.translations.apply);
    }

    /**
     * Renders the main block of the search interface, including search header and results.
     * @returns {string} The HTML string of the main block.
     */
  }, {
    key: "renderBlock",
    value: function renderBlock() {
      var desktopLayout = document.querySelector('.data-desktop-layout').getAttribute('class') || 'grid-cols--3';
      return this.html(_templateObject21 || (_templateObject21 = algoliaSearchTemplate_taggedTemplateLiteral(["\n      <div class=\"ais-block\">\n        <div class=\"ais-hits-container page-width ais-results-as-block grid ", "\" style=\"width: 100%;\"></div>\n      </div>\n    "])), desktopLayout);
    }
  }, {
    key: "searchTranslationAdd",
    value: function searchTranslationAdd() {
      var text = algoliaShopify.translations.filterPlusSort;
      var newNumberOfFacets = numberOfFacetsStore.getState().value;
      return this.html(_templateObject22 || (_templateObject22 = algoliaSearchTemplate_taggedTemplateLiteral(["\n      ", "\n    "])), text.replace('Filter', "Filter ".concat(numberOfFacets !== null && numberOfFacets !== void 0 && numberOfFacets.value ? '(' + (numberOfFacets === null || numberOfFacets === void 0 ? void 0 : numberOfFacets.value) + ')' : '')));
    }

    /**
     * Renders the search header, including stats, display options, and sort options.
     * @returns {string} The HTML string of the search header.
     */
  }, {
    key: "renderSearchHeader",
    value: function renderSearchHeader() {
      var _window$collection_me3;
      var isCollection = window.algoliaShopify.is_collection_results_page ? '' : 'hidden';
      var isCollectionResultsPage = window.algoliaShopify.is_collection_results_page;
      var showBrandFilters = isCollectionResultsPage ? (_window$collection_me3 = window.collection_metafields) === null || _window$collection_me3 === void 0 ? void 0 : _window$collection_me3.show_brand_filters : false;
      var isCollectionsPageAndShowBrandFilters = isCollectionResultsPage && showBrandFilters || window.algoliaShopify.is_collection_results_page == false;
      var localScopedBrandRefinement = window.Shopify.alternateBrand && isCollectionsPageAndShowBrandFilters;
      return this.html(_templateObject23 || (_templateObject23 = algoliaSearchTemplate_taggedTemplateLiteral(["\n      <div class=\"ais-search-header sticky page-width ", "  ", "\">\n\n        ", "\n        <div class=\"ais-stats-container\"></div>\n        ", "\n        ", "\n        ", "\n        ", "\n      </div>\n    "])), localScopedBrandRefinement ? 'ais-search-header--brand-refinement' : '', !isCollectionResultsPage ? 'ais-search-header--serp' : 'ais-search-header--plp', !this.isMobile ? this.renderFacetsButton() : '', this.renderDisplayChange(), this.renderSortOptions(), this.isMobile ? this.html(_templateObject24 || (_templateObject24 = algoliaSearchTemplate_taggedTemplateLiteral(["<div class=\"ais-facets-button ais-facets-button--mobile-toggle\">\n          <svg width=\"15\" height=\"12\" viewBox=\"0 0 15 12\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n          <rect y=\"2\" width=\"15\" height=\"1\" rx=\"0.5\" fill=\"black\"/>\n          <circle cx=\"10.5\" cy=\"2.5\" r=\"2\" fill=\"white\" stroke=\"black\"/>\n          <rect y=\"9\" width=\"15\" height=\"1\" rx=\"0.5\" fill=\"black\"/>\n          <circle cx=\"4.5\" cy=\"9.5\" r=\"2\" fill=\"white\" stroke=\"black\"/>\n          </svg>\n          <span>", "</span>\n          </div>"])), window.algoliaShopify.is_collection_results_page ? algoliaShopify.translations.filterPlusSort : this.searchTranslationAdd()) : '', this.renderCompareActions());
    }

    /**
     * Renders the compare products actions.
     * @returns {string} The HTML string of the compare products actions.
     */
  }, {
    key: "renderCompareActions",
    value: function renderCompareActions() {
      return this.html(_templateObject25 || (_templateObject25 = algoliaSearchTemplate_taggedTemplateLiteral(["\n    <div class=\"compare-products-actions algolia-compare-products-actions\">\n  <button type=\"button\" class=\"button button--secondary compare-products__button\" aria-label=\"Enable Compare Mode\"\n    data-label-compare=\"", "\" data-label-cancel=\"", "\" js-show-compare=\"\">\n    ", "\n    </button>\n</div>\n    "])), algoliaShopify.translations.compare, algoliaShopify.translations.cancel, algoliaShopify.translations.compare);
    }

    /**
     * Renders the button to toggle the visibility of the filters.
     * @returns {string} The HTML string of the toggle filters button.
     */
  }, {
    key: "toggleFilters",
    value: function toggleFilters() {
      var _this6 = this;
      return this.html(_templateObject26 || (_templateObject26 = algoliaSearchTemplate_taggedTemplateLiteral(["\n      <button type=\"button\" class=\"ais-toggle-filters button button--tertiary\" js-toggle-filters onclick=\"", "\">\n        ", "\n      </button>\n    "])), function (e) {
        _this6.toggleFiltersEvent(e);
        _this6.toggleFilterBarPadding();
      }, algoliaShopify.translations.hideFilters);
    }
  }, {
    key: "toggleFilterBarPadding",
    value: function toggleFilterBarPadding() {
      var grid = document.querySelector('.ais-grid');
      if (grid) {
        grid.classList.toggle('facets-active');
      }
    }

    /**
     * Renders the display change options (block or list view).
     * @returns {string} The HTML string of the display change options.
     */
  }, {
    key: "renderDisplayChange",
    value: function renderDisplayChange() {
      return this.html(_templateObject27 || (_templateObject27 = algoliaSearchTemplate_taggedTemplateLiteral(["\n      <div class=\"ais-change-display hidden\">\n        <span class=\"ais-change-display-block ais-change-display-selected\"><i class=\"fa fa-th-large\"></i></span>\n        <span class=\"ais-change-display-list\"><i class=\"fa fa-th-list\"></i></span>\n      </div>\n    "])));
    }

    /**
     * Renders the sort options for the search results.
     * @returns {string} The HTML string of the sort options.
     */
  }, {
    key: "renderSortOptions",
    value: function renderSortOptions() {
      algoliaShopify.translations.sortBy = algoliaShopify.extended_translations && algoliaShopify.extended_translations.sortBy ? algoliaShopify.extended_translations.sortBy : 'Sort by:';
      var sortBy = algoliaShopify.translations.sortBy;
      var relevance = algoliaShopify.translations.relevance;
      return this.data.multipleSortOrders ? this.html(_templateObject28 || (_templateObject28 = algoliaSearchTemplate_taggedTemplateLiteral(["<div class=\"sort-by sort-by__container ", "\"><span class=\"ais-sort-orders-container\"><span class=\"sort-by__label\">", "</span></span>\n</div>"])), this.isMobile ? 'hidden' : '', sortBy) : this.html(_templateObject29 || (_templateObject29 = algoliaSearchTemplate_taggedTemplateLiteral(["", " ", ""])), sortBy, relevance);
    }

    /**
     * Renders the CSS styles for the search interface.
     * @returns {string} The HTML string containing the style tag with CSS.
     */
  }, {
    key: "renderStyles",
    value: function renderStyles() {
      return this.html(_templateObject30 || (_templateObject30 = algoliaSearchTemplate_taggedTemplateLiteral(["\n      <style>\n\n        .ais-Hits-item::marker {\n          display: none !important;\n          content: none !important;\n        }\n      </style>\n    "])));
    }
  }]);
}();
/* harmony default export */ var algoliaSearchTemplate = (InstantSearchTemplate);
;// ./src/scripts/utils/eventListenerUtils.js
function eventListenerUtils_typeof(o) { "@babel/helpers - typeof"; return eventListenerUtils_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, eventListenerUtils_typeof(o); }
function eventListenerUtils_classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function eventListenerUtils_defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, eventListenerUtils_toPropertyKey(o.key), o); } }
function eventListenerUtils_createClass(e, r, t) { return r && eventListenerUtils_defineProperties(e.prototype, r), t && eventListenerUtils_defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function eventListenerUtils_toPropertyKey(t) { var i = eventListenerUtils_toPrimitive(t, "string"); return "symbol" == eventListenerUtils_typeof(i) ? i : i + ""; }
function eventListenerUtils_toPrimitive(t, r) { if ("object" != eventListenerUtils_typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != eventListenerUtils_typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var EventListenerUtils = /*#__PURE__*/function () {
  function EventListenerUtils() {
    eventListenerUtils_classCallCheck(this, EventListenerUtils);
    this.initialize();
  }
  return eventListenerUtils_createClass(EventListenerUtils, [{
    key: "initialize",
    value: function initialize() {
      // Self-invoking function to avoid polluting the global scope
      (function () {
        // WeakMap to store event listeners for elements without creating memory leaks
        var eventListenersMap = new WeakMap();

        // Store the original addEventListener and removeEventListener methods
        var originalAddEventListener = EventTarget.prototype.addEventListener;
        var originalRemoveEventListener = EventTarget.prototype.removeEventListener;

        // Override the addEventListener method
        EventTarget.prototype.addEventListener = function (type, listener, options) {
          // Initialize the event listeners array for this element if it doesn't exist
          if (!eventListenersMap.has(this)) {
            if (type === 'pageshow') return;
            eventListenersMap.set(this, []);
          }

          // Get the array of listeners for this element
          var listeners = eventListenersMap.get(this);

          // Add the event listener details to the array
          listeners.push({
            type: type,
            listener: listener,
            options: options
          });

          // Call the original addEventListener method
          originalAddEventListener.call(this, type, listener, options);
        };

        // Override the removeEventListener method
        EventTarget.prototype.removeEventListener = function (type, listener, options) {
          // Call the original removeEventListener method first
          originalRemoveEventListener.call(this, type, listener, options);

          // If the element has event listeners stored
          if (eventListenersMap.has(this)) {
            var listeners = eventListenersMap.get(this);

            // Find the index of the listener to remove
            var index = listeners.findIndex(function (l) {
              return l.type === type && l.listener === listener && JSON.stringify(l.options) === JSON.stringify(options);
            });

            // Remove the listener from the array if found
            if (index !== -1) {
              listeners.splice(index, 1);
            }

            // If no listeners are left, remove the element from the WeakMap
            if (listeners.length === 0) {
              eventListenersMap.delete(this);
            }
          }
        };

        // Function to retrieve all event listeners attached to a DOM element
        window.getEventListeners = function (element) {
          return eventListenersMap.get(element) || [];
        };

        // Function to remove all event listeners of a specific type from a DOM element
        window.removeAllEventListeners = function (element, type) {
          var listeners = eventListenersMap.get(element);
          if (listeners && listeners.length) {
            // Clone the array to avoid mutation issues
            var listenersToRemove = listeners.filter(function (listener) {
              return listener.type === type;
            });
            listenersToRemove.forEach(function (listener) {
              // Remove the listener using removeEventListener
              element.removeEventListener(listener.type, listener.listener, listener.options);
            });
          }
        };
      })();
    }
  }]);
}();
/* harmony default export */ var eventListenerUtils = (EventListenerUtils);
;// ./src/scripts/utils/mobileFilterToggle.js
function mobileFilterToggle_typeof(o) { "@babel/helpers - typeof"; return mobileFilterToggle_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, mobileFilterToggle_typeof(o); }
function mobileFilterToggle_classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function mobileFilterToggle_defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, mobileFilterToggle_toPropertyKey(o.key), o); } }
function mobileFilterToggle_createClass(e, r, t) { return r && mobileFilterToggle_defineProperties(e.prototype, r), t && mobileFilterToggle_defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function mobileFilterToggle_defineProperty(e, r, t) { return (r = mobileFilterToggle_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function mobileFilterToggle_toPropertyKey(t) { var i = mobileFilterToggle_toPrimitive(t, "string"); return "symbol" == mobileFilterToggle_typeof(i) ? i : i + ""; }
function mobileFilterToggle_toPrimitive(t, r) { if ("object" != mobileFilterToggle_typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != mobileFilterToggle_typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }


var mobileFilterToggle_numberOfFacets = numberOfFacetsStore.getState();
numberOfFacetsStore.subscribe(function () {
  mobileFilterToggle_numberOfFacets = numberOfFacetsStore.getState();
});
/**
 * @class MobileFilterToggle
 * @description Manages the mobile filter toggle functionality for a responsive design.
 * This class handles the showing and hiding of filters on mobile devices,
 * including scroll locking and event management.
 */
var MobileFilterToggle = /*#__PURE__*/function () {
  /**
   * @constructor
   * @description Initializes the MobileFilterToggle instance with default values.
   */
  function MobileFilterToggle() {
    var _this = this;
    mobileFilterToggle_classCallCheck(this, MobileFilterToggle);
    /**
     * @method clickAisFacetsButton
     * @description Triggers a click on the AIS facets button and handles any errors.
     */
    mobileFilterToggle_defineProperty(this, "clickAisFacetsButton", function () {
      try {
        _this.aisFacetsButton.click();
      } catch (error) {
        console.error('Error clicking .ais-facets-button:', error);
      }
    });
    /** @type {number} The minimum width for desktop devices in pixels */
    this.MIN_DESKTOP_WIDTH = 1024;

    /** @type {HTMLElement|null} The button to toggle facets */
    this.aisFacetsButton = null;

    /** @type {HTMLElement|null} The element to toggle filters */
    this.jsToggleFilters = null;
    this.showFiltersHTML = "<svg width=\"15\" height=\"12\" viewBox=\"0 0 15 12\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n  <rect y=\"2\" width=\"15\" height=\"1\" rx=\"0.5\" fill=\"black\" />\n  <circle cx=\"10.5\" cy=\"2.5\" r=\"2\" fill=\"white\" stroke=\"black\" />\n  <rect y=\"9\" width=\"15\" height=\"1\" rx=\"0.5\" fill=\"black\" />\n  <circle cx=\"4.5\" cy=\"9.5\" r=\"2\" fill=\"white\" stroke=\"black\" />\n</svg> Filter (".concat(numberOfFacetsStore.getState().value, ") + Sort");
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        new eventListenerUtils();
      });
    } else {
      new eventListenerUtils();
    }
  }

  /**
   * @method debounce
   * @param {Function} func - The function to debounce.
   * @param {number} wait - The time in milliseconds to wait before calling the function.
   * @param {boolean} immediate - Whether to call the function immediately.
   * @returns {Function} The debounced function.
   * @description Debounces a function to prevent excessive calls during resizing.
   */
  return mobileFilterToggle_createClass(MobileFilterToggle, [{
    key: "debounce",
    value: function debounce(func, wait, immediate) {
      var timeout;
      return function () {
        var context = this;
        var args = arguments;
        var later = function later() {
          timeout = null;
          if (!immediate) func.apply(context, args);
        };
        var callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) func.apply(context, args);
      };
    }

    /**
     * @method handleResize
     * @description Handles the window resize event and reinitializes the mobile filter toggle.
     * This method is debounced to prevent excessive calls during resizing.
     */
  }, {
    key: "handleResize",
    value: function handleResize() {
      if (this.isMobileDevice()) {
        this.cacheDOM();
        if (this.validateElements()) {
          this.bindEvents();
        }
      }
    }

    /**
     * @method init
     * @description Initializes the mobile filter toggle functionality if on a mobile device.
     */
  }, {
    key: "init",
    value: function init() {
      window.addEventListener('resize', this.debounce(this.handleResize.bind(this), 100));
      if (this.isMobileDevice()) {
        this.cacheDOM();
        if (this.validateElements()) {
          this.bindEvents();
        }
      }
    }

    /**
     * @method isMobileDevice
     * @returns {boolean} True if the current device is considered mobile, false otherwise.
     */
  }, {
    key: "isMobileDevice",
    value: function isMobileDevice() {
      return window.innerWidth < this.MIN_DESKTOP_WIDTH;
    }

    /**
     * @method cacheDOM
     * @description Caches the necessary DOM elements for later use.
     */
  }, {
    key: "cacheDOM",
    value: function cacheDOM() {
      this.aisFacetsButton = document.querySelector('.ais-facets-button');
      this.jsToggleFilters = document.querySelector('[js-toggle-filters]');
      if (window.matchMedia('(min-width: 1024px)').matches) {
        document.querySelector('.ais-facets--mobile').classList.remove('closed');
      } else {
        document.querySelector('.ais-facets--mobile').classList.add('closed');
      }
    }

    /**
     * @method validateElements
     * @returns {boolean} True if all required elements are found, false otherwise.
     * @description Validates that all required DOM elements are present.
     */
  }, {
    key: "validateElements",
    value: function validateElements() {
      if (!this.aisFacetsButton) {
        console.error('Element .ais-facets-button not found.');
        return false;
      }
      if (!this.jsToggleFilters) {
        console.error('Element [js-toggle-filters] not found.');
        return false;
      }
      return true;
    }

    /**
     * @method bindEvents
     * @description Binds the necessary event listeners.
     */
  }, {
    key: "bindEvents",
    value: function bindEvents() {
      var listeners = getEventListeners(this.aisFacetsButton);
      removeAllEventListeners(this.aisFacetsButton, 'click');

      // Use .bind(this) to ensure correct 'this' context in the handler
      this.aisFacetsButton.addEventListener('click', this.handleToggleFilters.bind(this));
      listeners = getEventListeners(this.aisFacetsButton);
    }

    /**
     * @method handleToggleFilters
     * @description Handles the toggling of filters, including body scroll and click listeners.
     * This method is bound to the AIS facets button element.
     * @param {Event} event - The click event object.
     * @listens click
     * @fires clickAisFacetsButton
     * @fires toggleBodyScroll
     * @fires toggleClickListener
     */
  }, {
    key: "handleToggleFilters",
    value: function handleToggleFilters() {
      // Determine if the filters are currently shown
      var isFiltersShown = this.isFiltersShown();

      // Toggle the closed class on the filters
      this.toggleClosedClass(isFiltersShown);

      // Recompute isFiltersShown after toggling the closed class
      isFiltersShown = this.isFiltersShown();

      // Toggle body scroll and click listener based on filter visibility
      this.toggleBodyScroll(isFiltersShown);
      this.toggleClickListener(isFiltersShown);
    }

    /**
     * @method isFiltersShown
     * @returns {boolean} True if the filters are currently shown, false otherwise.
     * @description Determines if the filters are currently shown based on visibility and mobile state.
     */
  }, {
    key: "isFiltersShown",
    value: function isFiltersShown() {
      return this.isFacetsShownVisible() || this.isFacetsMobileOpen();
    }

    /**
     * @method isFacetsShownVisible
     * @returns {boolean} True if the AIS facets are currently visible, false otherwise.
     * @description Determines if the AIS facets are currently visible on the page.
     */
  }, {
    key: "isFacetsShownVisible",
    value: function isFacetsShownVisible() {
      return document.querySelector('.ais-facets__shown') !== null;
    }

    /**
     * @method isFacetsMobileOpen
     * @returns {boolean} True if the mobile AIS facets are currently open, false otherwise.
     * @description Determines if the mobile AIS facets are currently open on the page.
     * This method checks for the 'closed' class on the mobile facets element.
     */
  }, {
    key: "isFacetsMobileOpen",
    value: function isFacetsMobileOpen() {
      var facetsMobileElement = document.querySelector('.ais-facets--mobile');
      return facetsMobileElement && !facetsMobileElement.classList.contains('closed');
    }

    /**
     * @method toggleClosedClass
     * @param {boolean} isFiltersShown - Whether the filters are currently shown.
     * @description Toggles the 'closed' class on the mobile facets element.
     * This method is used to show or hide the mobile filters.
     */
  }, {
    key: "toggleClosedClass",
    value: function toggleClosedClass() {
      if (document.querySelector('.ais-facets--mobile').classList.contains('closed')) {
        document.querySelector('.ais-facets--mobile').classList.remove('closed');
      } else {
        document.querySelector('.ais-facets--mobile').classList.add('closed');
      }
    }
    /**
     * @method toggleBodyScroll
     * @param {boolean} isFiltersShown - Whether the filters are currently shown.
     * @description Toggles the body scroll lock based on filter visibility.
     */
  }, {
    key: "toggleBodyScroll",
    value: function toggleBodyScroll(isFiltersShown) {
      document.body.classList.toggle('compare-products--no-scroll', isFiltersShown);
    }

    /**
     * @method toggleClickListener
     * @param {boolean} isFiltersShown - Whether the filters are currently shown.
     * @description Adds or removes the click event listener based on filter visibility.
     */
  }, {
    key: "toggleClickListener",
    value: function toggleClickListener(isFiltersShown) {
      /* get all this.jsToggleFilters event listeners and log each one */
      var listeners = getEventListeners(this.jsToggleFilters);

      // Remove all 'click' event listeners from the button
      removeAllEventListeners(this.jsToggleFilters, 'click');

      // Retrieve the event listeners again to verify removal
      listeners = getEventListeners(this.jsToggleFilters);
      if (isFiltersShown) {
        this.jsToggleFilters.addEventListener('click', this.clickAisFacetsButton);
        if (document.querySelector('.ais-facets--mobile').classList.contains('closed')) {
          document.querySelector('.ais-facets-button--mobile-toggle').innerHTML = "<svg width=\"15\" height=\"12\" viewBox=\"0 0 15 12\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n  <rect y=\"2\" width=\"15\" height=\"1\" rx=\"0.5\" fill=\"black\" />\n  <circle cx=\"10.5\" cy=\"2.5\" r=\"2\" fill=\"white\" stroke=\"black\" />\n  <rect y=\"9\" width=\"15\" height=\"1\" rx=\"0.5\" fill=\"black\" />\n  <circle cx=\"4.5\" cy=\"9.5\" r=\"2\" fill=\"white\" stroke=\"black\" />\n</svg> <span>Filter (".concat(numberOfFacetsStore.getState().value, ") + Sort</span>");
        }
      } else {
        this.jsToggleFilters.removeEventListener('click', this.clickAisFacetsButton);
        setTimeout(function () {
          document.querySelector('.ais-facets-button--mobile-toggle').innerHTML = "<svg width=\"15\" height=\"12\" viewBox=\"0 0 15 12\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n  <rect y=\"2\" width=\"15\" height=\"1\" rx=\"0.5\" fill=\"black\" />\n  <circle cx=\"10.5\" cy=\"2.5\" r=\"2\" fill=\"white\" stroke=\"black\" />\n  <rect y=\"9\" width=\"15\" height=\"1\" rx=\"0.5\" fill=\"black\" />\n  <circle cx=\"4.5\" cy=\"9.5\" r=\"2\" fill=\"white\" stroke=\"black\" />\n</svg> <span>Filter ".concat(numberOfFacetsStore.getState().value > 0 ? '(' + numberOfFacetsStore.getState().value + ')' : '', " + Sort</span>");
        }, 50);
      }
    }
  }]);
}();
/* harmony default export */ var utils_mobileFilterToggle = (MobileFilterToggle);
;// ./src/scripts/components/algoliaSearchInit.js
var algoliaSearchInit_templateObject;
function algoliaSearchInit_typeof(o) { "@babel/helpers - typeof"; return algoliaSearchInit_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, algoliaSearchInit_typeof(o); }
function algoliaSearchInit_taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
function algoliaSearchInit_toConsumableArray(r) { return algoliaSearchInit_arrayWithoutHoles(r) || algoliaSearchInit_iterableToArray(r) || algoliaSearchInit_unsupportedIterableToArray(r) || algoliaSearchInit_nonIterableSpread(); }
function algoliaSearchInit_nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function algoliaSearchInit_unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return algoliaSearchInit_arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? algoliaSearchInit_arrayLikeToArray(r, a) : void 0; } }
function algoliaSearchInit_iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function algoliaSearchInit_arrayWithoutHoles(r) { if (Array.isArray(r)) return algoliaSearchInit_arrayLikeToArray(r); }
function algoliaSearchInit_arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function algoliaSearchInit_classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function algoliaSearchInit_defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, algoliaSearchInit_toPropertyKey(o.key), o); } }
function algoliaSearchInit_createClass(e, r, t) { return r && algoliaSearchInit_defineProperties(e.prototype, r), t && algoliaSearchInit_defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function algoliaSearchInit_toPropertyKey(t) { var i = algoliaSearchInit_toPrimitive(t, "string"); return "symbol" == algoliaSearchInit_typeof(i) ? i : i + ""; }
function algoliaSearchInit_toPrimitive(t, r) { if ("object" != algoliaSearchInit_typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != algoliaSearchInit_typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }



var algoliaSearchInit_numberOfFacets = numberOfFacetsStore.getState();
numberOfFacetsStore.subscribe(function () {
  algoliaSearchInit_numberOfFacets = numberOfFacetsStore.getState().value;
});
var throttle = function throttle(func, wait) {
  var lastCall = 0;
  return function () {
    var now = new Date().getTime();
    if (now - lastCall < wait) return;
    lastCall = now;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    func.apply(this, args);
  };
};

/**
 * Represents an initializer for Instant Search functionality.
 * This class is responsible for setting up event listeners and hooks
 * to integrate the custom Instant Search template with Algolia.
 */
var InstantSearchInitializer = /*#__PURE__*/function () {
  /**
   * Creates an instance of InstantSearchInitializer and starts the initialization process.
   */
  function InstantSearchInitializer() {
    algoliaSearchInit_classCallCheck(this, InstantSearchInitializer);
    this.initialize();
  }

  /**
   * Initializes the Instant Search functionality by setting up an event listener
   * for Algolia's initialization hook.
   */
  return algoliaSearchInit_createClass(InstantSearchInitializer, [{
    key: "initialize",
    value: function initialize() {
      document.addEventListener('algolia.hooks.initialize', this.registerHooks.bind(this));
    }

    /**
     * Updates the header translations for the current refined values.
     * This method is used to ensure that the header text is translated correctly.
     * @returns {void}
     */
  }, {
    key: "updateHeaderTranslations",
    value: function updateHeaderTranslations() {
      var myInterval = setInterval(function () {
        if (document.querySelector('.ais-current-refined-values--header')) {
          clearInterval(myInterval);
          document.querySelector('.ais-current-refined-values--header').innerHTML = algoliaShopify.translations.selectedFilter;
        }
      }, 100);
    }
  }, {
    key: "searchToggleFilterListener",
    value: function searchToggleFilterListener() {
      var algoliaInterval = setInterval(function () {
        if (window.algoliaShopify) {
          clearInterval(algoliaInterval);
          var buttons = document.querySelectorAll('.ais-facets-button--search');
          buttons.forEach(function (button) {
            button.addEventListener('click', function (e) {
              var currentHTML = e.target.innerHTML;
              e.target.innerHTML = "\n            <svg width=\"15\" height=\"12\" viewBox=\"0 0 15 12\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n            <rect y=\"2\" width=\"15\" height=\"1\" rx=\"0.5\" fill=\"white\"/>\n            <circle cx=\"10.5\" cy=\"2.5\" r=\"2\" fill=\"black\" stroke=\"white\"/>\n            <rect y=\"9\" width=\"15\" height=\"1\" rx=\"0.5\" fill=\"white\"/>\n            <circle cx=\"4.5\" cy=\"9.5\" r=\"2\" fill=\"black\" stroke=\"white\"/>\n            </svg>\n            ".concat(currentHTML, "\n            ").concat(algoliaSearchInit_numberOfFacets > 0 ? '(' + algoliaSearchInit_numberOfFacets + ')' : '', "\n            ");
            });
          });
        }
      }, 100);
    }

    /**
     * Checks if Algolia has finished initializing by checking for the presence of the compare products buttons.
     * If the buttons are present, dispatches an event to indicate that Algolia has finished initialization.
     * This method is used to ensure that the custom Instant Search template is rendered correctly.
     * @returns {void}
     */
  }, {
    key: "algoliaEventListener",
    value: function algoliaEventListener() {
      var counter = 0;
      var myInterval = setInterval(function () {
        if (window.algoliaShopify.instantsearch) {
          clearInterval(myInterval);
          window.dispatchEvent(new Event('algolia.finishedInitialization'));
          window.dispatchEvent(new Event('algolia.finishedInitializationForMobile'));
        } else {
          counter++;
          if (counter > 100) {
            clearInterval(myInterval);
          }
        }
      }, 100);
    }
    /**
     * Registers custom hooks with Algolia Shopify.
     * This method is called when Algolia's initialization event is triggered.
     */
  }, {
    key: "registerHooks",
    value: function registerHooks() {
      algoliaShopify.hooks.registerHook('beforeInstantSearchMainTemplate', this.instantSearchMainTemplate.bind(this));
      this.updateHeaderTranslations();
      this.updateSortByEvents();
      this.updateFacetSortOrder();
      this.algoliaEventListener();
      this.searchToggleFilterListener();
      var _this = this;
      window.addEventListener('algolia.finishedInitializationForMobile', this.afterInitialization.bind(_this));
    }

    /**
     * Executes after the Algolia InstantSearch initialization is complete.
     * Initializes mobile filter toggle events and modal action event listeners.
     */
  }, {
    key: "afterInitialization",
    value: function afterInitialization() {
      this.mobileFilterToggleEvent();
      this.modalActionEventListeners();
      this.filterBar = document.querySelector('.ais-search-header');
      this.offsetTop = this.filterBar.offsetTop;
      var lastKnownScrollPosition = 0;
      var ticking = false;
      var _this = this;
      window.addEventListener('scroll', function (event) {
        lastKnownScrollPosition = window.scrollY;
        if (!ticking) {
          window.requestAnimationFrame(function () {
            _this.onScroll(lastKnownScrollPosition);
            ticking = false;
          });
          ticking = true;
        }
      });
    }

    /**
     * Handles scroll events for the filterbar
     * Adds sticky class and shadow when scrolled past the search bar position
     */
  }, {
    key: "onScroll",
    value: function onScroll(lastKnownScrollPosition) {
      if (!this.filterBar) return;
      this.searchBarPosition = this.filterBar.getBoundingClientRect().top;
      this.header = document.querySelector('sticky-header');
      if (this.searchBarPosition === 0) {
        this.filterBar.classList.add('shadow');
        this.header.classList.add('shopify-section-header-hidden');
        this.header.style.transition = 'transform 0.3s ease-out, opacity 0.3s ease-out';
      } else {
        this.filterBar.classList.remove('shadow');
        this.header.classList.remove('shopify-section-header-hidden');
        this.header.classList.remove('z-index-hide');
      }
    }

    /**
     * Adds event listeners for modal actions, such as clearing all filters and closing the modal.
     * Ensures that user interactions with modal controls trigger the appropriate actions.
     */
  }, {
    key: "modalActionEventListeners",
    value: function modalActionEventListeners() {
      // Add click event listeners to elements that clear all filters when clicked.
      algoliaSearchInit_toConsumableArray(document.querySelectorAll('[js-clear-all]')).forEach(function (el) {
        el.addEventListener('click', function () {
          // Programmatically click the Algolia Clear Refinements button to reset filters.
          document.querySelector('.ais-ClearRefinements-button').click();
        });
      });

      // Add click event listeners to elements that close the modal when clicked.
      algoliaSearchInit_toConsumableArray(document.querySelectorAll('[js-close-modal]')).forEach(function (el) {
        el.addEventListener('click', function () {
          // Programmatically click the filter toggle button to close the filters modal.
          document.querySelector('[js-toggle-filters]').click();
        });
      });
    }

    /**
     * Initializes the mobile filter toggle event.
     * Creates an instance of MobileFilterToggle and invokes its initialization method.
     */
  }, {
    key: "mobileFilterToggleEvent",
    value: function mobileFilterToggleEvent() {
      // Create a new instance of MobileFilterToggle.
      var mobileFilterToggle = new utils_mobileFilterToggle();
      // Initialize the mobile filter toggle functionality.
      mobileFilterToggle.init();
    }

    /**
     * Synchronizes custom sort UI elements with Algolia's sort functionality.
     * Sets up event listeners to update the sort order based on user interactions.
     */
  }, {
    key: "updateSortByEvents",
    value: function updateSortByEvents() {
      // Set an interval to periodically check for the presence of sort order elements.
      var sortByInterval = setInterval(function () {
        // Check if the sort orders container is present in the DOM.
        if (document.querySelector('[js-sort-orders]')) {
          // Clear the interval once the element is found.
          clearInterval(sortByInterval);

          // Find the correct key in renderState that starts with "shopify_products"
          var renderState = algoliaShopify.instantsearch.search.renderState;
          var shopifyProductsKey = Object.keys(renderState).find(function (key) {
            return key.startsWith('shopify_products');
          });

          // Default to empty string if no matching key or sortBy is found
          var currentRefinement = '';
          if (shopifyProductsKey && renderState[shopifyProductsKey].sortBy) {
            currentRefinement = renderState[shopifyProductsKey].sortBy.currentRefinement;
          }

          // Find the input element that matches the current refinement value.
          var inputToClick = algoliaSearchInit_toConsumableArray(document.querySelectorAll('[js-sort-order]')).filter(function (input) {
            return input.value === currentRefinement;
          });

          // If a matching input is found, simulate a click to update the selected sort order.
          if (inputToClick.length > 0) {
            inputToClick[0].click();
          }

          // Add click event listeners to all sort order radio buttons.
          algoliaSearchInit_toConsumableArray(document.querySelectorAll('[js-sort-order]')).forEach(function (radio) {
            radio.addEventListener('click', function (event) {
              // Update Algolia's sortBy selector with the selected sort value.
              var sortBy = radio.value;
              document.querySelector('.ais-SortBy-select').value = sortBy;
              // Dispatch a change event to trigger the sorting functionality.
              if (event.detail.sortByAlreadyChanged) return;
              document.querySelector('.ais-SortBy-select').dispatchEvent(new CustomEvent('change', {
                detail: {
                  sortByAlreadyChanged: true
                }
              }));
            });
          });
        }
      }, 100); // Check every 100 milliseconds.
    }

    /* List to change event on .ais-SortBy-Select and if value has changed, update facet js-sort order */
  }, {
    key: "updateFacetSortOrder",
    value: function updateFacetSortOrder() {
      var sortByInterval = setInterval(function () {
        if (document.querySelector('.ais-SortBy-select') && algoliaSearchInit_toConsumableArray(document.querySelectorAll('.ais-SortBy-select')).length > 1) {
          clearInterval(sortByInterval);
          var sortBySelect = algoliaSearchInit_toConsumableArray(document.querySelectorAll('.ais-SortBy-select'));
          sortBySelect.forEach(function (select) {
            select.addEventListener('change', function (event) {
              var _event$detail;
              var sortBy = select.value;
              if (event !== null && event !== void 0 && (_event$detail = event.detail) !== null && _event$detail !== void 0 && _event$detail.sortByAlreadyChanged) return;
              document.querySelector("#sort-order-".concat(sortBy)).click();
            });
          });
        }
      }, 100);
    }

    /**
     * Custom hook implementation for rendering the Instant Search main template.
     * This method creates and renders an InstantSearchTemplate instance.
     *
     * @param {Function} _defaultTemplate - The default template function (unused in this implementation).
     * @param {Object} data - The data object containing search configuration and results.
     * @param {Function} html - A template literal tag function for creating HTML.
     * @returns {string} The HTML string of the rendered Instant Search template.
     */
  }, {
    key: "instantSearchMainTemplate",
    value: function instantSearchMainTemplate(_defaultTemplate, data, html) {
      try {
        var templateRenderer = new algoliaSearchTemplate(data, html, this);
        var renderedTemplate = templateRenderer.render();
        return renderedTemplate;
      } catch (error) {
        console.error('Error rendering InstantSearch template:', error);
        // Return an empty template string in case of an error
        return html(algoliaSearchInit_templateObject || (algoliaSearchInit_templateObject = algoliaSearchInit_taggedTemplateLiteral([""])));
      }
    }
  }]);
}();
/* harmony default export */ var algoliaSearchInit = (InstantSearchInitializer);
;// ./src/scripts/utils/gridUpdater.js
function gridUpdater_typeof(o) { "@babel/helpers - typeof"; return gridUpdater_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, gridUpdater_typeof(o); }
function gridUpdater_regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ gridUpdater_regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == gridUpdater_typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(gridUpdater_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function gridUpdater_asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function gridUpdater_asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { gridUpdater_asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { gridUpdater_asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function gridUpdater_classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function gridUpdater_defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, gridUpdater_toPropertyKey(o.key), o); } }
function gridUpdater_createClass(e, r, t) { return r && gridUpdater_defineProperties(e.prototype, r), t && gridUpdater_defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function gridUpdater_toPropertyKey(t) { var i = gridUpdater_toPrimitive(t, "string"); return "symbol" == gridUpdater_typeof(i) ? i : i + ""; }
function gridUpdater_toPrimitive(t, r) { if ("object" != gridUpdater_typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != gridUpdater_typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * @fileoverview Defines the UpdateGrid class for managing and updating a grid of content blocks.
 * @module UpdateGrid
 */
/**
 * Class representing a grid updater.
 * @class
 */
var UpdateGrid = /*#__PURE__*/function () {
  /**
   * Create an UpdateGrid instance.
   * @constructor
   */
  function UpdateGrid() {
    gridUpdater_classCallCheck(this, UpdateGrid);
    /** @type {Element|null} The collection content blocks container element */
    this.collectionContentBlocks = null;
    /** @type {Element|null} The Algolia hits list element */
    this.aisHitsList = null;
  }

  /**
   * Update the grid.
   * @async
   * @throws {Error} If any step of the update process fails
   */
  return gridUpdater_createClass(UpdateGrid, [{
    key: "update",
    value: (function () {
      var _update = gridUpdater_asyncToGenerator(/*#__PURE__*/gridUpdater_regeneratorRuntime().mark(function _callee() {
        var elementsInitialized, fetchUrl, data, blocks;
        return gridUpdater_regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return this.initializeElements();
            case 3:
              elementsInitialized = _context.sent;
              if (elementsInitialized) {
                _context.next = 7;
                break;
              }
              console.warn('Failed to initialize elements');
              return _context.abrupt("return");
            case 7:
              fetchUrl = this.getFetchUrl();
              if (fetchUrl) {
                _context.next = 11;
                break;
              }
              console.warn('No fetch URL found');
              return _context.abrupt("return");
            case 11:
              _context.next = 13;
              return this.fetchData(fetchUrl);
            case 13:
              data = _context.sent;
              _context.next = 16;
              return this.parseBlocks(data);
            case 16:
              blocks = _context.sent;
              if (blocks) {
                _context.next = 20;
                break;
              }
              console.warn('No blocks found in the fetched document.');
              return _context.abrupt("return");
            case 20:
              _context.next = 22;
              return this.processBlocks(blocks);
            case 22:
              _context.next = 27;
              break;
            case 24:
              _context.prev = 24;
              _context.t0 = _context["catch"](0);
              console.warn('Error in UpdateGrid:', _context.t0.message);
            case 27:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[0, 24]]);
      }));
      function update() {
        return _update.apply(this, arguments);
      }
      return update;
    }()
    /**
     * Reload the grid.
     * @async
     * @throws {Error} If any step of the reload process fails
     * */
    )
  }, {
    key: "reloadGrid",
    value: (function () {
      var _reloadGrid = gridUpdater_asyncToGenerator(/*#__PURE__*/gridUpdater_regeneratorRuntime().mark(function _callee2() {
        var updatedItems;
        return gridUpdater_regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              _context2.next = 3;
              return this.updateExistingItems(0);
            case 3:
              updatedItems = _context2.sent;
              _context2.next = 9;
              break;
            case 6:
              _context2.prev = 6;
              _context2.t0 = _context2["catch"](0);
              console.error('Error in UpdateGrid Reload:', _context2.t0.message);
            case 9:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this, [[0, 6]]);
      }));
      function reloadGrid() {
        return _reloadGrid.apply(this, arguments);
      }
      return reloadGrid;
    }()
    /**
     * Initialize necessary DOM elements.
     * @async
     * @returns {Promise<boolean>} True if elements are initialized successfully, false otherwise
     * @throws {Error} If required elements are not found
     */
    )
  }, {
    key: "initializeElements",
    value: (function () {
      var _initializeElements = gridUpdater_asyncToGenerator(/*#__PURE__*/gridUpdater_regeneratorRuntime().mark(function _callee3() {
        var _this = this;
        return gridUpdater_regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              this.collectionContentBlocks = document.querySelector('.collection-content-blocks');
              if (this.collectionContentBlocks) {
                _context3.next = 3;
                break;
              }
              return _context3.abrupt("return", false);
            case 3:
              return _context3.abrupt("return", new Promise(function (resolve) {
                var timeout = setTimeout(function () {
                  clearInterval(hitListInterval);
                  resolve(false);
                }, 5000);
                var hitListInterval = setInterval(function () {
                  if (document.querySelector('.ais-Hits-list')) {
                    clearInterval(hitListInterval);
                    clearTimeout(timeout);
                    try {
                      _this.aisHitsList = document.querySelector('.ais-Hits-list');
                      if (!_this.collectionContentBlocks) {
                        console.warn('Element .collection-content-blocks not found.');
                        resolve(false);
                        return;
                      }
                      if (!_this.collectionContentBlocks.id) {
                        console.warn('The .collection-content-blocks element does not have an id.');
                        resolve(false);
                        return;
                      }
                      if (!_this.aisHitsList) {
                        console.warn('Element .ais-Hits-list not found.');
                        resolve(false);
                        return;
                      }
                      resolve(true);
                    } catch (error) {
                      console.error('Error initializing elements:', error);
                      resolve(false);
                    }
                  }
                }, 100);
              }));
            case 4:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function initializeElements() {
        return _initializeElements.apply(this, arguments);
      }
      return initializeElements;
    }()
    /**
     * Get the URL for fetching updated content.
     * @returns {string} The URL to fetch from
     */
    )
  }, {
    key: "getFetchUrl",
    value: function getFetchUrl() {
      if (!this.collectionContentBlocks) {
        return false;
      }
      var sectionId = encodeURIComponent(this.collectionContentBlocks.id);
      return "".concat(window.location.pathname, "?section_id=").concat(sectionId);
    }

    /**
     * Fetch data from the given URL.
     * @async
     * @param {string} url - The URL to fetch from
     * @returns {Promise<string>} The fetched data as text
     * @throws {Error} If the fetch fails or returns a non-OK status
     */
  }, {
    key: "fetchData",
    value: (function () {
      var _fetchData = gridUpdater_asyncToGenerator(/*#__PURE__*/gridUpdater_regeneratorRuntime().mark(function _callee4(url) {
        var response;
        return gridUpdater_regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return fetch(url);
            case 2:
              response = _context4.sent;
              if (response.ok) {
                _context4.next = 5;
                break;
              }
              throw new Error("HTTP error! status: ".concat(response.status));
            case 5:
              _context4.next = 7;
              return response.text();
            case 7:
              return _context4.abrupt("return", _context4.sent);
            case 8:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }));
      function fetchData(_x) {
        return _fetchData.apply(this, arguments);
      }
      return fetchData;
    }()
    /**
     * Parse the fetched HTML data into block elements.
     * @param {string} data - The HTML data to parse
     * @returns {Element[]} An array of parsed block elements
     * @throws {Error} If no blocks are found in the parsed document
     */
    )
  }, {
    key: "parseBlocks",
    value: (function () {
      var _parseBlocks = gridUpdater_asyncToGenerator(/*#__PURE__*/gridUpdater_regeneratorRuntime().mark(function _callee5(data) {
        var parser, parsedDocument, blocks;
        return gridUpdater_regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              parser = new DOMParser();
              parsedDocument = parser.parseFromString(data, 'text/html');
              blocks = Array.from(parsedDocument.querySelectorAll('.collection-content-blocks__block'));
              if (blocks.length) {
                _context5.next = 6;
                break;
              }
              throw new Error('No blocks found in the fetched document.');
            case 6:
              return _context5.abrupt("return", blocks);
            case 7:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }));
      function parseBlocks(_x2) {
        return _parseBlocks.apply(this, arguments);
      }
      return parseBlocks;
    }()
    /**
     * Process and insert the parsed blocks into the DOM.
     * @async
     * @param {Element[]} blocks - The blocks to process and insert
     */
    )
  }, {
    key: "processBlocks",
    value: (function () {
      var _processBlocks = gridUpdater_asyncToGenerator(/*#__PURE__*/gridUpdater_regeneratorRuntime().mark(function _callee6(blocks) {
        var _this2 = this;
        var fragment, existingPositions;
        return gridUpdater_regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              fragment = document.createDocumentFragment();
              existingPositions = new Set();
              blocks.forEach(function (el) {
                var position = el.dataset.position;
                if (!position) {
                  console.warn('Block element is missing the data-position attribute.');
                  return;
                }
                if (existingPositions.has(position)) {
                  console.warn("An item with data-position=\"".concat(position, "\" already exists."));
                  return;
                }
                existingPositions.add(position);
                _this2.prepareElementForInsertion(el, position);
                fragment.appendChild(el);
              });
              this.updateExistingItems(parseInt(blocks[0].dataset.position, 10));
              this.aisHitsList.appendChild(fragment);
            case 5:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this);
      }));
      function processBlocks(_x3) {
        return _processBlocks.apply(this, arguments);
      }
      return processBlocks;
    }()
    /**
     * Prepare an element for insertion by setting its order.
     * @param {Element} el - The element to prepare
     * @param {string} position - The position value for the element
     */
    )
  }, {
    key: "prepareElementForInsertion",
    value: function prepareElementForInsertion(el, position) {
      el.style.order = position;
    }

    /**
     * Update the order of existing items in the grid.
     * @param {number} newPosition - The position of the first new item
     */
  }, {
    key: "updateExistingItems",
    value: function updateExistingItems(newPosition) {
      if (!this.aisHitsList) {
        console.warn('No items found in the grid.');
        return false;
      }
      var items = this.aisHitsList.querySelectorAll('.ais-Hits-item');
      if (!items) {
        console.error('No items found in the grid.');
        return false;
      }
      items.forEach(function (item) {
        var itemFirstChild = item.firstElementChild;
        if (!itemFirstChild || !itemFirstChild.dataset) return;
        var algoliaPosition = parseInt(itemFirstChild.dataset.algoliaPosition, 10);
        if (!isNaN(algoliaPosition) && algoliaPosition >= newPosition) {
          item.style.order = (algoliaPosition + 1).toString();
        }
      });
    }
  }]);
}();
/* harmony default export */ var utils_gridUpdater = (UpdateGrid);
;// ./node_modules/instantsearch.js/es/lib/utils/escapeFacetValue.js
function unescapeFacetValue(value) {
  if (typeof value === 'string') {
    return value.replace(/^\\-/, '-');
  }
  return value;
}
function escapeFacetValue(value) {
  if (typeof value === 'number' && value < 0 || typeof value === 'string') {
    return String(value).replace(/^-/, '\\-');
  }
  return value;
}
;// ./node_modules/instantsearch.js/es/connectors/toggle-refinement/connectToggleRefinement.js
function connectToggleRefinement_typeof(o) { "@babel/helpers - typeof"; return connectToggleRefinement_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, connectToggleRefinement_typeof(o); }
function connectToggleRefinement_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function connectToggleRefinement_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? connectToggleRefinement_ownKeys(Object(t), !0).forEach(function (r) { connectToggleRefinement_defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : connectToggleRefinement_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function connectToggleRefinement_defineProperty(obj, key, value) { key = connectToggleRefinement_toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function connectToggleRefinement_toPropertyKey(t) { var i = connectToggleRefinement_toPrimitive(t, "string"); return "symbol" == connectToggleRefinement_typeof(i) ? i : String(i); }
function connectToggleRefinement_toPrimitive(t, r) { if ("object" != connectToggleRefinement_typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != connectToggleRefinement_typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function connectToggleRefinement_slicedToArray(arr, i) { return connectToggleRefinement_arrayWithHoles(arr) || connectToggleRefinement_iterableToArrayLimit(arr, i) || connectToggleRefinement_unsupportedIterableToArray(arr, i) || connectToggleRefinement_nonIterableRest(); }
function connectToggleRefinement_nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function connectToggleRefinement_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return connectToggleRefinement_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return connectToggleRefinement_arrayLikeToArray(o, minLen); }
function connectToggleRefinement_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function connectToggleRefinement_iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function connectToggleRefinement_arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var connectToggleRefinement_withUsage = createDocumentationMessageGenerator({
  name: 'toggle-refinement',
  connector: true
});
var connectToggleRefinement_$$type = 'ais.toggleRefinement';
var createSendEvent = function createSendEvent(_ref) {
  var instantSearchInstance = _ref.instantSearchInstance,
    helper = _ref.helper,
    attribute = _ref.attribute,
    on = _ref.on;
  var sendEventForToggle = function sendEventForToggle() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    if (args.length === 1) {
      instantSearchInstance.sendEventToInsights(args[0]);
      return;
    }
    var isRefined = args[1],
      _args$ = args[2],
      eventName = _args$ === void 0 ? 'Filter Applied' : _args$;
    var _args$0$split = args[0].split(':'),
      _args$0$split2 = connectToggleRefinement_slicedToArray(_args$0$split, 2),
      eventType = _args$0$split2[0],
      eventModifier = _args$0$split2[1];
    if (eventType !== 'click' || on === undefined) {
      return;
    }

    // only send an event when the refinement gets applied,
    // not when it gets removed
    if (!isRefined) {
      var _helper$lastResults;
      instantSearchInstance.sendEventToInsights({
        insightsMethod: 'clickedFilters',
        widgetType: connectToggleRefinement_$$type,
        eventType: eventType,
        eventModifier: eventModifier,
        payload: {
          eventName: eventName,
          index: ((_helper$lastResults = helper.lastResults) === null || _helper$lastResults === void 0 ? void 0 : _helper$lastResults.index) || helper.state.index,
          filters: on.map(function (value) {
            return "".concat(attribute, ":").concat(value);
          })
        },
        attribute: attribute
      });
    }
  };
  return sendEventForToggle;
};
/**
 * **Toggle** connector provides the logic to build a custom widget that will provide
 * an on/off filtering feature based on an attribute value or values.
 *
 * Two modes are implemented in the custom widget:
 *  - with or without the value filtered
 *  - switch between two values.
 */
var connectToggleRefinement = function connectToggleRefinement(renderFn) {
  var unmountFn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : noop_noop;
  checkRendering(renderFn, connectToggleRefinement_withUsage());
  return function (widgetParams) {
    var _ref2 = widgetParams || {},
      attribute = _ref2.attribute,
      _ref2$on = _ref2.on,
      userOn = _ref2$on === void 0 ? true : _ref2$on,
      userOff = _ref2.off;
    if (!attribute) {
      throw new Error(connectToggleRefinement_withUsage('The `attribute` option is required.'));
    }
    var hasAnOffValue = userOff !== undefined;
    // even though facet values can be numbers and boolean,
    // the helper methods only accept string in the type
    var on = toArray(userOn).map(escapeFacetValue);
    var off = hasAnOffValue ? toArray(userOff).map(escapeFacetValue) : undefined;
    var sendEvent;
    var toggleRefinementFactory = function toggleRefinementFactory(helper) {
      return function () {
        var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
            isRefined: false
          },
          isRefined = _ref3.isRefined;
        if (!isRefined) {
          sendEvent('click:internal', isRefined);
          if (hasAnOffValue) {
            off.forEach(function (v) {
              return helper.removeDisjunctiveFacetRefinement(attribute, v);
            });
          }
          on.forEach(function (v) {
            return helper.addDisjunctiveFacetRefinement(attribute, v);
          });
        } else {
          on.forEach(function (v) {
            return helper.removeDisjunctiveFacetRefinement(attribute, v);
          });
          if (hasAnOffValue) {
            off.forEach(function (v) {
              return helper.addDisjunctiveFacetRefinement(attribute, v);
            });
          }
        }
        helper.search();
      };
    };
    var connectorState = {
      createURLFactory: function createURLFactory(isRefined, _ref4) {
        var state = _ref4.state,
          createURL = _ref4.createURL,
          getWidgetUiState = _ref4.getWidgetUiState,
          helper = _ref4.helper;
        return function () {
          state = state.resetPage();
          var valuesToRemove = isRefined ? on : off;
          if (valuesToRemove) {
            valuesToRemove.forEach(function (v) {
              state = state.removeDisjunctiveFacetRefinement(attribute, v);
            });
          }
          var valuesToAdd = isRefined ? off : on;
          if (valuesToAdd) {
            valuesToAdd.forEach(function (v) {
              state = state.addDisjunctiveFacetRefinement(attribute, v);
            });
          }
          return createURL(function (uiState) {
            return getWidgetUiState(uiState, {
              searchParameters: state,
              helper: helper
            });
          });
        };
      }
    };
    return {
      $$type: connectToggleRefinement_$$type,
      init: function init(initOptions) {
        var instantSearchInstance = initOptions.instantSearchInstance;
        renderFn(connectToggleRefinement_objectSpread(connectToggleRefinement_objectSpread({}, this.getWidgetRenderState(initOptions)), {}, {
          instantSearchInstance: instantSearchInstance
        }), true);
      },
      render: function render(renderOptions) {
        var instantSearchInstance = renderOptions.instantSearchInstance;
        renderFn(connectToggleRefinement_objectSpread(connectToggleRefinement_objectSpread({}, this.getWidgetRenderState(renderOptions)), {}, {
          instantSearchInstance: instantSearchInstance
        }), false);
      },
      dispose: function dispose(_ref5) {
        var state = _ref5.state;
        unmountFn();
        return state.removeDisjunctiveFacet(attribute);
      },
      getRenderState: function getRenderState(renderState, renderOptions) {
        return connectToggleRefinement_objectSpread(connectToggleRefinement_objectSpread({}, renderState), {}, {
          toggleRefinement: connectToggleRefinement_objectSpread(connectToggleRefinement_objectSpread({}, renderState.toggleRefinement), {}, connectToggleRefinement_defineProperty({}, attribute, this.getWidgetRenderState(renderOptions)))
        });
      },
      getWidgetRenderState: function getWidgetRenderState(_ref6) {
        var state = _ref6.state,
          helper = _ref6.helper,
          results = _ref6.results,
          createURL = _ref6.createURL,
          instantSearchInstance = _ref6.instantSearchInstance;
        var isRefined = results ? on.every(function (v) {
          return state.isDisjunctiveFacetRefined(attribute, v);
        }) : on.every(function (v) {
          return state.isDisjunctiveFacetRefined(attribute, v);
        });
        var onFacetValue = {
          isRefined: isRefined,
          count: 0
        };
        var offFacetValue = {
          isRefined: hasAnOffValue && !isRefined,
          count: 0
        };
        if (results) {
          var offValue = toArray(off || false);
          var allFacetValues = results.getFacetValues(attribute, {}) || [];
          var onData = on.map(function (v) {
            return find(allFacetValues, function (_ref7) {
              var escapedValue = _ref7.escapedValue;
              return escapedValue === escapeFacetValue(String(v));
            });
          }).filter(function (v) {
            return v !== undefined;
          });
          var offData = hasAnOffValue ? offValue.map(function (v) {
            return find(allFacetValues, function (_ref8) {
              var escapedValue = _ref8.escapedValue;
              return escapedValue === escapeFacetValue(String(v));
            });
          }).filter(function (v) {
            return v !== undefined;
          }) : [];
          onFacetValue = {
            isRefined: onData.length ? onData.every(function (v) {
              return v.isRefined;
            }) : false,
            count: onData.reduce(function (acc, v) {
              return acc + v.count;
            }, 0) || null
          };
          offFacetValue = {
            isRefined: offData.length ? offData.every(function (v) {
              return v.isRefined;
            }) : false,
            count: offData.reduce(function (acc, v) {
              return acc + v.count;
            }, 0) || allFacetValues.reduce(function (total, _ref9) {
              var count = _ref9.count;
              return total + count;
            }, 0)
          };
        }
        if (!sendEvent) {
          sendEvent = createSendEvent({
            instantSearchInstance: instantSearchInstance,
            attribute: attribute,
            on: on,
            helper: helper
          });
        }
        var nextRefinement = isRefined ? offFacetValue : onFacetValue;
        return {
          value: {
            name: attribute,
            isRefined: isRefined,
            count: results ? nextRefinement.count : null,
            onFacetValue: onFacetValue,
            offFacetValue: offFacetValue
          },
          createURL: connectorState.createURLFactory(isRefined, {
            state: state,
            createURL: createURL,
            helper: helper,
            getWidgetUiState: this.getWidgetUiState
          }),
          sendEvent: sendEvent,
          canRefine: Boolean(results ? nextRefinement.count : null),
          refine: toggleRefinementFactory(helper),
          widgetParams: widgetParams
        };
      },
      getWidgetUiState: function getWidgetUiState(uiState, _ref10) {
        var searchParameters = _ref10.searchParameters;
        var isRefined = on && on.every(function (v) {
          return searchParameters.isDisjunctiveFacetRefined(attribute, v);
        });
        if (!isRefined) {
          var _uiState$toggle;
          // This needs to be done in the case `uiState` comes from `createURL`
          (_uiState$toggle = uiState.toggle) === null || _uiState$toggle === void 0 ? true : delete _uiState$toggle[attribute];
          return uiState;
        }
        return connectToggleRefinement_objectSpread(connectToggleRefinement_objectSpread({}, uiState), {}, {
          toggle: connectToggleRefinement_objectSpread(connectToggleRefinement_objectSpread({}, uiState.toggle), {}, connectToggleRefinement_defineProperty({}, attribute, isRefined))
        });
      },
      getWidgetSearchParameters: function getWidgetSearchParameters(searchParameters, _ref11) {
        var uiState = _ref11.uiState;
        if (searchParameters.isHierarchicalFacet(attribute) || searchParameters.isConjunctiveFacet(attribute)) {
           false ? 0 : void 0;
          return searchParameters;
        }
        var withFacetConfiguration = searchParameters.addDisjunctiveFacet(attribute).removeDisjunctiveFacetRefinement(attribute);
        var isRefined = Boolean(uiState.toggle && uiState.toggle[attribute]);
        if (isRefined) {
          if (on) {
            on.forEach(function (v) {
              withFacetConfiguration = withFacetConfiguration.addDisjunctiveFacetRefinement(attribute, v);
            });
          }
          return withFacetConfiguration;
        }

        // It's not refined with an `off` value
        if (hasAnOffValue) {
          if (off) {
            off.forEach(function (v) {
              withFacetConfiguration = withFacetConfiguration.addDisjunctiveFacetRefinement(attribute, v);
            });
          }
          return withFacetConfiguration;
        }

        // It's not refined without an `off` value
        return withFacetConfiguration.setQueryParameters({
          disjunctiveFacetsRefinements: connectToggleRefinement_objectSpread(connectToggleRefinement_objectSpread({}, searchParameters.disjunctiveFacetsRefinements), {}, connectToggleRefinement_defineProperty({}, attribute, []))
        });
      }
    };
  };
};
/* harmony default export */ var toggle_refinement_connectToggleRefinement = (connectToggleRefinement);
;// ./src/scripts/components/algoliaToggleRefinement.js


/**
 * Creates and returns toggle UI elements
 * @param {Object} config - Configuration for the toggle
 * @param {string} config.labelText - Text to display next to toggle
 * @param {Function} config.onChangeHandler - Function to call when toggle changes
 * @returns {Object} - The created DOM elements
 */
var createToggleElements = function createToggleElements() {
  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    labelText: 'In Stock Only',
    onChangeHandler: function onChangeHandler() {}
  };
  // Create elements
  var elements = {
    wrapper: document.createElement('div'),
    container: document.createElement('div'),
    label: document.createElement('label'),
    input: document.createElement('input'),
    toggleSwitch: document.createElement('span'),
    labelText: document.createElement('span'),
    count: document.createElement('span')
  };

  // Configure elements
  elements.wrapper.className = 'ais-custom-toggle-wrapper';
  elements.container.className = 'ais-ToggleRefinement ais-custom-toggle facet-style';
  elements.label.className = 'ais-ToggleRefinement-label ais-custom-toggle-label ais-facet-item__label';

  // Ensure the UI is checked from the start
  elements.input.type = 'checkbox';
  elements.input.className = 'ais-ToggleRefinement-checkbox ais-custom-toggle-input';
  elements.input.checked = true; // Set initial state to checked

  // Hook up the event handler
  elements.input.addEventListener('change', config.onChangeHandler);
  elements.toggleSwitch.className = 'ais-custom-toggle-switch';
  elements.labelText.className = 'ais-ToggleRefinement-labelText ais-custom-toggle-text';
  elements.labelText.textContent = config.labelText;
  elements.count.className = 'ais-ToggleRefinement-count ais-custom-toggle-count';

  // Assemble the elements
  elements.label.append(elements.input, elements.toggleSwitch, elements.labelText, elements.count);
  elements.container.appendChild(elements.label);
  elements.wrapper.append(elements.container);
  return elements;
};

/**
 * Positions the toggle in the facet list using MutationObserver
 * @param {string} toggleSelector - Selector for the toggle to position
 * @param {string} targetSelector - Selector for the container to insert into
 */
var positionToggleInFacets = function positionToggleInFacets(toggleSelector, targetSelector) {
  // Create an observer that only looks for specific selectors
  var observerConfig = {
    childList: true,
    subtree: true,
    attributes: false,
    characterData: false
  };
  var observer = new MutationObserver(function (mutations, obs) {
    var facetList = document.querySelector('.ais-facets');
    if (!facetList) return;
    var inventoryAvailableFacet = document.querySelector(targetSelector);
    if (!inventoryAvailableFacet) return;
    var ourToggle = document.querySelector("".concat(toggleSelector, " .ais-custom-toggle-wrapper"));
    if (!ourToggle) return;

    // Create a wrapper to match the structure of other facets
    var wrapper = document.createElement('div');
    wrapper.className = 'ais-facet-dropdown-wrapper ais-facet-toggle-inventory';
    wrapper.setAttribute('data-facet', 'inventory_available_toggle');
    wrapper.appendChild(ourToggle);

    // Insert in the correct position
    if (inventoryAvailableFacet.children.length >= 2) {
      inventoryAvailableFacet.insertBefore(wrapper, inventoryAvailableFacet.children[2]);
    } else {
      inventoryAvailableFacet.appendChild(wrapper);
    }

    // Stop observing once we've inserted our element
    obs.disconnect();
  });

  // Start observing with a target that's more specific than document.body
  var target = document.querySelector('.ais-facets') || document.body;
  observer.observe(target, observerConfig);
};

/**
 * Updates the toggle state based on the current refined values
 * @param {Object} value - Current value state from Algolia
 */
var updateToggleState = function updateToggleState(value, isFirstRender) {
  var toggleCheckbox = document.querySelector('.ais-custom-toggle-input');
  if (toggleCheckbox && 'checked' in toggleCheckbox) {
    toggleCheckbox.checked = value.isRefined;
    if (!value.isRefined) {
      var _window$algoliaShopif, _searchHelper$state;
      document.cookie = 'toggleInventory=false; path=/; expires=' + new Date(Date.now() + 1 * 24 * 60 * 60 * 1000).toUTCString();
      var searchHelper = (_window$algoliaShopif = window.algoliaShopify) === null || _window$algoliaShopif === void 0 || (_window$algoliaShopif = _window$algoliaShopif.instantsearch) === null || _window$algoliaShopif === void 0 || (_window$algoliaShopif = _window$algoliaShopif.search) === null || _window$algoliaShopif === void 0 ? void 0 : _window$algoliaShopif.helper;
      if (searchHelper !== null && searchHelper !== void 0 && (_searchHelper$state = searchHelper.state) !== null && _searchHelper$state !== void 0 && _searchHelper$state.filters) {
        searchHelper.state.filters = searchHelper.state.filters.replace('inventory_available:true', '');
      }
    } else {
      var _window$algoliaShopif2;
      // Set cookie with expired date in the past to remove it
      document.cookie = 'toggleInventory=; path=/; expires=' + new Date(0).toUTCString();
      var _searchHelper = (_window$algoliaShopif2 = window.algoliaShopify) === null || _window$algoliaShopif2 === void 0 || (_window$algoliaShopif2 = _window$algoliaShopif2.instantsearch) === null || _window$algoliaShopif2 === void 0 || (_window$algoliaShopif2 = _window$algoliaShopif2.search) === null || _window$algoliaShopif2 === void 0 ? void 0 : _window$algoliaShopif2.helper;
    }
  }
};

/**
 * Renders a custom toggle refinement for Algolia InstantSearch
 * @param {Object} renderOptions - Options from Algolia
 * @param {boolean} isFirstRender - Whether this is the first render
 */
var renderToggleRefinement = function renderToggleRefinement(renderOptions, isFirstRender) {
  var value = renderOptions.value,
    refine = renderOptions.refine,
    widgetParams = renderOptions.widgetParams,
    renderState = renderOptions.renderState,
    sendEvent = renderOptions.sendEvent,
    createURL = renderOptions.createURL;
  var container = document.querySelector(widgetParams.container);
  if (!container) return;
  // Force initial refinement if needed
  if (isFirstRender && widgetParams.initiallyRefined && !value.isRefined) {
    /* if toggleInventory cookie is false then return */
    if (document.cookie.includes('toggleInventory=false')) {} else {
      refine(true);
    }
  }
  // Hide the original facet if our toggle is being rendered
  var existingFacet = document.querySelector('.ais-facet-dropdown-wrapper.ais-facet-inventory_available');
  if (existingFacet && isFirstRender) {
    existingFacet.style.display = 'none';
  }
  if (isFirstRender) {
    // Create toggle elements (use refine with the correct checked logic)
    var toggleElements = createToggleElements({
      labelText: widgetParams.labelText || 'In Stock Only',
      onChangeHandler: function onChangeHandler(event) {
        return refine({
          isRefined: !event.target.checked
        });
      }
    });

    // Append to container
    container.appendChild(toggleElements.wrapper);

    // Position the toggle
    positionToggleInFacets(widgetParams.container, '[data-facet="inventory_available"]');
  }

  // Update UI state based on current refined values
  updateToggleState(value, isFirstRender);
};

/**
 * Creates a custom toggle refinement widget for Algolia InstantSearch
 * @param {Object} options - Configuration options
 * @param {string} options.container - CSS selector for the container
 * @param {string} options.attribute - The attribute to refine
 * @param {boolean} options.on - Whether the toggle should be "on" by default
 * @param {string} options.labelText - Custom label text for the toggle
 * @returns {Object} - The custom widget
 */
var customToggleRefinement = function customToggleRefinement(options) {
  // Ensure options has all required properties
  var widgetOptions = Object.assign({}, options, {
    labelText: options.labelText || 'In Stock Only',
    initiallyRefined: options.initiallyRefined || true
  });

  // Connect our custom renderer to the Toggle Refinement connector
  return toggle_refinement_connectToggleRefinement(renderToggleRefinement)(widgetOptions);
};
/* harmony default export */ var algoliaToggleRefinement = (customToggleRefinement);
;// ./src/scripts/sections/algolia.js
var algolia_templateObject, algolia_templateObject2, algolia_templateObject3, algolia_templateObject4, algolia_templateObject5, algolia_templateObject6, algolia_templateObject7, algolia_templateObject8, algolia_templateObject9, algolia_templateObject10, algolia_templateObject11, algolia_templateObject12, algolia_templateObject13, algolia_templateObject14, algolia_templateObject15;
function algolia_slicedToArray(r, e) { return algolia_arrayWithHoles(r) || algolia_iterableToArrayLimit(r, e) || algolia_unsupportedIterableToArray(r, e) || algolia_nonIterableRest(); }
function algolia_nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function algolia_iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function algolia_arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function algolia_createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = algolia_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function algolia_regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ algolia_regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == algolia_typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(algolia_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function algolia_asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function algolia_asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { algolia_asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { algolia_asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function algolia_toConsumableArray(r) { return algolia_arrayWithoutHoles(r) || algolia_iterableToArray(r) || algolia_unsupportedIterableToArray(r) || algolia_nonIterableSpread(); }
function algolia_nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function algolia_unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return algolia_arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? algolia_arrayLikeToArray(r, a) : void 0; } }
function algolia_iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function algolia_arrayWithoutHoles(r) { if (Array.isArray(r)) return algolia_arrayLikeToArray(r); }
function algolia_arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function algolia_typeof(o) { "@babel/helpers - typeof"; return algolia_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, algolia_typeof(o); }
function algolia_taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
function algolia_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function algolia_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? algolia_ownKeys(Object(t), !0).forEach(function (r) { algolia_defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : algolia_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function algolia_defineProperty(e, r, t) { return (r = algolia_toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function algolia_classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function algolia_defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, algolia_toPropertyKey(o.key), o); } }
function algolia_createClass(e, r, t) { return r && algolia_defineProperties(e.prototype, r), t && algolia_defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function algolia_toPropertyKey(t) { var i = algolia_toPrimitive(t, "string"); return "symbol" == algolia_typeof(i) ? i : i + ""; }
function algolia_toPrimitive(t, r) { if ("object" != algolia_typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != algolia_typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }








var initSearch = new algoliaSearchInit();
var algolia_numberOfResults = store.getState();
var algolia_searchQuery = searchQueryStore.getState();
var algolia_numberOfFacets = numberOfFacetsStore.getState();
var statsRendered = statsRenderedStore.getState();

// Can still subscribe to the store
store.subscribe(function () {
  algolia_numberOfResults = store.getState();
});
numberOfFacetsStore.subscribe(function () {
  algolia_numberOfFacets = numberOfFacetsStore.getState();
});
statsRenderedStore.subscribe(function () {
  statsRendered = statsRenderedStore.getState();
});
var algolia_debounce = function debounce(func, wait, immediate) {
  var timeout;
  return function () {
    var context = this,
      args = arguments;
    var later = function later() {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };
    var callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(context, args);
    return undefined;
  };
};

/**
 * Class representing the handler for Algolia Search interactions.
 */
var AlgoliaSearchHandler = /*#__PURE__*/function () {
  /**
   * Initializes a new instance of the AlgoliaSearchHandler class.
   */
  function AlgoliaSearchHandler() {
    algolia_classCallCheck(this, AlgoliaSearchHandler);
    /** @type {Object} Stores the count of facet values for each attribute. */
    this.facetValueCounts = {};
    /** @type {string} Keeps track of the current attribute being processed. */
    this.currentAttribute = '';

    // Ensure the global algoliaShopify object exists and assign facetValueCounts to it
    window.algoliaShopify = window.algoliaShopify || {};
    window.algoliaShopify.facetValueCounts = this.facetValueCounts;

    // Bind methods to the instance to preserve 'this' context
    this.handleOnRender = this.handleOnRender.bind(this);
    this.gridLoaded = false;
    this.isMobile = window.matchMedia('(max-width: 1024px)').matches;
    this.hasInitialized = false;
    this.updateRefinedInstanceArray = [];
  }

  /**
   * Initializes the AlgoliaSearchHandler by registering event listeners.
   */
  return algolia_createClass(AlgoliaSearchHandler, [{
    key: "initialize",
    value: function initialize() {
      /**
       * @fileoverview Listens for changes in the URL parameters (search params, hash, or pathname)
       * and logs event details including the source of the change.
       */

      this.registerEventListeners();
    }

    /**
     * Registers necessary event listeners for Algolia search events.
     */
  }, {
    key: "registerEventListeners",
    value: function registerEventListeners() {
      var _this2 = this;
      document.addEventListener('algolia.hooks.initialize', function () {
        _this2.registerHooks();

        // Initialize hierarchical menu once during hooks initialization
      });
      document.addEventListener('algolia.instantSearch.onRender', algolia_debounce(function () {
        _this2.handleOnRender();
      }, 100));
      this.onResizeReinit();
      window.addEventListener('algolia.finishedInitialization', function () {
        var referrerPathname = document.referrer ? new URL(document.referrer).pathname : null;
        var currentPathname = window.location.pathname;
        var hasReferrer = referrerPathname && referrerPathname !== currentPathname;
        var showBrandFilters = window.algoliaShopify.is_collection_results_page ? window.collection_metafields.show_brand_filters : false;
        if (window.algoliaShopify.is_collection_results_page && showBrandFilters === false || showBrandFilters === undefined) {
          return;
        }
        var alternateBrand = sessionStorage.getItem('shopify_alternate_brand');
        var brandSearchPerformed = Boolean(window.sessionStorage.getItem('brand_search_performed'));
        if (alternateBrand && alternateBrand !== 'gibson') {
          var capitalisedBrand = alternateBrand.charAt(0).toUpperCase() + alternateBrand.slice(1);
          setTimeout(function () {
            if (!brandSearchPerformed) {
              if (window.algoliaShopify.is_collection_results_page && window.algoliaShopify.instantsearch.search.helper.state.page == 0) {
                window.algoliaShopify.instantsearch.search.helper.addDisjunctiveFacetRefinement('vendor', capitalisedBrand);
                window.algoliaShopify.instantsearch.search.helper.search();
              }
              window.brandSearchPerformed = true;
              window.sessionStorage.setItem('brand_search_performed', true);
            }
          }, 10);
        }
      });
      window.addEventListener('algolia.finishedInitializationForMobile', function () {});
    }

    /**
     * Reinitializes the search interface when the window is resized.
     */
  }, {
    key: "onResizeReinit",
    value: function onResizeReinit() {
      var _this3 = this;
      window.addEventListener('resize', function () {
        var instantSearchInterval = setInterval(function () {
          if (algoliaShopify.instantsearch) {
            clearInterval(instantSearchInterval);
            if (_this3.isMobile !== window.matchMedia('(max-width: 1024px)').matches) {
              window.location.reload();
            }
          }
        }, 100);
      });
    }

    /**
     * Registers custom hooks for modifying the behavior of Algolia InstantSearch.
     */
  }, {
    key: "registerHooks",
    value: function registerHooks() {
      var _this4 = this;
      var _algoliaShopify = algoliaShopify,
        hooks = _algoliaShopify.hooks;
      algoliaShopify.hooks.registerHook('beforeInstantSearchFiltersString', function (defaultFilter) {
        if (defaultFilter && defaultFilter.includes('collection_ids')) {
          var collectionIDFilterRegex = /collection_ids:"\w+"/g;
          var matches = window.location.pathname.match(/\/collections\/([^/]+)/i);
          var collectionHandle = matches && matches.length === 2 ? matches[1] : null;
          if (collectionHandle) {
            defaultFilter = defaultFilter.replace(collectionIDFilterRegex, 'collections:' + collectionHandle);
          }
        }
        var country = window.Shopify.country;
        var locale = window.Shopify.country.toLowerCase();
        if (locale === 'us' || locale === 'united-states') {
          locale = 'en';
        } else if (locale === 'uk' || locale === 'united-kingdom' || locale === 'gb') {
          locale = 'en';
        } else if (locale === 'ie' || locale === 'ireland' || locale === 'ir') {
          locale = 'en';
        }
        var filterString = "".concat(locale, "-").concat(country);
        var alternateString = "en-".concat(country);
        var inheritNLMarketSuppression = false;
        if (window.Shopify.market_handle === 'europe' && country != 'IE' && (country != 'FR' || country != 'DE' || country != 'ES' || country != 'IT')) {
          inheritNLMarketSuppression = true;
        } else {
          inheritNLMarketSuppression = false;
        }
        if (defaultFilter) {
          var _window$algoliaShopif, _window$algoliaShopif2;
          if ((_window$algoliaShopif = window.algoliaShopify) !== null && _window$algoliaShopif !== void 0 && (_window$algoliaShopif = _window$algoliaShopif.instantsearch) !== null && _window$algoliaShopif !== void 0 && (_window$algoliaShopif = _window$algoliaShopif.search) !== null && _window$algoliaShopif !== void 0 && (_window$algoliaShopif = _window$algoliaShopif.helper) !== null && _window$algoliaShopif !== void 0 && (_window$algoliaShopif = _window$algoliaShopif.state) !== null && _window$algoliaShopif !== void 0 && (_window$algoliaShopif = _window$algoliaShopif.disjunctiveFacetsRefinements) !== null && _window$algoliaShopif !== void 0 && _window$algoliaShopif.inventory_available && ((_window$algoliaShopif2 = window.algoliaShopify) === null || _window$algoliaShopif2 === void 0 || (_window$algoliaShopif2 = _window$algoliaShopif2.instantsearch) === null || _window$algoliaShopif2 === void 0 || (_window$algoliaShopif2 = _window$algoliaShopif2.search) === null || _window$algoliaShopif2 === void 0 || (_window$algoliaShopif2 = _window$algoliaShopif2.helper) === null || _window$algoliaShopif2 === void 0 || (_window$algoliaShopif2 = _window$algoliaShopif2.state) === null || _window$algoliaShopif2 === void 0 || (_window$algoliaShopif2 = _window$algoliaShopif2.disjunctiveFacetsRefinements) === null || _window$algoliaShopif2 === void 0 || (_window$algoliaShopif2 = _window$algoliaShopif2.inventory_available) === null || _window$algoliaShopif2 === void 0 ? void 0 : _window$algoliaShopif2.length) > 0) {
            if (window.Shopify.market_handle === 'europe') {
              defaultFilter = defaultFilter + ' AND named_tags.in-stock:" europe"';
            } else if (window.Shopify.market_handle === 'united-kingdom') {
              defaultFilter = defaultFilter + ' AND named_tags.in-stock:" united_kingdom"';
            } else {
              defaultFilter = defaultFilter + ' AND named_tags.in-stock:" us"';
            }
          }
          if (inheritNLMarketSuppression) {
            if (filterString === alternateString) {
              return defaultFilter + " AND NOT meta.custom.market_suppression:\"".concat(filterString, "\" AND NOT meta.custom.market_suppression:\"nl-NL\"");
            } else {
              return defaultFilter + " AND NOT meta.custom.market_suppression:\"".concat(filterString, "\" AND NOT meta.custom.market_suppression:\"").concat(alternateString, "\" AND NOT meta.custom.market_suppression:\"nl-NL\"");
            }
          } else {
            if (filterString === alternateString) {
              return defaultFilter + " AND NOT meta.custom.market_suppression:\"".concat(filterString, "\"");
            } else {
              return defaultFilter + " AND NOT meta.custom.market_suppression:\"".concat(filterString, "\" AND NOT meta.custom.market_suppression:\"").concat(alternateString, "\"");
            }
          }
        } else {
          if (inheritNLMarketSuppression) {
            if (filterString === alternateString) {
              var _window$algoliaShopif3, _window$algoliaShopif4;
              if ((_window$algoliaShopif3 = window.algoliaShopify) !== null && _window$algoliaShopif3 !== void 0 && (_window$algoliaShopif3 = _window$algoliaShopif3.instantsearch) !== null && _window$algoliaShopif3 !== void 0 && (_window$algoliaShopif3 = _window$algoliaShopif3.search) !== null && _window$algoliaShopif3 !== void 0 && (_window$algoliaShopif3 = _window$algoliaShopif3.helper) !== null && _window$algoliaShopif3 !== void 0 && (_window$algoliaShopif3 = _window$algoliaShopif3.state) !== null && _window$algoliaShopif3 !== void 0 && (_window$algoliaShopif3 = _window$algoliaShopif3.disjunctiveFacetsRefinements) !== null && _window$algoliaShopif3 !== void 0 && _window$algoliaShopif3.inventory_available && ((_window$algoliaShopif4 = window.algoliaShopify) === null || _window$algoliaShopif4 === void 0 || (_window$algoliaShopif4 = _window$algoliaShopif4.instantsearch) === null || _window$algoliaShopif4 === void 0 || (_window$algoliaShopif4 = _window$algoliaShopif4.search) === null || _window$algoliaShopif4 === void 0 || (_window$algoliaShopif4 = _window$algoliaShopif4.helper) === null || _window$algoliaShopif4 === void 0 || (_window$algoliaShopif4 = _window$algoliaShopif4.state) === null || _window$algoliaShopif4 === void 0 || (_window$algoliaShopif4 = _window$algoliaShopif4.disjunctiveFacetsRefinements) === null || _window$algoliaShopif4 === void 0 || (_window$algoliaShopif4 = _window$algoliaShopif4.inventory_available) === null || _window$algoliaShopif4 === void 0 ? void 0 : _window$algoliaShopif4.length) > 0) {
                return "NOT meta.custom.market_suppression:\"".concat(filterString, "\" AND NOT meta.custom.market_suppression:\"nl-NL\" ");
              } else {
                return "NOT meta.custom.market_suppression:\"".concat(filterString, "\" AND NOT meta.custom.market_suppression:\"nl-NL\"");
              }
            } else {
              var _window$algoliaShopif5, _window$algoliaShopif6;
              if ((_window$algoliaShopif5 = window.algoliaShopify) !== null && _window$algoliaShopif5 !== void 0 && (_window$algoliaShopif5 = _window$algoliaShopif5.instantsearch) !== null && _window$algoliaShopif5 !== void 0 && (_window$algoliaShopif5 = _window$algoliaShopif5.search) !== null && _window$algoliaShopif5 !== void 0 && (_window$algoliaShopif5 = _window$algoliaShopif5.helper) !== null && _window$algoliaShopif5 !== void 0 && (_window$algoliaShopif5 = _window$algoliaShopif5.state) !== null && _window$algoliaShopif5 !== void 0 && (_window$algoliaShopif5 = _window$algoliaShopif5.disjunctiveFacetsRefinements) !== null && _window$algoliaShopif5 !== void 0 && _window$algoliaShopif5.inventory_available && ((_window$algoliaShopif6 = window.algoliaShopify) === null || _window$algoliaShopif6 === void 0 || (_window$algoliaShopif6 = _window$algoliaShopif6.instantsearch) === null || _window$algoliaShopif6 === void 0 || (_window$algoliaShopif6 = _window$algoliaShopif6.search) === null || _window$algoliaShopif6 === void 0 || (_window$algoliaShopif6 = _window$algoliaShopif6.helper) === null || _window$algoliaShopif6 === void 0 || (_window$algoliaShopif6 = _window$algoliaShopif6.state) === null || _window$algoliaShopif6 === void 0 || (_window$algoliaShopif6 = _window$algoliaShopif6.disjunctiveFacetsRefinements) === null || _window$algoliaShopif6 === void 0 || (_window$algoliaShopif6 = _window$algoliaShopif6.inventory_available) === null || _window$algoliaShopif6 === void 0 ? void 0 : _window$algoliaShopif6.length) > 0) {
                var filterToReturn = "NOT meta.custom.market_suppression:\"".concat(filterString, "\" AND NOT meta.custom.market_suppression:\"").concat(alternateString, "\" AND NOT meta.custom.market_suppression:\"nl-NL\"");
                return filterToReturn;
              } else {
                return "NOT meta.custom.market_suppression:\"".concat(filterString, "\" AND NOT meta.custom.market_suppression:\"").concat(alternateString, "\" AND NOT meta.custom.market_suppression:\"nl-NL\"");
              }
            }
          } else {
            if (filterString === alternateString) {
              var _window$algoliaShopif7;
              if (((_window$algoliaShopif7 = window.algoliaShopify) === null || _window$algoliaShopif7 === void 0 || (_window$algoliaShopif7 = _window$algoliaShopif7.instantsearch) === null || _window$algoliaShopif7 === void 0 || (_window$algoliaShopif7 = _window$algoliaShopif7.search) === null || _window$algoliaShopif7 === void 0 || (_window$algoliaShopif7 = _window$algoliaShopif7.helper) === null || _window$algoliaShopif7 === void 0 || (_window$algoliaShopif7 = _window$algoliaShopif7.state) === null || _window$algoliaShopif7 === void 0 || (_window$algoliaShopif7 = _window$algoliaShopif7.disjunctiveFacetsRefinements) === null || _window$algoliaShopif7 === void 0 || (_window$algoliaShopif7 = _window$algoliaShopif7.inventory_available) === null || _window$algoliaShopif7 === void 0 ? void 0 : _window$algoliaShopif7.length) > 0) {
                if (window.Shopify.market_handle === 'europe') {
                  defaultFilter = defaultFilter + ' AND named_tags.in-stock:" europe"';
                } else if (window.Shopify.market_handle === 'united-kingdom') {
                  defaultFilter = defaultFilter + ' AND named_tags.in-stock:" united_kingdom"';
                } else {
                  defaultFilter = defaultFilter + ' AND named_tags.in-stock:" us"';
                }
              } else {
                defaultFilter = defaultFilter;
              }
              return "NOT meta.custom.market_suppression:\"".concat(filterString, "\" ").concat(defaultFilter);
            } else {
              return "NOT meta.custom.market_suppression:\"".concat(filterString, "\" AND NOT meta.custom.market_suppression:\"").concat(alternateString, "\" ").concat(defaultFilter);
            }
          }
        }
      });

      /** Enable Query ID Tracking **/
      algoliaShopify.hooks.registerHook('beforeInstantSearchOptions', function (options) {
        if (!options.searchParameters) {
          options.searchParameters = {};
        }
        ;
        options.searchParameters.clickAnalytics = true;
        options.searchParameters.userToken = _this4.getUserToken();
        return options;
      });
      algoliaShopify.hooks.registerHook('beforeInstantSearchFacetParamsOptions', function (params, facet) {
        var escapedName = facet.escapedName;
        var _title = facet.title;
        if (window.translations && Array.isArray(window.translations)) {
          var matchingTranslation = window.translations.find(function (translation) {
            return (translation.guitar_spec || translation.amp_spec || translation.pedal_spec) && (translation.guitar_spec === escapedName || translation.amp_spec === escapedName || translation.pedal_spec === escapedName);
          });
          if (matchingTranslation) {
            _title = matchingTranslation.value;
            facet.title = _title;
          }
        }
        if (facet && facet.name == 'inventory_available') {
          // Hide the original inventory available facet - we'll replace it with our toggle
          params.collapsed = false;
          params.isCollapsed = false;
          params.isCollapsible = false;
          params.count = false;
          var newParams = algolia_objectSpread(algolia_objectSpread({}, params), {}, {
            cssClasses: algolia_objectSpread(algolia_objectSpread({}, params.cssClasses || {}), {}, {
              root: 'ais-hide-facet'
            })
          });
          return newParams;
        }
        return algolia_objectSpread(algolia_objectSpread({}, params), {}, {
          // Hide the original facet if there is 1 item and it's not refined
          transformItems: function transformItems(items) {
            var cleanedItems = items === null || items === void 0 ? void 0 : items.filter(function (item) {
              var _item$value, _item$label;
              return !(item !== null && item !== void 0 && (_item$value = item.value) !== null && _item$value !== void 0 && _item$value.includes('object Object')) || !(item !== null && item !== void 0 && (_item$label = item.label) !== null && _item$label !== void 0 && _item$label.includes('object Object'));
            });
            if (cleanedItems.length < 2 && cleanedItems.some(function (item) {
              return item.isRefined != true;
            })) {
              return [];
            }
            ;
            return cleanedItems;
          }
        });
      });

      // Add a style to hide the original facet
      var hideStyle = document.createElement('style');
      hideStyle.textContent = "\n      .ais-hide-facet {\n        display: none !important;\n      }\n    ";
      document.head.appendChild(hideStyle);

      // Hook into the facet item template rendering
      hooks.registerHook('beforeInstantSearchFacetItemTemplate', function (defaultTemplate, item, html) {
        return _this4.handleBeforeInstantSearchFacetItemTemplate(defaultTemplate, item, html);
      });

      // Hook into the stats template rendering
      hooks.registerHook('beforeInstantSearchStatsTemplate', function (defaultTemplate, data, html) {
        return _this4.handleBeforeInstantSearchStatsTemplate(defaultTemplate, data, html);
      });

      // Hook into the InstantSearch options before initialization
      hooks.registerHook('beforeInstantSearchOptions', function (options) {
        return _this4.handleBeforeInstantSearchOptions(options);
      });
      algoliaShopify.hooks.registerHook('beforeInstantSearchFacetPanelOptions', function (params, facet) {
        return algolia_objectSpread(algolia_objectSpread({}, params), {}, {
          templates: {
            header: function header(options, _ref) {
              var html = _ref.html;
              if (options.results && options.items && options.items.length > 0) {
                return html(algolia_templateObject || (algolia_templateObject = algolia_taggedTemplateLiteral(["<span\n                class=\"hidden\"\n                data-count-id=\"", "\"\n                data-current-facet-count=\"", "\"\n              ></span>"])), facet.name, options.items.length);
              }
            }
          }
        });
      });
      this.renderOperations();
    }

    /**
     * Handles modifications before rendering the InstantSearch facet item template.
     * @param {Function} _defaultTemplate - The default template function.
     * @param {Object} item - The facet item data.
     * @param {Function} html - The HTML rendering function.
     * @returns {string} - The modified HTML string for the facet item.
     */
  }, {
    key: "handleBeforeInstantSearchFacetItemTemplate",
    value: function handleBeforeInstantSearchFacetItemTemplate(_defaultTemplate, item, html) {
      // Encode the attribute name to be used as a key
      var urlEncodedAttribute = encodeURIComponent(item.attribute);

      // Reset count if processing a new attribute
      if (this.currentAttribute !== item.attribute) {
        this.facetValueCounts[urlEncodedAttribute] = 0;
        this.currentAttribute = item.attribute;
      }

      // Increment the facet value count for the current attribute
      this.facetValueCounts[urlEncodedAttribute]++;

      // Set a custom CSS class for the label
      item.cssClasses.label = 'ais-facet-item__label';

      // Return the custom facet item template
      return this.createFacetItemTemplate(item, html);
    }
  }, {
    key: "getUserToken",
    value: function getUserToken() {
      var userToken = localStorage.getItem('algolia_user_token');
      if (!userToken) {
        userToken = 'user-' + Math.random().toString(36).substring(2, 9) + '-' + Date.now();
        localStorage.setItem('algolia_user_token', userToken);
      }
      ;
      return userToken;
    }
  }, {
    key: "createFacetItemTemplate",
    value:
    /**
     * Creates a custom template for a facet item.
     * @param {Object} item - The facet item data.
     * @param {Function} html - The HTML rendering function.
     * @returns {string} - The HTML string for the facet item.
     */
    function createFacetItemTemplate(item, html) {
      if (item.attribute === 'price_range') {
        // Returns the currency symbol for a given currency code
        var getCurrencySymbol = function getCurrencySymbol(code) {
          if (currencySymbols[code]) return currencySymbols[code];
          // Fallback to Intl if not mapped
          return 0 .toLocaleString('en', {
            style: 'currency',
            currency: code,
            minimumFractionDigits: 0,
            maximumFractionDigits: 0
          }).replace(/\d/g, '').replace(/[\u00A0\s]/g, '').trim();
        };
        // Format prices to use commas
        var range = item.label;
        var formattedRange = range.split(':').map(function (num) {
          return Number(num).toLocaleString('en-US');
        }).join(':');

        // Set currency symbols
        var currencySymbols = {
          USD: '$',
          CAD: 'C$',
          GBP: '£',
          EUR: '€',
          JPY: '¥'
        };
        var currencyCode = Shopify.currency.active;
        var symbol = getCurrencySymbol(currencyCode);
        // Remove ':' and replace with '-' while also adding currency symbol to higher end of the range.
        var priceRangeValue = formattedRange.replace(':', " - ".concat(symbol));
        item.label = "".concat(symbol).concat(priceRangeValue);
      }
      if (item.attribute == 'meta.guitar_specifications.body-specification--body-shape') {
        item.label = item.label.replace(/"/g, '');
      }
      if (item.attribute == 'meta.product_flags.us_product_flags') {
        if (item.value !== 'Exclusive') {
          return html(algolia_templateObject2 || (algolia_templateObject2 = algolia_taggedTemplateLiteral(["<div class=\"hidden empty-facet\"></div>"])));
        }
      }
      if (item.attribute == 'meta.product_flags.eu_product_flags') {
        if (item.value !== 'Exclusive') {
          return html(algolia_templateObject3 || (algolia_templateObject3 = algolia_taggedTemplateLiteral(["<div class=\"hidden empty-facet\"></div>"])));
        }
      }
      item.attribute == 'meta.color.colorRGB' ? document.documentElement.style.setProperty("--color-".concat(item.label.split('#')[1]), item.label) : '';
      var coll = item.attribute == 'meta.color.colorRGB' ? item.label : '';
      if (item.attribute == 'inventory_available') {
        item.label = 'In Stock';
        coll = 'In Stock';
      }
      var createStyle = function createStyle(color) {
        var colorAsArray = color.split(':::name:');
        return html(algolia_templateObject4 || (algolia_templateObject4 = algolia_taggedTemplateLiteral(["<style>\n        [data-facet-color='", "']::after {\n          background: ", " !important;\n        }\n      </style>"])), colorAsArray[1], colorAsArray[0]);
      };
      var createLabelElement = function createLabelElement(item) {
        // Error handling
        if (!item || algolia_typeof(item) !== 'object') {
          console.error('Invalid item provided');
          return '';
        }
        var attribute = item.attribute,
          cssClasses = item.cssClasses,
          _item$label2 = item.label,
          label = _item$label2 === void 0 ? '' : _item$label2,
          _item$isRefined = item.isRefined,
          isRefined = _item$isRefined === void 0 ? false : _item$isRefined,
          _item$count = item.count,
          count = _item$count === void 0 ? 0 : _item$count;

        // Ensure cssClasses is valid
        if (!cssClasses || algolia_typeof(cssClasses) !== 'object') {
          console.error('Invalid cssClasses in item');
          return '';
        }

        // Format the count
        var formattedCount = algoliaShopify.helpers.formatNumber(count);

        // Default classes and content
        var labelClasses = cssClasses.label || '';
        var inputClasses = "".concat(cssClasses.checkbox || '', " ais-facet-item__checkbox");
        var spanClasses = cssClasses.count || '';
        var labelContent = coll ? coll : label;
        var extraLabelContent = '';
        var extraTopContent = '';
        var handlizedLabel = labelContent.toLowerCase().replace(/\s+/g, '-').replace(/[^\w-]/g, '');
        switch (attribute) {
          case 'meta.color.colorRGB':
            labelClasses += ' color-label';
            extraTopContent = createStyle(item.label);
            extraLabelContent = html(algolia_templateObject5 || (algolia_templateObject5 = algolia_taggedTemplateLiteral(["<div\n            class=\"ais-facet-swatch\"\n            style=\"background-color: ", ";\"\n          ></div>"])), labelContent.split(':::name:')[0]);
            labelContent = labelContent.split(':::name:')[1];
            /* Get the color label from window.algoliaShopify.colorPatterns */
            var colorLabel = window.algoliaShopify.colorPatterns.find(function (pattern) {
              if (pattern.handle === labelContent.trim().toLowerCase().replace(/ /g, '-')) {
                return pattern.label;
              }
            });
            if (colorLabel) {
              labelContent = colorLabel.label;
            }
            item.refinedLabel = labelContent;
            break;
          case 'meta.guitar_specifications.body-specification--body-finish':
            labelClasses += ' body-finish-label';
            labelContent = labelContent.replace(/["']/g, '').replace(/[[]/g, '');
            /* If labelContent contains a closing square bracket, remove it e.g: Gloss Nitro Lacquer (Top), Satin Nitro Lacquer (Back)] */
            labelContent = labelContent.replace(/[\]]/g, '');
            break;
          case 'meta.custom.strings':
            labelClasses += ' strings-label';
            inputClasses += ' strings-checkbox';
            spanClasses += ' strings-count';
            break;
          case 'inventory_available':
            labelClasses += ' inventory-available-label';
            break;
          case 'meta.product_flags.us_product_flags':
            inputClasses += ' ais-custom-toggle-input';
            labelClasses += ' ais-custom-toggle-label--exclusive';
            if (window.Shopify.country !== 'US') {
              labelClasses += ' hidden';
              inputClasses += ' hidden';
            }
            break;
          case 'meta.product_flags.eu_product_flags':
            inputClasses += ' ais-custom-toggle-input';
            labelClasses += ' ais-custom-toggle-label--exclusive';
            if (window.Shopify.country === 'US') {
              labelClasses += ' hidden';
              inputClasses += ' hidden';
            }
            break;
          case 'meta.sku.left_handed':
            labelContent = labelContent.replace(/["']/g, '').replace(/[[]/g, '').replace(/[\]]/g, '');
            if (labelContent === 'false') {
              labelContent = 'Right';
              var matchingTranslation = window.translations && window.translations.find(function (translation) {
                return translation.key === 'right';
              });
              if (matchingTranslation) {
                labelContent = matchingTranslation.value;
              }
            } else {
              labelContent = 'Left';
              var _matchingTranslation = window.translations && window.translations.find(function (translation) {
                return translation.key === 'left';
              });
              if (_matchingTranslation) {
                labelContent = _matchingTranslation.value;
              }
            }
            break;
          case 'product_type':
            labelContent = labelContent.replace(/["']/g, '').replace(/[[]/g, '').replace(/[\]]/g, '');
            break;
          case 'named_tags.primary_collection':
            if (window.Shopify.locale !== 'en') {
              var _matchingTranslation2 = window.translations && window.translations.find(function (translation) {
                return translation.concatenated_handle === "primary-collections-1--".concat(handlizedLabel) || translation.concatenated_handle === "primary-collections-2--".concat(handlizedLabel);
              });
              if (_matchingTranslation2) {
                labelContent = _matchingTranslation2.value;
              }
              ;
            }
            ;
            break;
          case 'named_tags.gifts-for-them':
            if (window.Shopify.locale !== 'en') {
              var matchingTranslatonGiftsForThem = window.translations && window.translations.find(function (translation) {
                return translation.key === handlizedLabel;
              });
              if (matchingTranslatonGiftsForThem) {
                labelContent = matchingTranslatonGiftsForThem.value;
              }
              ;
            }
            ;
            break;
          case 'named_tags.gifts-for-you':
            if (window.Shopify.locale !== 'en') {
              var matchingTranslationGiftsForYou = window.translations && window.translations.find(function (translation) {
                return translation.key === handlizedLabel;
              });
              if (matchingTranslationGiftsForYou) {
                labelContent = matchingTranslationGiftsForYou.value;
              }
              ;
            }
            break;
          default:
            // Example: "100% Cotton" (should become) -> 100% Cotton
            labelContent = labelContent.replace(/["']/g, '').replace(/[[]/g, '').replace(/[\]]/g, '');

            // No additional modifications
            break;
        }
        if (labelContent.includes('object Object')) return '';

        // Input element with conditional 'checked' attribute
        var inputElement = isRefined ? html(algolia_templateObject6 || (algolia_templateObject6 = algolia_taggedTemplateLiteral(["<input\n            type=\"checkbox\"\n            class=\"", "\"\n            checked=\"", "\"\n            data-attribute=\"", "\"\n            data-value=\"", "\"\n          />"])), inputClasses, isRefined, attribute, item.value) : html(algolia_templateObject7 || (algolia_templateObject7 = algolia_taggedTemplateLiteral(["<input\n            type=\"checkbox\"\n            class=\"", "\"\n            data-attribute=\"", "\"\n            data-value=\"", "\"\n          />"])), inputClasses, attribute, item.value);
        var formattedCountString = "(".concat(formattedCount, ")");
        labelContent = html(algolia_templateObject8 || (algolia_templateObject8 = algolia_taggedTemplateLiteral(["", " <span class=\"", "\">", "</span>"])), labelContent, spanClasses, formattedCountString);
        return html(algolia_templateObject9 || (algolia_templateObject9 = algolia_taggedTemplateLiteral(["\n        ", "\n      "])), item.attribute == 'meta.color.colorRGB' ? html(algolia_templateObject10 || (algolia_templateObject10 = algolia_taggedTemplateLiteral([" ", "\n              <label class=\"", "\" data-facet-color=\"", "\">\n                <div class=\"ais-facet-item__label-container\">", " ", " ", "</div>\n              </label>"])), extraTopContent, labelClasses, item.label.split(':::name:')[1], extraLabelContent, inputElement, labelContent) : item.attribute == 'meta.product_flags.us_product_flags' || item.attribute == 'meta.product_flags.eu_product_flags' ? html(algolia_templateObject11 || (algolia_templateObject11 = algolia_taggedTemplateLiteral([" <label class=\"", "\">\n                <div class=\"ais-facet-item__label-container\">\n                  ", " <span class=\"ais-custom-toggle-switch\"></span> ", "\n                </div>\n              </label>"])), labelClasses, inputElement, labelContent) : html(algolia_templateObject12 || (algolia_templateObject12 = algolia_taggedTemplateLiteral([" <label class=\"", "\">\n                <div class=\"ais-facet-item__label-container\">", " ", "</div>\n              </label>"])), labelClasses, inputElement, labelContent));
      };
      return html(algolia_templateObject13 || (algolia_templateObject13 = algolia_taggedTemplateLiteral(["", ""])), createLabelElement(item));
    }

    /**
     * Handles modifications before rendering the InstantSearch stats template.
     * @param {Function} _defaultTemplate - The default template function.
     * @param {Object} data - The stats data.
     * @param {Function} html - The HTML rendering function.
     * @returns {string} - The modified HTML string for the stats.
     */
  }, {
    key: "handleBeforeInstantSearchStatsTemplate",
    value: function handleBeforeInstantSearchStatsTemplate(_defaultTemplate, data, html) {
      try {
        var _window$algoliaShopif8;
        if ((_window$algoliaShopif8 = window.algoliaShopify.instantsearch.search) !== null && _window$algoliaShopif8 !== void 0 && (_window$algoliaShopif8 = _window$algoliaShopif8.helper) !== null && _window$algoliaShopif8 !== void 0 && (_window$algoliaShopif8 = _window$algoliaShopif8.lastResults) !== null && _window$algoliaShopif8 !== void 0 && (_window$algoliaShopif8 = _window$algoliaShopif8.renderingContent) !== null && _window$algoliaShopif8 !== void 0 && (_window$algoliaShopif8 = _window$algoliaShopif8.redirect) !== null && _window$algoliaShopif8 !== void 0 && _window$algoliaShopif8.url && window.Shopify.redirect_to_collection_on_search) {
          var _window$algoliaShopif9;
          window.location.href = (_window$algoliaShopif9 = window.algoliaShopify.instantsearch.search) === null || _window$algoliaShopif9 === void 0 || (_window$algoliaShopif9 = _window$algoliaShopif9.helper) === null || _window$algoliaShopif9 === void 0 || (_window$algoliaShopif9 = _window$algoliaShopif9.lastResults) === null || _window$algoliaShopif9 === void 0 ? void 0 : _window$algoliaShopif9.renderingContent.redirect.url;
        }
        store.dispatch(update(data.nbHits));
        statsRenderedStore.dispatch(updateStatsRendered(true));
      } catch (error) {
        console.error('error updating number of results', error);
      }
      if (data.hasOneResult) {
        return html(algolia_templateObject14 || (algolia_templateObject14 = algolia_taggedTemplateLiteral(["<span class=\"ais-stats--nb-results\">1 result found</span>"])));
      } else if (data.hasManyResults) {
        return html(algolia_templateObject15 || (algolia_templateObject15 = algolia_taggedTemplateLiteral(["\n        <span class=\"ais-stats--nb-results\">\n          ", " ", "</span\n        >\n      "])), algoliaShopify.helpers.formatNumber(data.nbHits), algoliaShopify.translations.resultsLowercase);
      }
      return '';
    }

    /**
     * Adds a 'loading' class to the grid element to indicate loading state.
     * This method is called when the search interface is rendering.
     */
  }, {
    key: "addGridLoadingClass",
    value: function addGridLoadingClass() {
      var grid = document.querySelector('.ais-Hits-list');
      grid.classList.add('loading');
    }

    /**
     * Removes the 'loading' class from the grid element to indicate loading state.
     * This method is called when the search interface has finished rendering.
     */
  }, {
    key: "removeGridLoadingClass",
    value: function removeGridLoadingClass() {
      var grid = document.querySelector('.ais-Hits-list');
      grid.classList.remove('loading');
    }

    /**
     * Removes all content blocks from the grid element.
     * This method is called when the search interface is rendering.
     */
  }, {
    key: "removeGridContentBlocks",
    value: function removeGridContentBlocks() {
      var grid = document.querySelector('.ais-Hits-list');
      var blocks = algolia_toConsumableArray(grid.querySelectorAll('.collection-content-blocks__block'));
      blocks.forEach(function (block) {
        block.remove();
      });
    }

    /**
     * Handles the 'onRender' event for Algolia InstantSearch.
     * Updates refined values and facet data when the search interface is rendered.
     */
  }, {
    key: "handleOnRender",
    value: function handleOnRender() {
      searchQueryStore.dispatch(updateSearchQuery(algoliaShopify.instantsearch.search.helper.state.query));
      var refinedKeys = window.algoliaShopify.instantsearch.search.helper.state.facetsRefinements;
      var disjunctiveRefinementKeys = window.algoliaShopify.instantsearch.search.helper.state.disjunctiveFacetsRefinements;

      /* get the total number of values for each facet and add it to the let totalFacetValues = 0; */
      var totalFacetValues = 0;
      var totalDisjunctiveFacetValues = 0;
      Object.keys(refinedKeys).forEach(function (key) {
        totalFacetValues += refinedKeys[key].length;
      });
      Object.keys(disjunctiveRefinementKeys).forEach(function (key) {
        totalDisjunctiveFacetValues += disjunctiveRefinementKeys[key].length;
      });
      totalFacetValues += totalDisjunctiveFacetValues;
      if (algolia_numberOfFacets.value !== totalFacetValues) {
        numberOfFacetsStore.dispatch(updateNumberOfFacets(totalFacetValues));
      } else if (algolia_numberOfFacets.value === 0) {
        numberOfFacetsStore.dispatch(updateNumberOfFacets(totalFacetValues));
      }
      this.updateFacetData();
      if (!statsRendered.value) return;
      if (!this.gridLoaded) {
        this.updateGrid();
        this.gridLoaded = true;
      } else {
        this.reloadGrid();
      }
    }

    /**
     * Updates the grid layout after the search interface has rendered.
     * This method is called after the search interface has rendered.
     */
  }, {
    key: "updateGrid",
    value: function updateGrid() {
      var gridUpdater = new utils_gridUpdater();
      this.gridUpdater = gridUpdater;
      this.gridUpdater.update();
    }
  }, {
    key: "reloadGrid",
    value: function reloadGrid() {
      this.gridUpdater.reloadGrid();
    }
  }, {
    key: "currencyFormatter",
    value: function currencyFormatter(value) {
      var locale = window.Shopify.locale + '-' + window.Shopify.country;
      return new Intl.NumberFormat(locale, {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
      }).format(value);
    }

    /**
     * Updates the facet data based on the latest search results.
     * Retrieves facet counts and updates the UI accordingly.
     */
  }, {
    key: "updateFacetData",
    value: (function () {
      var _updateFacetData = algolia_asyncToGenerator(/*#__PURE__*/algolia_regeneratorRuntime().mark(function _callee() {
        var _this5 = this;
        var instantsearch, facets, _instantsearch$search, userDataRefinementsAppliedVar, newQuery, allURLSearchParams, viewParamsMatch, originalQueryMatch;
        return algolia_regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              instantsearch = algoliaShopify.instantsearch;
              this.updater = new updateRefinedValues();

              // Check if InstantSearch is properly initialized
              if (!(!instantsearch || !instantsearch.search || !instantsearch.search.helper || !instantsearch.search.helper.lastResults)) {
                _context.next = 5;
                break;
              }
              console.warn('Algolia InstantSearch is not ready.');
              return _context.abrupt("return");
            case 5:
              _context.prev = 5;
              _context.next = 8;
              return this.updateRefinedValues();
            case 8:
              _context.next = 13;
              break;
            case 10:
              _context.prev = 10;
              _context.t0 = _context["catch"](5);
              console.error('Error updating refined values :( :', _context.t0);
            case 13:
              algolia_toConsumableArray(document.querySelectorAll('.ais-current-refined-values--link > div')).forEach(function (el) {
                el.setAttribute('title', el.textContent);
                if (!el.closest('.ais-Panel-body')) {
                  return;
                }
                var divToLook = el.closest('.ais-Panel-body').querySelector('div:first-of-type');
                var remainingListeners = getRemainingClickEventListeners(divToLook);
              });

              // Retrieve facets from the last search results
              facets = instantsearch.search.helper.lastResults.facets || [];
              facets.forEach(function (facet) {
                var urlEncodedName = encodeURIComponent(facet.name);
                var dataCount = Object.keys(facet.data || {}).length;
                _this5.facetValueCounts[urlEncodedName] = dataCount;

                /* check if facet data contains 'Exclusive' */

                if (facet.name === 'meta.product_flags.us_product_flags' || facet.name === 'meta.product_flags.eu_product_flags') {
                  if (!Object.keys(facet.data || {}).includes('Exclusive')) {
                    _this5.setNoExclusiveFacet(true);
                  }
                }
              });

              // Update the facet counts displayed in the UI
              this.updateFacetCounts();

              // If preselect_orientation_facets_on_search is true, apply user data refinements. This is settable in shop metafields.
              if (window.Shopify.preselect_orientation_facets_on_search) {
                userDataRefinementsAppliedVar = JSON.parse(window.sessionStorage.getItem('userDataRefinementsApplied'));
                newQuery = instantsearch === null || instantsearch === void 0 || (_instantsearch$search = instantsearch.search) === null || _instantsearch$search === void 0 || (_instantsearch$search = _instantsearch$search.helper) === null || _instantsearch$search === void 0 || (_instantsearch$search = _instantsearch$search.state) === null || _instantsearch$search === void 0 ? void 0 : _instantsearch$search.query;
                allURLSearchParams = new URLSearchParams(window.location.search);
                viewParamsMatch = userDataRefinementsAppliedVar && userDataRefinementsAppliedVar.viewParam === allURLSearchParams.get('view');
                originalQueryMatch = userDataRefinementsAppliedVar && userDataRefinementsAppliedVar.originalQuery === newQuery;
                if (!userDataRefinementsAppliedVar || !viewParamsMatch || !originalQueryMatch) {
                  this.applyUserDataRefinements(instantsearch);
                }
              }
            case 18:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[5, 10]]);
      }));
      function updateFacetData() {
        return _updateFacetData.apply(this, arguments);
      }
      return updateFacetData;
    }()
    /**
     * Applies user-defined facet refinements from Algolia search results.
     * This method processes userData from search results and applies any predefined refinements
     * to the search interface, typically used for applying saved filters or contextual refinements.
     *
     * @param {Object} instantsearch - The Algolia InstantSearch instance
     * @returns {Promise<void>} - Resolves when refinements have been applied
     */
    )
  }, {
    key: "applyUserDataRefinements",
    value: (function () {
      var _applyUserDataRefinements = algolia_asyncToGenerator(/*#__PURE__*/algolia_regeneratorRuntime().mark(function _callee2(instantsearch) {
        var _instantsearch$search2;
        var viewParam, _instantsearch$search3, searchResults, allURLSearchParams, _viewParam, sessionStorageItem, _iterator, _step, item;
        return algolia_regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              // Prevent multiple executions
              viewParam = new URLSearchParams(window.location.search).get('view');
              if (!(window.sessionStorage.getItem('userDataRefinementsApplied') && JSON.parse(window.sessionStorage.getItem('userDataRefinementsApplied')).originalQuery === (instantsearch === null || instantsearch === void 0 || (_instantsearch$search2 = instantsearch.search) === null || _instantsearch$search2 === void 0 || (_instantsearch$search2 = _instantsearch$search2.helper) === null || _instantsearch$search2 === void 0 || (_instantsearch$search2 = _instantsearch$search2.state) === null || _instantsearch$search2 === void 0 ? void 0 : _instantsearch$search2.query) && JSON.parse(window.sessionStorage.getItem('userDataRefinementsApplied')).viewParam === viewParam)) {
                _context2.next = 3;
                break;
              }
              return _context2.abrupt("return");
            case 3:
              _context2.prev = 3;
              _context2.next = 6;
              return this.waitForSearchResults(instantsearch, 5000);
            case 6:
              searchResults = _context2.sent;
              if (!(!(searchResults !== null && searchResults !== void 0 && searchResults.userData) || !Array.isArray(searchResults.userData))) {
                _context2.next = 9;
                break;
              }
              return _context2.abrupt("return");
            case 9:
              allURLSearchParams = new URLSearchParams(window.location.search);
              /* Check if url has view param */
              _viewParam = allURLSearchParams.get('view');
              sessionStorageItem = {
                originalQuery: instantsearch === null || instantsearch === void 0 || (_instantsearch$search3 = instantsearch.search) === null || _instantsearch$search3 === void 0 || (_instantsearch$search3 = _instantsearch$search3.helper) === null || _instantsearch$search3 === void 0 || (_instantsearch$search3 = _instantsearch$search3.state) === null || _instantsearch$search3 === void 0 ? void 0 : _instantsearch$search3.query,
                userDataApplied: true,
                viewParam: _viewParam || null
              };
              window.sessionStorage.setItem('userDataRefinementsApplied', JSON.stringify(sessionStorageItem));

              // Process each userData item
              _iterator = algolia_createForOfIteratorHelper(searchResults.userData);
              _context2.prev = 14;
              _iterator.s();
            case 16:
              if ((_step = _iterator.n()).done) {
                _context2.next = 23;
                break;
              }
              item = _step.value;
              if (!item.disjunctiveFacetsRefinements) {
                _context2.next = 21;
                break;
              }
              _context2.next = 21;
              return this.processRefinementItem(item, instantsearch, searchResults);
            case 21:
              _context2.next = 16;
              break;
            case 23:
              _context2.next = 28;
              break;
            case 25:
              _context2.prev = 25;
              _context2.t0 = _context2["catch"](14);
              _iterator.e(_context2.t0);
            case 28:
              _context2.prev = 28;
              _iterator.f();
              return _context2.finish(28);
            case 31:
              _context2.next = 36;
              break;
            case 33:
              _context2.prev = 33;
              _context2.t1 = _context2["catch"](3);
              console.error('Error applying user data refinements:', _context2.t1);
            case 36:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this, [[3, 33], [14, 25, 28, 31]]);
      }));
      function applyUserDataRefinements(_x) {
        return _applyUserDataRefinements.apply(this, arguments);
      }
      return applyUserDataRefinements;
    }()
    /**
     * Waits for search results to become available
     * @private
     */
    )
  }, {
    key: "waitForSearchResults",
    value: function waitForSearchResults(instantsearch) {
      var timeout = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 5000;
      return new Promise(function (resolve, reject) {
        var startTime = Date.now();
        var _checkResults = function checkResults() {
          var _instantsearch$search4;
          if (instantsearch !== null && instantsearch !== void 0 && (_instantsearch$search4 = instantsearch.search) !== null && _instantsearch$search4 !== void 0 && (_instantsearch$search4 = _instantsearch$search4.helper) !== null && _instantsearch$search4 !== void 0 && _instantsearch$search4.lastResults) {
            resolve(instantsearch.search.helper.lastResults);
          } else if (Date.now() - startTime > timeout) {
            reject(new Error('Timeout waiting for search results'));
          } else {
            setTimeout(_checkResults, 50);
          }
        };
        _checkResults();
      });
    }

    /**
     * Processes a single refinement item from userData
     * @private
     */
  }, {
    key: "processRefinementItem",
    value: (function () {
      var _processRefinementItem = algolia_asyncToGenerator(/*#__PURE__*/algolia_regeneratorRuntime().mark(function _callee3(item, instantsearch, searchResults) {
        var _instantsearch$search5;
        var refinementsString, refinements, currentRefinements, mergedRefinements, applyTheRefinements;
        return algolia_regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              refinementsString = item.disjunctiveFacetsRefinements;
              if (!(!refinementsString || typeof refinementsString !== 'string')) {
                _context3.next = 3;
                break;
              }
              return _context3.abrupt("return");
            case 3:
              // Parse refinements from the string format
              refinements = this.parseRefinementString(refinementsString); // Get current refinements from search state
              currentRefinements = (instantsearch === null || instantsearch === void 0 || (_instantsearch$search5 = instantsearch.search) === null || _instantsearch$search5 === void 0 || (_instantsearch$search5 = _instantsearch$search5.helper) === null || _instantsearch$search5 === void 0 || (_instantsearch$search5 = _instantsearch$search5.state) === null || _instantsearch$search5 === void 0 ? void 0 : _instantsearch$search5.disjunctiveFacetsRefinements) || {}; // Merge with parsed refinements
              mergedRefinements = this.mergeRefinements(currentRefinements, refinements);
              applyTheRefinements = true;
              Object.keys(searchResults.disjunctiveFacets).forEach(function (key) {
                Object.keys(mergedRefinements).forEach(function (mergedKey) {
                  if (mergedKey === searchResults.disjunctiveFacets[key].name && mergedRefinements[mergedKey].length > 0) {
                    var isInData = Object.keys(searchResults.disjunctiveFacets[key].data).includes(mergedRefinements[mergedKey][0]);
                    if (isInData) {} else {
                      applyTheRefinements = false;
                    }
                  }
                });
              });
              if (!applyTheRefinements) {
                _context3.next = 11;
                break;
              }
              _context3.next = 11;
              return this.applyRefinements(mergedRefinements, instantsearch);
            case 11:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function processRefinementItem(_x2, _x3, _x4) {
        return _processRefinementItem.apply(this, arguments);
      }
      return processRefinementItem;
    }()
    /**
     * Parses refinement string into structured object
     * @private
     */
    )
  }, {
    key: "parseRefinementString",
    value: function parseRefinementString(refinementString) {
      var refinements = {};

      // Convert the refinement string to URL parameters format
      // Example: "attribute:value" becomes "refinementList[attribute][0]=value"
      // Handle complex values that may contain special characters like "&"
      var formattedString = refinementString.replace(/([^:]+):(.+?)(?=,|$)/g, function (match, attribute, value) {
        return "refinementList[".concat(attribute, "][0]=").concat(encodeURIComponent(value));
      });
      var params = new URLSearchParams(formattedString);

      // Parse each parameter
      params.forEach(function (value, key) {
        // Extract attribute name from parameter key
        var match = key.match(/refinementList\[(.*?)\](?:\[\d+\])?$/);
        if (match) {
          var attribute = match[1];
          if (!refinements[attribute]) {
            refinements[attribute] = [];
          }
          // Only add if not already present
          if (!refinements[attribute].includes(value)) {
            refinements[attribute].push(value);
          }
        }
      });
      return refinements;
    }

    /**
     * Merges current refinements with new refinements
     * @private
     */
  }, {
    key: "mergeRefinements",
    value: function mergeRefinements(currentRefinements, newRefinements) {
      var merged = algolia_objectSpread({}, currentRefinements);
      Object.entries(newRefinements).forEach(function (_ref2) {
        var _ref3 = algolia_slicedToArray(_ref2, 2),
          attribute = _ref3[0],
          values = _ref3[1];
        if (!merged[attribute]) {
          merged[attribute] = [];
        }

        // Add new values that aren't already present
        values.forEach(function (value) {
          if (!merged[attribute].includes(value)) {
            merged[attribute].push(value);
          }
        });
      });
      return merged;
    }

    /**
     * Applies refinements to the search interface
     * @private
     */
  }, {
    key: "applyRefinements",
    value: (function () {
      var _applyRefinements = algolia_asyncToGenerator(/*#__PURE__*/algolia_regeneratorRuntime().mark(function _callee4(refinements, instantsearch) {
        var _instantsearch$search6;
        var helper;
        return algolia_regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              helper = instantsearch === null || instantsearch === void 0 || (_instantsearch$search6 = instantsearch.search) === null || _instantsearch$search6 === void 0 ? void 0 : _instantsearch$search6.helper;
              if (!helper) {
                _context4.next = 12;
                break;
              }
              _context4.prev = 2;
              Object.entries(refinements).forEach(function (_ref4) {
                var _ref5 = algolia_slicedToArray(_ref4, 2),
                  attribute = _ref5[0],
                  values = _ref5[1];
                values.forEach(function (value) {
                  // Check if refinement is not already applied
                  if (!helper.state.isDisjunctiveFacetRefined(attribute, value)) {
                    helper.addDisjunctiveFacetRefinement(attribute, value);
                  }
                });
              });

              // Trigger search with new refinements

              helper.search();
              // Update the state with the new refinements (this is to ensure URL params are updated)
              helper.setState(helper.state);
              return _context4.abrupt("return");
            case 9:
              _context4.prev = 9;
              _context4.t0 = _context4["catch"](2);
              console.warn('Failed to apply refinements via API, falling back to DOM manipulation:', _context4.t0);
            case 12:
              _context4.next = 14;
              return this.applyRefinementsViaDOM(refinements);
            case 14:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this, [[2, 9]]);
      }));
      function applyRefinements(_x5, _x6) {
        return _applyRefinements.apply(this, arguments);
      }
      return applyRefinements;
    }()
    /**
     * Applies refinements by simulating UI interactions (fallback method)
     * @private
     */
    )
  }, {
    key: "applyRefinementsViaDOM",
    value: (function () {
      var _applyRefinementsViaDOM = algolia_asyncToGenerator(/*#__PURE__*/algolia_regeneratorRuntime().mark(function _callee5(refinements) {
        return algolia_regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return new Promise(function (resolve) {
                return setTimeout(resolve, 100);
              });
            case 2:
              Object.entries(refinements).forEach(function (_ref6) {
                var _ref7 = algolia_slicedToArray(_ref6, 2),
                  attribute = _ref7[0],
                  values = _ref7[1];
                values.forEach(function (value) {
                  try {
                    var input = document.querySelector("input[data-attribute=\"".concat(attribute, "\"][data-value=\"").concat(value, "\"]"));
                    if (input && !input.checked) {
                      var listItem = input.closest('li');
                      if (listItem) {
                        // Dispatch click event to trigger refinement
                        listItem.dispatchEvent(new Event('click', {
                          bubbles: true,
                          cancelable: true
                        }));
                      }
                    }
                  } catch (domError) {
                    console.error("Failed to apply refinement ".concat(attribute, ":").concat(value, " via DOM:"), domError);
                  }
                });
              });
            case 3:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }));
      function applyRefinementsViaDOM(_x7) {
        return _applyRefinementsViaDOM.apply(this, arguments);
      }
      return applyRefinementsViaDOM;
    }() // Rename the original method call in updateFacetData
    )
  }, {
    key: "toggleOrientationFacet",
    value: function toggleOrientationFacet(instantsearch) {
      // Redirect to the new implementation
      this.applyUserDataRefinements(instantsearch);
    }
  }, {
    key: "setNoExclusiveFacet",
    value: function setNoExclusiveFacet(value) {
      this.noExclusiveFacet = value;
    }

    /**
     * Updates the refined values in the UI to reflect the current search state.
     * Modifies the UI to display the currently selected facet values.
     */
  }, {
    key: "updateRefinedValues",
    value: (function () {
      var _updateRefinedValues = algolia_asyncToGenerator(/*#__PURE__*/algolia_regeneratorRuntime().mark(function _callee6() {
        return algolia_regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 2;
              return this.updater.updateRefinedValues();
            case 2:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this);
      }));
      function updateRefinedValues() {
        return _updateRefinedValues.apply(this, arguments);
      }
      return updateRefinedValues;
    }()
    /**
     * Updates the UI to reflect the current counts of facet values.
     * Modifies the facet headers to include the count of available options.
     */
    )
  }, {
    key: "updateFacetCounts",
    value: function updateFacetCounts() {
      var _this6 = this;
      Object.entries(this.facetValueCounts).forEach(function (_ref8) {
        var _facetElement$querySe;
        var _ref9 = algolia_slicedToArray(_ref8, 2),
          key = _ref9[0],
          value = _ref9[1];
        if (key === 'inventory_available') return;
        var facetElement = document.querySelector("[data-facet=\"".concat(key, "\"]"));
        var countSpanOther = document.querySelector("[data-count-id=\"".concat(key, "\"]"));
        var currentFacetCount = countSpanOther ? parseInt(countSpanOther.dataset.currentFacetCount) : value;
        if (!facetElement) return;
        if (key === 'meta.product_flags.us_product_flags' || key === 'meta.product_flags.eu_product_flags') {
          if (_this6.noExclusiveFacet) {
            facetElement.classList.add('hidden');
            return;
          } else {
            return;
          }
        }
        // Find or create the count span element
        var countSpan = facetElement.querySelector('span.facet-count');
        if (!countSpan) {
          countSpan = document.createElement('span');
          countSpan.classList.add('facet-count');
          var header = facetElement.querySelector('.ais-facet__header');
          if (header) {
            header.insertBefore(countSpan, header.querySelector('svg'));
          }
        }

        // Update the count and toggle visibility based on dropdown state
        countSpan.innerHTML = "&nbsp;(".concat(currentFacetCount, ")");
        var isChecked = (_facetElement$querySe = facetElement.querySelector('[name=dropdown]')) === null || _facetElement$querySe === void 0 ? void 0 : _facetElement$querySe.checked;
        countSpan.classList.toggle('checked-hidden', !isChecked);
      });
      var inventoryAvailableFacet = document.querySelector('.ais-facet-dropdown-wrapper.ais-facet-inventory_available');
      if (inventoryAvailableFacet) {}
    }

    /**
     * Updates facet translations based on window.translations
     * Replaces the facet in algoliaShopify.translations.facets with updated translations
     * @param {Object} agShopify - The Algolia Shopify object
     */
  }, {
    key: "setFacetTranslations",
    value: function setFacetTranslations(agShopify) {
      if (!window.translations || !Array.isArray(window.translations)) return;
      var translations = agShopify.translations;
      var facets = translations.facets;
      var _loop = function _loop() {
        var facet = facets[i];
        var escapedName = facet.name;
        var matchingTranslation = window.translations.find(function (translation) {
          return (translation.guitar_spec || translation.amp_spec || translation.pedal_spec) && (translation.guitar_spec === escapedName || translation.amp_spec === escapedName || translation.pedal_spec === escapedName);
        });
        if (matchingTranslation) {
          var updatedFacet = algolia_objectSpread(algolia_objectSpread({}, facet), {}, {
            title: matchingTranslation.value,
            label: matchingTranslation.value
          });
          facets[i] = updatedFacet;
        }
      };
      for (var i = 0; i < facets.length; i++) {
        _loop();
      }
      window.algoliaShopify.translations.facets = facets;
    }
    /**
     * Renders custom operations for the InstantSearch interface.
     */
  }, {
    key: "renderOperations",
    value: function renderOperations() {
      var _this = this;
      algoliaShopify.hooks.registerHook('beforeInstantSearchConfigurationOptions', function (options) {
        algoliaShopify.translations.filterAndSort = 'Filter & Sort';
        options.preserveSharedStateOnUnmount = true;
        window.algoliaShopify.customSearchClient = options.searchClient;
        _this.setFacetTranslations(algoliaShopify);
        return options;
      });
    }
  }, {
    key: "setupOnStateChange",
    value: function setupOnStateChange(options) {
      var _this7 = this;
      options.onStateChange = function (_ref10) {
        var state = _ref10.state;
        _this7.currentState = state;

        // Skip updates during loading state
        if (state.status === 'loading') return;

        // Update store with new state
        stateStore.dispatch(update({
          query: state.query,
          isOpen: state.isOpen,
          status: state.status
        }));
      };
    }

    /**
     * Modifies the InstantSearch options before initialization.
     * Sets facets widgets to be collapsible and collapsed by default.
     * @param {Object} options - The InstantSearch options object.
     * @returns {Object} - The modified options object.
     */
  }, {
    key: "handleBeforeInstantSearchOptions",
    value: function handleBeforeInstantSearchOptions(options) {
      var _options$search$helpe,
        _options$search$helpe2,
        _this8 = this;
      var stateVar = ((_options$search$helpe = options.search.helper) === null || _options$search$helpe === void 0 ? void 0 : _options$search$helpe.state) || {};
      var lastResultsVar = ((_options$search$helpe2 = options.search.helper) === null || _options$search$helpe2 === void 0 ? void 0 : _options$search$helpe2.lastResults) || {};

      // Update widgets to make refinement lists collapsible

      var updatedWidgets = options.facets.widgets.map(function (widget) {
        if (widget.params.attribute === 'inventory_available') {
          widget.params.isRefined = true;
        }
        if (widget.name === 'refinementList') {
          return _this8.updateRefinementListWidget(widget);
        }
        return widget;
      });

      /*
          preserveSharedStateOnUnmount: true,
      */
      options.preserveSharedStateOnUnmount = true;
      var hasInventoryAvailableFacet = updatedWidgets.some(function (widget) {
        return widget.name === 'refinementList' && widget.params.attribute === 'inventory_available';
      });
      if (hasInventoryAvailableFacet) {
        // Create and add the custom toggle refinement widget
        var myToggleRefinement = algoliaToggleRefinement({
          container: '#toggle-refinement-0',
          attribute: 'inventory_available',
          initiallyRefined: true
        });

        // Add the toggle refinement widget
        options.search.addWidgets([myToggleRefinement]);
      }

      // Return the modified options
      return algolia_objectSpread(algolia_objectSpread({}, options), {}, {
        facets: algolia_objectSpread(algolia_objectSpread({}, options.facets), {}, {
          widgets: updatedWidgets
        })
      });
    }

    /**
     * Updates the configuration of a refinement list widget to be collapsible.
     * @param {Object} widget - The widget configuration object.
     * @returns {Object} - The updated widget configuration.
     */
  }, {
    key: "updateRefinementListWidget",
    value: function updateRefinementListWidget(widget) {
      return algolia_objectSpread(algolia_objectSpread({}, widget), {}, {
        params: algolia_objectSpread(algolia_objectSpread({}, widget.params), {}, {
          collapsible: true,
          collapsed: true,
          isCollapsed: true,
          isCollapsible: true,
          count: true
        })
      });
    }
  }]);
}(); // Instantiate and initialize the AlgoliaSearchHandler
var algoliaSearchHandler = new AlgoliaSearchHandler();
algoliaSearchHandler.initialize();
}();
/******/ })()
;